import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Grid,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  Paper,
  Card,
  Divider,
  CardContent,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TableSortLabel,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  Menu,
  MenuList,
  ListItemIcon,
  ListItemText,
  Switch,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  InputAdornment,
  Tabs,
  Tab,
  Fade,
  Grow,
  Zoom,
  Collapse,
  ButtonGroup,
  Popover,
  List,
  ListItem,
  ListItemButton,
  Checkbox,
  Radio,
  RadioGroup,
  FormLabel,
  FormGroup,
  FormHelperText,
  NativeSelect,
  OutlinedInput,
  FilledInput,
  Input,
  DialogContentText,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Breadcrumbs,
  Avatar,
  Badge,
  Rating,
  LinearProgress,
  Skeleton,
  Stack,
  Drawer,
  SwipeableDrawer,
  Modal,
  Autocomplete,
  ToggleButton,
  ToggleButtonGroup,
  Slider,
  Container,
  CssBaseline,
  Toolbar,
  AppBar,
  Fab
} from '@mui/material';
import ProcessSelector from './ProcessSelector';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CheckCircle as CheckCircleIcon,
  DoneAll as DoneAllIcon,
  WarningAmber as WarningAmberIcon,
  Visibility as VisibilityIcon,
  Print as PrintIcon,
  GetApp as DownloadIcon,
  MoreVert as MoreVertIcon,
  FilterList as FilterIcon,
  ViewColumn as ViewColumnIcon,
  Search as SearchIcon,
  Remove as RemoveIcon,
  Navigation as WazeIcon,
  DirectionsCar as MapIcon,
  Update as UpdateIcon,
  Refresh as RefreshIcon,
  PendingActions as PendingActionsIcon,
  Note as NoteIcon,
  EventRepeat as EventRepeatIcon,
} from '@mui/icons-material';
import { Client, PublicClient, InventoryItem } from '../models';
import GoogleMapComponent from './GoogleMapComponent';
import { CSVLink } from 'react-csv';
import { alpha } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { fontSize, keyframes, margin, styled } from '@mui/system';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { MapContainer, Marker, Popup, TileLayer, useMap } from 'react-leaflet';
import { Polyline } from 'react-leaflet';
import L, { LatLng } from 'leaflet';
import { CodeIcon, PhoneIcon, MailIcon, MapPinIcon, FullscreenIcon } from 'lucide-react';
import CloseIcon from '@mui/icons-material/Close';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CancelIcon from '@mui/icons-material/Cancel';
import CreateIcon from '@mui/icons-material/Create';
import TransferIcon from '@mui/icons-material/TransferWithinAStation'; // Adjust the import based on the correct icon
import { useNavigate } from 'react-router-dom'; // Importa useNavigate
import NotificationsIcon from '@mui/icons-material/Notifications';
import { format, addDays, subDays, addWeeks, addMonths, isSameDay, getWeekOfMonth, getDay, startOfDay, endOfDay, isAfter, isEqual } from 'date-fns';
import { es } from 'date-fns/locale';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import HistoryIcon from '@mui/icons-material/History';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import InfoIcon from '@mui/icons-material/Info';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { addDoc, getDoc, doc, Timestamp, setDoc, deleteDoc, collection, getDocs, query, where, updateDoc, orderBy, or, serverTimestamp } from 'firebase/firestore';
import { RouteGroup, Route, Order } from '../models';
import OrderCreationModal from './OrderCreationModal';
import { Map as LeafletMap } from 'leaflet';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { toast } from 'react-toastify';
import { db } from '../firebase';
import { FaWaze } from 'react-icons/fa';
import GoogleIcon from '@mui/icons-material/Google';
import TableChartIcon from '@mui/icons-material/TableChart';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const columnNames: { [key in keyof Client]: string } = {
  name: 'Nombre',
  phoneNumber: 'Teléfono',
  email: 'Correo Electrónico',
  googleMapsLink: 'Enlace Google Maps',
  wazeLink: 'Enlace Waze',
  id: 'ID',
  cedula_nacional: 'Cédula Nacional',
  second_phoneNumber: 'Teléfono Secundario',
  tipo_documento: 'Tipo de Documento',
  tipo_client: 'Tipo de Cliente',
  tipo_compostera: 'Tipo de Compostera',
  tipo_entrega: 'Tipo Entrega',
  senas: 'Señas',
  nota: 'Nota',
  imageUrl: 'URL de Imagen',
  provincia: 'Provincia',
  canton: 'Cantón',
  distrito: 'Distrito',
  municipalidades: 'Municipalidad',
  cant_gato: 'Gato 0-6Kg',
  cant_perro_mini: 'Mini 0-6Kg',
  cant_perro_pequeno: 'Pequeño 6-10Kg',
  cant_perro_mediano: 'Mediano 10-25Kg',
  cant_perro_grande: 'Grande 25-45Kg',
  cant_perro_gigante: 'Gigante +45Kg',
  nota_admin: 'Nota Admin',
  codigo_referencia: 'Código de Referencia',
};

const MapEventHandler = ({ onClick }: { onClick: (e: L.LeafletMouseEvent) => void }) => {
  const map = useMap();

  React.useEffect(() => {
    // Remove any existing click handlers to prevent duplicates
    map.off('click');
    
    // Add the click event to the map
    map.on('click', onClick);

    // Clean up the event when the component unmounts or when dependencies change
    return () => {
      map.off('click', onClick);
    };
  }, [map, onClick]);

  return null; // This component doesn't render anything
};
// Datos estáticos para Costa Rica
const costaRicaData = {
  provinces: ['Alajuela', 'Cartago', 'Guanacaste', 'Heredia', 'Limón', 'Puntarenas', 'San José'],
  cantons: {
    'Alajuela': ['Alajuela', 'San Ramón', 'Grecia', 'San Mateo', 'Atenas', 'Naranjo', 'Palmares', 'Poás', 'Orotina', 'San Carlos', 'Zarcero', 'Sarchí', 'Upala', 'Los Chiles', 'Guatuso', 'Río Cuarto'],
    'Cartago': ['Cartago', 'Paraíso', 'La Unión', 'Jiménez', 'Turrialba', 'Alvarado', 'Oreamuno', 'El Guarco'],
    'Guanacaste': ['Liberia', 'Nicoya', 'Santa Cruz', 'Bagaces', 'Carrillo', 'Cañas', 'Abangares', 'Tilarán', 'Nandayure', 'La Cruz', 'Hojancha'],
    'Heredia': ['Heredia', 'Barva', 'Santo Domingo', 'Santa Bárbara', 'San Rafael', 'San Isidro', 'Belén', 'Flores', 'San Pablo', 'Sarapiquí'],
    'Limón': ['Limón', 'Pococí', 'Siquirres', 'Talamanca', 'Matina', 'Guácimo'],
    'Puntarenas': ['Puntarenas', 'Esparza', 'Buenos Aires', 'Montes de Oro', 'Osa', 'Quepos', 'Golfito', 'Coto Brus', 'Parrita', 'Corredores', 'Garabito'],
    'San José': ['San José', 'Escazú', 'Desamparados', 'Puriscal', 'Tarrazú', 'Aserrí', 'Mora', 'Goicoechea', 'Santa Ana', 'Alajuelita', 'Vázquez de Coronado', 'Acosta', 'Tibás', 'Moravia', 'Montes de Oca', 'Turrubares', 'Dota', 'Curridabat', 'Pérez Zeledón', 'León Cortés Castro']
  },
  districts: {
    'Alajuela': {
      'Alajuela': ['Alajuela', 'San José', 'Carrizal', 'San Antonio', 'Guácima', 'San Isidro', 'Sabanilla', 'San Rafael', 'Río Segundo', 'Desamparados', 'Turrúcares', 'Tambor', 'Garita', 'Sarapiquí'],
      'San Ramón': ['San Ramón', 'Santiago', 'San Juan', 'Piedades Norte', 'Piedades Sur', 'San Rafael', 'San Isidro', 'Ángeles', 'Alfaro', 'Volio', 'Concepción', 'Zapotal', 'Peñas Blancas', 'San Lorenzo'],
      'Grecia': ['Grecia', 'San Isidro', 'San José', 'San Roque', 'Tacares', 'Río Cuarto', 'Puente de Piedra', 'Bolívar'],
      'San Mateo': ['San Mateo', 'Desmonte', 'Jesús María', 'Labrador'],
      'Atenas': ['Atenas', 'Jesús', 'Mercedes', 'San Isidro', 'Concepción', 'San José', 'Santa Eulalia', 'Escobal'],
      'Naranjo': ['Naranjo', 'San Miguel', 'San José', 'Cirrí Sur', 'San Jerónimo', 'San Juan', 'El Rosario', 'Palmitos'],
      'Palmares': ['Palmares', 'Zaragoza', 'Buenos Aires', 'Santiago', 'Candelaria', 'Esquipulas', 'La Granja'],
      'Poás': ['San Pedro', 'San Juan', 'San Rafael', 'Carrillos', 'Sabana Redonda'],
      'Orotina': ['Orotina', 'El Mastate', 'Hacienda Vieja', 'Coyolar', 'La Ceiba'],
      'San Carlos': ['Quesada', 'Florencia', 'Buenavista', 'Aguas Zarcas', 'Venecia', 'Pital', 'La Fortuna', 'La Tigra', 'La Palmera', 'Venado', 'Cutris', 'Monterrey', 'Pocosol'],
      'Zarcero': ['Zarcero', 'Laguna', 'Tapesco', 'Guadalupe', 'Palmira', 'Zapote', 'Brisas'],
      'Sarchí': ['Sarchí Norte', 'Sarchí Sur', 'Toro Amarillo', 'San Pedro', 'Rodríguez'],
      'Upala': ['Upala', 'Aguas Claras', 'San José o Pizote', 'Bijagua', 'Delicias', 'Dos Ríos', 'Yolillal', 'Canalete'],
      'Los Chiles': ['Los Chiles', 'Caño Negro', 'El Amparo', 'San Jorge'],
      'Guatuso': ['San Rafael', 'Buenavista', 'Cote', 'Katira'],
      'Río Cuarto': ['Río Cuarto', 'Santa Rita', 'Santa Isabel']
    },
    'Cartago': {
      'Cartago': ['Oriental', 'Occidental', 'Carmen', 'San Nicolás', 'Aguacaliente', 'Guadalupe', 'Corralillo', 'Tierra Blanca', 'Dulce Nombre', 'Llano Grande', 'Quebradilla'],
      'Paraíso': ['Paraíso', 'Santiago', 'Orosi', 'Cachí', 'Llanos de Santa Lucía'],
      'La Unión': ['Tres Ríos', 'San Diego', 'San Juan', 'San Rafael', 'Concepción', 'Dulce Nombre', 'San Ramón', 'Río Azul'],
      'Jiménez': ['Juan Viñas', 'Tucurrique', 'Pejibaye'],
      'Turrialba': ['Turrialba', 'La Suiza', 'Peralta', 'Santa Cruz', 'Santa Teresita', 'Pavones', 'Tuis', 'Tayutic', 'Santa Rosa', 'Tres Equis', 'La Isabel', 'Chirripó'],
      'Alvarado': ['Pacayas', 'Cervantes', 'Capellades'],
      'Oreamuno': ['San Rafael', 'Cot', 'Potrero Cerrado', 'Cipreses', 'Santa Rosa'],
      'El Guarco': ['El Tejar', 'San Isidro', 'Tobosi', 'Patio de Agua']
    },
    'Guanacaste': {
      'Liberia': ['Liberia', 'Cañas Dulces', 'Mayorga', 'Nacascolo', 'Curubandé'],
      'Nicoya': ['Nicoya', 'Mansión', 'San Antonio', 'Quebrada Honda', 'Sámara', 'Nosara', 'Belén de Nosarita'],
      'Santa Cruz': ['Santa Cruz', 'Bolsón', 'Veintisiete de Abril', 'Tempate', 'Cartagena', 'Cuajiniquil', 'Diriá', 'Cabo Velas', 'Tamarindo'],
      'Bagaces': ['Bagaces', 'La Fortuna', 'Mogote', 'Río Naranjo'],
      'Carrillo': ['Filadelfia', 'Palmira', 'Sardinal', 'Belén'],
      'Cañas': ['Cañas', 'Palmira', 'San Miguel', 'Bebedero', 'Porozal'],
      'Abangares': ['Las Juntas', 'Sierra', 'San Juan', 'Colorado'],
      'Tilarán': ['Tilarán', 'Quebrada Grande', 'Tronadora', 'Santa Rosa', 'Líbano', 'Tierras Morenas', 'Arenal', 'Cabeceras'],
      'Nandayure': ['Carmona', 'Santa Rita', 'Zapotal', 'San Pablo', 'Porvenir', 'Bejuco'],
      'La Cruz': ['La Cruz', 'Santa Cecilia', 'La Garita', 'Santa Elena'],
      'Hojancha': ['Hojancha', 'Monte Romo', 'Puerto Carrillo', 'Huacas', 'Matambú']
    },
    'Heredia': {
      'Heredia': ['Heredia', 'Mercedes', 'San Francisco', 'Ulloa', 'Varablanca'],
      'Barva': ['Barva', 'San Pedro', 'San Pablo', 'San Roque', 'Santa Lucía', 'San José de la Montaña'],
      'Santo Domingo': ['Santo Domingo', 'San Vicente', 'San Miguel', 'Paracito', 'Santo Tomás', 'Santa Rosa', 'Tures', 'Pará'],
      'Santa Bárbara': ['Santa Bárbara', 'San Pedro', 'San Juan', 'Jesús', 'Santo Domingo', 'Purabá'],
      'San Rafael': ['San Rafael', 'San Josecito', 'Santiago', 'Ángeles', 'Concepción'],
      'San Isidro': ['San Isidro', 'San José', 'Concepción', 'San Francisco'],
      'Belén': ['San Antonio', 'La Ribera', 'La Asunción'],
      'Flores': ['San Joaquín', 'Barrantes', 'Llorente'],
      'San Pablo': ['San Pablo', 'Rincón de Sabanilla'],
      'Sarapiquí': ['Puerto Viejo', 'La Virgen', 'Las Horquetas', 'Llanuras del Gaspar', 'Cureña']
    },
    'Limón': {
      'Limón': ['Limón', 'Valle La Estrella', 'Río Blanco', 'Matama'],
      'Pococí': ['Guápiles', 'Jiménez', 'Rita', 'Roxana', 'Cariari', 'Colorado', 'La Colonia'],
      'Siquirres': ['Siquirres', 'Pacuarito', 'Florida', 'Germania', 'El Cairo', 'Alegría', 'Reventazón'],
      'Talamanca': ['Bratsi', 'Sixaola', 'Cahuita', 'Telire'],
      'Matina': ['Matina', 'Batán', 'Carrandi'],
      'Guácimo': ['Guácimo', 'Mercedes', 'Pocora', 'Río Jiménez', 'Duacarí']
    },
    'Puntarenas': {
      'Puntarenas': ['Puntarenas', 'Pitahaya', 'Chomes', 'Lepanto', 'Paquera', 'Manzanillo', 'Guacimal', 'Barranca', 'Monte Verde', 'Isla del Coco', 'Cóbano', 'Chacarita', 'Chira', 'Acapulco', 'El Roble', 'Arancibia'],
      'Esparza': ['Espíritu Santo', 'San Juan Grande', 'Macacona', 'San Rafael', 'San Jerónimo', 'Caldera'],
      'Buenos Aires': ['Buenos Aires', 'Volcán', 'Potrero Grande', 'Boruca', 'Pilas', 'Colinas', 'Chánguena', 'Biolley', 'Brunka'],
      'Montes de Oro': ['Miramar', 'La Unión', 'San Isidro'],
      'Osa': ['Puerto Cortés', 'Palmar', 'Sierpe', 'Bahía Ballena', 'Piedras Blancas', 'Bahía Drake'],
      'Quepos': ['Quepos', 'Savegre', 'Naranjito'],
      'Golfito': ['Golfito', 'Puerto Jiménez', 'Guaycará', 'Pavón'],
      'Coto Brus': ['San Vito', 'Sabalito', 'Aguabuena', 'Limoncito', 'Pittier', 'Gutiérrez Braun'],
      'Parrita': ['Parrita'],
      'Corredores': ['Corredor', 'La Cuesta', 'Canoas', 'Laurel'],
      'Garabito': ['Jacó', 'Tárcoles']
    },
    'San José': {
      'San José': ['Carmen', 'Merced', 'Hospital', 'Catedral', 'Zapote', 'San Francisco de Dos Ríos', 'Uruca', 'Mata Redonda', 'Pavas', 'Hatillo', 'San Sebastián'],
      'Escazú': ['Escazú', 'San Antonio', 'San Rafael'],
      'Desamparados': ['Desamparados', 'San Miguel', 'San Juan de Dios', 'San Rafael Arriba', 'San Antonio', 'Frailes', 'Patarrá', 'San Cristóbal', 'Rosario', 'Damas', 'San Rafael Abajo', 'Gravilias', 'Los Guido'],
      'Puriscal': ['Santiago', 'Mercedes Sur', 'Barbacoas', 'Grifo Alto', 'San Rafael', 'Candelarita', 'Desamparaditos', 'San Antonio', 'Chires'],
      'Tarrazú': ['San Marcos', 'San Lorenzo', 'San Carlos'],
      'Aserrí': ['Aserrí', 'Tarbaca', 'Vuelta de Jorco', 'San Gabriel', 'Legua', 'Monterrey', 'Salitrillos'],
      'Mora': ['Colón', 'Guayabo', 'Tabarcia', 'Piedras Negras', 'Picagres', 'Jaris', 'Quitirrisí'],
      'Goicoechea': ['Guadalupe', 'San Francisco', 'Calle Blancos', 'Mata de Plátano', 'Ipís', 'Rancho Redondo', 'Purral'],
      'Santa Ana': ['Santa Ana', 'Salitral', 'Pozos', 'Uruca', 'Piedades', 'Brasil'],
      'Alajuelita': ['Alajuelita', 'San Josecito', 'San Antonio', 'Concepción', 'San Felipe'],
      'Vázquez de Coronado': ['San Isidro', 'San Rafael', 'Dulce Nombre de Jesús', 'Patalillo', 'Cascajal'],
      'Acosta': ['San Ignacio', 'Guaitil', 'Palmichal', 'Cangrejal', 'Sabanillas'],
      'Tibás': ['San Juan', 'Cinco Esquinas', 'Anselmo Llorente', 'León XIII', 'Colima'],
      'Moravia': ['San Vicente', 'San Jerónimo', 'La Trinidad'],
      'Montes de Oca': ['San Pedro', 'Sabanilla', 'Mercedes', 'San Rafael'],
      'Turrubares': ['San Pablo', 'San Pedro', 'San Juan de Mata', 'San Luis', 'Carara'],
      'Dota': ['Santa María', 'Jardín', 'Copey'],
      'Curridabat': ['Curridabat', 'Granadilla', 'Sánchez', 'Tirrases'],
      'Pérez Zeledón': ['San Isidro de El General', 'El General', 'Daniel Flores', 'Rivas', 'San Pedro', 'Platanares', 'Pejibaye', 'Cajón', 'Barú', 'Río Nuevo', 'Páramo', 'La Amistad'],
      'León Cortés Castro': ['San Pablo', 'San Andrés', 'Llano Bonito', 'San Isidro', 'Santa Cruz', 'San Antonio']
    }
  },
  municipalities: {
    'Alajuela': [
      "Municipalidad de Alajuela",
      "Municipalidad de San Ramón",
      "Municipalidad de Grecia",
      "Municipalidad de San Mateo",
      "Municipalidad de Atenas",
      "Municipalidad de Naranjo",
      "Municipalidad de Palmares",
      "Municipalidad de Poás",
      "Municipalidad de Orotina",
      "Municipalidad de San Carlos",
      "Municipalidad de Zarcero",
      "Municipalidad de Sarchí",
      "Municipalidad de Upala",
      "Municipalidad de Los Chiles",
      "Municipalidad de Guatuso",
      "Municipalidad de Río Cuarto"
    ],
    'Cartago': [
      "Municipalidad de Cartago",
      "Municipalidad de Paraíso",
      "Municipalidad de La Unión",
      "Municipalidad de Jiménez",
      "Municipalidad de Turrialba",
      "Municipalidad de Alvarado",
      "Municipalidad de Oreamuno",
      "Municipalidad de El Guarco"
    ],
    'Guanacaste': [
      "Municipalidad de Liberia",
      "Municipalidad de Nicoya",
      "Municipalidad de Santa Cruz",
      "Municipalidad de Bagaces",
      "Municipalidad de Carrillo",
      "Municipalidad de Cañas",
      "Municipalidad de Abangares",
      "Municipalidad de Tilarán",
      "Municipalidad de Nandayure",
      "Municipalidad de La Cruz",
      "Municipalidad de Hojancha"
    ],
    'Heredia': [
      "Municipalidad de Heredia",
      "Municipalidad de Barva",
      "Municipalidad de Santo Domingo",
      "Municipalidad de Santa Bárbara",
      "Municipalidad de San Rafael",
      "Municipalidad de San Isidro",
      "Municipalidad de Belén",
      "Municipalidad de Flores",
      "Municipalidad de San Pablo",
      "Municipalidad de Sarapiquí"
    ],
    'Limón': [
      "Municipalidad de Limón",
      "Municipalidad de Pococí",
      "Municipalidad de Siquirres",
      "Municipalidad de Talamanca",
      "Municipalidad de Matina",
      "Municipalidad de Guácimo"
    ],
    'Puntarenas': [
      "Municipalidad de Puntarenas",
      "Municipalidad de Esparza",
      "Municipalidad de Buenos Aires",
      "Municipalidad de Montes de Oro",
      "Municipalidad de Osa",
      "Municipalidad de Quepos",
      "Municipalidad de Golfito",
      "Municipalidad de Coto Brus",
      "Municipalidad de Parrita",
      "Municipalidad de Corredores",
      "Municipalidad de Garabito"
    ],
    'San José': [
      "Municipalidad de San José",
      "Municipalidad de Escazú",
      "Municipalidad de Desamparados",
      "Municipalidad de Puriscal",
      "Municipalidad de Tarrazú",
      "Municipalidad de Aserrí",
      "Municipalidad de Mora",
      "Municipalidad de Goicoechea",
      "Municipalidad de Santa Ana",
      "Municipalidad de Alajuelita",
      "Municipalidad de Vázquez de Coronado",
      "Municipalidad de Acosta",
      "Municipalidad de Tibás",
      "Municipalidad de Moravia",
      "Municipalidad de Montes de Oca",
      "Municipalidad de Turrubares",
      "Municipalidad de Dota",
      "Municipalidad de Curridabat",
      "Municipalidad de Pérez Zeledón",
      "Municipalidad de León Cortés Castro"
    ]
  }
};

interface ClientListProps {
  clients: Client[];
  publicClients: PublicClient[];
  onUpdate: (client: Client) => Promise<void>;
  onDelete: (clientId: string) => Promise<void>;
  onAddNew: (client: Omit<Client, 'id'>) => Promise<void>;
  onUpdatePublicClient: (client: PublicClient) => Promise<void>;
  onUpdateClient?: (client: Client) => Promise<void>;
  onAddNewPublicClient: (client: Omit<PublicClient, 'id'>) => Promise<void>;
  onDeletePublicClient: (clientId: string) => Promise<void>;
  savingRoute?: boolean;
  setSavingRoute?: (saving: boolean) => void;
}

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const RecoleccionIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 512 512">
    <path d="M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z" />
  </SvgIcon>
);

// Add styled components
const ErrorNotificationPopup = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#fff',
  padding: '2rem',
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1rem',
  zIndex: 1301,
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  border: '2px solid #ff6b6b'
}));

// Define styled components
const DarkOverlay = styled(Box)({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  backdropFilter: 'blur(4px)',
  zIndex: 9998,
  animation: 'fadeIn 0.3s ease-out',
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },
});

const NotificationPopup = styled(Box)({
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'rgba(255, 255, 255, 0.98)',
  padding: '32px 48px',
  borderRadius: '24px',
  boxShadow: '0 8px 40px rgba(0, 0, 0, 0.25)',
  backdropFilter: 'blur(10px)',
  display: 'flex',
  alignItems: 'center',
  gap: '24px',
  zIndex: 9999,
  animation: 'slideIn 0.5s ease-out',
  '@keyframes slideIn': {
    '0%': {
      transform: 'translate(-50%, -40%)',
      opacity: 0,
    },
    '100%': {
      transform: 'translate(-50%, -50%)',
      opacity: 1,
    },
  },
});

const AnimatedEmoji = styled('span')({
  display: 'inline-block',
  animation: 'bounce 1s ease infinite',
  fontSize: '2.5rem',
  '@keyframes bounce': {
    '0%, 100%': {
      transform: 'translateY(0)',
    },
    '50%': {
      transform: 'translateY(-8px)',
    },
  },
});

// Componente para manejar el clic en el mapa
const MapClickHandler = ({ onMapClick }: { onMapClick: (lat: number, lng: number) => void }) => {
  const map = useMap();

  // Manejar el clic en el mapa
  map.on('click', (event) => {
    const { lat, lng } = event.latlng;
    // handleLocationSelect({ lat, lng }); // Llama a la función aquí
    onMapClick(lat, lng);
  });

  return null; // Este componente no renderiza nada
};

interface OrderTableItem {
  id: string;
  clientId: string;
  clientName: string;
  clientPhone: string;
  createdAt: Date;
  routeName: string;
  status: string;
  deliveryType: 'ollinItems';
  order: Order;
  routeGroup: RouteGroup;
  clientData?: any; // Optional client data from route
  orderNote?: string; // Optional note for the order
  notes?: string; // Optional transferred notes from route changes
}

interface RutasBoardViewProps {
  clients: Client[];
  inventoryItems: InventoryItem[];
  routeBoardStartDate: Date | null;
  routeBoardEndDate: Date | null;
  setRouteBoardStartDate: (date: Date | null) => void;
  setRouteBoardEndDate: (date: Date | null) => void;
  allRoutes: OrderTableItem[];
  setAllRoutes: (routes: OrderTableItem[]) => void;
  loadingRoutes: boolean;
  setLoadingRoutes: (loading: boolean) => void;
  routeOrdersDialogOpen: boolean;
  setRouteOrdersDialogOpen: (open: boolean) => void;
  selectedRouteOrders: OrderTableItem[];
  setSelectedRouteOrders: (orders: OrderTableItem[]) => void;
  orderHistoryDialogOpen: boolean;
  setOrderHistoryDialogOpen: (open: boolean) => void;
  historyClient: Client | null;
  setHistoryClient: (client: Client | null) => void;
  historyStartDate: Date | null;
  historyEndDate: Date | null;
  setHistoryStartDate: (date: Date | null) => void;
  setHistoryEndDate: (date: Date | null) => void;
  clientOrderHistory: OrderTableItem[];
  setClientOrderHistory: (orders: OrderTableItem[]) => void;
  loadingHistory: boolean;
  setLoadingHistory: (loading: boolean) => void;
  viewOpen: boolean;
  setViewOpen: (open: boolean) => void;
  waitlistClientIds: string[];
  handleDeleteClick: (target: { type: string, data: any }) => void;
}

const RutasBoardView: React.FC<RutasBoardViewProps> = ({
  clients,
  inventoryItems,
  routeBoardStartDate,
  routeBoardEndDate,
  setRouteBoardStartDate,
  setRouteBoardEndDate,
  allRoutes,
  setAllRoutes,
  loadingRoutes,
  setLoadingRoutes,
  routeOrdersDialogOpen,
  setRouteOrdersDialogOpen,
  selectedRouteOrders,
  setSelectedRouteOrders,
  orderHistoryDialogOpen,
  setOrderHistoryDialogOpen,
  historyClient,
  setHistoryClient,
  historyStartDate,
  historyEndDate,
  setHistoryStartDate,
  setHistoryEndDate,
  clientOrderHistory,
  setClientOrderHistory,
  loadingHistory,
  setLoadingHistory,
  viewOpen,
  setViewOpen,
  waitlistClientIds,
  handleDeleteClick
}) => {
  const [rutasBoardDraggedOrder, setRutasBoardDraggedOrder] = useState<OrderTableItem | null>(null);
  const [rutasBoardDragSource, setRutasBoardDragSource] = useState<'orders' | 'pending' | null>(null);
  const [rutasBoardPendingOrders, setRutasBoardPendingOrders] = useState<OrderTableItem[]>([]);
  const [rutasBoardNotification, setRutasBoardNotification] = useState<{ open: boolean; message: string; type: 'success' | 'error' | 'warning' }>({ open: false, message: '', type: 'success' });
  const [deleteOrderDialogOpen, setDeleteOrderDialogOpen] = useState(false);
  const [orderToDelete, setOrderToDelete] = useState<string | null>(null);

  const fetchAllRoutes = async () => {
    if (!routeBoardStartDate || !routeBoardEndDate) return;
    setLoadingRoutes(true);
    try {
      const routeGroupsRef = collection(db, 'routeGroups');
      const querySnapshot = await getDocs(routeGroupsRef);
      
      let fetchedOrders: OrderTableItem[] = [];
      
      const startDateTime = startOfDay(routeBoardStartDate);
      const endDateTime = endOfDay(routeBoardEndDate);

      for (const docSnapshot of querySnapshot.docs) {
        const routeGroup = { id: docSnapshot.id, ...docSnapshot.data() } as RouteGroup;
        const routesUnionRef = collection(db, `routeGroups/${docSnapshot.id}/routesUnion`);
        const routesUnionQuery = query(
          routesUnionRef,
          where('date', '>=', startDateTime),
          where('date', '<=', endDateTime)
        );
        const routesUnionSnapshot = await getDocs(routesUnionQuery);

        for (const routeUnionDoc of routesUnionSnapshot.docs) {
          const routeUnionData = routeUnionDoc.data();
          const routes = routeUnionData.routes || [];

          for (const route of routes) {
            const client = clients.find(c => c.id === route.clientId);
            if (client) {
              const orderDate = routeUnionData.date.toDate();
              fetchedOrders.push({
                id: `${docSnapshot.id}-${route.id}-${routeUnionDoc.id}-${orderDate.getTime()}`,
                clientId: route.clientId,
                clientName: client.name,
                clientPhone: client.phoneNumber,
                createdAt: orderDate,
                routeName: routeGroup.name,
                status: route.status,
                deliveryType: 'ollinItems',
                order: route.order as Order,
                routeGroup: routeGroup
              });
            }
          }
        }
      }
      
      fetchedOrders.sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime());
      setAllRoutes(fetchedOrders);
    } catch (error) {
      console.error('Error fetching routes:', error);
      toast.error('Error al cargar las rutas');
    } finally {
      setLoadingRoutes(false);
    }
  };

  useEffect(() => {
    fetchAllRoutes();
  }, [routeBoardStartDate, routeBoardEndDate, clients]);

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
  const rutasProximaEntrega = allRoutes.filter(r => {
    const routeDate = new Date(r.createdAt.getFullYear(), r.createdAt.getMonth(), r.createdAt.getDate());
    return routeDate >= today && (r.status === 'pending' || r.status === 'pending');
  });
  
  const rutasPendientes = allRoutes.filter(r => r.status === 'pending' || r.status === 'pending');
  const rutasCompletadas = allRoutes.filter(r => r.status === 'completed' || r.status === 'Entregado');

  const handleRouteClick = async (route: OrderTableItem) => {
    const routesWithThisClient = allRoutes.filter(r => r.clientId === route.clientId);
    setSelectedRouteOrders(routesWithThisClient);
    setRouteOrdersDialogOpen(true);
    
    try {
      const pendingRef = collection(db, 'pendingOrders');
      const snapshot = await getDocs(pendingRef);
      let pending: OrderTableItem[] = [];
      snapshot.forEach((doc) => {
        const data = doc.data();
        pending.push({
          id: doc.id,
          clientId: data.clientId,
          clientName: data.clientName,
          clientPhone: data.clientPhone,
          createdAt: data.pendingDate?.toDate() || new Date(),
          routeName: data.routeName || 'Sin asignar',
          status: 'pending',
          deliveryType: data.deliveryType || 'ollinItems',
          order: data.order as Order,
          routeGroup: data.routeGroup
        });
      });
      // Filter to only include pending orders for clients in waitlist
      pending = pending.filter(p => waitlistClientIds.includes(p.clientId));
      setRutasBoardPendingOrders(pending);
    } catch (error: any) {
      console.error('Error fetching pending orders:', error);
      setRutasBoardPendingOrders([]);
    }
  };

  const handleRutasBoardDragStart = (order: OrderTableItem, source: 'orders' | 'pending') => {
    setRutasBoardDraggedOrder(order);
    setRutasBoardDragSource(source);
  };

  const handleRutasBoardDragEnd = () => {
    setRutasBoardDraggedOrder(null);
    setRutasBoardDragSource(null);
  };

  const moveOrderToPendingInRutasBoard = async (order: OrderTableItem) => {
    try {
      await setDoc(doc(db, 'pendingOrders', order.id), {
        clientId: order.clientId,
        clientName: order.clientName,
        clientPhone: order.clientPhone,
        order: order.order,
        deliveryType: order.deliveryType,
        routeGroupId: order.routeGroup?.id,
        routeName: order.routeName,
        originalRouteDate: order.createdAt,
        pendingDate: new Date(),
        status: 'pending'
      });

      const currentOrders = selectedRouteOrders.filter(o => o.id !== order.id);
      setSelectedRouteOrders(currentOrders);
      setRutasBoardPendingOrders([...rutasBoardPendingOrders, { ...order, status: 'pending' }]);
      
      setRutasBoardNotification({
        open: true,
        message: `Pedido movido a pendientes exitosamente`,
        type: 'success'
      });
    } catch (error) {
      console.error('Error moving to pending:', error);
      setRutasBoardNotification({
        open: true,
        message: 'Error al mover el pedido a pendientes',
        type: 'error'
      });
    }
  };

  const moveOrderFromPendingToRouteInRutasBoard = async (order: OrderTableItem) => {
    if (!selectedRouteOrders.length || !selectedRouteOrders[0]?.routeGroup?.id) {
      setRutasBoardNotification({
        open: true,
        message: 'No hay una ruta válida para reasignar',
        type: 'error'
      });
      return;
    }

    const targetRoute = selectedRouteOrders[0];
    
    try {
      const routeGroupsRef = collection(db, 'routeGroups');
      const querySnapshot = await getDocs(routeGroupsRef);
      
      for (const docSnapshot of querySnapshot.docs) {
        if (docSnapshot.id === targetRoute.routeGroup.id) {
          const routesUnionRef = collection(db, `routeGroups/${docSnapshot.id}/routesUnion`);
          const routesUnionSnapshot = await getDocs(routesUnionRef);

          for (const routeUnionDoc of routesUnionSnapshot.docs) {
            const routeUnionData = routeUnionDoc.data();
            const routes = routeUnionData.routes || [];
            
            const routeIndex = routes.findIndex((r: any) => r.clientId === order.clientId);
            
            if (routeIndex !== -1) {
              const updatedOrder = {
                ...routes[routeIndex].order,
                items: [...(routes[routeIndex].order?.items || []), ...order.order.items]
              };
              
              routes[routeIndex].order = updatedOrder;
              routes[routeIndex].status = 'pending';
              
              await setDoc(doc(db, `routeGroups/${docSnapshot.id}/routesUnion`, routeUnionDoc.id), {
                ...routeUnionData,
                routes: routes
              }, { merge: true });

              await deleteDoc(doc(db, 'pendingOrders', order.id));

              const filteredPending = rutasBoardPendingOrders.filter(o => o.id !== order.id);
              setRutasBoardPendingOrders(filteredPending);
              setSelectedRouteOrders([...selectedRouteOrders, { ...order, status: 'pending' }]);
              
              setRutasBoardNotification({
                open: true,
                message: `Pedido reasignado a la ruta exitosamente`,
                type: 'success'
              });
              return;
            }
          }
        }
      }
      
      setRutasBoardNotification({
        open: true,
        message: 'No se encontró la ruta destino',
        type: 'error'
      });
    } catch (error) {
      console.error('Error moving from pending to route:', error);
      setRutasBoardNotification({
        open: true,
        message: 'Error al reasignar el pedido',
        type: 'error'
      });
    }
  };

  const handleDeleteOrder = async () => {
    if (!orderToDelete) return;
    try {
      await deleteDoc(doc(db, 'pendingOrders', orderToDelete));
      setRutasBoardPendingOrders(prev => prev.filter(order => order.id !== orderToDelete));
      setRutasBoardNotification({
        open: true,
        message: 'Pedido eliminado de la lista de espera exitosamente',
        type: 'success'
      });
    } catch (error) {
      console.error('Error deleting pending order:', error);
      toast.error('Error al eliminar el pedido');
    } finally {
      setDeleteOrderDialogOpen(false);
      setOrderToDelete(null);
    }
  };

  const handleViewOrderDetails = (order: OrderTableItem) => {
    const client = clients.find(c => c.id === order.clientId);
    if (client) {
      setHistoryClient(client);
      setOrderHistoryDialogOpen(true);
    }
  };

  const fetchClientHistory = async () => {
    if (!historyClient || !historyStartDate || !historyEndDate) return;
    setLoadingHistory(true);
    try {
      const routeGroupsRef = collection(db, 'routeGroups');
      const querySnapshot = await getDocs(routeGroupsRef);
      
      let fetchedOrders: OrderTableItem[] = [];
      
      const startDateTime = startOfDay(historyStartDate);
      const endDateTime = endOfDay(historyEndDate);

      for (const docSnapshot of querySnapshot.docs) {
        const routeGroup = { id: docSnapshot.id, ...docSnapshot.data() } as RouteGroup;
        const routesUnionRef = collection(db, `routeGroups/${docSnapshot.id}/routesUnion`);
        const routesUnionQuery = query(
          routesUnionRef,
          where('date', '>=', startDateTime),
          where('date', '<=', endDateTime)
        );
        const routesUnionSnapshot = await getDocs(routesUnionQuery);

        for (const routeUnionDoc of routesUnionSnapshot.docs) {
          const routeUnionData = routeUnionDoc.data();
          const routes = routeUnionData.routes || [];

          for (const route of routes) {
            if (route.clientId === historyClient.id) {
              const orderDate = routeUnionData.date.toDate();
              fetchedOrders.push({
                id: `${docSnapshot.id}-${route.id}-${routeUnionDoc.id}-${orderDate.getTime()}`,
                clientId: route.clientId,
                clientName: historyClient.name,
                clientPhone: historyClient.phoneNumber,
                createdAt: orderDate,
                routeName: routeGroup.name,
                status: route.status,
                deliveryType: 'ollinItems',
                order: route.order as Order,
                routeGroup: routeGroup
              });
            }
          }
        }
      }
      
      fetchedOrders.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());
      setClientOrderHistory(fetchedOrders);
    } catch (error) {
      console.error('Error fetching client history:', error);
      toast.error('Error al cargar el historial');
    } finally {
      setLoadingHistory(false);
    }
  };

  useEffect(() => {
    if (orderHistoryDialogOpen && historyClient) {
      fetchClientHistory();
    }
  }, [orderHistoryDialogOpen, historyClient, historyStartDate, historyEndDate]);

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'completed':
      case 'Entregado':
        return 'success';
      case 'pending':
        return 'warning';
      case 'cancelled':
        return 'error';
      default:
        return 'default';
    }
  };

  const RouteColumn = ({ title, routes, color, icon }: { title: string, routes: OrderTableItem[], color: string, icon: React.ReactNode }) => (
    <Box sx={{ minWidth: '320px', width: '320px', flexShrink: 0 }}>
      <Paper sx={{ p: 2, bgcolor: '#f8f9fa', height: '100%', borderRadius: 2, borderTop: `4px solid ${color}` }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          {icon}
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{title}</Typography>
          <Chip label={routes.length} size="small" sx={{ ml: 'auto', bgcolor: color, color: 'white' }} />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {routes.map((route, index) => {
            const client = clients.find(c => c.id === route.clientId);
            return (
              <Card 
                key={index}
                sx={{ 
                  borderRadius: 2,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  '&:hover': { 
                    transform: 'translateY(-4px)', 
                    boxShadow: 4
                  }
                }}
                onClick={() => handleRouteClick(route)}
              >
                <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', fontSize: '0.875rem' }}>
                      {route.routeName}
                    </Typography>
                    <Chip 
                      label={route.status === 'completed' || route.status === 'Entregado' ? 'Completado' : route.status === 'pending' ? 'Cobro Pendiente' : 'Cancelado'} 
                      size="small" 
                      color={getStatusColor(route.status)}
                      sx={{ fontSize: '0.7rem' }}
                    />
                  </Box>
                  <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.8rem', mb: 1 }}>
                    {format(route.createdAt, 'dd/MM/yyyy')}
                  </Typography>
                  {client && (
                    <Box sx={{ bgcolor: '#e3f2fd', p: 1, borderRadius: 1, mb: 1 }}>
                      <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block' }}>
                        {client.name}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {client.phoneNumber}
                      </Typography>
                    </Box>
                  )}
                  <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                    {route.order?.items?.slice(0, 2).map((item, idx) => {
                      const invItem = inventoryItems.find(i => i.id === item.inventoryItemId);
                      return (
                        <Chip 
                          key={idx}
                          icon={invItem?.imageUrl ? (
                            <Box sx={{ width: 16, height: 16, ml: 1, overflow: 'hidden', borderRadius: 1 }}>
                              <img src={invItem.imageUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            </Box>
                          ) : undefined}
                          label={`${invItem?.name || item.inventoryItemId.substring(0, 8)} x${item.quantity}`} 
                          size="small" 
                          variant="outlined"
                          sx={{ fontSize: '0.65rem', height: 22 }}
                        />
                      );
                    })}
                    {(route.order?.items?.length || 0) > 2 && (
                      <Chip label={`+${(route.order?.items?.length || 0) - 2}`} size="small" sx={{ fontSize: '0.65rem', height: 22 }} />
                    )}
                  </Box>
                </CardContent>
              </Card>
            );
          })}
          {routes.length === 0 && (
            <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'textSecondary', textAlign: 'center', py: 4 }}>
              No hay rutas
            </Typography>
          )}
        </Box>
      </Paper>
    </Box>
  );

  return (
    <Box>
      <Paper sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#00b4d8' }}>Desde</Typography>
            <DatePicker
              selected={routeBoardStartDate}
              onChange={(date) => setRouteBoardStartDate(date)}
              dateFormat="dd/MM/yyyy"
              locale={es}
              customInput={<TextField size="small" variant="outlined" />}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#00b4d8' }}>Hasta</Typography>
            <DatePicker
              selected={routeBoardEndDate}
              onChange={(date) => setRouteBoardEndDate(date)}
              dateFormat="dd/MM/yyyy"
              locale={es}
              customInput={<TextField size="small" variant="outlined" />}
            />
          </Box>
          <Button 
            variant="contained" 
            onClick={fetchAllRoutes}
            startIcon={<RefreshIcon />}
            sx={{ backgroundColor: '#00b4d8', mt: 2 }}
          >
            Actualizar
          </Button>
        </Box>
      </Paper>

      {loadingRoutes ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ 
          display: 'flex', 
          gap: 2, 
          overflowX: 'auto', 
          pb: 2,
          minHeight: '500px',
          '&::-webkit-scrollbar': { height: '8px' },
          '&::-webkit-scrollbar-thumb': { backgroundColor: '#00b4d8', borderRadius: '4px' }
        }}>
          <RouteColumn 
            title="Próxima Entrega" 
            routes={rutasProximaEntrega} 
            color="#ff9800"
            icon={<AccessTimeIcon sx={{ color: '#ff9800' }} />}
          />
          <RouteColumn 
            title="Cobros Pendientes" 
            routes={rutasPendientes} 
            color="#f44336"
            icon={<PendingActionsIcon sx={{ color: '#f44336' }} />}
          />
          <RouteColumn 
            title="Completadas" 
            routes={rutasCompletadas} 
            color="#4caf50"
            icon={<CheckCircleIcon sx={{ color: '#4caf50' }} />}
          />
        </Box>
      )}

      {/* Add/Edit Client Dialog - available from all tabs */}
      <Dialog
        open={routeOrdersDialogOpen}
        onClose={() => setRouteOrdersDialogOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, maxHeight: '90vh' } }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #00b4d8 0%, #0077b6 100%)',
          color: 'white',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <LocalShippingIcon /> Pedidos de la Ruta
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={7}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                Pedidos de la Ruta
              </Typography>
              <Box 
                sx={{ minHeight: '300px', maxHeight: '500px', overflowY: 'auto' }}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                  e.preventDefault();
                  if (rutasBoardDragSource === 'pending' && rutasBoardDraggedOrder) {
                    moveOrderFromPendingToRouteInRutasBoard(rutasBoardDraggedOrder);
                  }
                  handleRutasBoardDragEnd();
                }}
              >
                {selectedRouteOrders.map((order, idx) => {
                  const client = clients.find(c => c.id === order.clientId);
                  const cantonColor = client ? getCantonColor(client.canton) : '#00b4d8';
                  return (
                    <Paper 
                      key={idx} 
                      elevation={2} 
                      draggable
                      onDragStart={() => handleRutasBoardDragStart(order, 'orders')}
                      onDragEnd={handleRutasBoardDragEnd}
                      sx={{ 
                        p: 2, 
                        borderRadius: 2,
                        mb: 2,
                        cursor: 'grab',
                        opacity: rutasBoardDragSource === 'orders' && rutasBoardDraggedOrder?.id === order.id ? 0.5 : 1,
                        borderLeft: '4px solid ' + cantonColor
                      }}
                    >
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                        <Box>
                          <Typography variant="subtitle1" fontWeight="bold">{order.routeName}</Typography>
                          <Typography variant="body2" color="textSecondary">{format(order.createdAt, 'dd/MM/yyyy')}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Chip 
                            label={order.status === 'completed' || order.status === 'Entregado' ? 'Completado' : order.status === 'pending' ? 'Pendiente' : 'Cancelado'} 
                            size="small" 
                            color={getStatusColor(order.status)}
                          />
                          <Button 
                            size="small" 
                            variant="outlined"
                            onClick={() => handleViewOrderDetails(order)}
                          >
                            Ver Detalles
                          </Button>
                          <Button 
                            size="small" 
                            variant="outlined"
                            color="warning"
                            onClick={() => moveOrderToPendingInRutasBoard(order)}
                          >
                            Mover a Cobros Pendientes
                          </Button>
                        </Box>
                      </Box>
                      {client && (
                        <Box sx={{ bgcolor: '#e3f2fd', p: 2, borderRadius: 2, mb: 2 }}>
                          <Typography variant="subtitle2" color="primary">Información del Cliente</Typography>
                          <Typography variant="body2"><strong>Nombre:</strong> {client.name}</Typography>
                          <Typography variant="body2"><strong>Teléfono:</strong> {client.phoneNumber}</Typography>
                          <Typography variant="body2"><strong>Dirección:</strong> {client.provincia}, {client.canton}, {client.distrito}</Typography>
                          {client.senas && <Typography variant="body2"><strong>Señas:</strong> {client.senas}</Typography>}
                        </Box>
                      )}
                      <Typography variant="subtitle2" sx={{ mb: 1 }}>Productos del Pedido</Typography>
                      <Grid container spacing={1}>
                        {order.order?.items?.map((item, itemIdx) => {
                          const invItem = inventoryItems.find(i => i.id === item.inventoryItemId);
                          return (
                            <Grid item xs={12} sm={6} key={itemIdx}>
                              <Paper sx={{ p: 1.5, borderRadius: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                                {invItem?.imageUrl ? (
                                  <Box sx={{ width: 40, height: 40, borderRadius: 1, overflow: 'hidden', flexShrink: 0 }}>
                                    <img src={invItem.imageUrl} alt={invItem.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                  </Box>
                                ) : (
                                  <Box sx={{ width: 40, height: 40, borderRadius: 1, bgcolor: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <ShoppingCartIcon sx={{ color: '#999' }} />
                                  </Box>
                                )}
                                <Box>
                                  <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.8rem' }}>
                                    {invItem?.name || item.inventoryItemId}
                                  </Typography>
                                  <Typography variant="caption" color="textSecondary">
                                    Cantidad: {item.quantity}
                                  </Typography>
                                </Box>
                              </Paper>
                            </Grid>
                          );
                         })}
                       </Grid>

                       {/* Notas del Pedido */}
                       {order.orderNote && (
                         <Box sx={{ mt: 2, pt: 1, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                           <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                             Notas del Pedido:
                           </Typography>
                           <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'text.primary', display: 'block', mt: 0.5 }}>
                             {order.orderNote}
                           </Typography>
                         </Box>
                       )}
                     </Paper>
                   );
                 })}
                {selectedRouteOrders.length === 0 && (
                  <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'textSecondary', textAlign: 'center', py: 4 }}>
                    No hay pedidos en esta ruta
                  </Typography>
                )}
              </Box>
            </Grid>
            
            <Grid item xs={12} md={5}>
              <Paper sx={{ p: 2, borderRadius: 2, bgcolor: '#fff3e0', height: '100%', borderTop: '4px solid #f44336' }}>
                <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', color: '#f44336' }}>
                  Cobros Pendientes
                </Typography>
                <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 2 }}>
                  Arrastra un pedido aquí para moverlo a pendientes
                </Typography>
                <Box 
                  sx={{ minHeight: '300px', maxHeight: '500px', overflowY: 'auto', bgcolor: 'rgba(244, 67, 54, 0.05)', borderRadius: 2, p: 1 }}
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={(e) => {
                    e.preventDefault();
                    if (rutasBoardDragSource === 'orders' && rutasBoardDraggedOrder) {
                      moveOrderToPendingInRutasBoard(rutasBoardDraggedOrder);
                    }
                    handleRutasBoardDragEnd();
                  }}
                >
                  {rutasBoardPendingOrders.length > 0 ? (
                    rutasBoardPendingOrders.map((order, idx) => (
                      <Card 
                        key={idx}
                        draggable
                        onDragStart={() => handleRutasBoardDragStart(order, 'pending')}
                        onDragEnd={handleRutasBoardDragEnd}
                        sx={{ 
                          mb: 2, 
                          borderRadius: 2,
                          cursor: 'grab',
                          borderLeft: '4px solid #f44336',
                          opacity: rutasBoardDragSource === 'pending' && rutasBoardDraggedOrder?.id === order.id ? 0.5 : 1,
                          transition: 'all 0.3s ease',
                          '&:hover': { 
                            transform: 'translateY(-2px)', 
                            boxShadow: 3
                          }
                        }}
                      >
                        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{order.clientName}</Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <IconButton 
                                size="small" 
                                color="error" 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOrderToDelete(order.id);
                                  setDeleteOrderDialogOpen(true);
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                              <Chip label="Pendiente" size="small" color="warning" sx={{ fontSize: '0.65rem' }} />
                            </Box>
                          </Box>
                          <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}>
                            {format(order.createdAt, 'dd/MM/yyyy')}
                          </Typography>
                           <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 1 }}>
                             {order.order?.items?.slice(0, 2).map((item, itemIdx) => {
                               const invItem = inventoryItems.find(i => i.id === item.inventoryItemId);
                               return (
                                 <Chip
                                   key={itemIdx}
                                   label={`${invItem?.name?.substring(0, 10) || item.inventoryItemId.substring(0, 6)} x${item.quantity}`}
                                   size="small"
                                   variant="outlined"
                                   sx={{ fontSize: '0.6rem', height: 20 }}
                                 />
                               );
                             })}
                           </Box>

                           {/* Notas del Pedido */}
                           {order.orderNote && (
                             <Box sx={{ mt: 1, pt: 0.5, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                               <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                 Notas del Pedido:
                               </Typography>
                               <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'text.primary', display: 'block', mt: 0.25 }}>
                                 {order.orderNote}
                               </Typography>
                             </Box>
                           )}

                           <Button
                             size="small"
                             fullWidth
                             variant="contained"
                             sx={{ mt: 1, fontSize: '0.7rem', backgroundColor: '#4caf50' }}
                             onClick={() => moveOrderFromPendingToRouteInRutasBoard(order)}
                           >
                             Reasignar a Ruta
                           </Button>
                        </CardContent>
                      </Card>
                    ))
                  ) : (
                    <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'textSecondary', textAlign: 'center', py: 4 }}>
                      No hay pedidos pendientes
                    </Typography>
                  )}
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setRouteOrdersDialogOpen(false)} variant="contained" sx={{ backgroundColor: '#00b4d8' }}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={orderHistoryDialogOpen}
        onClose={() => setOrderHistoryDialogOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, maxHeight: '90vh' } }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #7b1fa2 0%, #4a148c 100%)',
          color: 'white',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <HistoryIcon /> Historial de Pedidos - {historyClient?.name}
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Paper sx={{ p: 2, mb: 3, borderRadius: 2 }}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#7b1fa2' }}>Desde</Typography>
                <DatePicker
                  selected={historyStartDate}
                  onChange={(date) => setHistoryStartDate(date)}
                  dateFormat="dd/MM/yyyy"
                  locale={es}
                  customInput={<TextField size="small" variant="outlined" />}
                />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#7b1fa2' }}>Hasta</Typography>
                <DatePicker
                  selected={historyEndDate}
                  onChange={(date) => setHistoryEndDate(date)}
                  dateFormat="dd/MM/yyyy"
                  locale={es}
                  customInput={<TextField size="small" variant="outlined" />}
                />
              </Box>
              <Button 
                variant="contained" 
                onClick={fetchClientHistory}
                startIcon={<RefreshIcon />}
                sx={{ backgroundColor: '#7b1fa2', mt: 2 }}
              >
                Filtrar
              </Button>
            </Box>
          </Paper>

          {loadingHistory ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
              <CircularProgress />
            </Box>
          ) : clientOrderHistory.length > 0 ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {clientOrderHistory.map((order, idx) => (
                <Paper key={idx} elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                    <Box>
                      <Typography variant="subtitle1" fontWeight="bold">{order.routeName}</Typography>
                      <Typography variant="body2" color="textSecondary">{format(order.createdAt, 'dd/MM/yyyy')}</Typography>
                    </Box>
                    <Chip 
                      label={order.status === 'completed' || order.status === 'Entregado' ? 'Completado' : order.status === 'pending' ? 'Pendiente' : 'Cancelado'} 
                      size="small" 
                      color={getStatusColor(order.status)}
                    />
                  </Box>
                  <Divider sx={{ my: 1 }} />
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>Productos</Typography>
                  <Grid container spacing={1}>
                    {order.order?.items?.map((item, itemIdx) => {
                      const invItem = inventoryItems.find(i => i.id === item.inventoryItemId);
                      return (
                        <Grid item xs={12} sm={6} md={4} key={itemIdx}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                            {invItem?.imageUrl ? (
                              <Box sx={{ width: 32, height: 32, borderRadius: 1, overflow: 'hidden', flexShrink: 0 }}>
                                <img src={invItem.imageUrl} alt={invItem.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                              </Box>
                            ) : (
                              <Box sx={{ width: 32, height: 32, borderRadius: 1, bgcolor: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <ShoppingCartIcon sx={{ fontSize: 16, color: '#999' }} />
                              </Box>
                            )}
                            <Typography variant="caption">
                              {invItem?.name || item.inventoryItemId} x{item.quantity}
                            </Typography>
                          </Box>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Paper>
              ))}
            </Box>
          ) : (
            <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'textSecondary', textAlign: 'center', py: 4 }}>
              No hay historial de pedidos en el rango de fechas seleccionado
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setOrderHistoryDialogOpen(false)} variant="contained" sx={{ backgroundColor: '#7b1fa2' }}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar 
        open={rutasBoardNotification.open} 
        autoHideDuration={4000} 
        onClose={() => setRutasBoardNotification({ ...rutasBoardNotification, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={() => setRutasBoardNotification({ ...rutasBoardNotification, open: false })} 
          severity={rutasBoardNotification.type}
          sx={{ width: '100%' }}
        >
          {rutasBoardNotification.message}
        </Alert>
      </Snackbar>

      <Dialog
        open={deleteOrderDialogOpen}
        onClose={() => setDeleteOrderDialogOpen(false)}
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ fontWeight: 'bold' }}>Eliminar Pedido</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Estás seguro de que deseas eliminar este pedido de la lista de espera? Esta acción no se puede deshacer.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setDeleteOrderDialogOpen(false)} color="inherit">
            Cancelar
          </Button>
          <Button onClick={handleDeleteOrder} color="error" variant="contained">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

interface PedidosBoardViewProps {
  clients: Client[];
  inventoryItems: InventoryItem[];
  pedidosBoardStartDate: Date | null;
  pedidosBoardEndDate: Date | null;
  setPedidosBoardStartDate: (date: Date | null) => void;
  setPedidosBoardEndDate: (date: Date | null) => void;
  allRoutes: OrderTableItem[];
  setAllRoutes: (routes: OrderTableItem[]) => void;
  pendingOrders: OrderTableItem[];
  setPendingOrders: (orders: OrderTableItem[]) => void;
  loadingPendingOrders: boolean;
  setLoadingPendingOrders: (loading: boolean) => void;
  notification: { open: boolean; message: string; type: 'success' | 'error' | 'warning' };
  setNotification: (notification: { open: boolean; message: string; type: 'success' | 'error' | 'warning' }) => void;
}

const getCantonColor = (canton: string): string => {
  const colors: { [key: string]: string } = {
    'Alajuela': '#E53935',
    'San Ramón': '#D81B60',
    'Grecia': '#8E24AA',
    'Atenas': '#5E35B1',
    'Naranjo': '#3949AB',
    'Palmares': '#1E88E5',
    'Poás': '#039BE5',
    'Cartago': '#00ACC1',
    'Paraíso': '#00897B',
    'La Unión': '#43A047',
    'Turrialba': '#7CB342',
    'Heredia': '#C0CA33',
    'Barva': '#FDD835',
    'Santo Domingo': '#FFB300',
    'San Rafael': '#FB8C00',
    'San Isidro': '#F4511E',
    'Liberia': '#6D4C41',
    'Nicoya': '#757575',
    'Santa Cruz': '#546E7A',
  };
  return colors[canton] || '#00b4d8';
};

const PedidosBoardView: React.FC<PedidosBoardViewProps> = ({
  clients,
  inventoryItems,
  pedidosBoardStartDate,
  pedidosBoardEndDate,
  setPedidosBoardStartDate,
  setPedidosBoardEndDate,
  allRoutes,
  setAllRoutes,
  pendingOrders,
  setPendingOrders,
  loadingPendingOrders,
  setLoadingPendingOrders,
  notification,
  setNotification
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const [draggedOrderId, setDraggedOrderId] = useState<string | null>(null);
  const [dragSource, setDragSource] = useState<'proximos' | 'pendientes' | null>(null);
  const [dropTargetRouteId, setDropTargetRouteId] = useState<string | null>(null);
  const [deleteOrderDialogOpen, setDeleteOrderDialogOpen] = useState(false);
  const [orderToDelete, setOrderToDelete] = useState<string | null>(null);

  const fetchPendingOrders = async () => {
    setLoadingPendingOrders(true);
    try {
      const pendingRef = collection(db, 'pendingOrders');
      const pendingSnapshot = await getDocs(pendingRef);
      const orders: OrderTableItem[] = [];
      
      pendingSnapshot.forEach((doc) => {
        const data = doc.data();
        const client = clients.find(c => c.id === data.clientId);
        if (client) {
          orders.push({
            id: doc.id,
            clientId: data.clientId,
            clientName: client.name,
            clientPhone: client.phoneNumber,
            createdAt: data.pendingDate?.toDate() || new Date(),
            routeName: data.routeName || 'Sin asignar',
            status: 'pending',
            deliveryType: data.deliveryType || 'ollinItems',
            order: data.order as Order,
            routeGroup: data.routeGroup
          });
        }
      });
      
      // Ordenar por fecha de creación descendente (más recientes primero)
      orders.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());
      
      setPendingOrders(orders);
    } catch (error) {
      console.error('Error fetching pending orders:', error);
    } finally {
      setLoadingPendingOrders(false);
    }
  };

  useEffect(() => {
    fetchPendingOrders();
  }, [clients]);

  const fetchPedidosRoutes = async () => {
    if (!pedidosBoardStartDate || !pedidosBoardEndDate) return;
    setLoadingPendingOrders(true);
    try {
      const routeGroupsRef = collection(db, 'routeGroups');
      const querySnapshot = await getDocs(routeGroupsRef);
      
      let fetchedOrders: OrderTableItem[] = [];
      
      const startDateTime = startOfDay(pedidosBoardStartDate);
      const endDateTime = endOfDay(pedidosBoardEndDate);

      for (const docSnapshot of querySnapshot.docs) {
        const routeGroup = { id: docSnapshot.id, ...docSnapshot.data() } as RouteGroup;
        const routesUnionRef = collection(db, `routeGroups/${docSnapshot.id}/routesUnion`);
        const routesUnionQuery = query(
          routesUnionRef,
          where('date', '>=', startDateTime),
          where('date', '<=', endDateTime)
        );
        const routesUnionSnapshot = await getDocs(routesUnionQuery);

        for (const routeUnionDoc of routesUnionSnapshot.docs) {
          const routeUnionData = routeUnionDoc.data();
          const routes = routeUnionData.routes || [];

          for (const route of routes) {
            const client = clients.find(c => c.id === route.clientId);
            if (client) {
              const orderDate = routeUnionData.date.toDate();
              fetchedOrders.push({
                id: `${docSnapshot.id}-${route.id}-${routeUnionDoc.id}-${orderDate.getTime()}`,
                clientId: route.clientId,
                clientName: client.name,
                clientPhone: client.phoneNumber,
                createdAt: orderDate,
                routeName: routeGroup.name,
                status: route.status,
                deliveryType: 'ollinItems',
                order: route.order as Order,
                routeGroup: routeGroup
              });
            }
          }
        }
      }
      
      fetchedOrders.sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime());
      setAllRoutes(fetchedOrders);
    } catch (error) {
      console.error('Error fetching pedidos routes:', error);
    } finally {
      setLoadingPendingOrders(false);
    }
  };

  useEffect(() => {
    fetchPedidosRoutes();
  }, [pedidosBoardStartDate, pedidosBoardEndDate, clients]);

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
  const proximosPedidos = allRoutes.filter(r => {
    const routeDate = new Date(r.createdAt.getFullYear(), r.createdAt.getMonth(), r.createdAt.getDate());
    return routeDate >= today && r.status === 'pending';
  });

  const upcomingRoutes = allRoutes.filter(r => {
    const routeDate = new Date(r.createdAt.getFullYear(), r.createdAt.getMonth(), r.createdAt.getDate());
    return routeDate >= today;
  });

  const routesByCanton = upcomingRoutes.reduce((acc, route) => {
    const client = clients.find(c => c.id === route.clientId);
    if (client && client.canton) {
      if (!acc[client.canton]) {
        acc[client.canton] = [];
      }
      acc[client.canton].push({ ...route, client });
    }
    return acc;
  }, {} as { [key: string]: (OrderTableItem & { client: Client })[] });

  const handleDragStart = (e: React.DragEvent, order: OrderTableItem, source: 'proximos' | 'pendientes') => {
    setIsDragging(true);
    setDraggedOrderId(order.id);
    setDragSource(source);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    setDraggedOrderId(null);
    setDragSource(null);
    setDropTargetRouteId(null);
  };

  const handleDragOver = (e: React.DragEvent, routeId: string) => {
    e.preventDefault();
    if (dragSource === 'pendientes') {
      setDropTargetRouteId(routeId);
    }
  };

  const handleDragLeave = () => {
    setDropTargetRouteId(null);
  };

  const moveToPending = async (order: OrderTableItem) => {
    try {
      await setDoc(doc(db, 'pendingOrders', order.id), {
        clientId: order.clientId,
        clientName: order.clientName,
        clientPhone: order.clientPhone,
        order: order.order,
        deliveryType: order.deliveryType,
        routeGroupId: order.routeGroup.id,
        routeName: order.routeName,
        originalRouteDate: order.createdAt,
        pendingDate: new Date(),
        status: 'pending'
      });

      setNotification({
        open: true,
        message: `Pedido movido a pendientes exitosamente`,
        type: 'success'
      });
      
      fetchPendingOrders();
    } catch (error) {
      console.error('Error moving to pending:', error);
      setNotification({
        open: true,
        message: 'Error al mover el pedido a pendientes',
        type: 'error'
      });
    }
  };

  const handleDropOnPending = async (e: React.DragEvent, order: OrderTableItem) => {
    e.preventDefault();
    if (dragSource === 'proximos') {
      await moveToPending(order);
    }
    handleDragEnd();
  };

  const assignToRoute = async (order: OrderTableItem, targetRoute: OrderTableItem) => {
    try {
      const routeGroupsRef = collection(db, 'routeGroups');
      const querySnapshot = await getDocs(routeGroupsRef);
      
      for (const docSnapshot of querySnapshot.docs) {
        const routeGroup = docSnapshot.data();
        const routesUnionRef = collection(db, `routeGroups/${docSnapshot.id}/routesUnion`);
        const routesUnionSnapshot = await getDocs(routesUnionRef);

        for (const routeUnionDoc of routesUnionSnapshot.docs) {
          const routeUnionData = routeUnionDoc.data();
          const routes = routeUnionData.routes || [];
          
          const routeIndex = routes.findIndex((r: any) => r.clientId === targetRoute.clientId && 
            new Date(routeUnionData.date.toDate()).toDateString() === targetRoute.createdAt.toDateString());
          
          if (routeIndex !== -1) {
            const updatedOrder = {
              ...order.order,
              items: [...routes[routeIndex].order?.items || [], ...order.order.items]
            };
            
            routes[routeIndex].order = updatedOrder;
            
            await setDoc(doc(db, `routeGroups/${docSnapshot.id}/routesUnion`, routeUnionDoc.id), {
              ...routeUnionData,
              routes: routes
            }, { merge: true });

            await deleteDoc(doc(db, 'pendingOrders', order.id));

            setNotification({
              open: true,
              message: `Pedido asignado a la ruta ${targetRoute.routeName} exitosamente`,
              type: 'success'
            });

            fetchPendingOrders();
            return;
          }
        }
      }
    } catch (error) {
      console.error('Error assigning to route:', error);
      setNotification({
        open: true,
        message: 'Error al asignar el pedido a la ruta',
        type: 'error'
      });
    }
  };

  const handleDropOnRoute = async (e: React.DragEvent, order: OrderTableItem, targetRoute: OrderTableItem) => {
    e.preventDefault();
    if (dragSource === 'pendientes') {
      await assignToRoute(order, targetRoute);
    }
    handleDragEnd();
  };

  const handleDeleteOrder = async () => {
    if (!orderToDelete) return;
    try {
      await deleteDoc(doc(db, 'pendingOrders', orderToDelete));
      setPendingOrders(pendingOrders.filter(order => order.id !== orderToDelete));
      setNotification({
        open: true,
        message: 'Pedido eliminado de la lista de espera exitosamente',
        type: 'success'
      });
    } catch (error) {
      console.error('Error deleting pending order:', error);
      setNotification({
        open: true,
        message: 'Error al eliminar el pedido',
        type: 'error'
      });
    } finally {
      setDeleteOrderDialogOpen(false);
      setOrderToDelete(null);
    }
  };

  const OrderCard = ({ order, source, onDelete }: { order: OrderTableItem; source: 'proximos' | 'pendientes'; onDelete?: (id: string) => void }) => {
    const client = clients.find(c => c.id === order.clientId);
    const cantonColor = client ? getCantonColor(client.canton) : '#00b4d8';
    
    return (
      <Card
        draggable={source === 'proximos' || source === 'pendientes'}
        onDragStart={(e) => handleDragStart(e, order, source)}
        onDragEnd={handleDragEnd}
        sx={{ 
          mb: 2, 
          borderRadius: 2,
          cursor: source === 'proximos' || source === 'pendientes' ? 'grab' : 'default',
          opacity: draggedOrderId === order.id ? 0.5 : 1,
          borderLeft: `4px solid ${cantonColor}`,
          transition: 'all 0.3s ease',
          '&:hover': { 
            transform: 'translateY(-2px)', 
            boxShadow: 3
          }
        }}
      >
        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', fontSize: '0.85rem' }}>
              {order.clientName}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {source === 'pendientes' && onDelete && (
                <IconButton 
                  size="small" 
                  color="error" 
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(order.id);
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              )}
              <Chip 
                label={source === 'proximos' ? 'Próximo' : 'Pedidos Pendiente'} 
                size="small" 
                color={source === 'proximos' ? 'primary' : 'warning'}
                sx={{ fontSize: '0.65rem' }}
              />
            </Box>
          </Box>
          <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem', mb: 1 }}>
            {format(order.createdAt, 'dd/MM/yyyy')} - {order.routeName}
          </Typography>
          {client && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
              <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: cantonColor }} />
              <Typography variant="caption" color="textSecondary">{client.canton}</Typography>
            </Box>
          )}
          <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
            {order.order?.items?.slice(0, 2).map((item, idx) => {
              const invItem = inventoryItems.find(i => i.id === item.inventoryItemId);
              return (
                <Chip 
                  key={idx}
                  icon={invItem?.imageUrl ? (
                    <Box sx={{ width: 14, height: 14, ml: 1, overflow: 'hidden', borderRadius: 1 }}>
                      <img src={invItem.imageUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    </Box>
                  ) : undefined}
                  label={`${invItem?.name?.substring(0, 8) || item.inventoryItemId.substring(0, 6)} x${item.quantity}`} 
                  size="small" 
                  variant="outlined"
                  sx={{ fontSize: '0.6rem', height: 20 }}
                />
              );
            })}
            {(order.order?.items?.length || 0) > 2 && (
              <Chip label={`+${(order.order?.items?.length || 0) - 2}`} size="small" sx={{ fontSize: '0.6rem', height: 20 }} />
            )}
          </Box>
          {source === 'proximos' && (
            <Button 
              size="small" 
              fullWidth 
              variant="outlined" 
              sx={{ mt: 1, fontSize: '0.7rem', borderColor: '#f44336', color: '#f44336' }}
              onClick={() => moveToPending(order)}
              onDragStart={(e) => e.stopPropagation()}
            >
              Mover a Pedidos Pendientes
            </Button>
          )}
        </CardContent>
      </Card>
    );
  };

  return (
    <Box>
      <Paper sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#00b4d8' }}>Desde</Typography>
            <DatePicker
              selected={pedidosBoardStartDate}
              onChange={(date) => setPedidosBoardStartDate(date)}
              dateFormat="dd/MM/yyyy"
              locale={es}
              customInput={<TextField size="small" variant="outlined" />}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#00b4d8' }}>Hasta</Typography>
            <DatePicker
              selected={pedidosBoardEndDate}
              onChange={(date) => setPedidosBoardEndDate(date)}
              dateFormat="dd/MM/yyyy"
              locale={es}
              customInput={<TextField size="small" variant="outlined" />}
            />
          </Box>
          <Button 
            variant="contained" 
            onClick={fetchPendingOrders}
            startIcon={<RefreshIcon />}
            sx={{ backgroundColor: '#00b4d8', mt: 2 }}
          >
            Actualizar
          </Button>
        </Box>
      </Paper>

      <Box sx={{ display: 'flex', gap: 3 }}>
        <Box sx={{ display: 'flex', gap: 2, flex: 1, overflowX: 'auto', pb: 2 }}>
          <Box sx={{ minWidth: '300px', width: '300px', flexShrink: 0 }}>
            <Paper sx={{ p: 2, bgcolor: '#fff3e0', height: '100%', borderRadius: 2, borderTop: '4px solid #ff9800' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <AccessTimeIcon sx={{ color: '#ff9800' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Próximos</Typography>
                <Chip label={proximosPedidos.length} size="small" sx={{ ml: 'auto', bgcolor: '#ff9800', color: 'white' }} />
              </Box>
              <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 2 }}>
                Arrastra a "Pedidos Pendientes" para mover
              </Typography>
              <Box 
                sx={{ minHeight: '400px', maxHeight: '600px', overflowY: 'auto' }}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                  const order = proximosPedidos.find(o => o.id === draggedOrderId);
                  if (order) handleDropOnPending(e, order);
                }}
              >
                {loadingPendingOrders ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>
                ) : proximosPedidos.length > 0 ? (
                  proximosPedidos.map((order, idx) => (
                    <OrderCard key={idx} order={order} source="proximos" />
                  ))
                ) : (
                  <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'textSecondary', textAlign: 'center', py: 4 }}>
                    No hay pedidos próximos
                  </Typography>
                )}
              </Box>
            </Paper>
          </Box>

          <Box sx={{ minWidth: '300px', width: '300px', flexShrink: 0 }}>
            <Paper sx={{ p: 2, bgcolor: '#fff3e0', height: '100%', borderRadius: 2, borderTop: '4px solid #f44336' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <PendingActionsIcon sx={{ color: '#f44336' }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Pedidos Pendientes</Typography>
                <Chip label={pendingOrders.length} size="small" sx={{ ml: 'auto', bgcolor: '#f44336', color: 'white' }} />
              </Box>
              <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 2 }}>
                Arrastra a una ruta para asignar
              </Typography>
              <Box 
                sx={{ minHeight: '400px', maxHeight: '600px', overflowY: 'auto', bgcolor: 'rgba(244, 67, 54, 0.05)', borderRadius: 2, p: 1 }}
                onDragOver={(e) => e.preventDefault()}
              >
                {pendingOrders.length > 0 ? (
                  pendingOrders.map((order, idx) => (
                    <OrderCard 
                      key={idx} 
                      order={order} 
                      source="pendientes" 
                      onDelete={(id) => {
                        setOrderToDelete(id);
                        setDeleteOrderDialogOpen(true);
                      }}
                    />
                  ))
                ) : (
                  <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'textSecondary', textAlign: 'center', py: 4 }}>
                    No hay pedidos pendientes
                  </Typography>
                )}
              </Box>
            </Paper>
          </Box>
        </Box>

        <Paper sx={{ p: 2, borderRadius: 2, minWidth: '400px', flex: 1, maxHeight: '700px', overflow: 'auto' }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#00b4d8' }}>
            Rutas Próximas por Ubicación
          </Typography>
          <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 2 }}>
            Arrastra un pedido pendiente a una ruta para asignarlo
          </Typography>
          
          <Box sx={{ mb: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>Mapa de Rutas</Typography>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
              {Object.entries(routesByCanton).slice(0, 6).map(([canton, routes]) => (
                <Tooltip key={canton} title={`${canton}: ${routes.length} rutas`}>
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    p: 1,
                    borderRadius: 2,
                    bgcolor: 'white',
                    minWidth: 60
                  }}>
                    <Box sx={{ width: 24, height: 24, borderRadius: '50%', bgcolor: getCantonColor(canton), display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <LocationOnIcon sx={{ fontSize: 14, color: 'white' }} />
                    </Box>
                    <Typography variant="caption" sx={{ fontSize: '0.65rem', mt: 0.5, textAlign: 'center' }}>{canton.substring(0, 8)}</Typography>
                    <Typography variant="caption" sx={{ fontSize: '0.6rem', color: 'textSecondary' }}>{routes.length}</Typography>
                  </Box>
                </Tooltip>
              ))}
            </Box>
            <Box sx={{ mt: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              {Object.entries(routesByCanton).map(([canton, routes]) => (
                <Chip 
                  key={canton}
                  label={canton}
                  size="small"
                  sx={{ bgcolor: getCantonColor(canton), color: 'white', fontSize: '0.65rem' }}
                />
              ))}
            </Box>
          </Box>
          
          {Object.entries(routesByCanton).map(([canton, routes]) => (
            <Box key={canton} sx={{ mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Box sx={{ width: 16, height: 16, borderRadius: '50%', bgcolor: getCantonColor(canton) }} />
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>{canton}</Typography>
                <Chip label={routes.length} size="small" sx={{ ml: 'auto', bgcolor: getCantonColor(canton), color: 'white', fontSize: '0.7rem' }} />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pl: 2 }}>
                {routes.slice(0, 5).map((route, idx) => (
                  <Card
                    key={idx}
                    sx={{ 
                      borderRadius: 2,
                      border: dropTargetRouteId === route.id ? '2px dashed #00b4d8' : '1px solid #e0e0e0',
                      bgcolor: dropTargetRouteId === route.id ? 'rgba(0, 180, 216, 0.1)' : 'white',
                      transition: 'all 0.2s ease'
                    }}
                    onDragOver={(e) => handleDragOver(e, route.id)}
                    onDragLeave={handleDragLeave}
                    onDrop={(e) => {
                      const order = pendingOrders.find(o => o.id === draggedOrderId);
                      if (order) handleDropOnRoute(e, order, route);
                    }}
                  >
                    <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                      <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
                        {route.routeName}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {format(route.createdAt, 'dd/MM/yyyy')}
                      </Typography>
                      <Typography variant="caption" display="block" sx={{ color: getCantonColor(route.client.canton), fontSize: '0.7rem' }}>
                        {route.client.provincia}, {route.client.distrito}
                      </Typography>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            </Box>
          ))}
        </Paper>
      </Box>

      <Snackbar 
        open={notification.open} 
        autoHideDuration={4000} 
        onClose={() => setNotification({ ...notification, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setNotification({ ...notification, open: false })} 
          severity={notification.type}
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>

      <Dialog
        open={deleteOrderDialogOpen}
        onClose={() => setDeleteOrderDialogOpen(false)}
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ fontWeight: 'bold' }}>Eliminar Pedido</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Estás seguro de que deseas eliminar este pedido de la lista de espera? Esta acción no se puede deshacer.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setDeleteOrderDialogOpen(false)} color="inherit">
            Cancelar
          </Button>
          <Button onClick={handleDeleteOrder} color="error" variant="contained">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

const CustomerTracking = ({
  clients,
  publicClients,
  handlePublicOpen,
  handleViewOpenPublic,
  onUpdatePublicClient,
  onDeletePublicClient,
  onUpdateClient,
  openPublic,
  setOpenPublic,
  viewOpenPublic,
  setViewOpenPublic,
  currentPublicClient,
  setCurrentPublicClient,
  setSelectedPublicClientForWaitlist,
  setMainNotification,
  handleOpen,
  currentClient,
  setCurrentClient,
  open,
  setOpen,
  viewOpen,
  setViewOpen,
  newTabValue,
  setNewTabValue,
  setTableSearchTerm,
  workflowStartDate,
  setWorkflowStartDate,
  workflowEndDate,
  setWorkflowEndDate,
  workflowSearchTerm,
  setWorkflowSearchTerm,
  filterProvincia,
  setFilterProvincia,
  filterCanton,
  setFilterCanton,
  filterDistrito,
  setFilterDistrito,
  isMinimized
}: {
  clients: Client[];
  publicClients: PublicClient[];
  handlePublicOpen: (client: PublicClient | null) => void;
  handleViewOpenPublic: (client: PublicClient) => void;
  onUpdatePublicClient: (client: PublicClient) => Promise<void>;
  onDeletePublicClient: (clientId: string) => Promise<void>;
  onUpdateClient?: (client: Client) => Promise<void>;
  openPublic: boolean;
  setOpenPublic: (open: boolean) => void;
  viewOpenPublic: boolean;
  setViewOpenPublic: (open: boolean) => void;
  currentPublicClient: PublicClient | null;
  setCurrentPublicClient: (client: PublicClient | null) => void;
  setSelectedPublicClientForWaitlist: (client: PublicClient | null) => void;
  viewOpen: boolean;
  setViewOpen: (open: boolean) => void;
  setMainNotification: (notification: { open: boolean; message: string; type: 'success' | 'error' | 'warning' }) => void;
  currentClient: Client | null;
  setCurrentClient: (client: Client | null) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
  newTabValue: number;
  setNewTabValue: (value: number) => void;
  setTableSearchTerm: (value: string) => void;
  workflowStartDate: Date | null;
  setWorkflowStartDate: (date: Date | null) => void;
  workflowEndDate: Date | null;
  setWorkflowEndDate: (date: Date | null) => void;
  workflowSearchTerm: string;
  setWorkflowSearchTerm: (term: string) => void;
  filterProvincia: string;
  setFilterProvincia: (prov: string) => void;
  filterCanton: string;
  setFilterCanton: (cant: string) => void;
  filterDistrito: string;
  setFilterDistrito: (dist: string) => void;
  handleOpen: (client: Client | null) => void;
  isMinimized: boolean;
}) => {
  // Debug: Verificar si las funciones están llegando correctamente
  console.log('CustomerTracking - handlePublicOpen:', typeof handlePublicOpen);
  console.log('CustomerTracking - handleViewOpenPublic:', typeof handleViewOpenPublic);
  
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [endDate, setEndDate] = useState<Date | null>(addDays(new Date(), 30));
  const [searchText, setSearchText] = useState('');
  const [selectedClient, setSelectedClient] = useState<Client | null>(null);
  const [clientRoutes, setClientRoutes] = useState<OrderTableItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [workflowDropLoading, setWorkflowDropLoading] = useState(false);
  const [subTabValue, setSubTabValue] = useState(3);
  const [pedidosPreprogramados, setPedidosPreprogramados] = useState<any[]>([]);

  // States for improved UI/UX - Route and Order Detail Dialogs
  const [inventoryItems, setInventoryItems] = useState<InventoryItem[]>([]);
  const [routeDetailDialogOpen, setRouteDetailDialogOpen] = useState(false);
  const [orderDetailDialogOpen, setOrderDetailDialogOpen] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState<OrderTableItem | null>(null);
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);

  // States for Rutas board view
  const [routeBoardStartDate, setRouteBoardStartDate] = useState<Date | null>(new Date());
  const [routeBoardEndDate, setRouteBoardEndDate] = useState<Date | null>(addDays(new Date(), 60));
  const [allRoutes, setAllRoutes] = useState<OrderTableItem[]>([]);
  const [loadingRoutes, setLoadingRoutes] = useState(false);
  const [routeOrdersDialogOpen, setRouteOrdersDialogOpen] = useState(false);
  const [selectedRouteOrders, setSelectedRouteOrders] = useState<OrderTableItem[]>([]);
  const [orderHistoryDialogOpen, setOrderHistoryDialogOpen] = useState(false);
  const [historyClient, setHistoryClient] = useState<Client | null>(null);
  const [historyStartDate, setHistoryStartDate] = useState<Date | null>(addMonths(new Date(), -3));
  const [historyEndDate, setHistoryEndDate] = useState<Date | null>(new Date());
  const [clientOrderHistory, setClientOrderHistory] = useState<OrderTableItem[]>([]);
  const [loadingHistory, setLoadingHistory] = useState(false);

  // States for Pedidos board view
  const [pendingOrders, setPendingOrders] = useState<OrderTableItem[]>([]);
  const [loadingPendingOrders, setLoadingPendingOrders] = useState(false);
  const [pedidosBoardStartDate, setPedidosBoardStartDate] = useState<Date | null>(new Date());
  const [pedidosBoardEndDate, setPedidosBoardEndDate] = useState<Date | null>(addDays(new Date(), 30));
  const [notification, setNotification] = useState<{ open: boolean; message: string; type: 'success' | 'error' | 'warning' }>({ open: false, message: '', type: 'success' });
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedClientToDelete, setSelectedClientToDelete] = useState<any>(null);

  const handleDeleteClick = (target: { type: string, data: any }) => {
    setSelectedClientToDelete(target);
    setDeleteDialogOpen(true);
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setSelectedClientToDelete(null);
  };

  const handleDeleteConfirm = async () => {
    if (!selectedClientToDelete) return;
    
    const { type, data } = selectedClientToDelete;
    try {
      setDeleteDialogOpen(false);
      setSelectedClientToDelete(null);
      // REMOVED setWorkflowLoading(true) to avoid double loading flicker

      if (type === 'remove_from_waitlist') {
        if (data.id) {
          // Set workflow_stage to 'process' so routes in columns 2/3 remain visible
          await setDoc(doc(db, 'clients', data.id), { workflow_stage: 'process' }, { merge: true });
          
          // Remove associated pending orders
          const pendingRef = collection(db, 'pendingOrders');
          const q = query(pendingRef, where('clientId', '==', data.id));
          const snapshot = await getDocs(q);
          await Promise.all(snapshot.docs.map(docSnap => deleteDoc(doc(db, 'pendingOrders', docSnap.id))));
        }
        // REMOVED refreshWorkflowData and setWorkflowRefreshKey to avoid UI update before reload
      } else if (type === 'public') {
        if (data.id) await onDeletePublicClient(data.id);
      } else if (type === 'client') {
        if (data.id) await deleteDoc(doc(db, 'clients', data.id));
      } else if (type === 'pendingOrder') {
        if (data.id) await deleteDoc(doc(db, 'pendingOrders', data.id));
      } else if (type === 'reprogrammedOrder') {
        if (data.id) await deleteDoc(doc(db, 'pedidoPreprogramado', data.id));
      }
      
      // Force full page reload immediately after DB operation
      window.location.reload();
    } catch (error) {
      console.error('Error deleting item:', error);
      setDeleteDialogOpen(false);
      setNotification({ open: true, message: 'Error al procesar la solicitud', type: 'error' });
    }
  };
  const [draggedOrder, setDraggedOrder] = useState<OrderTableItem | null>(null);
  const [dropTargetRoute, setDropTargetRoute] = useState<OrderTableItem | null>(null);

  // Removed local state to avoid conflict with props

  // States for Workflow board (Flujo de trabajo)
  const [workflowLoading, setWorkflowLoading] = useState(true);
  const [loadingPendingOrdersForWorkflow, setLoadingPendingOrdersForWorkflow] = useState(false);
  // Estados para filtros de ubicación
  const [waitlistDialogOpen, setWaitlistDialogOpen] = useState(false);
  const [selectedWaitlistClient, setSelectedWaitlistClient] = useState<{ type: 'public' | 'client'; data: PublicClient | Client } | null>(null);
  const [waitlistDialogLoading, setWaitlistDialogLoading] = useState(false);
  const [waitlistDataLoading, setWaitlistDataLoading] = useState(false);
  const [globalLoadingAfterClose, setGlobalLoadingAfterClose] = useState(false);
  const [waitlistOrderDataLoading, setWaitlistOrderDataLoading] = useState(false);
  const [readyForProcessIds, setReadyForProcessIds] = useState<Set<string>>(new Set());
  const [readyForProcessRouteIds, setReadyForProcessRouteIds] = useState<Set<string>>(new Set());
  const [showCompletionPopup, setShowCompletionPopup] = useState(false);
  const [selectedWaitlistDate, setSelectedWaitlistDate] = useState<Date | null>(new Date());
  const [selectedWaitlistRouteGroupId, setSelectedWaitlistRouteGroupId] = useState<string>('');
  const [originalReprogrammedRoute, setOriginalReprogrammedRoute] = useState<{ groupId: string; unionId: string; routeId: string } | null>(null);
  const [selectedWaitlistOrderId, setSelectedWaitlistOrderId] = useState<string | null>(null);
  const [selectedWaitlistSource, setSelectedWaitlistSource] = useState<'pending' | 'reprogrammed' | null>(null);
  const [routeGroupsForWaitlist, setRouteGroupsForWaitlist] = useState<RouteGroup[]>([]);
  const [futureRouteDates, setFutureRouteDates] = useState<Date[]>([]);
  const [clientPendingOrder, setClientPendingOrder] = useState<Order | null>(null);
  const [openCreateOrderModal, setOpenCreateOrderModal] = useState(false);
  const [existingOrderForEdit, setExistingOrderForEdit] = useState<Order | null>(null);
  const [clientPendingOrderDocId, setClientPendingOrderDocId] = useState<string | null>(null);
  const [forceCompletedIds, setForceCompletedIds] = useState<Set<string>>(new Set());

  // States for General tab drag and drop
  const [generalTabDraggedOrder, setGeneralTabDraggedOrder] = useState<OrderTableItem | null>(null);
  const [generalTabDragSource, setGeneralTabDragSource] = useState<'routes' | 'pending' | null>(null);
  const [generalTabPendingOrders, setGeneralTabPendingOrders] = useState<OrderTableItem[]>([]);

  const [localViewOpen, setLocalViewOpen] = useState(false);
  const [localCurrentClient, setLocalCurrentClient] = useState<Client | null>(null);
  const [workflowDragged, setWorkflowDragged] = useState<{ type: 'public' | 'client'; id: string; stage: number } | null>(null);
  const [pendingOrdersForWorkflow, setPendingOrdersForWorkflow] = useState<{ id: string; clientId: string; clientName: string; pendingDate?: Date; order?: Order; orderNote?: string; status?: string; routeName?: string }[]>([]);

  const handleLocalViewClose = () => {
    setLocalViewOpen(false);
    setLocalCurrentClient(null);
  };

  const [removedWaitlistClientIds, setRemovedWaitlistClientIds] = useState<Set<string>>(new Set());

  const handleCloseWaitlistDialog = () => {
    setWaitlistDialogOpen(false);
    setWaitlistOrderNote('');
    setSelectedWaitlistClient(null);
    setClientPendingOrder(null);
    setSelectedWaitlistRouteGroupId('');
    setSelectedWaitlistDate(null);
    setSelectedWaitlistOrderId(null);
    if (notesInputRef.current) {
      notesInputRef.current.value = '';
    }
  };

  const isRemovedWaitlistClient = (clientId?: string) => clientId ? removedWaitlistClientIds.has(clientId) : false;
   
   // States for route order details dialog in workflow
   const [routeOrderDetailsDialogOpen, setRouteOrderDetailsDialogOpen] = useState(false);
   const [selectedRouteOrderForDetails, setSelectedRouteOrderForDetails] = useState<OrderTableItem | null>(null);
   const [localProcesos, setLocalProcesos] = useState<{ [key: string]: string }>({});
   const [workflowRefreshKey, setWorkflowRefreshKey] = useState(0);
   const [waitlistFilterEstado, setWaitlistFilterEstado] = useState('pending');
   const [waitlistFilterRuta, setWaitlistFilterRuta] = useState('todas');
   const [showReprogrammedByTransporter, setShowReprogrammedByTransporter] = useState(false);
   const [waitlistFiltersAnchorEl, setWaitlistFiltersAnchorEl] = useState<null | HTMLElement>(null);
   const [routeOrderNotes, setRouteOrderNotes] = useState<{ [key: string]: string }>({});
   const [savedNotes, setSavedNotes] = useState<{ [key: string]: boolean }>({});
   const [selectedPublicClient, setSelectedPublicClient] = useState<PublicClient | null>(null);
   const [isSavingNote, setIsSavingNote] = useState(false);
   const [routesWithNotes, setRoutesWithNotes] = useState<{ [key: string]: boolean }>({});
   const [savingRoute, setSavingRoute] = useState(false);

  // Estado local para el popup de creación en el tab de seguimiento

  // State for editing note
    const [isEditingNote, setIsEditingNote] = useState(false);
    const [originalNoteValue, setOriginalNoteValue] = useState('');
  
  // Estado local para el popup de creación en el tab de seguimiento
  const [createClientDialogOpenLocal, setCreateClientDialogOpenLocal] = useState(false);
  const [clientCreationSuccessOpen, setClientCreationSuccessOpen] = useState(false);
  const [moveSuccessOpen, setMoveSuccessOpen] = useState<{ message: string; reload: boolean } | null>(null);
  const [selectedClientLocal, setSelectedClientLocal] = useState<PublicClient | null>(null);
  
  // Efecto para limpiar el estado cuando se cierra el popup sin crear
  useEffect(() => {
    if (!createClientDialogOpenLocal && workflowDragged) {
      // Si el popup se cierra y todavía hay un elemento arrastrado, limpiarlo
      setWorkflowDragged(null);
    }
  }, [createClientDialogOpenLocal, workflowDragged]);

  const handleCreateClient = (client: PublicClient) => {
    setSelectedClientLocal(client);
    setCreateClientDialogOpenLocal(true);
  };

  useEffect(() => {
    const fetchReprogrammed = async () => {
      try {
        const snap = await getDocs(collection(db, 'pedidoPreprogramado'));
        setPedidosPreprogramados(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      } catch (e) {
        console.error('Error fetching reprogrammed orders:', e);
      }
    };
    fetchReprogrammed();
  }, []);

  // Estado para manejar el drag over visual
  const [dragOverColumn, setDragOverColumn] = useState<number | null>(null);
  const [waitlistOrderNote, setWaitlistOrderNote] = useState('');

  // Ref para el TextField de notas
  const notesInputRef = useRef<HTMLTextAreaElement>(null);

  // Componente optimizado para el TextField de notas - CONTROLADO para habilitar botones en tiempo real
  const renderNotesTextField = () => (
    <TextField
      fullWidth
      multiline
      rows={4}
      placeholder="Agregar notas importantes sobre este pedido...

Ej: Instrucciones especiales, detalles de entrega, información adicional relevante"
      value={waitlistOrderNote}
      onChange={(e) => setWaitlistOrderNote(e.target.value)}
      variant="outlined"
      size="medium"
      inputProps={{
        style: {
          fontFamily: 'inherit',
          fontSize: '14px',
        }
      }}
      inputRef={notesInputRef}
    />
  );

  // Load existing order note when opening client popup - ONLY RUN ONCE WHEN DIALOG OPENS
  useEffect(() => {
    if (waitlistDialogOpen && selectedWaitlistClient) {
      // We let fetchClientPendingOrderForDialog handle loading the note directly from Firestore
      return;
    }
    // Clear only when dialog closes
    if (!waitlistDialogOpen) {
      setWaitlistOrderNote('');
    }
  }, [waitlistDialogOpen, selectedWaitlistClient]);
  const [isChangingRoute, setIsChangingRoute] = useState(false);
  const [availableRoutesForChange, setAvailableRoutesForChange] = useState<RouteGroup[]>([]);
  const [revisionFiltersAnchorEl, setRevisionFiltersAnchorEl] = useState<null | HTMLElement>(null);
  const [showAllRevisionCards, setShowAllRevisionCards] = useState(false);
  
  // Función para verificar si una ruta tiene fechas futuras disponibles
  const getRoutesWithFutureDates = async (routeGroups: RouteGroup[]): Promise<RouteGroup[]> => {
    const availableRoutes: RouteGroup[] = [];
    const today = startOfDay(new Date());
    
    for (const routeGroup of routeGroups) {
      try {
        const routesUnionRef = collection(db, `routeGroups/${routeGroup.id}/routesUnion`);
        const routesUnionSnapshot = await getDocs(routesUnionRef);
        
        const hasFutureDates = routesUnionSnapshot.docs.some(doc => {
          const routeData = doc.data();
          if (routeData.date) {
            const routeDate = startOfDay(routeData.date.toDate());
            return isAfter(routeDate, today) || isEqual(routeDate, today);
          }
          return false;
        });
        
        if (hasFutureDates) {
          availableRoutes.push(routeGroup);
        }
      } catch (error) {
        console.error(`Error checking dates for route group ${routeGroup.id}:`, error);
      }
    }
    
    return availableRoutes;
  };

  // Cargar rutas disponibles con fechas futuras
  useEffect(() => {
    const loadAvailableRoutes = async () => {
      if (routeGroupsForWaitlist.length > 0) {
        const available = await getRoutesWithFutureDates(routeGroupsForWaitlist);
        setAvailableRoutesForChange(available);
      }
    };
    
    loadAvailableRoutes();
  }, [routeGroupsForWaitlist]);
  const createClient = async (client: Client) => {
    const { id, ...clientData } = client;
    try {
      // Esta función necesita ser pasada como prop desde el componente padre
      console.log("Creando cliente:", clientData);
      // await onAddNew(clientData); // Comentado ya que onAddNew no está disponible en este scope
    } catch (error) {
      console.error("Error al crear el cliente:", error);
    }
  };

  // Componente para mostrar el loading de guardar ruta
  const LoadingOverlay = () => {
    if (!savingRoute && !isChangingRoute) return null;
    
    return (
      <Backdrop
        sx={{ 
          color: '#fff', 
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(0, 0, 0, 0.7)'
        }}
        open={true}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <CircularProgress color="inherit" size={60} />
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            {isChangingRoute ? 'Cambiando ruta del pedido...' : 'Guardando pedido en la ruta...'}
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Por favor espera un momento
          </Typography>
        </Box>
      </Backdrop>
    );
  };

  // Función para verificar si una ruta tiene notas guardadas
  const hasRouteOrderNote = async (route: OrderTableItem): Promise<boolean> => {
    try {
      const routeGroupsRef = collection(db, 'routeGroups');
      const routeGroupsQuery = await getDocs(routeGroupsRef);
      
      for (const routeGroupDoc of routeGroupsQuery.docs) {
        const routesUnionRef = collection(db, `routeGroups/${routeGroupDoc.id}/routesUnion`);
        const routesUnionSnapshot = await getDocs(routesUnionRef);
        
        for (const routeUnionDoc of routesUnionSnapshot.docs) {
          const routeUnionData = routeUnionDoc.data() as any;
          const routes = routeUnionData.routes || [];
          
          // Buscar la ruta específica por clientId y fecha
          const routeData = routes.find((r: any) => 
            r.clientId === route.clientId && 
            new Date(routeUnionData.date.toDate()).toDateString() === route.createdAt.toDateString()
          );
          
          if (routeData) {
            const note = routeData.notes || '';
            return note.trim() !== ''; // Retorna true si hay una nota no vacía
          }
        }
      }
      
      return false; // No se encontró la ruta o no tiene nota
    } catch (error) {
      console.error('Error al verificar nota:', error);
      return false;
    }
  };

  // Función para cargar notas de todas las rutas en proceso y completados
  const loadAllRouteNotes = async () => {
    const allRoutesToCheck = [...procesoRouteOrders, ...completedRouteOrders];
    const notesStatus: { [key: string]: boolean } = {};
    
    console.log('Debug - Cargando notas para rutas:', allRoutesToCheck.length);
    console.log('Debug - Rutas a verificar:', allRoutesToCheck.map(r => ({ 
      clientId: r.clientId, 
      clientName: r.clientName, 
      date: r.createdAt.toDateString() 
    })));
    
    try {
      const routeGroupsRef = collection(db, 'routeGroups');
      const routeGroupsQuery = await getDocs(routeGroupsRef);
      
      // Obtener todas las rutas con sus notas de la base de datos
      for (const routeGroupDoc of routeGroupsQuery.docs) {
        const routesUnionRef = collection(db, `routeGroups/${routeGroupDoc.id}/routesUnion`);
        const routesUnionSnapshot = await getDocs(routesUnionRef);
        
        for (const routeUnionDoc of routesUnionSnapshot.docs) {
          const routeUnionData = routeUnionDoc.data() as any;
          const routes = routeUnionData.routes || [];
          
          console.log('Debug - Revisando routeUnion con fecha:', routeUnionData.date.toDate().toDateString());
          console.log('Debug - Rutas en este union:', routes.length);
          
          // Revisar cada ruta para ver si tiene notas
          for (const routeData of routes) {
            if (routeData.clientId && routeData.notes) {
              const note = routeData.notes || '';
              console.log('Debug - Ruta con nota encontrada:', {
                clientId: routeData.clientId,
                note: note,
                noteLength: note.length,
                hasNote: note.trim() !== ''
              });
              
              if (note.trim() !== '') {
                // Buscar si esta ruta está en nuestras listas actuales
                const matchingRoute = allRoutesToCheck.find(route => 
                  route.clientId === routeData.clientId &&
                  new Date(routeUnionData.date.toDate()).toDateString() === route.createdAt.toDateString()
                );
                
                console.log('Debug - Buscando coincidencia para:', {
                  routeClientId: routeData.clientId,
                  routeDate: routeUnionData.date.toDate().toDateString()
                });
                
                if (matchingRoute) {
                  const routeKey = `${matchingRoute.clientId}-${matchingRoute.createdAt.getTime()}`;
                  notesStatus[routeKey] = true;
                  console.log('Debug - ¡Coincidencia encontrada! Key:', routeKey);
                } else {
                  console.log('Debug - No se encontró coincidencia');
                }
              }
            }
          }
        }
      }
      
      console.log('Debug - Estado final de notas:', notesStatus);
      
      // Actualizar el estado con todas las notas encontradas
      if (Object.keys(notesStatus).length > 0) {
        setRoutesWithNotes(prev => ({ ...prev, ...notesStatus }));
      }
      
    } catch (error) {
      console.error('Error al cargar todas las notas:', error);
    }
  };

  // Función para cargar notas del pedido
  const loadRouteOrderNotes = async (route: OrderTableItem) => {
    try {
      console.log('DEBUG - loadRouteOrderNotes llamado con route.orderNote:', route.orderNote);
      
      // Si el objeto route ya tiene orderNote, usarlo directamente
      if (route.orderNote && route.orderNote.trim() !== '') {
        const uniqueRouteId = `${route.clientId}-${route.createdAt.getTime()}`;
        setRouteOrderNotes(prev => ({
          ...prev,
          [uniqueRouteId]: route.orderNote || ''
        }));
        console.log('DEBUG - Usando orderNote del objeto route:', route.orderNote);
        return;
      }
      
      // Buscar el routeGroup y la ruta específica para cargar la nota
      const routeGroupsRef = collection(db, 'routeGroups');
      const routeGroupsQuery = await getDocs(routeGroupsRef);
      
      let noteFound = false;
      const uniqueRouteId = `${route.clientId}-${route.createdAt.getTime()}`;
      
      for (const routeGroupDoc of routeGroupsQuery.docs) {
        const routesUnionRef = collection(db, `routeGroups/${routeGroupDoc.id}/routesUnion`);
        const routesUnionSnapshot = await getDocs(routesUnionRef);
        
        for (const routeUnionDoc of routesUnionSnapshot.docs) {
          const routeUnionData = routeUnionDoc.data();
          const routes = routeUnionData.routes || [];
          
          // Buscar la ruta específica por clientId y fecha
          const routeData = routes.find((r: any) => 
            r.clientId === route.clientId && 
            new Date(routeUnionData.date.toDate()).toDateString() === route.createdAt.toDateString()
          );
          
          if (routeData) {
            const note = routeData.notes || '';
            // Priorizar el orderNote si existe, sino usar el note tradicional
            const orderNote = routeData.orderNote || note;
            
            // Actualizar el estado con la nota de Firebase
            setRouteOrderNotes(prev => ({
              ...prev,
              [uniqueRouteId]: orderNote || ''
            }));
            
            // Marcar si la nota está guardada en la base de datos
            setSavedNotes(prev => ({
              ...prev,
              [uniqueRouteId]: note.trim() !== ''
            }));
            
            // Actualizar el estado de notas para mostrar el indicador
            setRoutesWithNotes(prev => ({ 
              ...prev, 
              [uniqueRouteId]: note.trim() !== '' 
            }));
            
            noteFound = true;
            break;
          }
        }
        
        if (noteFound) break;
      }
    } catch (error) {
      console.error('Error al cargar notas:', error);
    }
  };

  // Función para abrir el popup de detalles y cargar notas
  const openRouteOrderDetails = async (route: OrderTableItem) => {
    console.log('DEBUG - openRouteOrderDetails llamado con route:', route);
    console.log('DEBUG - route.orderNote:', route.orderNote);
    setSelectedRouteOrderForDetails(route);
    setRouteOrderDetailsDialogOpen(true);
    
    // Cargar las notas del pedido
    await loadRouteOrderNotes(route);
  };

  const openClientDetails = (clientAny: any) => {
    if (!clientAny) {
      toast.error('No se encontró la información del cliente');
      return;
    }
    
    toast.info(`Abriendo detalles de ${clientAny.name}...`);
    
    if (clientAny._isPublic || (clientAny.status_create_public_client && clientAny.status_create_public_client !== 'completed')) {
      handleViewOpenPublic(clientAny);
    } else {
      setLocalCurrentClient(clientAny as Client);
      setLocalViewOpen(true);
    }
  };


  // Escuchar eventos de actualización del workflow
  React.useEffect(() => {
    const handleWorkflowUpdate = (event: any) => {
      console.log('handleWorkflowUpdate: Evento recibido', event.detail);
      // Forzar re-renderizado y actualizar datos del workflow
      refreshWorkflowData(true);
    };

    window.addEventListener('workflowDataUpdated', handleWorkflowUpdate);
    
    return () => {
      window.removeEventListener('workflowDataUpdated', handleWorkflowUpdate);
    };
  }, []);

  // Cargar notas guardadas de todos los pedidos al montar el componente
  React.useEffect(() => {
    const loadAllSavedNotes = async () => {
      try {
        // Obtener todos los routeGroups y sus rutas
        const routeGroupsRef = collection(db, 'routeGroups');
        const querySnapshot = await getDocs(routeGroupsRef);
        
        const savedNotesData: { [key: string]: boolean } = {};
        const routeOrderNotesData: { [key: string]: string } = {};
        
        for (const routeGroupDoc of querySnapshot.docs) {
          const routesUnionRef = collection(db, `routeGroups/${routeGroupDoc.id}/routesUnion`);
          const routesUnionSnapshot = await getDocs(routesUnionRef);
          
          for (const routeUnionDoc of routesUnionSnapshot.docs) {
            const routeUnionData = routeUnionDoc.data();
            const routes = routeUnionData.routes || [];
            const orderDate = routeUnionData.date?.toDate?.() || new Date();
            
            for (const route of routes) {
              if (route.clientId && route.notes) {
                const note = route.notes || '';
                const hasNote = note.trim() !== '';
                
                if (hasNote) {
                  // Crear un ID único para la ruta basado en clientId y fecha
                  const uniqueRouteId = `${route.clientId}-${orderDate.getTime()}`;
                  savedNotesData[uniqueRouteId] = true;
                  routeOrderNotesData[uniqueRouteId] = note;
                }
              }
            }
          }
        }
        
        setSavedNotes(savedNotesData);
        setRouteOrderNotes(routeOrderNotesData);
      } catch (error) {
        console.error('Error al cargar notas guardadas:', error);
      }
    };

    loadAllSavedNotes();
  }, []); // Solo se ejecuta al montar el componente

  const procesoOptions = [
    'Ingresado en Xpress Pago',
    'Link de pago enviado',
    'Inscripción pagada',
    'Mensualidad programada',
    'Tarjeta inválida',
    'Fondos insuficientes',
    'Link de pago no completado',
    'Otro'
  ];
  
  // Estados por color para el borde
  const procesoGreen = ['Inscripción pagada', 'Mensualidad programada', 'Ingresado en Xpress Pago', 'Link de pago enviado'];
  const procesoRed = ['Tarjeta inválida', 'Fondos insuficientes', 'Link de pago no completado'];
  const procesoSuccess = ['Inscripción pagada', 'Mensualidad programada', 'Completado'];

  // Función para determinar el color del borde según el proceso
  const getProcesoBorderColor = (proceso: string | undefined, status?: string) => {
    // Si el pedido está completado, siempre verde
    if (status === 'completed') return '#2e7d32';
    
    // Si no hay proceso, azul por defecto
    if (!proceso) return '#1976d2';
    
    // Determinar color según el proceso
    if (procesoGreen.includes(proceso)) return '#2e7d32'; // Verde
    if (procesoRed.includes(proceso)) return '#d32f2f'; // Rojo
    return '#1976d2'; // Azul por defecto
  };

  // Función para renderizar opciones del select con indicadores de color
  const renderProcesoOption = (option: string) => {
    let color = '#1976d2'; // Azul por defecto
    let icon = null;
    
    if (procesoGreen.includes(option)) {
      color = '#2e7d32'; // Verde
      icon = '✓';
    } else if (procesoRed.includes(option)) {
      color = '#d32f2f'; // Rojo
      icon = '✗';
    }
    
    return (
      <MenuItem key={option} value={option}>
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          {icon && (
            <Box 
              sx={{ 
                width: 16, 
                height: 16, 
                borderRadius: '50%', 
                backgroundColor: color, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                color: 'white',
                fontSize: '10px',
                fontWeight: 'bold',
                mr: 1
              }}
            >
              {icon}
            </Box>
          )}
          <Typography sx={{ color: color, fontWeight: icon ? 'bold' : 'normal' }}>
            {option}
          </Typography>
        </Box>
      </MenuItem>
    );
  };

  const isLocationCompletePublic = (c: PublicClient) => {
    return Boolean(c.provincia && c.canton && c.distrito && (c.googleMapsLink || c.wazeLink) && c.senas && c.senas.trim() !== '');
  };

  // Función de filtrado para búsqueda en el flujo de trabajo
  const matchesWorkflowSearch = React.useCallback((item: PublicClient | Client | OrderTableItem) => {
    const searchTerm = workflowSearchTerm?.toLowerCase().trim() || '';

    if (searchTerm) {
      console.log('🔍 Matching item against searchTerm:', searchTerm, 'Item:', (item as any).name || (item as any).clientName);
      // Para PublicClient o Client
      if ('name' in item) {
        const client = item as PublicClient | Client;
        const matchesText = (
          client.name?.toLowerCase().includes(searchTerm) ||
          client.phoneNumber?.includes(searchTerm) ||
          client.provincia?.toLowerCase().includes(searchTerm) ||
          client.canton?.toLowerCase().includes(searchTerm) ||
          client.distrito?.toLowerCase().includes(searchTerm) ||
          client.phoneNumber?.includes(searchTerm) ||
          client.cedula_nacional?.includes(searchTerm)
        );
        console.log('Match result (Client):', matchesText);
        if (!matchesText) return false;
      }

      // Para OrderTableItem
      if ('deliveryType' in item) {
        const order = item as OrderTableItem;
        const matches = (
          order.clientName?.toLowerCase().includes(searchTerm) ||
          order.clientPhone?.includes(searchTerm) ||
          order.routeName?.toLowerCase().includes(searchTerm)
        );
        console.log('Match result (Order):', matches);
        if (!matches) return false;
      }
    }
    
    // Verificar filtros de ubicación
    if (filterProvincia || filterCanton || filterDistrito) {
      // Para PublicClient o Client
      if ('name' in item) {
        const client = item as PublicClient | Client;
        
        if (filterProvincia && client.provincia !== filterProvincia) return false;
        if (filterCanton && client.canton !== filterCanton) return false;
        if (filterDistrito && client.distrito !== filterDistrito) return false;
      }
      
      // Para OrderTableItem - buscar el cliente correspondiente
      if ('deliveryType' in item) {
        const order = item as OrderTableItem;
        const client = clients.find(c => c.id === order.clientId) || (order.clientData as Client | PublicClient | null);
        if (!client) return false;
        
        if (filterProvincia && client.provincia !== filterProvincia) return false;
        if (filterCanton && client.canton !== filterCanton) return false;
        if (filterDistrito && client.distrito !== filterDistrito) return false;
      }
    }
    
    return true;
  }, [workflowSearchTerm, filterProvincia, filterCanton, filterDistrito, clients]);


  // Crear mapa de clientes para búsquedas más eficientes
  const clientMap = React.useMemo(() => {
    const map = new Map<string, Client | PublicClient>();
    clients.forEach(client => {
      if (client.id) map.set(client.id, client);
    });
    publicClients.forEach(publicClient => {
      if (publicClient.id) map.set(publicClient.id, publicClient);
    });
    return map;
  }, [clients, publicClients]);

  const refreshWorkflowData = useCallback(async (forceRefresh: boolean = false) => {
    try {
      console.log('🔍 Workflow Full Fetch - Direct from Firestore | ForceRefresh:', forceRefresh);

      // Set loading states when fetching from Firestore
      setWorkflowLoading(true);
      setLoadingPendingOrdersForWorkflow(true);
      setLoadingRoutes(true);

      // --- Fetch Pending Orders ---
      const pendingRef = collection(db, 'pendingOrders');
      const pendingSnapshot = await getDocs(pendingRef);
      const pendingList: { id: string; clientId: string; clientName: string; pendingDate?: Date; order?: Order; orderNote?: string }[] = [];

      const pendingDocs = pendingSnapshot.docs;
      const orderIds = pendingDocs
        .map(d => d.data().orderId)
        .filter((id): id is string => !!id);

      const orderMap = new Map<string, Order>();

      // Chunk orderIds into groups of 30 to avoid Firestore 'in' query limit
      for (let i = 0; i < orderIds.length; i += 30) {
        const chunk = orderIds.slice(i, i + 30);
        const ordersQuery = query(collection(db, 'orders'), where('__name__', 'in', chunk));
        const ordersSnapshot = await getDocs(ordersQuery);
        ordersSnapshot.forEach(doc => {
          orderMap.set(doc.id, doc.data() as Order);
        });
      }

      pendingDocs.forEach(document => {
        const data = document.data();
        if (data.clientId) {
          const orderData = data.orderId ? orderMap.get(data.orderId) : undefined;
          const client = clientMap.get(data.clientId);
          pendingList.push({
            id: document.id, // Include the pendingOrder document ID
            clientId: data.clientId,
            clientName: data.clientName || client?.name || 'Cliente desconocido',
            pendingDate: data.pendingDate?.toDate?.() || undefined,
            order: orderData ? { ...orderData, id: data.orderId } : undefined,
            orderNote: data.orderNote
          } as any);
        }
      });

      // --- Fetch All Routes for Workflow ---
      const routeGroupsRef = collection(db, 'routeGroups');
      const routeGroupsSnapshot = await getDocs(routeGroupsRef);
      let fetchedRoutes: OrderTableItem[] = [];

      for (const docSnapshot of routeGroupsSnapshot.docs) {
        const routeGroup = { id: docSnapshot.id, ...docSnapshot.data() } as RouteGroup;
        const routesUnionRef = collection(db, `routeGroups/${docSnapshot.id}/routesUnion`);
        const routesUnionSnapshot = await getDocs(routesUnionRef);

        routesUnionSnapshot.forEach((routeUnionDoc) => {
          const routeUnionData = routeUnionDoc.data();
          const routes = routeUnionData.routes || [];
          routes.forEach((route: any) => {
            const client = clientMap.get(route.clientId);
            const fallbackClientData = route.clientData || route.client || null;
            const clientName = client?.name || fallbackClientData?.name || route.clientName || 'Cliente';
            const clientPhone = (client?.phoneNumber || fallbackClientData?.phone || route.clientPhone || '') as string;

            if (client || fallbackClientData) {
              fetchedRoutes.push({
                id: route.id || routeUnionDoc.id,
                clientId: route.clientId,
                clientName,
                clientPhone,
                createdAt: routeUnionData.date?.toDate?.() || new Date(),
                routeName: routeGroup.name || 'Sin asignar',
                status: route.status,
                deliveryType: 'ollinItems',
                order: route.order as Order,
                routeGroup: routeGroup
              });
            }
          });
        });
      }
      fetchedRoutes.sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime());

      setPendingOrdersForWorkflow(pendingList);
      setAllRoutes(fetchedRoutes);
      setWorkflowRefreshKey(prev => prev + 1);
    } catch (e) {
      console.error('Workflow full fetch error:', e);
    } finally {
      setWorkflowLoading(false);
      setLoadingPendingOrdersForWorkflow(false);
      setLoadingRoutes(false);
    }
  }, [clientMap]);

  useEffect(() => {
    refreshWorkflowData();
  }, []); // Call once on mount when entering the tab

  // useEffect(() => {
  //   const autoAdvanceMissingLocation = async () => {
  //     const toAdvance = publicClients.filter(pc => pc.status_create_public_client === 'pending' && (pc.workflow_stage === 'missing_location') && isLocationCompletePublic(pc));
  //     for (const pc of toAdvance) {
  //       if (!pc.id) continue;
  //       try {
  //         await setDoc(doc(db, 'publicClients', pc.id), { workflow_stage: 'waitlist' }, { merge: true });
  //       } catch (e) {
  //         console.error(e);
  //       }
  //     }
  //   };
  //   autoAdvanceMissingLocation();
  // }, [publicClients]);

  const checkCompletedInRoutes = useCallback(async (clientId: string) => {
    try {
      const routeGroupsRef = collection(db, 'routeGroups');
      const querySnapshot = await getDocs(routeGroupsRef);
      const since = addDays(new Date(), -90);
      for (const docSnapshot of querySnapshot.docs) {
        const routesUnionRef = collection(db, `routeGroups/${docSnapshot.id}/routesUnion`);
        const routesUnionSnapshot = await getDocs(routesUnionRef);
        for (const ru of routesUnionSnapshot.docs) {
          const data = ru.data();
          const date = data.date?.toDate?.() || new Date();
          if (date < since) continue;
          const routes = data.routes || [];
          const match = routes.find((r: any) => r.clientId === clientId && (r.status === 'completed' || r.delivery_completed === true));
          if (match) return true;
        }
      }
      return false;
    } catch (e) {
      console.error(e);
      return false;
    }
  }, []);

  const handleWorkflowDropWithData = async (dragData: { type: 'public' | 'client', id: string, stage: number }, targetStage: number) => {
    console.log('🚀 HANDLE WORKFLOW DROP WITH DATA - targetStage:', targetStage);
    console.log('📦 dragData:', dragData);
    
    const newIndex = targetStage - 1;
    if (Math.abs(newIndex - dragData.stage) > 1) {
      setNotification({ open: true, message: 'Solo puedes mover a la columna adyacente', type: 'warning' });
      return;
    }
    
    try {
      if (dragData.type === 'public') {
        const pc = publicClients.find(p => p.id === dragData.id);
        if (!pc || !pc.id) return;
        
        if (targetStage === 1) {
          try {
            await setDoc(doc(db, 'publicClients', pc.id), {
              workflow_stage: 'waitlist',
              movedAt: serverTimestamp()
            }, { merge: true });
            setMoveSuccessOpen({ message: 'El cliente ha sido movido a Lista de Espera exitosamente', reload: false });
            await refreshWorkflowData(true);
          } catch (e) {
            console.error('Error moving public client to waitlist:', e);
            setNotification({ open: true, message: 'Error al mover cliente a lista de espera', type: 'error' });
          }
          return;
        }
        
        if (targetStage === 2) {
          const publicClientData: PublicClient = {
            id: pc.id,
            name: pc.name,
            phoneNumber: pc.phoneNumber,
            second_phoneNumber: pc.second_phoneNumber,
            email: pc.email,
            cedula_nacional: pc.cedula_nacional,
            tipo_documento: pc.tipo_documento,
            tipo_client: pc.tipo_client,
            tipo_compostera: pc.tipo_compostera,
            tipo_entrega: pc.tipo_entrega,
            senas: pc.senas,
            nota: pc.nota,
            imageUrl: pc.imageUrl,
            provincia: pc.provincia,
            canton: pc.canton,
            distrito: pc.distrito,
            municipalidades: pc.municipalidades || '',
            cant_gato: pc.cant_gato || '0',
            cant_perro_mini: pc.cant_perro_mini || '0',
            cant_perro_pequeno: pc.cant_perro_pequeno || '0',
            cant_perro_mediano: pc.cant_perro_mediano || '0',
            cant_perro_grande: pc.cant_perro_grande || '0',
            cant_perro_gigante: pc.cant_perro_gigante || '0',
            codigo_referencia: pc.codigo_referencia || '',
            googleMapsLink: pc.googleMapsLink || '',
            wazeLink: pc.wazeLink || '',
            workflow_stage: 'waitlist' as const,
            status_create_public_client: 'pending' as const,
            location: pc.location || [0, 0]
          };
          
          setSelectedClientLocal(publicClientData);
          setCreateClientDialogOpenLocal(true);
          setWorkflowDropLoading(false);
          return;
        }
      } else if (dragData.type === 'client') {
        const client = clients.find(c => c.id === dragData.id);
        if (!client || !client.id) return;
        
        if (targetStage === 1) {
          try {
            await setDoc(doc(db, 'clients', client.id), {
              workflow_stage: 'waitlist',
              movedAt: serverTimestamp()
            }, { merge: true });
            if (onUpdateClient) {
              await onUpdateClient({ ...client, workflow_stage: 'waitlist' });
            }
            setMoveSuccessOpen({ message: 'El cliente ha sido movido a Lista de Espera exitosamente', reload: false });
            await refreshWorkflowData(true);
          } catch (e) {
            console.error('Error moving client to waitlist:', e);
            setNotification({ open: true, message: 'Error al mover cliente a lista de espera', type: 'error' });
          }
          return;
        }
        
        if (targetStage === 2) {
          try {
            await setDoc(doc(db, 'clients', client.id), {
              workflow_stage: 'waitlist',
              movedAt: serverTimestamp()
            }, { merge: true });
            setNotification({ open: true, message: 'Cliente movido a Lista de espera exitosamente', type: 'success' });
            if (onUpdateClient) {
              await onUpdateClient({ ...client, workflow_stage: 'waitlist' });
            }
            await refreshWorkflowData(true);
          } catch (e) {
            console.error('Error moving client to waitlist:', e);
            setNotification({ open: true, message: 'Error al mover cliente a lista de espera', type: 'error' });
          }
          return;
        }
      }
    } catch (e) {
      console.error('❌ Error en handleWorkflowDropWithData:', e);
      setNotification({ open: true, message: 'Error al mover elemento', type: 'error' });
    }
  };

  const handleWorkflowDrop = async (targetStage: number) => {
    console.log('🚀 HANDLE WORKFLOW DROP - targetStage:', targetStage);
    console.log('📦 workflowDragged actual:', workflowDragged);
    
    if (!workflowDragged) {
      console.log('❌ workflowDragged es null, saliendo');
      return;
    }
    
    const newIndex = targetStage - 1;
    if (Math.abs(newIndex - workflowDragged.stage) > 1) {
      setNotification({ open: true, message: 'Solo puedes mover a la columna adyacente', type: 'warning' });
      setWorkflowDragged(null);
      return;
    }
    
    try {
      if (workflowDragged.type === 'public') {
        const pc = publicClients.find(p => p.id === workflowDragged.id);
        if (!pc || !pc.id) return;
        
        if (targetStage === 2) {
          const publicClientData: PublicClient = {
            id: pc.id,
            name: pc.name,
            phoneNumber: pc.phoneNumber,
            second_phoneNumber: pc.second_phoneNumber,
            email: pc.email,
            cedula_nacional: pc.cedula_nacional,
            tipo_documento: pc.tipo_documento,
            tipo_client: pc.tipo_client,
            tipo_compostera: pc.tipo_compostera,
            tipo_entrega: pc.tipo_entrega,
            senas: pc.senas,
            nota: pc.nota,
            imageUrl: pc.imageUrl,
            provincia: pc.provincia,
            canton: pc.canton,
            distrito: pc.distrito,
            municipalidades: pc.municipalidades || '',
            cant_gato: pc.cant_gato || '0',
            cant_perro_mini: pc.cant_perro_mini || '0',
            cant_perro_pequeno: pc.cant_perro_pequeno || '0',
            cant_perro_mediano: pc.cant_perro_mediano || '0',
            cant_perro_grande: pc.cant_perro_grande || '0',
            cant_perro_gigante: pc.cant_perro_gigante || '0',
            codigo_referencia: pc.codigo_referencia || '',
            googleMapsLink: pc.googleMapsLink || '',
            wazeLink: pc.wazeLink || '',
            workflow_stage: 'waitlist' as const,
            status_create_public_client: 'pending' as const,
            location: pc.location || [0, 0]
          };
          
          setSelectedClientLocal(publicClientData);
          setCreateClientDialogOpenLocal(true);
          setWorkflowDropLoading(false);
          return;
        }
        
        if (targetStage === 1) {
          const updatedClient = { ...pc, workflow_stage: 'missing_location' as const, status_create_public_client: 'pending' as const };
          await setDoc(doc(db, 'publicClients', pc.id), { 
            workflow_stage: 'missing_location',
            status_create_public_client: 'pending'
          }, { merge: true });
          await onUpdatePublicClient(updatedClient);
          setNotification({ open: true, message: 'Cliente movido a Revisión de Datos', type: 'success' });
        }
      } else if (workflowDragged.type === 'client') {
        const client = clients.find(c => c.id === workflowDragged.id);
        if (!client || !client.id) return;
        
        if (targetStage === 2) {
          try {
            await setDoc(doc(db, 'clients', client.id), { workflow_stage: 'waitlist' }, { merge: true });
            setNotification({ open: true, message: 'Cliente movido a Lista de espera exitosamente', type: 'success' });
            if (onUpdateClient) {
              await onUpdateClient({ ...client, workflow_stage: 'waitlist' });
            }
            await refreshWorkflowData(true);
          } catch (e) {
            console.error('Error moving client to waitlist:', e);
            setNotification({ open: true, message: 'Error al mover cliente a lista de espera', type: 'error' });
          }
          return;
        }
        
        if (targetStage === 3) {
          try {
            // Update route status to 'completed' for all routes of this client
            const routesToComplete = procesoRouteOrders.filter(r => r.clientId === client.id);
            if (routesToComplete.length > 0) {
              const routeGroupsRef = collection(db, 'routeGroups');
              const routeGroupsQuery = await getDocs(routeGroupsRef);
              for (const routeGroupDoc of routeGroupsQuery.docs) {
                const routesUnionRef = collection(db, `routeGroups/${routeGroupDoc.id}/routesUnion`);
                const routesUnionSnapshot = await getDocs(routesUnionRef);
                for (const routeUnionDoc of routesUnionSnapshot.docs) {
                  const routeUnionData = routeUnionDoc.data();
                  const routes = routeUnionData.routes || [];
                  let changed = false;
                  routes.forEach((r: any) => {
                    if (r.clientId === client.id) {
                      r.status = 'completed';
                      changed = true;
                    }
                  });
                  if (changed) {
                    await setDoc(doc(db, `routeGroups/${routeGroupDoc.id}/routesUnion`, routeUnionDoc.id), {
                      ...routeUnionData,
                      routes: routes
                    }, { merge: true });
                  }
                }
              }
            }
            // Delete any pending orders for this client so it doesn't reappear in col 1
            try {
              const pendingRef = collection(db, 'pendingOrders');
              const q = query(pendingRef, where('clientId', '==', client.id));
              const pendingSnapshot = await getDocs(q);
              await Promise.all(pendingSnapshot.docs.map(docSnap => deleteDoc(doc(db, 'pendingOrders', docSnap.id))));
            } catch (e) {
              console.warn('Error cleaning up pending orders during drag complete:', e);
            }
            await moveToCompleted(client.id || '');
            await refreshWorkflowData(true);
            setNotification({ open: true, message: 'Pedido movido a Completados exitosamente', type: 'success' });
          } catch (e) {
            console.error('Error moving to completados via drag:', e);
            setNotification({ open: true, message: 'Error al mover a completados', type: 'error' });
          }
        }
      }
    } catch (e) {
      console.error('❌ Error en handleWorkflowDrop:', e);
      setNotification({ open: true, message: 'Error al mover elemento', type: 'error' });
    } finally {
      setWorkflowDragged(null);
    }
  };


  const missingLocationClients = React.useMemo(() => 
    publicClients.filter(pc => pc.status_create_public_client === 'pending' && (!pc.workflow_stage || pc.workflow_stage === 'missing_location')),
    [publicClients]
  );

  const inWorkflowRange = React.useCallback((date?: Date | null) => {
    if (!workflowStartDate || !workflowEndDate || !date) return true;
    const s = startOfDay(workflowStartDate);
    const e = endOfDay(workflowEndDate);
    return date >= s && date <= e;
  }, [workflowStartDate, workflowEndDate]);

  const waitlistPendingFiltered = React.useMemo(() =>
    pendingOrdersForWorkflow.filter(p => inWorkflowRange(p.pendingDate)),
    [pendingOrdersForWorkflow, inWorkflowRange, workflowRefreshKey]
  );

  const waitlistClientIdsFromPending = React.useMemo(() => {
    const pendingIds = new Set(waitlistPendingFiltered.map(p => p.clientId));
    // Also include clients with administratively reprogrammed orders from allRoutes
    allRoutes?.forEach(route => {
      if (route.status?.toLowerCase() === 'reprogrammed') {
        pendingIds.add(route.clientId);
      }
    });
    return pendingIds;
  }, [waitlistPendingFiltered, allRoutes]);

  
  const revisionDataClients = React.useMemo(() => {
    const publicInRevision = publicClients.filter(pc => {
      return pc.status_create_public_client === 'pending';
    }).map(pc => ({ ...pc, _isPublic: true }));
    const routesInDateRange = allRoutes.filter(route => {
      if (!workflowStartDate || !workflowEndDate) return true;
      const routeDate = route.createdAt ? new Date(route.createdAt) : null;
      if (!routeDate) return true;
      const start = startOfDay(workflowStartDate);
      const end = endOfDay(workflowEndDate);
      return routeDate >= start && routeDate <= end;
    });
    const clientsWithRouteIds = new Set(routesInDateRange.map(r => r.clientId));

    const pendingInDateRange = pendingOrdersForWorkflow.filter(p => {
      if (!workflowStartDate || !workflowEndDate) return true;
      const pDate = p.pendingDate ? new Date(p.pendingDate) : null;
      if (!pDate) return true;
      const start = startOfDay(workflowStartDate);
      const end = endOfDay(workflowEndDate);
      return pDate >= start && pDate <= end;
    });
    const clientsWithPendingIds = new Set(pendingInDateRange.map(p => p.clientId));

    const clientsInRevision = clients.filter(c =>
      !clientsWithRouteIds.has(c.id || '') &&
      !clientsWithPendingIds.has(c.id || '') &&
      !waitlistClientIdsFromPending.has(c.id || '') &&
      c.workflow_stage !== 'waitlist'
    ).map(c => ({ ...c, _isPublic: false }));
    return [...publicInRevision, ...clientsInRevision];
  }, [publicClients, clients, allRoutes, pendingOrdersForWorkflow, workflowStartDate, workflowEndDate, workflowRefreshKey]);
  
  const waitlistClientsPublic = React.useMemo(() => {
    const clientIds = new Set(clients.map(c => c.id));
    const clientPhones = new Set(clients.map(c => c.phoneNumber?.trim()));
    return publicClients.filter(pc =>
      pc.workflow_stage === 'waitlist' &&
      !clientIds.has(pc.id || '') &&
      !clientPhones.has(pc.phoneNumber?.trim()) &&
      !(pc.id && removedWaitlistClientIds.has(pc.id))
    );
  }, [publicClients, clients, removedWaitlistClientIds]);
  
  // Función para verificar si una ruta tiene fechas futuras disponibles
  
  const missingLocationClientsFiltered = React.useMemo(() => 
    missingLocationClients.filter(pc => {
      const created = (pc as any).createdAt?.toDate?.() || (pc as any).createdAt || null;
      return inWorkflowRange(created);
    }),
    [missingLocationClients, inWorkflowRange, workflowRefreshKey]
  );
  
  const revisionDataClientsFiltered = React.useMemo(() => 
    revisionDataClients.filter(pc => {
      const created = (pc as any).createdAt?.toDate?.() || (pc as any).createdAt || null;
      return inWorkflowRange(created);
    }),
    [revisionDataClients, inWorkflowRange, workflowRefreshKey]
  );
  
  const revisionDataClientsFilteredSearch = React.useMemo(() => {
    const filtered = revisionDataClientsFiltered.filter(pc => matchesWorkflowSearch(pc));

    // Ordenar: clientes formulario (pending) primero (celeste),
    // luego clientes existentes por fecha de creación descendente (más recientes primero)
    const getTime = (item: any): number => {
      const val = item.createdAt;
      if (!val) return Number.MIN_SAFE_INTEGER;
      if (typeof val === 'object' && val.toDate) return val.toDate().getTime();
      if (val instanceof Date) return val.getTime();
      if (typeof val === 'string') return new Date(val).getTime();
      return Number(val) || Number.MIN_SAFE_INTEGER;
    };
    const publicItems = filtered.filter(a => 'status_create_public_client' in a);
    const nonPublicItems = filtered.filter(a => !('status_create_public_client' in a));
    nonPublicItems.sort((a, b) => getTime(b) - getTime(a));
    const sorted = [...publicItems, ...nonPublicItems];

    console.log('DEBUG - revisionDataClientsFilteredSearch:', {
      inputLength: revisionDataClientsFiltered.length,
      filteredLength: sorted.length,
      searchTerm: workflowSearchTerm
    });
    return sorted;
  }, [revisionDataClientsFiltered, workflowSearchTerm, filterProvincia, filterCanton, filterDistrito]);
  
  const uniqueRouteNames = React.useMemo(() => {
    const names = new Set<string>();
    allRoutes.forEach(r => {
      if (r.routeName) names.add(r.routeName);
    });
    return Array.from(names).sort();
  }, [allRoutes]);

  const waitlistClientsPublicFiltered = React.useMemo(() =>
    waitlistClientsPublic.filter(pc => {
      if (waitlistFilterEstado !== 'todas' && waitlistFilterEstado !== 'pending') return false;
      const created = (pc as any).createdAt?.toDate?.() || (pc as any).createdAt || null;
      return inWorkflowRange(created) && pc.name && pc.name.trim() !== '';
    }),
    [waitlistClientsPublic, inWorkflowRange, workflowRefreshKey, waitlistFilterEstado]
  );
  
  
  const waitlistClientsFromPending = React.useMemo(() => {
    const filtered = clients.filter(c =>
      (waitlistClientIdsFromPending.has(c.id || '') || c.workflow_stage === 'waitlist') &&
      c.workflow_stage !== 'completed' &&
      c.name && c.name.trim() !== '' &&
      !(c.id && removedWaitlistClientIds.has(c.id))
    );
    return Array.from(new Map(filtered.map(c => [c.id, c])).values());
  }, [clients, waitlistClientIdsFromPending, workflowRefreshKey, removedWaitlistClientIds]);
  
  // Filtros para cartas sin nombre
  const waitlistClientsPublicNoName = React.useMemo(() => 
    waitlistClientsPublic.filter(pc => {
      const created = (pc as any).createdAt?.toDate?.() || (pc as any).createdAt || null;
      return inWorkflowRange(created) && (!pc.name || pc.name.trim() === '');
    }),
    [waitlistClientsPublic, inWorkflowRange, workflowRefreshKey]
  );
  
  const waitlistClientsFromPendingNoName = React.useMemo(() => {
    const filtered = clients.filter(c =>
      waitlistClientIdsFromPending.has(c.id || '') &&
      (!c.name || c.name.trim() === '') &&
      !(c.id && removedWaitlistClientIds.has(c.id))
    );
    return Array.from(new Map(filtered.map(c => [c.id, c])).values());
  }, [clients, waitlistClientIdsFromPending, workflowRefreshKey, removedWaitlistClientIds]);
  
  const waitlistClientsPublicNoNameSearch = React.useMemo(() => 
    waitlistClientsPublicNoName.filter(pc => matchesWorkflowSearch(pc)),
    [waitlistClientsPublicNoName, workflowSearchTerm, filterProvincia, filterCanton, filterDistrito]
  );
  
  const waitlistClientsFromPendingNoNameSearch = React.useMemo(() => 
    waitlistClientsFromPendingNoName.filter(c => matchesWorkflowSearch(c)),
    [waitlistClientsFromPendingNoName, workflowSearchTerm, filterProvincia, filterCanton, filterDistrito]
  );
  
  // Get route orders for "2. En proceso" column
  // Show only route orders created from the waitlist save flow.
  const procesoRouteOrders = React.useMemo(() => allRoutes.filter(route => {
    if (route.status === 'completed') return false;
    if (!route.order?.items || route.order.items.length === 0) return false;

    // Filter by date range using route's createdAt
    if (workflowStartDate && workflowEndDate) {
      const routeDate = route.createdAt;
      const start = startOfDay(workflowStartDate);
      const end = endOfDay(workflowEndDate);
      if (!(routeDate >= start && routeDate <= end)) return false;
    }

    // Bypass client existence check for recently-assigned routes from waitlist
    if (route.id && readyForProcessRouteIds.has(route.id)) return true;
    if (route.clientId && readyForProcessIds.has(route.clientId)) return true;
    if (route.clientId && removedWaitlistClientIds.has(route.clientId)) return true;

    const client = clients.find(c => c.id === route.clientId);
    if (!client) return false;

    const routeClientWorkflowStage = client.workflow_stage || route.clientData?.workflow_stage;
    if (routeClientWorkflowStage === 'process') return true;

    return false;
  }), [allRoutes, clients, publicClients, readyForProcessIds, removedWaitlistClientIds, readyForProcessRouteIds, workflowStartDate, workflowEndDate, workflowRefreshKey]);

  console.log('DEBUG - allRoutes.length:', allRoutes.length);
  console.log('DEBUG - procesoRouteOrders.length:', procesoRouteOrders.length);
  console.log('DEBUG - procesoRouteOrders items:', procesoRouteOrders.map(o => ({ 
    id: o.id, 
    clientId: o.clientId, 
    clientName: o.clientName,
    routeName: o.routeName 
  })));

  // Get route orders with successful process for "3. Completados" column
  const completedRouteOrders = React.useMemo(() => allRoutes.filter(route => {
    if (route.status === 'pending') return false;

    const regularClient = clients.find(c => c.id === route.clientId);
    if (!regularClient) return false;

    const isCompleted = procesoSuccess.includes(regularClient.proceso || '');
    if (!isCompleted) return false;

    // Filter by date range using route's createdAt as fallback
    if (workflowStartDate && workflowEndDate) {
      const routeDate = route.createdAt;
      const start = startOfDay(workflowStartDate);
      const end = endOfDay(workflowEndDate);
      if (!(routeDate >= start && routeDate <= end)) return false;
    }

    return true;
  }), [allRoutes, clients, procesoSuccess, workflowStartDate, workflowEndDate, workflowRefreshKey]);

  // Get clients who are marked as completed but don't have a route assigned
  const completedClientsOnly = React.useMemo(() => {
    return clients.filter(client => {
      // Filter: only show cards where the client's name exists in the formulario table (publicClients)
      const publicClientWithName = publicClients.find(pc => pc.name === client.name);
      if (!publicClientWithName) return false;

      const isCompleted = procesoSuccess.includes(client.proceso || '');
      if (!isCompleted) return false;

      // Check date filter if dates are set
      if (workflowStartDate && workflowEndDate) {
        const completedAt = client.completed_at;
        if (!completedAt) return false;
        const completedDate = completedAt.toDate();
        const start = startOfDay(workflowStartDate);
        const end = endOfDay(workflowEndDate);
        if (!(completedDate >= start && completedDate <= end)) return false;
      }

      const hasRoute = completedRouteOrders.some(route => route.clientId === client.id);
      return !hasRoute;
    });
  }, [clients, publicClients, completedRouteOrders, workflowStartDate, workflowEndDate]);

  // Variables filtradas para búsqueda
  const procesoRouteOrdersFilteredSearch = React.useMemo(() => {
    const filtered = procesoRouteOrders.filter(order => matchesWorkflowSearch(order));
    console.log('Debug - procesoRouteOrders:', procesoRouteOrders.length, 'filtered:', filtered.length, 'searchTerm:', workflowSearchTerm);
    console.log('Debug - procesoRouteOrders items:', procesoRouteOrders.map(o => ({ id: o.id, clientName: o.clientName })));
    console.log('Debug - filtered items:', filtered.map(o => ({ id: o.id, clientName: o.clientName })));
    
    // Ordenar: primero las no completadas, luego las completadas
    const sorted = filtered.sort((a, b) => {
      const aCompleted = a.status === 'completed';
      const bCompleted = b.status === 'completed';
      
      if (aCompleted && !bCompleted) return 1; // a va después
      if (!aCompleted && bCompleted) return -1; // a va antes
      return 0; // mantener orden original
    });
    
    return sorted;
  }, [procesoRouteOrders, workflowSearchTerm, filterProvincia, filterCanton, filterDistrito]);

  const completedRouteOrdersFilteredSearch = React.useMemo(() => 
    completedRouteOrders.filter(order => matchesWorkflowSearch(order)),
    [completedRouteOrders, workflowSearchTerm, filterProvincia, filterCanton, filterDistrito]
  );

  const completedClientsOnlyFilteredSearch = React.useMemo(() => 
    completedClientsOnly.filter(client => matchesWorkflowSearch(client)),
    [completedClientsOnly, workflowSearchTerm, filterProvincia, filterCanton, filterDistrito]
  );

  // Cargar notas cuando cambian las rutas
  useEffect(() => {
    loadAllRouteNotes();
  }, [procesoRouteOrders, completedRouteOrders, workflowRefreshKey]);

  // Cargar notas al montar el componente (para persistencia)
  useEffect(() => {
    if (procesoRouteOrders.length > 0 || completedRouteOrders.length > 0) {
      loadAllRouteNotes();
    }
  }, []); // Solo se ejecuta al montar

  const missingLocationClientsFilteredSearch = React.useMemo(() => 
    missingLocationClientsFiltered.filter(pc => matchesWorkflowSearch(pc)),
    [missingLocationClientsFiltered, workflowSearchTerm, filterProvincia, filterCanton, filterDistrito]
  );

  const getMovedAtTime = (item: any): number => {
    const val = item.movedAt;
    if (!val) return Number.MIN_SAFE_INTEGER;
    if (typeof val === 'object' && val.toDate) return val.toDate().getTime();
    if (val instanceof Date) return val.getTime();
    if (typeof val === 'string') return new Date(val).getTime();
    return Number(val) || Number.MIN_SAFE_INTEGER;
  };

  const waitlistClientsPublicFilteredSearch = React.useMemo(() =>
    waitlistClientsPublicFiltered.filter(pc => matchesWorkflowSearch(pc)).sort((a, b) => getMovedAtTime(b) - getMovedAtTime(a)),
    [waitlistClientsPublicFiltered, workflowSearchTerm, filterProvincia, filterCanton, filterDistrito]
  );

  // Helper function to get pending order for a client
  const getPendingOrderForClient = (clientId: string) => {
    // 1. Prioritize reprogrammed orders from pedidosPreprogramados collection
    const reproOrder = pedidosPreprogramados?.find(p => p.routeRreprogrammed?.clientId === clientId);
    if (reproOrder) {
      const routeGroup = routeGroupsForWaitlist.find(rg => rg.id === reproOrder.destinyReprogrammedRouteGroupId);
      return {
        ...reproOrder,
        status: 'reprogrammed',
        routeName: routeGroup?.name || reproOrder.routeRreprogrammed?.routeName || 'Sin asignar',
        date: reproOrder.destinyReprogrammedDate instanceof Date ? 
               reproOrder.destinyReprogrammedDate : 
               (reproOrder.destinyReprogrammedDate as any)?.toDate?.() || 
               (reproOrder.destinyReprogrammedDate ? new Date(reproOrder.destinyReprogrammedDate) : null)
      };
    }

    // 2. Then prioritize administratively reprogrammed orders from allRoutes
    const reprogrammedRoute = allRoutes?.find(r => r.clientId === clientId && r.status?.toLowerCase() === 'reprogrammed');
    if (reprogrammedRoute) {
      return {
        ...reprogrammedRoute,
        order: reprogrammedRoute.order,
        date: reprogrammedRoute.createdAt instanceof Date ? 
               reprogrammedRoute.createdAt : 
               (reprogrammedRoute.createdAt as any)?.toDate?.() || 
               new Date(reprogrammedRoute.createdAt)
      };
    }
    
    // 3. Then look for orders in pendingOrdersForWorkflow
    const pendingOrder = pendingOrdersForWorkflow?.find(p => p.clientId === clientId);
    if (pendingOrder) {
      return {
        ...pendingOrder,
        status: pendingOrder.status || 'pending',
        routeName: pendingOrder.routeName || 'Sin asignar',
        date: pendingOrder.pendingDate instanceof Date ? 
               pendingOrder.pendingDate : 
               (pendingOrder.pendingDate as any)?.toDate?.() || 
               (pendingOrder.pendingDate ? new Date(pendingOrder.pendingDate) : new Date())
      };
    }
    
    // 4. Fallback to any route in allRoutes
    const route = allRoutes?.find(r => r.clientId === clientId);
    if (route) {
      return {
        ...route,
        order: route.order,
        date: route.createdAt instanceof Date ? 
               route.createdAt : 
               (route.createdAt as any)?.toDate?.() || 
               new Date(route.createdAt)
      };
    }
    return null;
  };

  const waitlistClientsFromPendingFilteredSearch = React.useMemo(() => {
    if (showReprogrammedByTransporter) return [];

    return waitlistClientsFromPending.filter(c => {
      if (!matchesWorkflowSearch(c)) return false;
      
      const pendingOrder = getPendingOrderForClient(c.id || '');
      
      // SPECIAL CASE: Reprogrammed orders MUST be date filtered
      if (waitlistFilterEstado === 'reprogrammed') {
        if (!pendingOrder) return false;

        if (workflowStartDate && workflowEndDate) {
          const orderDate = pendingOrder.date instanceof Date ? 
                             pendingOrder.date : 
                             (pendingOrder.date as any)?.toDate?.() || 
                             new Date(pendingOrder.date);
          if (isNaN(orderDate.getTime()) || orderDate < startOfDay(workflowStartDate) || orderDate > endOfDay(workflowEndDate)) {
            return false;
          }
        }
        if (pendingOrder.status?.toLowerCase() !== 'reprogrammed') return false;
        return true;
      }

      if (!pendingOrder) {
        if (waitlistFilterEstado === 'cancelled') return false;
        if (waitlistFilterEstado !== 'todas' && waitlistFilterEstado !== 'pending') return false;
        if (waitlistFilterRuta !== 'todas') return false;
        return true;
      }

      if (waitlistFilterEstado === 'cancelled') {
        if (pendingOrder.status !== 'cancelled') return false;
      } else if (waitlistFilterEstado !== 'todas' && waitlistFilterEstado !== 'pending' && pendingOrder.status !== waitlistFilterEstado) {
        return false;
      }
      
      if (waitlistFilterEstado === 'pending' && pendingOrder.status?.toLowerCase() !== 'pending' && pendingOrder.status?.toLowerCase() !== 'reprogrammed') {
        return false;
      }

      if (waitlistFilterRuta !== 'todas' && pendingOrder.routeName !== waitlistFilterRuta) {
        return false;
      }

      return true;
    }).sort((a, b) => getMovedAtTime(b) - getMovedAtTime(a));
  }, [waitlistClientsFromPending, workflowSearchTerm, filterProvincia, filterCanton, filterDistrito, waitlistFilterEstado, waitlistFilterRuta, pedidosPreprogramados, workflowStartDate, workflowEndDate, showReprogrammedByTransporter]);

  const reprogrammedOrdersFilteredSearch = React.useMemo(() => {
    return pedidosPreprogramados.filter(pedido => {
      const clientId = pedido.routeRreprogrammed?.clientId;
      if (isRemovedWaitlistClient(clientId)) return false;
      const client = clients.find(c => c.id === clientId);
      if (!client) return false;
      
      const matches = matchesWorkflowSearch(client);
      if (!matches) return false;

      // 1. Date Range Filter (using destinyReprogrammedDate as in OrdersCalendar)
      if (workflowStartDate && workflowEndDate) {
        const destinyDate = pedido.destinyReprogrammedDate ?
          (pedido.destinyReprogrammedDate instanceof Date ?
              pedido.destinyReprogrammedDate :
              (pedido.destinyReprogrammedDate as any)?.toDate?.() ||
              new Date(pedido.destinyReprogrammedDate)) : null;
        
        if (!destinyDate) return false;
        
        const start = startOfDay(workflowStartDate);
        const end = endOfDay(workflowEndDate);
        if (destinyDate < start || destinyDate > end) return false;
      }

      // 2. Status Filter
      const status = pedido.routeRreprogrammed?.status?.toLowerCase();
      const isCompleted = status === 'completed' || pedido.routeRreprogrammed?.delivery_completed;
      const isCancelled = status === 'cancelled';
      const isPending = !isCompleted && !isCancelled;
      const isReprogrammedByTransporter = status === 'reprogrammed' || (status === 'cancelled' && pedido.routeRreprogrammed?.id);

      if (waitlistFilterEstado === 'cancelled') {
        if (!isCancelled) return false;
      } else if (waitlistFilterEstado === 'pending') {
        if (!isPending) return false;
      } else if (waitlistFilterEstado === 'reprogrammed') {
        if (!isReprogrammedByTransporter) return false;
      } else if (waitlistFilterEstado !== 'todas') {
        return false;
      }

      // 3. Route Filter (using destination route group name)
      if (waitlistFilterRuta !== 'todas') {
        const routeGroup = routeGroupsForWaitlist.find(rg => rg.id === pedido.destinyReprogrammedRouteGroupId);
        if (!routeGroup || routeGroup.name !== waitlistFilterRuta) return false;
      }

      return true;
    });
  }, [pedidosPreprogramados, clients, workflowSearchTerm, filterProvincia, filterCanton, filterDistrito, waitlistFilterEstado, waitlistFilterRuta, routeGroupsForWaitlist, workflowStartDate, workflowEndDate, showReprogrammedByTransporter]);

  // Obtener opciones únicas de ubicación
  const getProvinciasOptions = React.useMemo(() => {
    const provincias = new Set<string>();
    clients.forEach(client => {
      if (client.provincia) provincias.add(client.provincia);
    });
    return Array.from(provincias).sort();
  }, [clients]);

  const getCantonesOptions = React.useMemo(() => {
    if (!filterProvincia) return [];
    const cantones = new Set<string>();
    clients.forEach(client => {
      if (client.provincia === filterProvincia && client.canton) cantones.add(client.canton);
    });
    return Array.from(cantones).sort();
  }, [clients, filterProvincia]);

  const getDistritosOptions = React.useMemo(() => {
    if (!filterProvincia || !filterCanton) return [];
    const distritos = new Set<string>();
    clients.forEach(client => {
      if (client.provincia === filterProvincia && client.canton === filterCanton && client.distrito) distritos.add(client.distrito);
    });
    return Array.from(distritos).sort();
  }, [clients, filterProvincia, filterCanton]);

  const fetchRouteGroupsForWaitlist = useCallback(async () => {
    try {
      console.log('DEBUG: fetchRouteGroupsForWaitlist started');
      const routeGroupsRef = collection(db, 'routeGroups');
      const querySnapshot = await getDocs(routeGroupsRef);
      console.log('DEBUG: fetchRouteGroupsForWaitlist querySnapshot docs count:', querySnapshot.docs.length);
      const groups = querySnapshot.docs.map(d => ({ id: d.id, ...d.data() } as RouteGroup));
      console.log('DEBUG: fetchRouteGroupsForWaitlist finished, groups count:', groups.length);
      setRouteGroupsForWaitlist(groups);
    } catch (e) {
      console.error('Error fetching route groups for waitlist:', e);
    }
  }, []);

  useEffect(() => {
    fetchRouteGroupsForWaitlist();
  }, [fetchRouteGroupsForWaitlist]);

  // Function to fetch future dates for a selected route group
  const fetchFutureRouteDates = async (routeGroupId: string) => {
    if (!routeGroupId) {
      setFutureRouteDates([]);
      return;
    }
    
    try {
      const routesUnionRef = collection(db, `routeGroups/${routeGroupId}/routesUnion`);
      const oneWeekAgo = startOfDay(new Date());
      oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
      const routesUnionQuery = query(
        routesUnionRef,
        where('date', '>=', oneWeekAgo),
        orderBy('date', 'asc')
      );
      const routesUnionSnapshot = await getDocs(routesUnionQuery);
      
      const futureDates = routesUnionSnapshot.docs.map(doc => {
        const data = doc.data();
        return data.date.toDate();
      });
      
      setFutureRouteDates(futureDates);
    } catch (e) {
      console.error('Error fetching future route dates:', e);
      setFutureRouteDates([]);
    }
  };

  // Load future dates when route selection changes
  useEffect(() => {
    if (selectedWaitlistRouteGroupId) {
      fetchFutureRouteDates(selectedWaitlistRouteGroupId);
    } else {
      setFutureRouteDates([]);
    }
  }, [selectedWaitlistRouteGroupId]);

  // Removed subTabValue useEffect to prevent opacity flicker on tab switch

  // Efecto para controlar cuando todos los datos del workflow están cargados
  // Workflow loading is now managed solely by refreshWorkflowData


  // Fetch client pending order for dialog
  const fetchClientPendingOrderForDialog = useCallback(async (clientId: string) => {
    setWaitlistOrderDataLoading(true);
    try {
      console.log('Fetching pending order for client:', clientId);
      const pendingRef = collection(db, 'pendingOrders');
      const q = query(pendingRef, where('clientId', '==', clientId));
      const snapshot = await getDocs(q);
      let found: Order | null = null;
      let foundId: string | null = null;
      let foundNote: string = '';

      snapshot.forEach((docSnap) => {
        const data = docSnap.data();
        console.log('Found pending order data:', data);
        if (data.orderData) {
          console.log('Found pending order data:', data.orderData);
          found = data.orderData as Order;
          foundId = docSnap.id;
          foundNote = data.orderNote || '';
        }
      });

      console.log('Setting clientPendingOrder:', found);
      setClientPendingOrder(found);
      setClientPendingOrderDocId(foundId);
      setWaitlistOrderNote(foundNote); // Load existing order note into text input
      // Also update the input value directly
      if (notesInputRef.current) {
        notesInputRef.current.value = foundNote;
      }
    } catch (e) {
      console.error('Error fetching pending order:', e);
      setClientPendingOrder(null);
      setClientPendingOrderDocId(null);
      setWaitlistOrderNote('');
      // Also clear the input value
      if (notesInputRef.current) {
        notesInputRef.current.value = '';
      }
    } finally {
      setWaitlistOrderDataLoading(false);
    }
  }, []);

  const handleWaitlistDialogOpen = useCallback((order: any) => {
    console.log('handleWaitlistDialogOpen called in CustomerTracking with order:', order);

    let clientId = order.clientId;
    let orderData = order.order || null;
    let orderNote = order.orderNote || '';
    let clientName = order.clientName || 'Cliente no encontrado';
    let clientData = order.order || {};
    let routeGroupId = '';
    let orderId = order.id || null;

    // Manejar Pedidos Reprogramados
    if (order.routeRreprogrammed) {
      clientId = order.routeRreprogrammed.clientId;
      orderData = order.routeRreprogrammed.order || null;
      orderNote = order.routeRreprogrammed.order?.orderNote || '';
      routeGroupId = order.destinyReprogrammedRouteGroupId || order.routeRreprogrammed?.destinyReprogrammedRouteGroupId || '';
      orderId = order.id || order.routeRreprogrammed?.id || null;
      setSelectedWaitlistSource('reprogrammed');
      
      // Guardar info de la ruta original para poder eliminar el pedido de ahí al guardar
      setOriginalReprogrammedRoute({
        groupId: order.originRouteGroupId || order.routeRreprogrammed?.originRouteGroupId || '',
        unionId: order.originRouteUnionId || order.routeRreprogrammed?.originRouteUnionId || '',
        routeId: order.id || order.routeRreprogrammed?.id || ''
      });

      // Sincronizar fecha de la ruta trabajada/reprogramada
      const reprogrammedDate = order.destinyReprogrammedDate || order.routeRreprogrammed?.destinyReprogrammedDate;
      if (reprogrammedDate) {
        const dateObj = reprogrammedDate instanceof Timestamp ? reprogrammedDate.toDate() : new Date(reprogrammedDate);
        setSelectedWaitlistDate(dateObj);
      }
      
      const foundClient = clients.find(c => c.id === clientId);
      if (foundClient) {
        clientName = foundClient.name;
        clientData = { ...foundClient, ...orderData };
      } else {
        clientData = { ...orderData };
      }
    } else {
      setOriginalReprogrammedRoute(null);
      setSelectedWaitlistSource('pending');
    }

    const selectedWaitlistClient = {
      type: 'public' as const,
      data: {
        id: clientId,
        name: clientName,
        phoneNumber: clientData.phoneNumber || '',
        provincia: clientData.provincia || '',
        canton: clientData.canton || '',
        senas: clientData.senas || '',
        nota: clientData.nota || '',
        ...clientData
      }
    };

    setSelectedWaitlistClient(selectedWaitlistClient);
    setClientPendingOrder(orderData);
    setWaitlistOrderNote(orderNote);
    setSelectedWaitlistRouteGroupId(routeGroupId);
    setSelectedWaitlistOrderId(orderId);
    fetchRouteGroupsForWaitlist();
    
    if (notesInputRef.current) {
      notesInputRef.current.value = orderNote;
    }

    if (!order.routeRreprogrammed && clientId && typeof fetchClientPendingOrderForDialog === 'function') {
       fetchClientPendingOrderForDialog(clientId);
    } else if (!order.routeRreprogrammed && clientId) {
       const fetchPending = async (id: string) => {
         try {
           const pendingRef = collection(db, 'pendingOrders');
           const q = query(pendingRef, where('clientId', '==', id));
           const snap = await getDocs(q);
           if (!snap.empty) {
             setClientPendingOrder({
               ...snap.docs[0].data(),
               id: snap.docs[0].id
             } as Order);
           }
         } catch (e) { console.error(e); }
       };
       fetchPending(clientId);
    }

    setWaitlistDialogOpen(true);
  }, [fetchClientPendingOrderForDialog, clients]);

  useEffect(() => {
    // Only reset data when dialog closes, data loading is now handled in button clicks
    if (!waitlistDialogOpen) {
      setWaitlistDataLoading(false);
      setClientPendingOrder(null);
      setClientPendingOrderDocId(null);
      setWaitlistOrderNote('');
      setSelectedWaitlistOrderId(null);
      if (notesInputRef.current) {
        notesInputRef.current.value = '';
      }
    }
  }, [waitlistDialogOpen]);

  const saveOrderWithoutRoute = useCallback(async (orderToSave: Order | null, targetClientId: string) => {
    console.log('=== saveOrderWithoutRoute INICIADO ===');
    console.log('Parámetros:', { orderToSave, targetClientId });
    try {
      setSavingRoute(true);

      if (!orderToSave && (!waitlistOrderNote || waitlistOrderNote.trim() === '')) {
        setNotification({ open: true, message: 'Debes crear un pedido o agregar notas', type: 'warning' });
        setSavingRoute(false);
        return;
      }

      // 0. If it's a reprogrammed order, remove it from its original route first
      if (originalReprogrammedRoute) {
        console.log('Eliminando pedido reprogramado de su ruta original...');
        const originalUnionRef = doc(db, 'routeGroups', originalReprogrammedRoute.groupId, 'routesUnion', originalReprogrammedRoute.unionId);
        const originalUnionSnap = await getDoc(originalUnionRef);
        if (originalUnionSnap.exists()) {
          const originalData = originalUnionSnap.data();
          const updatedRoutes = (originalData.routes || []).filter(
            (r: any) => r.id !== originalReprogrammedRoute.routeId
          );
          await updateDoc(originalUnionRef, { routes: updatedRoutes });
          console.log('Pedido reprogramado eliminado de la ruta original');
        }
      }

      const finalNote = notesInputRef.current?.value || waitlistOrderNote || '';
      
      if (selectedWaitlistSource === 'reprogrammed' && selectedWaitlistOrderId) {
        console.log('Actualizando nota en pedidoPreprogramado...');
        const reprogrammedRef = doc(db, 'pedidoPreprogramado', selectedWaitlistOrderId);
        
        // Update the note inside the nested routeRreprogrammed.order object
        await updateDoc(reprogrammedRef, {
          'routeRreprogrammed.order.orderNote': finalNote,
          updatedAt: new Date()
        });
        console.log('Pedido reprogramado actualizado exitosamente con nota:', finalNote);
      } else {
        // Standard pending order save
        const docId = selectedWaitlistOrderId || targetClientId;
        console.log('Guardando pedido pendiente con docId:', docId);
        const pendingDocRef = doc(db, 'pendingOrders', docId);
        
        await setDoc(pendingDocRef, {
          clientId: targetClientId,
          orderData: orderToSave || { items: [] },
          orderNote: finalNote,
          updatedAt: new Date(),
        }, { merge: true });
        console.log('Pedido guardado exitosamente sin ruta con nota:', finalNote);
      }

      setNotification({ open: true, message: 'Pedido guardado correctamente', type: 'success' });

      // Update local state to reflect the saved order
      setClientPendingOrder(orderToSave || { items: [] });
      setClientPendingOrderDocId(selectedWaitlistOrderId || targetClientId);
      
      // Close dialog and refresh data
      setWaitlistDialogOpen(false);
      refreshWorkflowData();

    } catch (e) {
      console.error('Error saving order without route:', e);
      setNotification({ open: true, message: 'Error al guardar el pedido', type: 'error' });
    } finally {
      setSavingRoute(false);
    }
  }, [waitlistOrderNote, refreshWorkflowData, originalReprogrammedRoute, selectedWaitlistOrderId, selectedWaitlistSource]);

  const moveToCompleted = useCallback(async (clientId: string, shouldReload: boolean = true) => {
    console.log('=== moveToCompleted INICIADO ===');
    try {
      setSavingRoute(true);

      let finalClientId = clientId;

      // Check if it's a regular client
      const regularClient = clients.find(c => c.id === clientId);

      if (!regularClient) {
        // Check if it's a public client and needs conversion
        const publicClient = publicClients.find(p => p.id === clientId);
        if (publicClient) {
          console.log('Convirtiendo PublicClient a Client antes de mover a completados...');
          const clientsRef = collection(db, 'clients');
          const newClient: Client = {
            name: publicClient.name,
            phoneNumber: publicClient.phoneNumber,
            email: publicClient.email,
            googleMapsLink: publicClient.googleMapsLink,
            wazeLink: publicClient.wazeLink,
            cedula_nacional: publicClient.cedula_nacional,
            second_phoneNumber: publicClient.second_phoneNumber,
            tipo_documento: publicClient.tipo_documento,
            tipo_client: publicClient.tipo_client,
            tipo_compostera: publicClient.tipo_compostera,
            tipo_entrega: publicClient.tipo_entrega,
            senas: publicClient.senas,
            nota: publicClient.nota,
            imageUrl: publicClient.imageUrl,
            provincia: publicClient.provincia,
            canton: publicClient.canton,
            distrito: publicClient.distrito,
            municipalidades: publicClient.municipalidades,
            cant_gato: publicClient.cant_gato,
            cant_perro_mini: publicClient.cant_perro_mini,
            cant_perro_pequeno: publicClient.cant_perro_pequeno,
            cant_perro_mediano: publicClient.cant_perro_mediano,
            cant_perro_grande: publicClient.cant_perro_grande,
            cant_perro_gigante: publicClient.cant_perro_gigante,
            codigo_referencia: publicClient.codigo_referencia,
            nota_admin: '',
            proceso: 'Completado',
          };
          const createdDoc = await addDoc(clientsRef, { ...newClient, createdAt: serverTimestamp(), fromPublicForm: true });
          finalClientId = createdDoc.id;

          // Set the workflow stage to completed for the new client
          await setDoc(doc(db, 'clients', finalClientId), {
            workflow_stage: 'completed',
            proceso: 'Completado',
            completed_at: Timestamp.now()
          }, { merge: true });
        } else {
          // If neither, just try to set it (might be a case where it's already converted but not in local state)
          await setDoc(doc(db, 'clients', clientId), {
            workflow_stage: 'completed',
            proceso: 'Completado',
            completed_at: Timestamp.now()
          }, { merge: true });
        }
      } else {
        // It's already a regular client
        await setDoc(doc(db, 'clients', finalClientId), {
          workflow_stage: 'completed',
          proceso: 'Completado',
          completed_at: Timestamp.now()
        }, { merge: true });
      }

      setMoveSuccessOpen({ message: 'El cliente ha sido movido a Completados exitosamente', reload: shouldReload });
    } catch (e) {
      console.error('Error moving to completed:', e);
      setNotification({ open: true, message: 'Error al mover a completados', type: 'error' });
    } finally {
      setSavingRoute(false);
    }
  }, [clients, publicClients]);

  const completeRouteOrder = useCallback(async () => {
    if (!selectedRouteOrderForDetails) return;
    setSavingRoute(true);

    try {
      const routeOrder = selectedRouteOrderForDetails;

      // Update route status to 'completed' in Firestore for all routesUnion docs with this client
      const routeGroupsRef = collection(db, 'routeGroups');
      const routeGroupsQuery = await getDocs(routeGroupsRef);
      let routeFound = false;
      for (const routeGroupDoc of routeGroupsQuery.docs) {
        const routesUnionRef = collection(db, `routeGroups/${routeGroupDoc.id}/routesUnion`);
        const routesUnionSnapshot = await getDocs(routesUnionRef);
        for (const routeUnionDoc of routesUnionSnapshot.docs) {
          const routeUnionData = routeUnionDoc.data();
          const routes = routeUnionData.routes || [];
          let changed = false;
          routes.forEach((r: any) => {
            if (r.clientId === routeOrder.clientId) {
              r.status = 'completed';
              changed = true;
            }
          });
          if (changed) {
            await setDoc(doc(db, `routeGroups/${routeGroupDoc.id}/routesUnion`, routeUnionDoc.id), {
              ...routeUnionData,
              routes: routes
            }, { merge: true });
            routeFound = true;
          }
        }
      }
      if (!routeFound) {
        console.warn('Route not found in Firestore for status update, client was still updated');
      }

      // Delete any pending orders for this client so it doesn't reappear in col 1 after reload
      try {
        const pendingRef = collection(db, 'pendingOrders');
        const q = query(pendingRef, where('clientId', '==', routeOrder.clientId));
        const pendingSnapshot = await getDocs(q);
        await Promise.all(pendingSnapshot.docs.map(docSnap => deleteDoc(doc(db, 'pendingOrders', docSnap.id))));
      } catch (e) {
        console.warn('Error cleaning up pending orders during completion:', e);
      }

      await moveToCompleted(routeOrder.clientId, false);

      // Clean up local bypass states so the route doesn't reappear in column 2
      if (routeOrder.id) {
        setReadyForProcessRouteIds(prev => {
          const next = new Set(prev);
          next.delete(routeOrder.id!);
          return next;
        });
      }
      if (routeOrder.clientId) {
        setReadyForProcessIds(prev => {
          const next = new Set(prev);
          next.delete(routeOrder.clientId!);
          return next;
        });
        setRemovedWaitlistClientIds(prev => {
          const next = new Set(prev);
          next.add(routeOrder.clientId!);
          return next;
        });
      }

      await refreshWorkflowData(true);
      setRouteOrderDetailsDialogOpen(false);
      setMoveSuccessOpen({ message: 'El pedido ha sido movido a Completados exitosamente', reload: true });
    } catch (error) {
      console.error('Error moviendo el pedido a completados:', error);
      setNotification({ open: true, message: 'Error al mover el pedido a completados', type: 'error' });
    } finally {
      setSavingRoute(false);
    }
  }, [selectedRouteOrderForDetails, moveToCompleted, refreshWorkflowData]);

  const assignOrderToRouteGroup = async (orderToAssign: Order | null, targetClientId: string, routeGroupId: string, date: Date) => {
    console.log('=== assignOrderToRouteGroup INICIADO ===');
    console.log('Parámetros:', { orderToAssign, clientId: targetClientId, routeGroupId, date });
    try {
      // Mostrar loading al iniciar
      console.log('ACTIVANDO loading...');
      setSavingRoute(true);
      console.log('Loading activado');
      
      // If no order exists, show error message
      if (!orderToAssign) {
        console.log('ERROR: No hay orderToAssign');
        setNotification({ open: true, message: 'Debes crear un pedido antes de asignar a la ruta', type: 'warning' });
        setSavingRoute(false);
        return;
      }

      console.log('PASO 1: Buscando ruta existente para la fecha...');
      // Find the existing route for the selected date
      const routesUnionRef = collection(db, `routeGroups/${routeGroupId}/routesUnion`);
      const startOfDayDate = startOfDay(date);
      const endOfDayDate = endOfDay(date);
      
      console.log('PASO 2: Creando query...');
      const routesUnionQuery = query(
        routesUnionRef,
        where('date', '>=', startOfDayDate),
        where('date', '<=', endOfDayDate)
      );
      
      console.log('PASO 3: Ejecutando query...');
      const routesUnionSnapshot = await getDocs(routesUnionQuery);
      console.log('PASO 4: Query ejecutado, docs encontrados:', routesUnionSnapshot.docs.length);
      
      if (routesUnionSnapshot.empty) {
        console.log('ERROR: No existe ruta para la fecha');
        setNotification({ open: true, message: 'No existe una ruta para la fecha seleccionada', type: 'error' });
        setSavingRoute(false);
        return;
      }

      // Find the route document for the selected date
      console.log('PASO 5: Procesando documento de ruta...');
      const routeDoc = routesUnionSnapshot.docs[0];
      const routeData = routeDoc.data();
      const existingRoutes = routeData.routes || [];
      console.log('PASO 6: Rutas existentes:', existingRoutes.length);

      // Check if client is already in this route
      console.log('PASO 7: Verificando si cliente ya está en ruta...');
      const clientAlreadyInRoute = existingRoutes.some((route: any) => route.clientId === targetClientId);
      if (clientAlreadyInRoute) {
        console.log('ERROR: Cliente ya está en la ruta');
        // Mostrar popup más visible
        window.alert('⚠️ Este cliente ya está asignado a esta ruta. No se puede agregar nuevamente.');
        setNotification({ open: true, message: 'El cliente ya está asignado a esta ruta', type: 'warning' });
        setSavingRoute(false);
        return;
      }

      console.log('PASO 8: Creando nueva ruta para el cliente...');
      console.log('DEBUG - clientId:', targetClientId);
      console.log('DEBUG - clients.length:', clients.length);
      console.log('DEBUG - publicClients.length:', publicClients.length);
      console.log('DEBUG - selectedWaitlistClient:', selectedWaitlistClient);
      
      // Get complete client data from the appropriate source
      let completeClientData: any = {};
      
      // First try to get from regular clients
      const regularClient = clients.find(c => c.id === targetClientId);
      console.log('DEBUG - regularClient encontrado:', regularClient);
      if (regularClient) {
        completeClientData = {
          name: regularClient.name || '',
          phone: regularClient.phoneNumber || '',
          email: regularClient.email || '',
          address: `${regularClient.provincia || ''}, ${regularClient.canton || ''}, ${regularClient.distrito || ''}`,
          provincia: regularClient.provincia || '',
          canton: regularClient.canton || '',
          distrito: regularClient.distrito || '',
          senas: regularClient.senas || '',
          nota: regularClient.nota || '',
          codigo_referencia: regularClient.codigo_referencia || '',
          cedula_nacional: regularClient.cedula_nacional || '',
          tipo_documento: regularClient.tipo_documento || '',
          tipo_client: regularClient.tipo_client || '',
          tipo_compostera: regularClient.tipo_compostera || '',
          tipo_entrega: regularClient.tipo_entrega || '',
          cant_gato: regularClient.cant_gato || 0,
          cant_perro_mini: regularClient.cant_perro_mini || 0,
          cant_perro_pequeno: regularClient.cant_perro_pequeno || 0,
          cant_perro_mediano: regularClient.cant_perro_mediano || 0,
          cant_perro_grande: regularClient.cant_perro_grande || 0,
          cant_perro_gigante: regularClient.cant_perro_gigante || 0,
          googleMapsLink: regularClient.googleMapsLink || '',
          wazeLink: regularClient.wazeLink || '',
          imageUrl: regularClient.imageUrl || ''
        };
        console.log('Cliente encontrado en clients:', completeClientData);
      } else {
          // Try to get from public clients
          const publicClient = publicClients.find(p => p.id === targetClientId);
          console.log('DEBUG - publicClient encontrado:', publicClient);
        if (publicClient) {
          completeClientData = {
            name: publicClient.name || '',
            phone: publicClient.phoneNumber || '',
            email: publicClient.email || '',
            address: `${publicClient.provincia || ''}, ${publicClient.canton || ''}, ${publicClient.distrito || ''}`,
            provincia: publicClient.provincia || '',
            canton: publicClient.canton || '',
            distrito: publicClient.distrito || '',
            senas: publicClient.senas || '',
            nota: publicClient.nota || '',
            codigo_referencia: publicClient.codigo_referencia || '',
            cedula_nacional: publicClient.cedula_nacional || '',
            tipo_documento: publicClient.tipo_documento || '',
            tipo_client: publicClient.tipo_client || '',
            tipo_compostera: publicClient.tipo_compostera || '',
            tipo_entrega: publicClient.tipo_entrega || '',
            cant_gato: publicClient.cant_gato || 0,
            cant_perro_mini: publicClient.cant_perro_mini || 0,
            cant_perro_pequeno: publicClient.cant_perro_pequeno || 0,
            cant_perro_mediano: publicClient.cant_perro_mediano || 0,
            cant_perro_grande: publicClient.cant_perro_grande || 0,
            cant_perro_gigante: publicClient.cant_perro_gigante || 0,
            googleMapsLink: publicClient.googleMapsLink || '',
            wazeLink: publicClient.wazeLink || '',
            imageUrl: publicClient.imageUrl || ''
          };
          console.log('Cliente encontrado en publicClients:', completeClientData);
        } else {
          console.error('No se encontró el cliente en ninguna lista:', targetClientId);
          console.log('DEBUG - Usando fallback a selectedWaitlistClient');
          // Fallback to selectedWaitlistClient data - use the complete data
          completeClientData = selectedWaitlistClient?.data as any || {};
          console.log('DEBUG - Fallback data:', completeClientData);
        }
      }
      
      // Update client status
      // Always use the selected waitlist client - don't search for other existing clients
      let existingId: string | null = null;
      
      const targetClient = clients.find(c => (c.id || '') === targetClientId);
      if (targetClient?.id) {
        // It's a regular client, just update status - leave proceso empty for new route assignments
        // await setDoc(doc(db, 'clients', targetClient.id), { proceso: 'Inscripción pagada' }, { merge: true });
        existingId = targetClient.id; // Use the existing client ID
        setForceCompletedIds(prev => {
          const newSet = new Set(prev);
          if (targetClient.id) {
            newSet.add(targetClient.id);
          }
          return newSet;
        });
      } else {
        // It's a public client - convert to regular client using the selected waitlist client data
        const targetPublic = publicClients.find(p => (p.id || '') === targetClientId);
        if (targetPublic) {
          // Create new client from the selected public client - don't search for duplicates
          const clientsRef = collection(db, 'clients');
          const newClient: Client = {
            name: targetPublic.name,
            phoneNumber: targetPublic.phoneNumber,
            email: targetPublic.email,
            googleMapsLink: targetPublic.googleMapsLink,
            wazeLink: targetPublic.wazeLink,
            cedula_nacional: targetPublic.cedula_nacional,
            second_phoneNumber: targetPublic.second_phoneNumber,
            tipo_documento: targetPublic.tipo_documento,
            tipo_client: targetPublic.tipo_client,
            tipo_compostera: targetPublic.tipo_compostera,
            tipo_entrega: targetPublic.tipo_entrega,
            senas: targetPublic.senas,
            nota: targetPublic.nota,
            imageUrl: targetPublic.imageUrl,
            provincia: targetPublic.provincia,
            canton: targetPublic.canton,
            distrito: targetPublic.distrito,
            municipalidades: targetPublic.municipalidades,
            cant_gato: targetPublic.cant_gato,
            cant_perro_mini: targetPublic.cant_perro_mini,
            cant_perro_pequeno: targetPublic.cant_perro_pequeno,
            cant_perro_mediano: targetPublic.cant_perro_mediano,
            cant_perro_grande: targetPublic.cant_perro_grande,
            cant_perro_gigante: targetPublic.cant_perro_gigante,
            codigo_referencia: targetPublic.codigo_referencia,
            nota_admin: '',
            proceso: '', // Leave proceso empty for new route assignments
          };
          const createdDoc = await addDoc(clientsRef, { ...newClient, createdAt: serverTimestamp(), fromPublicForm: true });
          existingId = createdDoc.id;
          
          // Update the new client status
          // await setDoc(doc(db, 'clients', existingId), { proceso: 'Inscripción pagada' }, { merge: true });
          setForceCompletedIds(prev => {
            const newSet = new Set(prev);
            if (existingId) {
              newSet.add(existingId);
            }
            return newSet;
          });
        }
      }

      // Use the new clientId if a new client was created, otherwise use the original
      const finalClientId = existingId || targetClientId;
      
      // Update client status to 'process' to move from 'waitlist' to 'Proceso'
      if (finalClientId) {
        console.log('Moviendo cliente a etapa de proceso...');
        await setDoc(doc(db, 'clients', finalClientId), { workflow_stage: 'process' }, { merge: true });
      }

      // Clean order object to remove any clientId inside it
      const { clientId: orderClientId, ...orderWithoutClientId } = (orderToAssign as any) || {};
      const cleanedOrderForRoute = orderToAssign ? orderWithoutClientId : null;
      
      // Add new order to existing route with standard structure
      const newRoute = {
        id: `route-${routeDoc.id}-${finalClientId}-${Date.now()}`, // Add unique ID
        clientId: finalClientId, // Use the final clientId (existingId if new client was created)
        status: 'pending',
        order: cleanedOrderForRoute, // Use cleaned order without clientId
        // Include complete client information
        clientData: completeClientData,
        // Also save route notes directly in route for compatibility
        note_admin: orderToAssign?.routeNotes?.note_admin || '',
        note_driver: orderToAssign?.routeNotes?.note_driver || '',
        // Save the waitlist order note
        orderNote: waitlistOrderNote || ''
      };
      console.log('Nueva ruta creada con información completa del cliente:', newRoute);

      console.log('PASO 9: Actualizando lista de rutas...');
      const updatedRoutes = [...existingRoutes, newRoute];
      console.log('Rutas actualizadas:', updatedRoutes.length);

      console.log('PASO 10: Guardando en Firestore...');
      console.log('DEBUG - Datos a guardar en Firestore:', {
        ...routeData,
        routes: updatedRoutes
      });
      // Update the route document
      await setDoc(doc(db, `routeGroups/${routeGroupId}/routesUnion`, routeDoc.id), {
        ...routeData,
        routes: updatedRoutes
      }, { merge: true });
      console.log('PASO 11: Documento actualizado en Firestore');

      console.log('PASO 12: Eliminando pedido pendiente si existe...');
      // Delete from pending orders if exists
      const docIdToDelete = selectedWaitlistOrderId || clientPendingOrderDocId;
      if (docIdToDelete) {
        if (selectedWaitlistSource === 'reprogrammed') {
          console.log('Eliminando de pedidoPreprogramado:', docIdToDelete);
          await deleteDoc(doc(db, 'pedidoPreprogramado', docIdToDelete));
        } else {
          console.log('Eliminando de pendingOrders:', docIdToDelete);
          await deleteDoc(doc(db, 'pendingOrders', docIdToDelete));
        }
        console.log('PASO 13: Pedido eliminado:', docIdToDelete);
      } else {
        console.log('No había pedido pendiente para eliminar');
      }

      // Formatear la fecha para mostrarla en la notificación
      const formattedDate = date.toLocaleDateString('es-ES', { 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric' 
      });

      const routeGroupInfo = routeGroupsForWaitlist.find(rg => rg.id === routeGroupId);
      
      console.log('DEBUG - completeClientData antes de crear newOrderTableItem:', completeClientData);
      console.log('DEBUG - clientId original:', targetClientId);
      console.log('DEBUG - existingId (nuevo cliente):', existingId);
      
      // Clean the order object to remove any clientId inside it
      const { clientId: orderClientId2, ...orderWithoutClientId2 } = (orderToAssign as any) || {};
      const cleanedOrder = orderToAssign ? orderWithoutClientId2 : {
        id: '',
        items: [],
        routeGroupId: '',
        routeId: ''
      };
      
      const newOrderTableItem: OrderTableItem = {
        id: newRoute.id,
        clientId: finalClientId, // Always use the finalClientId at the top level
        clientName: completeClientData?.name || 'Cliente',
        clientPhone: completeClientData?.phone || '',
        createdAt: date,
        routeName: routeGroupInfo?.name || 'Ruta',
        status: 'pending',
        deliveryType: 'ollinItems',
        order: cleanedOrder, // Provide default Order object when null
        routeGroup: routeGroupInfo || {} as RouteGroup,
        clientData: completeClientData, // Include the complete client data
        orderNote: notesInputRef.current?.value || '' // Include the waitlist order note
      };
      
      console.log('DEBUG - newOrderTableItem creado:', newOrderTableItem);

      setMoveSuccessOpen({ 
        message: `Pedido guardado exitosamente en la ruta del ${formattedDate}`, 
        reload: true 
      });
      
      const originalSelectedId = (selectedWaitlistClient?.data as any)?.id || '';
      const removedIds = new Set<string>();
      if (originalSelectedId) removedIds.add(originalSelectedId);
      if (targetClientId) removedIds.add(targetClientId);
      if (finalClientId) removedIds.add(finalClientId);
      if (removedIds.size > 0) {
        setRemovedWaitlistClientIds(prev => {
          const newSet = new Set(prev);
          removedIds.forEach(id => newSet.add(id));
          return newSet;
        });
      }

      // Clear the waitlist order note and close dialog
      setWaitlistOrderNote('');
      setWaitlistDialogOpen(false);
      setSelectedWaitlistClient(null);
      setClientPendingOrder(null);
      setSelectedWaitlistRouteGroupId('');
      setSelectedWaitlistDate(null);
      setClientPendingOrderDocId('');
      if (finalClientId) {
        setReadyForProcessIds(prev => new Set([...Array.from(prev), finalClientId]));
      }
      
      // Update the public client to remove from waitlist if it was a public client
      if (selectedWaitlistClient?.type === 'public') {
        const publicClient = selectedWaitlistClient.data as PublicClient;
        const updatedPublicClient: PublicClient = {
          ...publicClient,
          workflow_stage: 'converted' as const,
          status_create_public_client: 'completed' as const
        };
        await onUpdatePublicClient(updatedPublicClient);
        console.log('Public client actualizado a converted:', publicClient.id);
      }
      
      // Refresh workflow state and remove the card from the waitlist immediately
      setWorkflowRefreshKey(prev => prev + 1);
      await refreshWorkflowData(true);
      console.log('PASO 14: assignOrderToRouteGroup COMPLETADO');
      
    } catch (e) {
      console.error('Error al asignar pedido a ruta existente:', e);
      setNotification({ open: true, message: 'Error al asignar pedido a ruta', type: 'error' });
    } finally {
      setSavingRoute(false);
    }
  };

  useEffect(() => {
    const fetchInventoryItems = async () => {
      try {
        const inventoryRef = collection(db, 'inventoryItems');
        const inventorySnapshot = await getDocs(inventoryRef);
        const items: InventoryItem[] = [];
        inventorySnapshot.forEach((doc) => {
          items.push({ id: doc.id, ...doc.data() } as InventoryItem);
        });
        setInventoryItems(items);
      } catch (error) {
        console.error('Error fetching inventory:', error);
      }
    };
    fetchInventoryItems();
  }, []);

  // Limpiar estados cuando se cierra el diálogo de lista de espera
  useEffect(() => {
    if (!waitlistDialogOpen) {
      console.log('Diálogo cerrado, limpiando estados');
      setSelectedWaitlistClient(null);
      setClientPendingOrder(null);
      setSelectedWaitlistRouteGroupId('');
      setSelectedWaitlistDate(null);
      setClientPendingOrderDocId('');
    }
  }, [waitlistDialogOpen]);

  const fetchClientData = async (client: Client) => {
    if (!startDate || !endDate) return;
    setLoading(true);
    try {
      const routeGroupsRef = collection(db, 'routeGroups');
      const querySnapshot = await getDocs(routeGroupsRef);
      
      let fetchedOrders: OrderTableItem[] = [];
      
      const startDateTime = startOfDay(startDate);
      const endDateTime = endOfDay(endDate);

      for (const docSnapshot of querySnapshot.docs) {
        const routeGroup = { id: docSnapshot.id, ...docSnapshot.data() } as RouteGroup;
        const routesUnionRef = collection(db, `routeGroups/${docSnapshot.id}/routesUnion`);
        const routesUnionQuery = query(
          routesUnionRef,
          where('date', '>=', startDateTime),
          where('date', '<=', endDateTime)
        );
        const routesUnionSnapshot = await getDocs(routesUnionQuery);

        for (const routeUnionDoc of routesUnionSnapshot.docs) {
          const routeUnionData = routeUnionDoc.data();
          const routes = routeUnionData.routes || [];

          for (const route of routes) {
            if (route.clientId === client.id) {
              const orderDate = routeUnionData.date.toDate();
              fetchedOrders.push({
                id: `${docSnapshot.id}-${route.id}-${routeUnionDoc.id}-${orderDate.getTime()}`,
                clientId: route.clientId,
                clientName: client.name,
                clientPhone: client.phoneNumber,
                createdAt: orderDate,
                routeName: routeGroup.name,
                status: route.status,
                deliveryType: 'ollinItems',
                order: route.order as Order,
                routeGroup: routeGroup
              });
            }
          }
        }
      }
      
      fetchedOrders.sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime());
      setClientRoutes(fetchedOrders);
    } catch (error) {
      console.error('Error fetching client data:', error);
      toast.error('Error al cargar las rutas del cliente');
    } finally {
      setLoading(false);
    }
  };

  const handleClientClick = (client: Client) => {
    setSelectedClient(client);
    fetchClientData(client);
    if (client.id) {
      fetchGeneralTabPendingOrders(client.id);
    }
  };

  const fetchGeneralTabPendingOrders = async (clientId: string) => {
    try {
      const pendingRef = collection(db, 'pendingOrders');
      const q = query(pendingRef, where('clientId', '==', clientId));
      const snapshot = await getDocs(q);
      const orders: OrderTableItem[] = [];
      snapshot.forEach((doc) => {
        const data = doc.data();
        orders.push({
          id: doc.id,
          clientId: data.clientId,
          clientName: data.clientName,
          clientPhone: data.clientPhone,
          createdAt: data.pendingDate?.toDate() || new Date(),
          routeName: data.routeName || 'Sin asignar',
          status: 'pending',
          deliveryType: data.deliveryType || 'ollinItems',
          order: data.order as Order,
          routeGroup: data.routeGroup
        });
      });
      setGeneralTabPendingOrders(orders);
    } catch (error) {
      console.error('Error fetching general tab pending orders:', error);
    }
  };

  const handleGeneralTabDragStart = (order: OrderTableItem, source: 'routes' | 'pending') => {
    setGeneralTabDraggedOrder(order);
    setGeneralTabDragSource(source);
  };

  const handleGeneralTabDragEnd = () => {
    setGeneralTabDraggedOrder(null);
    setGeneralTabDragSource(null);
  };

  const moveToPendingInGeneralTab = async (order: OrderTableItem) => {
    try {
      await setDoc(doc(db, 'pendingOrders', order.id), {
        clientId: order.clientId,
        clientName: order.clientName,
        clientPhone: order.clientPhone,
        order: order.order,
        deliveryType: order.deliveryType,
        routeGroupId: order.routeGroup?.id,
        routeName: order.routeName,
        originalRouteDate: order.createdAt,
        pendingDate: new Date(),
        status: 'pending'
      });

      setClientRoutes(prev => prev.filter(r => r.id !== order.id));
      
      setGeneralTabPendingOrders(prev => [...prev, { ...order, status: 'pending' }]);
      
      setNotification({
        open: true,
        message: `Pedido movido a pendientes exitosamente`,
        type: 'success'
      });
    } catch (error) {
      console.error('Error moving to pending:', error);
      setNotification({
        open: true,
        message: 'Error al mover el pedido a pendientes',
        type: 'error'
      });
    }
  };

  const moveFromPendingToRoute = async (order: OrderTableItem) => {
    if (!selectedClient || !order.routeGroup?.id) {
      setNotification({
        open: true,
        message: 'No se puede reasignar el pedido sin una ruta válida',
        type: 'error'
      });
      return;
    }

    try {
      const routeGroupsRef = collection(db, 'routeGroups');
      const querySnapshot = await getDocs(routeGroupsRef);
      
      for (const docSnapshot of querySnapshot.docs) {
        if (docSnapshot.id === order.routeGroup.id) {
          const routesUnionRef = collection(db, `routeGroups/${docSnapshot.id}/routesUnion`);
          const routesUnionSnapshot = await getDocs(routesUnionRef);

          for (const routeUnionDoc of routesUnionSnapshot.docs) {
            const routeUnionData = routeUnionDoc.data() as any;
            const routes = routeUnionData.routes || [];
            
            const routeIndex = routes.findIndex((r: any) => r.clientId === order.clientId);
            
            if (routeIndex !== -1) {
              const updatedOrder = {
                ...routes[routeIndex].order,
                items: [...(routes[routeIndex].order?.items || []), ...order.order.items]
              };
              
              routes[routeIndex].order = updatedOrder;
              routes[routeIndex].status = 'pending';
              
              await setDoc(doc(db, `routeGroups/${docSnapshot.id}/routesUnion`, routeUnionDoc.id), {
                ...routeUnionData,
                routes: routes
              }, { merge: true });

              await deleteDoc(doc(db, 'pendingOrders', order.id));

              setGeneralTabPendingOrders(prev => prev.filter(o => o.id !== order.id));
              setClientRoutes(prev => [...prev, { ...order, status: 'pending' }]);
              
              setNotification({
                open: true,
                message: `Pedido reasignado a la ruta exitosamente`,
                type: 'success'
              });
              return;
            }
          }
        }
      }
      
      setNotification({
        open: true,
        message: 'No se encontró la ruta destino',
        type: 'error'
      });
    } catch (error) {
      console.error('Error moving from pending to route:', error);
      setNotification({
        open: true,
        message: 'Error al reasignar el pedido',
        type: 'error'
      });
    }
  };

  const filteredClients = clients.filter(c =>
    c.name?.toLowerCase().includes(searchText?.toLowerCase() || '') ||
    c.phoneNumber?.includes(searchText || '')
  );

  const nextOrder = clientRoutes.find(r => r.createdAt >= new Date());
  const deliveredOrders = clientRoutes.filter(r => r.status === 'delivered' || r.status === 'Entregado');

  // Funciones para validar el botón "Guardar Pedido"
  const isSaveButtonDisabled = () => {
    return !selectedWaitlistClient || 
           !clientPendingOrder || 
           !selectedWaitlistRouteGroupId || 
           !selectedWaitlistDate ||
           !clientPendingOrder.items || 
           clientPendingOrder.items.length === 0;
  };

  const getSaveButtonTooltip = () => {
    if (!selectedWaitlistClient) return 'Selecciona un cliente';
    if (!clientPendingOrder) return 'Crea un pedido primero';
    if (!clientPendingOrder.items || clientPendingOrder.items.length === 0) return 'Agrega al menos un producto al pedido';
    if (!selectedWaitlistRouteGroupId) return 'Selecciona una ruta';
    if (!selectedWaitlistDate) return 'Selecciona una fecha';
    return 'Guardar Pedido';
  };

  return (
    <Box>
    {!isMinimized && (
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs 
          value={subTabValue} 
          onChange={(e, newValue) => {
            setSubTabValue(newValue);
            if (newValue === 3 && newTabValue === 1) {
              refreshWorkflowData();
            }
          }}
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '1rem',
              color: '#555',
              '&.Mui-selected': {
                color: '#00b4d8',
              },
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#00b4d8',
            },
          }}
        >
          <Tab icon={<InfoIcon />} iconPosition="start" label="General" />
          <Tab icon={<LocalShippingIcon />} iconPosition="start" label="Rutas" />
          <Tab icon={<ShoppingCartIcon />} iconPosition="start" label="Pedidos" />
          <Tab icon={<TrendingUpIcon />} iconPosition="start" label="Flujo de Trabajo" />
        </Tabs>
      </Box>
    )}

      {subTabValue === 0 && !isMinimized && (
        <Box>
          <Grid container spacing={3}>
        {/* Left Side: Client Table */}
        <Grid item xs={12} md={selectedClient ? 4 : 12}>
          <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
            <Typography variant="h6" sx={{ color: 'rgb(0, 180, 216)', mb: 2, fontWeight: 'bold' }}>
              Seleccionar Cliente
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Buscar cliente..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              InputProps={{
                startAdornment: <SearchIcon sx={{ color: 'rgb(0, 180, 216)', mr: 1 }} />
              }}
              sx={{ mb: 2 }}
            />
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ backgroundColor: '#87CEEB', color: 'white', fontWeight: 'bold' }}>Nombre</TableCell>
                    <TableCell sx={{ backgroundColor: '#87CEEB', color: 'white', fontWeight: 'bold' }}>Teléfono</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredClients.map((client) => (
                    <TableRow 
                      key={client.id} 
                      hover 
                      onClick={() => handleClientClick(client)}
                      selected={selectedClient?.id === client.id}
                      sx={{ cursor: 'pointer' }}
                    >
                      <TableCell>{client.name}</TableCell>
                      <TableCell>{client.phoneNumber}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>

        {/* Right Side: Trello Board for Selected Client */}
        {selectedClient && (
          <Grid item xs={12} md={8}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {/* Date Range Selectors */}
              <Paper elevation={3} sx={{ p: 2, borderRadius: 2, display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'center' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'rgb(0, 180, 216)' }}>Desde</Typography>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    dateFormat="dd/MM/yyyy"
                    locale={es}
                    customInput={<TextField size="small" variant="outlined" />}
                  />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'rgb(0, 180, 216)' }}>Hasta</Typography>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    dateFormat="dd/MM/yyyy"
                    locale={es}
                    customInput={<TextField size="small" variant="outlined" />}
                  />
                </Box>
                <Button 
                  variant="contained" 
                  onClick={() => fetchClientData(selectedClient)}
                  sx={{ backgroundColor: '#87CEEB', mt: 2 }}
                  startIcon={<RefreshIcon />}
                >
                  Actualizar
                </Button>
              </Paper>

              {/* Trello Board */}
              <Box sx={{ 
                display: 'flex', 
                gap: 2, 
                overflowX: 'auto', 
                pb: 2,
                minHeight: '500px',
                '&::-webkit-scrollbar': { height: '8px' },
                '&::-webkit-scrollbar-thumb': { backgroundColor: '#87CEEB', borderRadius: '4px' }
              }}>
                {/* Column 1: Info & Next Order */}
                <Box sx={{ minWidth: '300px', width: '300px' }}>
                  <Paper sx={{ p: 2, bgcolor: '#f4f5f7', height: '100%', borderRadius: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <InfoIcon color="primary" /> Info & Próximo Pedido
                    </Typography>
                    
                    <Card sx={{ mb: 2, borderRadius: 2 }}>
                      <CardContent>
                        <Typography variant="subtitle2" color="primary" gutterBottom>Cliente</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{selectedClient.name}</Typography>
                        <Typography variant="body2">{selectedClient.phoneNumber}</Typography>
                        <Typography variant="body2" color="textSecondary">{selectedClient.provincia}, {selectedClient.canton}</Typography>
                      </CardContent>
                    </Card>

                    {nextOrder ? (
                      <Card sx={{ mb: 2, borderRadius: 2, borderLeft: '5px solid #4caf50' }}>
                        <CardContent>
                          <Typography variant="subtitle2" sx={{ color: '#4caf50' }} gutterBottom>Próximo Pedido</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{format(nextOrder.createdAt, 'dd/MM/yyyy')}</Typography>
                          <Typography variant="body2">Ruta: {nextOrder.routeName}</Typography>
                          <Typography variant="body2" color="textSecondary">Estado: {nextOrder.status}</Typography>
                        </CardContent>
                      </Card>
                    ) : (
                      <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'textSecondary' }}>No hay pedidos programados</Typography>
                    )}

                    <Card sx={{ borderRadius: 2, bgcolor: '#e3f2fd' }}>
                      <CardContent>
                        <Typography variant="subtitle2" color="primary" gutterBottom>Resumen de Entregas</Typography>
                        <Typography variant="h4" sx={{ textAlign: 'center', fontWeight: 'bold' }}>{deliveredOrders.length}</Typography>
                        <Typography variant="body2" sx={{ textAlign: 'center' }}>Total Entregados</Typography>
                      </CardContent>
                    </Card>
                  </Paper>
                </Box>

                {/* Column 2.5: Pending Orders */}
                <Box sx={{ minWidth: '300px', width: '300px' }}>
                  <Paper sx={{ p: 2, bgcolor: '#fff3e0', height: '100%', borderRadius: 2, borderTop: '4px solid #f44336' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <PendingActionsIcon sx={{ color: '#f44336' }} /> Pedidos Pendientes
                    </Typography>
                    <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 2 }}>
                      Arrastra un pedido aquí para moverlo a pendientes
                    </Typography>
                    <Box 
                      sx={{ minHeight: '300px', maxHeight: '400px', overflowY: 'auto', bgcolor: 'rgba(244, 67, 54, 0.05)', borderRadius: 2, p: 1 }}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        if (generalTabDragSource === 'routes' && generalTabDraggedOrder) {
                          moveToPendingInGeneralTab(generalTabDraggedOrder);
                        }
                        handleGeneralTabDragEnd();
                      }}
                    >
                      {generalTabPendingOrders.length > 0 ? (
                        generalTabPendingOrders.map((order, index) => (
                          <Card 
                            key={index}
                            draggable
                            onDragStart={() => handleGeneralTabDragStart(order, 'pending')}
                            onDragEnd={handleGeneralTabDragEnd}
                            sx={{ 
                              mb: 2, 
                              borderRadius: 2,
                              cursor: 'grab',
                              borderLeft: '4px solid #f44336',
                              opacity: generalTabDragSource === 'pending' && generalTabDraggedOrder?.id === order.id ? 0.5 : 1,
                              transition: 'all 0.3s ease',
                              '&:hover': { 
                                transform: 'translateY(-2px)', 
                                boxShadow: 3
                              }
                            }}
                          >
                            <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{order.clientName}</Typography>
                                <Chip label="Pendiente" size="small" color="warning" sx={{ fontSize: '0.65rem' }} />
                              </Box>
                              <Typography variant="body2" color="textSecondary" sx={{ fontSize: '0.75rem' }}>
                                {format(order.createdAt, 'dd/MM/yyyy')}
                              </Typography>
                              <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 1 }}>
                                {order.order?.items?.slice(0, 2).map((item, idx) => {
                                  const invItem = inventoryItems.find(i => i.id === item.inventoryItemId);
                                  return (
                                    <Chip 
                                      key={idx}
                                      label={`${invItem?.name?.substring(0, 10) || item.inventoryItemId.substring(0, 6)} x${item.quantity}`} 
                                      size="small" 
                                      variant="outlined"
                                      sx={{ fontSize: '0.6rem', height: 20 }}
                                    />
                                  );
                                })}
                              </Box>
                              <Button 
                                size="small" 
                                fullWidth 
                                variant="outlined" 
                                sx={{ mt: 1, fontSize: '0.7rem', borderColor: '#4caf50', color: '#4caf50' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  moveFromPendingToRoute(order);
                                }}
                              >
                                Reasignar a Ruta
                              </Button>
                            </CardContent>
                          </Card>
                        ))
                      ) : (
                        <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'textSecondary', textAlign: 'center', py: 4 }}>
                          No hay pedidos pendientes
                        </Typography>
                      )}
                    </Box>
                  </Paper>
                </Box>

                {/* Column 3: Delivery History */}
                <Box sx={{ minWidth: '300px', width: '300px' }}>
                  <Paper sx={{ p: 2, bgcolor: '#f4f5f7', height: '100%', borderRadius: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <HistoryIcon color="primary" /> Historial de Entregas
                    </Typography>
                    {loading ? (
                      <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress /></Box>
                    ) : deliveredOrders.length > 0 ? (
                      deliveredOrders.map((route, index) => (
                        <Card 
                          key={index} 
                          sx={{ 
                            mb: 2, 
                            borderRadius: 2, 
                            borderLeft: '5px solid #2196f3',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            '&:hover': { 
                              transform: 'translateY(-4px)', 
                              boxShadow: 6
                            }
                          }}
                          onClick={() => {
                            setSelectedRoute(route);
                            setRouteDetailDialogOpen(true);
                          }}
                        >
                          <CardContent>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{route.routeName}</Typography>
                              <Chip label="Ver" size="small" color="success" variant="outlined" />
                            </Box>
                            <Typography variant="body2">{format(route.createdAt, 'dd/MM/yyyy')}</Typography>
                            <Typography variant="caption" color="success" sx={{ display: 'block', mt: 1 }}>
                              {route.order?.items?.length || 0} productos - Click para ver detalles
                            </Typography>
                          </CardContent>
                        </Card>
                      ))
                    ) : (
                      <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'textSecondary' }}>Sin historial de entregas</Typography>
                    )}
                  </Paper>
                </Box>
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>

      <Dialog
        open={routeDetailDialogOpen}
        onClose={() => {
          setRouteDetailDialogOpen(false);
          setSelectedRoute(null);
          setSelectedClient(null);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3 }
        }}
      >
        {selectedRoute && (
          <>
            <DialogTitle sx={{ 
              background: 'linear-gradient(135deg, #00b4d8 0%, #0077b6 100%)',
              color: 'white',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}>
              <LocalShippingIcon /> Detalles de la Ruta
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Paper elevation={0} sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
                    <Typography variant="subtitle2" color="primary" gutterBottom>Información de la Ruta</Typography>
                    <Divider sx={{ mb: 2 }} />
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" color="textSecondary">Nombre de Ruta:</Typography>
                        <Typography variant="body2" fontWeight="bold">{selectedRoute.routeName}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" color="textSecondary">Fecha:</Typography>
                        <Typography variant="body2" fontWeight="bold">{format(selectedRoute.createdAt, 'dd/MM/yyyy')}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" color="textSecondary">Estado:</Typography>
                        <Chip 
                          label={selectedRoute.status === 'completed' ? 'Completado' : selectedRoute.status === 'pending' ? 'Pendiente' : 'Cancelado'} 
                          color={selectedRoute.status === 'completed' ? 'success' : selectedRoute.status === 'pending' ? 'warning' : 'error'}
                          size="small"
                        />
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" color="textSecondary">Tipo de Entrega:</Typography>
                        <Typography variant="body2" fontWeight="bold">{selectedRoute.deliveryType === 'ollinItems' ? 'Productos Ollin' : 'Recolección'}</Typography>
                      </Box>
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Paper elevation={0} sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
                    <Typography variant="subtitle2" color="primary" gutterBottom>Información del Cliente</Typography>
                    <Divider sx={{ mb: 2 }} />
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" color="textSecondary">Nombre:</Typography>
                        <Typography variant="body2" fontWeight="bold">{selectedClient?.name}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" color="textSecondary">Teléfono:</Typography>
                        <Typography variant="body2" fontWeight="bold">{selectedClient?.phoneNumber}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" color="textSecondary">Provincia:</Typography>
                        <Typography variant="body2" fontWeight="bold">{selectedClient?.provincia}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" color="textSecondary">Cantón:</Typography>
                        <Typography variant="body2" fontWeight="bold">{selectedClient?.canton}</Typography>
                      </Box>
                    </Box>
                  </Paper>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ShoppingCartIcon color="primary" /> Pedidos de esta Ruta
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Card 
                        sx={{ 
                          borderRadius: 2, 
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          '&:hover': { 
                            transform: 'translateY(-4px)', 
                            boxShadow: 6 
                          }
                        }}
                        onClick={() => {
                          setSelectedOrder(selectedRoute.order);
                          setOrderDetailDialogOpen(true);
                        }}
                      >
                        <CardContent>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            <Typography variant="subtitle2" color="primary">Orden de Pedido</Typography>
                            <Chip label="Ver Detalle" size="small" color="primary" variant="outlined" />
                          </Box>
                          <Typography variant="body2" color="textSecondary">
                            {selectedRoute.order?.items?.length || 0} productos
                          </Typography>
                          <Box sx={{ mt: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {selectedRoute.order?.items?.slice(0, 3).map((item, idx) => {
                              const invItem = inventoryItems.find(i => i.id === item.inventoryItemId);
                              return (
                                <Paper
                                  key={idx}
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    px: 1,
                                    py: 0.5,
                                    borderRadius: 2,
                                    border: '1px solid #e0e0e0',
                                    bgcolor: '#fafafa'
                                  }}
                                >
                                  {invItem?.imageUrl ? (
                                    <Box sx={{ width: 24, height: 24, borderRadius: 1, overflow: 'hidden', flexShrink: 0 }}>
                                      <img src={invItem.imageUrl} alt={invItem.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </Box>
                                  ) : (
                                    <Box sx={{ width: 24, height: 24, borderRadius: 1, bgcolor: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                      <ShoppingCartIcon sx={{ fontSize: 14, color: '#999' }} />
                                    </Box>
                                  )}
                                  <Typography variant="caption">
                                    {invItem?.name || item.inventoryItemId} x{item.quantity}
                                  </Typography>
                                </Paper>
                              );
                            })}
                            {(selectedRoute.order?.items?.length || 0) > 3 && (
                              <Chip label={`+${(selectedRoute.order?.items?.length || 0) - 3} más`} size="small" />
                            )}
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button onClick={() => setRouteDetailDialogOpen(false)} variant="contained" sx={{ backgroundColor: '#00b4d8' }}>
                Cerrar
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      <Dialog
        open={orderDetailDialogOpen}
        onClose={() => setOrderDetailDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3 }
        }}
      >
        {selectedOrder && (
          <>
            <DialogTitle sx={{ 
              background: 'linear-gradient(135deg, #2ecc71 0%, #27ae60 100%)',
              color: 'white',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}>
              <AssignmentIndIcon /> Detalles del Pedido
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
              <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold', color: '#333' }}>
                Productos del Pedido
              </Typography>
              <Grid container spacing={2}>
                {selectedOrder.items?.map((item, idx) => {
                  const invItem = inventoryItems.find(i => i.id === item.inventoryItemId);
                  return (
                    <Grid item xs={12} key={idx}>
                      <Paper elevation={2} sx={{ 
                        p: 2, 
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        transition: 'all 0.2s ease',
                        '&:hover': { bgcolor: '#f5f5f5' }
                      }}>
                        <Box sx={{ 
                          width: 60, 
                          height: 60, 
                          borderRadius: 2, 
                          overflow: 'hidden',
                          flexShrink: 0
                        }}>
                          {invItem?.imageUrl ? (
                            <img 
                              src={invItem.imageUrl} 
                              alt={invItem.name}
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          ) : (
                            <Box sx={{ 
                              width: '100%', 
                              height: '100%', 
                              bgcolor: '#e0e0e0',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}>
                              <ShoppingCartIcon sx={{ color: '#999' }} />
                            </Box>
                          )}
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="subtitle1" fontWeight="bold">
                            {invItem?.name || item.inventoryItemId}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            {invItem?.category}
                          </Typography>
                          {invItem?.description && (
                            <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
                              {invItem.description}
                            </Typography>
                          )}
                        </Box>
                        <Box sx={{ textAlign: 'right' }}>
                          <Typography variant="h6" color="primary" fontWeight="bold">
                            x{item.quantity}
                          </Typography>
                          {invItem?.price && (
                            <Typography variant="body2" color="textSecondary">
                              ₡{(invItem.price * item.quantity).toLocaleString()}
                            </Typography>
                          )}
                        </Box>
                      </Paper>
                    </Grid>
                  );
                })}
              </Grid>
              <Divider sx={{ my: 3 }} />
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2 }}>
                <Typography variant="subtitle1" color="textSecondary">Total de Productos:</Typography>
                <Typography variant="h5" fontWeight="bold" color="primary">
                  {selectedOrder.items?.reduce((sum, item) => sum + item.quantity, 0)}
                </Typography>
              </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button onClick={() => setOrderDetailDialogOpen(false)} variant="contained" sx={{ backgroundColor: '#2ecc71' }}>
                Cerrar
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
      </Box>
      )}

      {subTabValue === 1 && !isMinimized && (
        <Box>
          <RutasBoardView
            clients={clients}
            inventoryItems={inventoryItems}
            routeBoardStartDate={routeBoardStartDate}
            routeBoardEndDate={routeBoardEndDate}
            setRouteBoardStartDate={setRouteBoardStartDate}
            setRouteBoardEndDate={setRouteBoardEndDate}
            allRoutes={allRoutes}
            setAllRoutes={setAllRoutes}
            loadingRoutes={loadingRoutes}
            setLoadingRoutes={setLoadingRoutes}
            routeOrdersDialogOpen={routeOrdersDialogOpen}
            setRouteOrdersDialogOpen={setRouteOrdersDialogOpen}
            selectedRouteOrders={selectedRouteOrders}
            setSelectedRouteOrders={setSelectedRouteOrders}
            orderHistoryDialogOpen={orderHistoryDialogOpen}
            setOrderHistoryDialogOpen={setOrderHistoryDialogOpen}
            historyClient={historyClient}
            setHistoryClient={setHistoryClient}
            historyStartDate={historyStartDate}
            historyEndDate={historyEndDate}
            setHistoryStartDate={setHistoryStartDate}
            setHistoryEndDate={setHistoryEndDate}
            clientOrderHistory={clientOrderHistory}
            setClientOrderHistory={setClientOrderHistory}
            loadingHistory={loadingHistory}
            setLoadingHistory={setLoadingHistory}
            viewOpen={viewOpen}
            setViewOpen={setViewOpen}
            waitlistClientIds={[...waitlistClientsPublicFilteredSearch.map(pc => pc.id || ''), ...waitlistClientsFromPendingFilteredSearch.map(c => c.id || '')]}
            handleDeleteClick={handleDeleteClick}
          />
        </Box>
      )}

      {subTabValue === 2 && !isMinimized && (
        <Box>
          <PedidosBoardView 
            clients={clients}
            inventoryItems={inventoryItems}
            pedidosBoardStartDate={pedidosBoardStartDate}
            pedidosBoardEndDate={pedidosBoardEndDate}
            setPedidosBoardStartDate={setPedidosBoardStartDate}
            setPedidosBoardEndDate={setPedidosBoardEndDate}
            allRoutes={allRoutes}
            setAllRoutes={setAllRoutes}
            pendingOrders={pendingOrders}
            setPendingOrders={setPendingOrders}
            loadingPendingOrders={loadingPendingOrders}
            setLoadingPendingOrders={setLoadingPendingOrders}
            notification={notification}
            setNotification={setNotification}
          />
        </Box>
      )}

      {subTabValue === 3 && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, overflowX: 'auto', pb: 2, minHeight: '520px', position: 'relative', width: '100%' }}>
          {workflowLoading && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: '#ffffff',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
                borderRadius: 2
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                <CircularProgress size={40} sx={{ color: '#00b4d8' }} />
                <Typography variant="body2" color="textSecondary">
                  Cargando flujo de trabajo...
                </Typography>
              </Box>
            </Box>
          )}
          <Paper sx={{ p: 2, borderRadius: 2 }}>
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'flex-end', 
              alignItems: 'center', 
              gap: 2, 
              mb: 2, 
              pb: 2, 
              borderBottom: '1px solid rgba(0, 180, 216, 0.2)' 
            }}>
              <Button
                startIcon={<AddIcon />}
                variant="contained"
                color="primary"
                onClick={() => {
                  setNewTabValue(0);
                  setCurrentClient({
                    name: '',
                    phoneNumber: '',
                    email: '',
                    googleMapsLink: '',
                    wazeLink: '',
                    cedula_nacional: '',
                    second_phoneNumber: '',
                    tipo_documento: 'Nacional',
                    tipo_client: 'Municipalidad',
                    tipo_compostera: 'Recolección',
                    tipo_entrega: 'Recolección',
                    senas: '',
                    nota: '',
                    imageUrl: '',
                    provincia: '',
                    canton: '',
                    distrito: '',
                    municipalidades: '',
                    cant_gato: '',
                    cant_perro_mini: '',
                    cant_perro_pequeno: '',
                    cant_perro_mediano: '',
                    cant_perro_grande: '',
                    cant_perro_gigante: '',
                    nota_admin: '',
                    codigo_referencia: ''
                  } as Client);
                  setOpen(true);
                }}
                sx={{
                  backgroundColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgb(135, 206, 235)',
                  },
                  fontWeight: 'bold',
                  fontSize: '0.85rem',
                  px: 2
                }}
              >
                Agregar Pedido
              </Button>
              <Tooltip title="Recargar datos">
                <IconButton
                  size="medium"
                  onClick={() => refreshWorkflowData(true)}
                  sx={{
                    color: '#00b4d8',
                    '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' }
                  }}
                >
                  <RefreshIcon />
                </IconButton>
              </Tooltip>
            </Box>

            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#00b4d8', mb: 0.5 }}>Desde</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <DatePicker
                    selected={workflowStartDate}
                    onChange={(date) => setWorkflowStartDate(date)}
                    dateFormat="dd/MM/yyyy"
                    locale={es}
                    customInput={<TextField size="small" variant="outlined" />}
                  />
                </Box>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#00b4d8' }}>Hasta</Typography>
                <DatePicker
                  selected={workflowEndDate}
                  onChange={(date) => setWorkflowEndDate(date)}
                  dateFormat="dd/MM/yyyy"
                  locale={es}
                  customInput={<TextField size="small" variant="outlined" />}
                />
              </Box>
              {/* <Button 
                variant="contained" 
                startIcon={<RefreshIcon />}
                onClick={() => {
                  if (workflowStartDate && workflowEndDate) {
                    const fetchRoutesForWorkflow = async () => {
                      setLoadingRoutes(true);
                      try {
                        const routeGroupsRef = collection(db, 'routeGroups');
                        const querySnapshot = await getDocs(routeGroupsRef);
                        
                        let fetchedOrders: OrderTableItem[] = [];
                        
                        const startDateTime = startOfDay(workflowStartDate);
                        const endDateTime = endOfDay(workflowEndDate);

                        for (const docSnapshot of querySnapshot.docs) {
                          const routeGroup = { id: docSnapshot.id, ...docSnapshot.data() } as RouteGroup;
                          const routesUnionRef = collection(db, `routeGroups/${docSnapshot.id}/routesUnion`);
                          const routesUnionQuery = query(
                            routesUnionRef,
                            where('date', '>=', startDateTime),
                            where('date', '<=', endDateTime)
                          );
                          const routesUnionSnapshot = await getDocs(routesUnionQuery);

                          for (const routeUnionDoc of routesUnionSnapshot.docs) {
                            const routeUnionData = routeUnionDoc.data();
                            const routes = routeUnionData.routes || [];

                            for (const route of routes) {
                              if (route.clientId) {
                                const client = clients.find(c => c.id === route.clientId);
                                if (client) {
                                  fetchedOrders.push({
                                    id: routeUnionDoc.id,
                                    clientId: route.clientId,
                                    clientName: client.name,
                                    clientPhone: client.phoneNumber,
                                    createdAt: routeUnionData.date?.toDate?.() || new Date(),
                                    routeName: routeGroup.name || 'Sin asignar',
                                    status: route.status,
                                    deliveryType: 'ollinItems',
                                    order: route.order as Order,
                                    routeGroup: routeGroup
                                  });
                                }
                              }
                            }
                          }
                        }
                        
                        fetchedOrders.sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime());
                        setAllRoutes(fetchedOrders);
                      } catch (error) {
                        console.error('Error fetching routes for workflow:', error);
                      } finally {
                        setLoadingRoutes(false);
                      }
                    };
                    fetchRoutesForWorkflow();
                  }
                }}
                sx={{ backgroundColor: '#00b4d8', mt: 2 }}
              >
                Aplicar
              </Button> */}
              
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 250 }}>
                <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#00b4d8' }}>Buscar</Typography>
                <TextField
                  size="small"
                  placeholder="Nombre, provincia, cantón, distrito..."
                  value={workflowSearchTerm}
                  onChange={(e) => setWorkflowSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: '#00b4d8' }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              
              {/* Filtros de ubicación */}
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 120 }}>
                  <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#00b4d8' }}>Provincia</Typography>
                  <Select
                    size="small"
                    value={filterProvincia}
                    onChange={(e) => {
                      setFilterProvincia(e.target.value);
                      setFilterCanton('');
                      setFilterDistrito('');
                    }}
                    displayEmpty
                  >
                    <MenuItem value="">Todas</MenuItem>
                    {getProvinciasOptions.map(provincia => (
                      <MenuItem key={provincia} value={provincia}>{provincia}</MenuItem>
                    ))}
                  </Select>
                </Box>
                
                <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 120 }}>
                  <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#00b4d8' }}>Cantón</Typography>
                  <Select
                    size="small"
                    value={filterCanton}
                    onChange={(e) => {
                      setFilterCanton(e.target.value);
                      setFilterDistrito('');
                    }}
                    disabled={!filterProvincia}
                    displayEmpty
                  >
                    <MenuItem value="">Todos</MenuItem>
                    {getCantonesOptions.map(canton => (
                      <MenuItem key={canton} value={canton}>{canton}</MenuItem>
                    ))}
                  </Select>
                </Box>
                
                <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 120 }}>
                  <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#00b4d8' }}>Distrito</Typography>
                  <Select
                    size="small"
                    value={filterDistrito}
                    onChange={(e) => setFilterDistrito(e.target.value)}
                    disabled={!filterCanton}
                    displayEmpty
                  >
                    <MenuItem value="">Todos</MenuItem>
                    {getDistritosOptions.map(distrito => (
                      <MenuItem key={distrito} value={distrito}>{distrito}</MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>
            </Box>
          </Paper>
          
          {/* Contenedor horizontal para las columnas del flujo de trabajo */}
          <Box key={`workflow-${workflowSearchTerm}-${workflowRefreshKey}`} sx={{ display: 'flex', gap: 2, minWidth: 'max-content', pb: 2 }}>
            {/* Columna 1: Revision de Datos */}
            <Box sx={{ width: 320, flexShrink: 0 }}>
              <Paper 
                sx={{ 
                  p: 2, 
                  borderTop: '4px solid #f57c00', 
                  borderRadius: 2
                }}
                onDragOver={(e) => {
                  console.log('onDragOver llamado en Paper columna 1');
                  e.preventDefault();
                  e.stopPropagation();
                  setDragOverColumn(1);
                }}
                onDragLeave={() => setDragOverColumn(null)}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>0. Revisión de Datos</Typography>
                  <IconButton 
                    size="small" 
                    onClick={(e) => setRevisionFiltersAnchorEl(e.currentTarget)}
                    sx={{ color: 'text.secondary' }}
                  >
                    <MoreVertIcon fontSize="small" />
                  </IconButton>
                  <Menu
                    anchorEl={revisionFiltersAnchorEl}
                    open={Boolean(revisionFiltersAnchorEl)}
                    onClose={() => setRevisionFiltersAnchorEl(null)}
                    PaperProps={{ sx: { width: 200, p: 1 } }}
                  >
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 1 }}>
                      <FormControlLabel
                        control={
                          <Switch 
                            checked={showAllRevisionCards} 
                            onChange={(e) => setShowAllRevisionCards(e.target.checked)} 
                          />
                        }
                        label={<Typography sx={{ fontSize: '0.8rem' }}>Mostrar todas las cartas</Typography>}
                      />
                    </Box>
                  </Menu>
                  <Chip label={revisionDataClientsFilteredSearch.length} size="small" sx={{ ml: 'auto' }} />
                </Box>
                                <Box
                  onDragOver={(e) => {
                    console.log('🎯 DRAG OVER - Columna 1');
                    e.preventDefault();
                    e.dataTransfer.dropEffect = 'move';
                    setDragOverColumn(1);
                  }}
                  onDrop={(e) => {
                    console.log('🎯 DROP - Columna 1');
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Obtener datos del drag
                    let dragData = null;
                    try {
                      const jsonData = e.dataTransfer.getData('application/json');
                      if (jsonData) {
                        dragData = JSON.parse(jsonData);
                      }
                    } catch (error) {
                      console.log('Error parsing drag data:', error);
                    }
                    
                    console.log('📦 Drag data:', dragData);
                    console.log('📦 workflowDragged actual:', workflowDragged);
                    
                    // Usar el dragData si está disponible, sino usar workflowDragged
                    const finalDragData = dragData || workflowDragged;
                    
                    if (finalDragData) {
                      console.log('✅ Usando datos:', finalDragData);
                      
                      // Llamar directamente a handleWorkflowDrop con los datos
                      // sin depender del estado workflowDragged
                      handleWorkflowDropWithData(finalDragData, 1);
                    } else {
                      console.log('❌ No hay datos de drag');
                    }
                    
                    setDragOverColumn(null);
                  }}
                  sx={{ 
                    mt: 2, 
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: 1,
                    minHeight: '200px',
                    border: '2px dashed transparent',
                    transition: 'all 0.2s ease',
                    ...(dragOverColumn === 1 && {
                      border: '2px dashed #1976d2',
                      backgroundColor: 'rgba(25, 118, 210, 0.04)'
                    })
                  }}
                >
                  {!workflowLoading && revisionDataClientsFilteredSearch.length === 0 && (
                    <Typography
                      variant="body2"
                      sx={{
                        fontStyle: 'italic',
                        color: 'textSecondary',
                        py: 4,
                        textAlign: 'center',
                        fontSize: '14px',
                        fontWeight: 'bold'
                      }}
                    >
                      Arrastra clientes aquí
                    </Typography>
                  )}
                  {!workflowLoading && revisionDataClientsFilteredSearch.length > 0 ? (
                    revisionDataClientsFilteredSearch
                      .filter(pc => showAllRevisionCards || 'status_create_public_client' in pc)
                      .map(pc => {
                        const hasIcon = 'status_create_public_client' in pc;
                        return (
                      <Card
                        key={pc.id}
                        draggable={true}
                        onDragStart={(e) => {
                          const dragData = { type: ((pc as any)._isPublic ? 'public' : 'client') as 'public' | 'client', id: pc.id || '', stage: 0 };
                          console.log('🎯 DRAG START - Cliente desde columna 1:', pc.id, pc.name);
                          setWorkflowDragged(dragData);
                          e.dataTransfer.effectAllowed = 'move';
                          e.dataTransfer.setData('application/json', JSON.stringify(dragData));
                        }}
                        onDragEnd={() => {
                          setWorkflowDragged(null);
                          setDragOverColumn(null);
                        }}
                        onDragOver={(e) => {
                          console.log('onDragOver sobre tarjeta existente en columna 1');
                          e.preventDefault();
                          e.stopPropagation();
                          setDragOverColumn(1);
                        }}
                        onDragLeave={(e) => {
                          // Solo limpiar si el drag está saliendo realmente del área
                          if (!e.currentTarget.contains(e.relatedTarget as Node)) {
                            setDragOverColumn(null);
                          }
                        }}
                        onDrop={(e) => {
                          console.log('onDrop sobre tarjeta existente en columna 1');
                          e.preventDefault();
                          e.stopPropagation();
                          setDragOverColumn(null);
                          handleWorkflowDrop(1);
                        }}
                         sx={{
                          borderLeft: `4px solid ${(pc as any)._isPublic ? (isLocationCompletePublic(pc as any) ? '#2e7d32' : '#f57c00') : '#87CEEB'}`,
                          bgcolor: (pc as any)._isPublic || (pc as any).fromPublicForm ? '#edf7ff' : 'white',
                          cursor: 'grab',
                          minWidth: '280px',
                          '&:hover': {
                            boxShadow: 2
                          }
                        }}
                      >
                        <CardContent sx={{ p: 2 }}>
                          <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            mb: 1,
                            backgroundColor: hasIcon ? '#E0F7FA' : 'transparent',
                            p: hasIcon ? 1 : 0,
                            borderRadius: hasIcon ? 1 : 0
                          }}>
                            <Box sx={{ flex: 1 }}>
                             <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>{pc.name}</Typography>
                             <Typography variant="caption" display="block" color="textSecondary" sx={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                               {pc.provincia}, {pc.canton}, {pc.distrito}
                             </Typography>
                             <Box sx={{ display: 'flex', gap: 1, mt: 0.5, flexWrap: 'wrap' }}>
                               <Tooltip title={pc.googleMapsLink ? "Abrir Google Maps" : "Sin link de Google Maps"}>
                                 <IconButton
                                   size="small"
                                   onClick={(e) => {
                                     e.stopPropagation();
                                     if (pc.googleMapsLink) window.open(pc.googleMapsLink, '_blank');
                                   }}
                                   disabled={!pc.googleMapsLink}
                                   sx={{
                                     color: pc.googleMapsLink ? '#4285F4' : 'rgba(0,0,0,0.26)',
                                     p: 0.5,
                                     '&:hover': { backgroundColor: pc.googleMapsLink ? 'rgba(66, 133, 244, 0.1)' : 'transparent' }
                                   }}
                                 >
                                   <GoogleIcon style={{ fontSize: 32 }} />
                                 </IconButton>
                               </Tooltip>
                               <Tooltip title={pc.wazeLink ? "Abrir Waze" : "Sin link de Waze"}>
                                 <IconButton
                                   size="small"
                                   onClick={(e) => {
                                     e.stopPropagation();
                                     if (pc.wazeLink) window.open(pc.wazeLink, '_blank');
                                   }}
                                   disabled={!pc.wazeLink}
                                   sx={{
                                     color: pc.wazeLink ? '#33CCFF' : 'rgba(0,0,0,0.26)',
                                     p: 0.5,
                                     '&:hover': { backgroundColor: pc.wazeLink ? 'rgba(51, 204, 255, 0.1)' : 'transparent' }
                                   }}
                                 >
                                   <FaWaze style={{ fontSize: 32 }} />
                                 </IconButton>
                               </Tooltip>
                               {(() => {
                                 const pendingOrder = getPendingOrderForClient(pc.id || '');
                                 return pendingOrder && ((pendingOrder.order?.items && pendingOrder.order.items.length > 0) || pendingOrder.orderNote) ? (
                                   <Chip
                                     label="Pedido guardado"
                                     size="small"
                                     color="success"
                                     variant="outlined"
                                     sx={{
                                       fontSize: '0.65rem',
                                       height: '16px',
                                       '& .MuiChip-label': { px: 0.5 }
                                     }}
                                   />
                                 ) : null;
                               })()}
                             </Box>
                              {(pc.nota || (pc as any).nota_admin) && (
                                <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5, pt: 0.5, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                  {pc.nota && (
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                      <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                        Nota Cliente:
                                      </Typography>
                                      <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'text.primary' }}>
                                        {pc.nota}
                                      </Typography>
                                    </Box>
                                  )}
                                  {(pc as any).nota_admin && (
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                      <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                        Nota Admin:
                                      </Typography>
                                      <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'primary.main' }}>
                                        {(pc as any).nota_admin}
                                      </Typography>
                                    </Box>
                                  )}
                                </Box>
                              )}
                            </Box>
                             <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                                {(pc as any)._isPublic ? (
                                 <Tooltip title="Ver detalles">
                                   <IconButton
                                     size="small"
                                     onClick={(e) => {
                                       e.stopPropagation();
                                       openClientDetails(pc);
                                     }}
                                     sx={{
                                       color: '#00b4d8',
                                       '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' }
                                     }}
                                   >
                                     <VisibilityIcon fontSize="small" />
                                   </IconButton>
                                 </Tooltip>
                              ) : (
                                <Box sx={{ display: 'flex', gap: 0.5 }}>
                                   <Tooltip title="Ver detalles">
                                     <IconButton
                                       size="small"
                                       onClick={(e) => {
                                         e.stopPropagation();
                                         openClientDetails(pc);
                                       }}
                                       sx={{
                                         color: '#00b4d8',
                                         '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' }
                                       }}
                                     >
                                       <VisibilityIcon fontSize="small" />
                                     </IconButton>
                                   </Tooltip>
                                   <Tooltip title="Editar cliente">
                                     <IconButton
                                       size="small"
                                       onClick={(e) => {
                                         e.stopPropagation();
                                         setNewTabValue(0);
                                         handleOpen(pc as Client);
                                       }}
                                       sx={{
                                         color: '#00b4d8',
                                         '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' }
                                       }}
                                     >
                                       <EditIcon fontSize="small" />
                                     </IconButton>
                                   </Tooltip>
                                   <Tooltip title="Mover a Lista de espera">
                                     <IconButton
                                       size="small"
                                       onClick={(e) => {
                                         e.stopPropagation();
                                         handleWorkflowDropWithData({ type: (pc as any)._isPublic ? 'public' : 'client', id: pc.id || '', stage: 0 }, 1);
                                       }}
                                       sx={{
                                         color: '#00b4d8',
                                         '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' }
                                       }}
                                     >
                                       <ChevronRightIcon fontSize="small" />
                                     </IconButton>
                                   </Tooltip>
                                </Box>
                              )}
                              {/* <Tooltip title="Editar">
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handlePublicOpen(pc);
                                  }}
                                  sx={{
                                    color: '#00b4d8',
                                    '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' }
                                  }}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip> */}
                              {'status_create_public_client' in pc && (
                                <Tooltip title={pc.status_create_public_client === 'completed' ? 'Cliente ya creado' : 'Crear cliente'}>
                                  <span>
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleCreateClient({ ...pc });
                                      }}
                                      disabled={pc.status_create_public_client === 'completed'}
                                      sx={{
                                        color: '#00b4d8',
                                        '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' },
                                        '&.Mui-disabled': {
                                          color: 'rgba(0, 0, 0, 0.26)'
                                        }
                                      }}
                                    >
                                      <TransferIcon fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              )}
                            </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  )
                })
                  ) : null}
                </Box>
              </Paper>
            </Box>

            {/* Columna 1: Lista de espera */}
            <Box sx={{ width: 320, flexShrink: 0 }}>
              <Paper sx={{ p: 2, borderTop: '4px solid #d32f2f', borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>1. Lista de espera</Typography>
                  <IconButton 
                    size="small" 
                    onClick={(e) => setWaitlistFiltersAnchorEl(e.currentTarget)}
                    sx={{ color: 'text.secondary' }}
                  >
                    <MoreVertIcon fontSize="small" />
                  </IconButton>
                  <Menu
                    anchorEl={waitlistFiltersAnchorEl}
                    open={Boolean(waitlistFiltersAnchorEl)}
                    onClose={() => setWaitlistFiltersAnchorEl(null)}
                    PaperProps={{ sx: { width: 200, p: 1 } }}
                  >
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 1 }}>
                        {/* <FormControlLabel
                          control={
                            <Switch 
                              checked={showReprogrammedByTransporter} 
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setShowReprogrammedByTransporter(checked);
                                setWaitlistFilterEstado(checked ? 'reprogrammed' : 'pending');
                              }} 
                            />
                          }
                          label={<Typography sx={{ fontSize: '0.8rem' }}>Reprogramado Transportista</Typography>}
                        /> */}
                      <FormControl fullWidth size="small">
                        <InputLabel sx={{ fontSize: '0.75rem' }}>Estado</InputLabel>
                        <Select
                          value={waitlistFilterEstado}
                          label="Estado"
                          onChange={(e) => {
                            const val = e.target.value;
                            setWaitlistFilterEstado(val);
                            if (val === 'reprogrammed') {
                              setShowReprogrammedByTransporter(true);
                            } else if (val === 'pending' || val === 'cancelled') {
                              setShowReprogrammedByTransporter(false);
                            }
                          }}
                          sx={{ fontSize: '0.8rem' }}
                        >
                          <MenuItem value="todas">Todas</MenuItem>
                          <MenuItem value="pending">Pendiente</MenuItem>
                          {showReprogrammedByTransporter && (
                            <MenuItem value="reprogrammed">Reprogramado Transportista</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                      <FormControl fullWidth size="small">
                        <InputLabel sx={{ fontSize: '0.75rem' }}>Ruta</InputLabel>
                        <Select
                          value={waitlistFilterRuta}
                          label="Ruta"
                          onChange={(e) => setWaitlistFilterRuta(e.target.value)}
                          sx={{ fontSize: '0.8rem' }}
                        >
                          <MenuItem value="todas">Todas las rutas</MenuItem>
                          {uniqueRouteNames.map(name => (
                            <MenuItem key={name} value={name}>{name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </Menu>
                  <Chip label={waitlistClientsPublicFilteredSearch.length + waitlistClientsFromPendingFilteredSearch.length + reprogrammedOrdersFilteredSearch.length} size="small" sx={{ ml: 'auto' }} />
                </Box>
                <Box
                  onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setDragOverColumn(2);
                  }}
                  onDragLeave={() => setDragOverColumn(null)}
                  onDrop={(e) => {
                    console.log('🎯 DROP - Columna 2');
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Obtener datos del drag
                    let dragData = null;
                    try {
                      const jsonData = e.dataTransfer.getData('application/json');
                      if (jsonData) {
                        dragData = JSON.parse(jsonData);
                      }
                    } catch (error) {
                      console.log('Error parsing drag data:', error);
                    }
                    
                    console.log('📦 Drag data:', dragData);
                    console.log('📦 workflowDragged actual:', workflowDragged);
                    
                    // Usar el dragData si está disponible, sino usar workflowDragged
                    const finalDragData = dragData || workflowDragged;
                    
                    if (finalDragData) {
                      console.log('✅ Usando datos:', finalDragData);
                      
                      // Llamar directamente a handleWorkflowDrop con los datos
                      // sin depender del estado workflowDragged
                      handleWorkflowDropWithData(finalDragData, 2);
                    } else {
                      console.log('❌ No hay datos de drag');
                    }
                    
                    setDragOverColumn(null);
                  }}
                  sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}
                >
                  {waitlistClientsPublicFilteredSearch.map(pc => {
                    const hasFormularioName = publicClients.find(p => p.name === pc.name);
                    return (
                    <Card
                      key={`wlpc-${pc.id}`}
                      draggable={false}
                      sx={{
                        borderLeft: '4px solid #d32f2f',
                        cursor: 'default',
                        '&:hover': {
                          boxShadow: 2
                        }
                      }}
                      onDragStart={() => setWorkflowDragged({ type: 'public', id: pc.id || '', stage: 2 })}
                      onDragEnd={() => setWorkflowDragged(null)}
                    >
                       <CardContent sx={{ p: 2 }}>
                         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1, backgroundColor: hasFormularioName ? '#e3f2fd' : 'transparent', borderRadius: 1, p: hasFormularioName ? 1 : 0 }}>
                           <Box sx={{ flex: 1 }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>{pc.name}</Typography>
                            <Typography variant="caption" display="block" color="textSecondary">
                              {pc.provincia}, {pc.canton}, {pc.distrito}
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
                              <Tooltip title={pc.googleMapsLink ? "Abrir Google Maps" : "Sin link de Google Maps"}>
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (pc.googleMapsLink) window.open(pc.googleMapsLink, '_blank');
                                  }}
                                  disabled={!pc.googleMapsLink}
                                  sx={{
                                    color: pc.googleMapsLink ? '#4285F4' : 'rgba(0,0,0,0.26)',
                                    p: 0.5,
                                    '&:hover': { backgroundColor: pc.googleMapsLink ? 'rgba(66, 133, 244, 0.1)' : 'transparent' }
                                  }}
                                >
                                  <GoogleIcon style={{ fontSize: 32 }} />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={pc.wazeLink ? "Abrir Waze" : "Sin link de Waze"}>
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (pc.wazeLink) window.open(pc.wazeLink, '_blank');
                                  }}
                                  disabled={!pc.wazeLink}
                                  sx={{
                                    color: pc.wazeLink ? '#33CCFF' : 'rgba(0,0,0,0.26)',
                                    p: 0.5,
                                    '&:hover': { backgroundColor: pc.wazeLink ? 'rgba(51, 204, 255, 0.1)' : 'transparent' }
                                  }}
                                >
                                  <FaWaze style={{ fontSize: 32 }} />
                                </IconButton>
                              </Tooltip>
                            </Box>

                            {(() => {
                              const pendingOrder = getPendingOrderForClient(pc.id || '');
                              return pendingOrder?.orderNote ? (
                                <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5, pt: 0.5, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                  <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                    Nota del Pedido:
                                  </Typography>
                                  <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'primary.main' }}>
                                    {pendingOrder.orderNote}
                                  </Typography>
                                </Box>
                              ) : null;
                            })()}

                            {(() => {
                              const pOrder = getPendingOrderForClient(pc.id || '');
                              return pOrder?.orderNote ? (
                                <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5, pt: 0.5, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                  <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                    Nota del Pedido:
                                  </Typography>
                                  <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'primary.main' }}>
                                    {pOrder.orderNote}
                                  </Typography>
                                </Box>
                              ) : null;
                            })()}
                            {(pc.nota || (pc as any).nota_admin) && (
                              <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5, pt: 0.5, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                {pc.nota && (
                                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                      Nota Cliente:
                                    </Typography>
                                    <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'text.primary' }}>
                                      {pc.nota}
                                    </Typography>
                                  </Box>
                                )}
                                {(pc as any).nota_admin && (
                                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                      Nota Admin:
                                    </Typography>
                                    <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'primary.main' }}>
                                      {(pc as any).nota_admin}
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            )}
                          </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
                              <Box sx={{ display: 'flex', gap: 0.5 }}>
                                {! (getPendingOrderForClient(pc.id || '')?.status === 'reprogrammed' || pedidosPreprogramados.some(p => p.routeRreprogrammed?.clientId === (pc.id || ''))) && (
                                  <Tooltip title="Eliminar de lista de espera">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteClick({ type: 'public', data: pc });
                                      }}
                                      sx={{ color: '#d32f2f', '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.1)' } }}
                                    >
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                )}
                                <Tooltip title="Ver detalles">
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openClientDetails(pc);
                                    }}
                                    sx={{ color: '#00b4d8', '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' } }}
                                  >
                                    <VisibilityIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Editar cliente">
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setNewTabValue(0);
                                      handleOpen(pc as any);
                                    }}
                                    sx={{ color: '#00b4d8', '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' } }}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Mover a Lista de Proceso">
                                  <IconButton
                                    size="small"
                                    onClick={async (e) => {
                                      e.stopPropagation();
                                      setWaitlistDialogLoading(true);
                                      setSelectedWaitlistClient({ type: 'public', data: pc });
                                      setWaitlistDataLoading(true);
                                      try {
                                        const pendingRef = collection(db, 'pendingOrders');
                                        const q = query(pendingRef, where('clientId', '==', pc.id));
                                        const snapshot = await getDocs(q);
                                        let found: Order | null = null;
                                        let foundId: string | null = null;
                                        let foundNote: string = '';
                                        snapshot.forEach((docSnap) => {
                                          const data = docSnap.data();
                                          if (data.orderData) {
                                            found = data.orderData as Order;
                                            foundId = docSnap.id;
                                            foundNote = data.orderNote || '';
                                          }
                                        });
                                        setClientPendingOrder(found);
                                        setClientPendingOrderDocId(foundId);
                                        setWaitlistOrderNote(foundNote);
                                        if (notesInputRef.current) {
                                          notesInputRef.current.value = foundNote;
                                        }
                                      } catch (error) {
                                        console.error('Error fetching pending order:', error);
                                        setClientPendingOrder(null);
                                        setClientPendingOrderDocId(null);
                                        setWaitlistOrderNote('');
                                        if (notesInputRef.current) {
                                          notesInputRef.current.value = '';
                                        }
                                      } finally {
                                        setWaitlistDataLoading(false);
                                      }
                                      fetchRouteGroupsForWaitlist();
                                      setWaitlistDialogOpen(true);
                                      setWaitlistDialogLoading(false);
                                    }}
                                    disabled={waitlistDialogLoading}
                                    sx={{ color: '#00b4d8', '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' } }}
                                  >
                                    <ChevronRightIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                              <Tooltip title="Mover a Completados">
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    moveToCompleted(pc.id || '');
                                  }}
                                  sx={{ color: '#4caf50', '&:hover': { backgroundColor: 'rgba(76, 175, 80, 0.1)' } }}
                                >
                                  <DoneAllIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                             </Box>
                         </Box>
                       </CardContent>
                     </Card>
                    );
                   })}
                  {waitlistClientsFromPendingFilteredSearch.map(c => {
                    const pendingOrder = getPendingOrderForClient(c.id || '');
                    const hasFormularioName = publicClients.find(p => p.name === c.name);
                    console.log('Debug - Rendering client card:', {
                      clientId: c.id,
                      clientName: c.name,
                      pendingOrder: pendingOrder,
                      hasOrder: !!pendingOrder?.order,
                      hasNotes: !!pendingOrder?.order?.routeNotes
                    });
                    return (
                      <Card
                        key={`wlc-${c.id}`}
                        sx={{
                          borderLeft: '4px solid #87CEEB',
                          cursor: 'default',
                          minWidth: '280px',
                          '&:hover': {
                            boxShadow: 2
                          }
                        }}
                      draggable={false}
                      onDragStart={() => setWorkflowDragged({ type: 'client', id: c.id || '', stage: 2 })}
                      onDragEnd={() => setWorkflowDragged(null)}
                    >
                      <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1, backgroundColor: hasFormularioName ? '#e3f2fd' : 'transparent', borderRadius: 1, p: hasFormularioName ? 1 : 0 }}>
                           <Box sx={{ flex: 1 }}>
                             <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>{c.name}</Typography>
                             <Typography variant="caption" display="block" color="textSecondary" sx={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                               {c.provincia}, {c.canton}, {c.distrito}
                             </Typography>
                               <Box sx={{ display: 'flex', gap: 1, mt: 0.5, flexWrap: 'wrap', alignItems: 'center' }}>
                                 {pendingOrder && (
                                   <Chip 
                                     label={
                                       (showReprogrammedByTransporter && waitlistFilterEstado !== 'pending' && pedidosPreprogramados.some(p => p.routeRreprogrammed?.clientId === (c.id || ''))) 
                                       ? 'Reprogramado Transportista' 
                                       : (pedidosPreprogramados.some(p => p.routeRreprogrammed?.clientId === (c.id || '')) || pendingOrder.status === 'reprogrammed' 
                                          ? 'Reprogramados' 
                                          : (pendingOrder.status === 'cancelled' ? 'Cancelado' : 'Pendiente'))
                                     } 
                                     size="small" 
                                     color={
                                       (showReprogrammedByTransporter && waitlistFilterEstado !== 'pending' && pedidosPreprogramados.some(p => p.routeRreprogrammed?.clientId === (c.id || '')))
                                       ? 'warning'
                                       : (pedidosPreprogramados.some(p => p.routeRreprogrammed?.clientId === (c.id || '')) || pendingOrder.status === 'reprogrammed' || pendingOrder.status === 'cancelled' 
                                          ? 'error' 
                                          : 'warning')
                                     }
                                     sx={{ fontSize: '0.65rem', height: '16px', '& .MuiChip-label': { px: 0.5 } }} 
                                   />
                                 )}
                                 {pendingOrder && (
                                   <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'text.secondary', fontWeight: 'bold' }}>
                                     {pendingOrder.routeName} • {pendingOrder.date ? format(pendingOrder.date, 'dd/MM/yy', { locale: es }) : 'Sin fecha'}
                                   </Typography>
                                 )}
                                 <Tooltip title={c.googleMapsLink ? "Abrir Google Maps" : "Sin link de Google Maps"}>
                                   <IconButton
                                     size="small"
                                     onClick={(e) => {
                                       e.stopPropagation();
                                       if (c.googleMapsLink) window.open(c.googleMapsLink, '_blank');
                                     }}
                                     disabled={!c.googleMapsLink}
                                     sx={{
                                       color: c.googleMapsLink ? '#4285F4' : 'rgba(0,0,0,0.26)',
                                       p: 0.5,
                                       '&:hover': { backgroundColor: c.googleMapsLink ? 'rgba(66, 133, 244, 0.1)' : 'transparent' }
                                     }}
                                   >
                                     <GoogleIcon style={{ fontSize: 32 }} />
                                   </IconButton>
                                 </Tooltip>
                                 <Tooltip title={c.wazeLink ? "Abrir Waze" : "Sin link de Waze"}>
                                   <IconButton
                                     size="small"
                                     onClick={(e) => {
                                       e.stopPropagation();
                                       if (c.wazeLink) window.open(c.wazeLink, '_blank');
                                     }}
                                     disabled={!c.wazeLink}
                                     sx={{
                                       color: c.wazeLink ? '#33CCFF' : 'rgba(0,0,0,0.26)',
                                       p: 0.5,
                                       '&:hover': { backgroundColor: c.wazeLink ? 'rgba(51, 204, 255, 0.1)' : 'transparent' }
                                     }}
                                   >
                                     <FaWaze style={{ fontSize: 32 }} />
                                   </IconButton>
                                 </Tooltip>
                                 {pendingOrder && ((pendingOrder.order?.items && pendingOrder.order.items.length > 0) || pendingOrder.orderNote) && (
                                   <Chip
                                     label="Pedido guardado"
                                     size="small"
                                     color="success"
                                     variant="outlined"
                                     sx={{
                                       fontSize: '0.65rem',
                                       height: '16px',
                                       '& .MuiChip-label': { px: 0.5 }
                                     }}
                                   />
                                 )}
                               </Box>

                            {(() => {
                              const pOrder = getPendingOrderForClient(c.id || '');
                              return pOrder?.orderNote ? (
                                <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5, pt: 0.5, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                  <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                    Nota del Pedido:
                                  </Typography>
                                  <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'primary.main' }}>
                                    {pOrder.orderNote}
                                  </Typography>
                                </Box>
                              ) : null;
                            })()}
                            {(c.nota || c.nota_admin) && (
                              <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5, pt: 0.5, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                {c.nota && (
                                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                      Nota Cliente:
                                    </Typography>
                                    <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'text.primary' }}>
                                      {c.nota}
                                    </Typography>
                                  </Box>
                                )}
                                {c.nota_admin && (
                                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                      Nota Admin:
                                    </Typography>
                                    <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'primary.main' }}>
                                      {c.nota_admin}
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            )}
                           </Box>
                             <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5, backgroundColor: hasFormularioName ? '#e3f2fd' : 'transparent', borderRadius: 1, p: hasFormularioName ? 1 : 0 }}>
                               <Box sx={{ display: 'flex', gap: 0.5 }}>
                                {! (getPendingOrderForClient(c.id || '')?.status === 'reprogrammed' || pedidosPreprogramados.some(p => p.routeRreprogrammed?.clientId === (c.id || ''))) && (
                                  <Tooltip title="Eliminar de lista de espera">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDeleteClick({ type: 'remove_from_waitlist', data: c });
                                      }}
                                      sx={{ color: '#d32f2f', '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.1)' } }}
                                    >
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                )}
                               <Tooltip title="Ver detalles">
                                 <IconButton
                                   size="small"
                                   onClick={(e) => {
                                     e.stopPropagation();
                                     openClientDetails(c);
                                   }}
                                   sx={{ color: '#00b4d8', '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' } }}
                                 >
                                   <VisibilityIcon fontSize="small" />
                                 </IconButton>
                               </Tooltip>
                               <Tooltip title="Editar cliente">
                                 <IconButton
                                   size="small"
                                   onClick={(e) => {
                                     e.stopPropagation();
                                     setNewTabValue(0);
                                     handleOpen(c);
                                   }}
                                   sx={{ color: '#00b4d8', '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' } }}
                                 >
                                   <EditIcon fontSize="small" />
                                 </IconButton>
                               </Tooltip>
                                 <Tooltip title="Mover a Lista de Proceso">
                                   <IconButton
                                     size="small"
                                       onClick={async (e) => {
                                         e.stopPropagation();
                                         setWaitlistDialogLoading(true);
                                         setSelectedWaitlistClient({ type: 'client', data: c });

                                         // Load data immediately before opening popup
                                         setWaitlistDataLoading(true);
                                         try {
                                           console.log('Fetching pending order for client:', c.id);
                                           const pendingRef = collection(db, 'pendingOrders');
                                           const q = query(pendingRef, where('clientId', '==', c.id));
                                           const snapshot = await getDocs(q);
                                           let found: Order | null = null;
                                           let foundId: string | null = null;
                                           let foundNote: string = '';

                                           snapshot.forEach((docSnap) => {
                                             const data = docSnap.data();
                                             console.log('Found pending order data:', data);
                                             if (data.orderData) {
                                               console.log('Found pending order data:', data.orderData);
                                               found = data.orderData as Order;
                                               foundId = docSnap.id;
                                               foundNote = data.orderNote || '';
                                             }
                                           });

                                           console.log('Setting clientPendingOrder:', found);
                                           setClientPendingOrder(found);
                                           setClientPendingOrderDocId(foundId);
                                           setWaitlistOrderNote(foundNote); // Load existing order note into text input
                                           // Also update the input value directly
                                           if (notesInputRef.current) {
                                             notesInputRef.current.value = foundNote;
                                           }
                                         } catch (error) {
                                           console.error('Error fetching pending order:', error);
                                           setClientPendingOrder(null);
                                           setClientPendingOrderDocId(null);
                                           setWaitlistOrderNote('');
                                           // Also clear the input value
                                           if (notesInputRef.current) {
                                             notesInputRef.current.value = '';
                                           }
                                         } finally {
                                           setWaitlistDataLoading(false);
                                         }

                                         fetchRouteGroupsForWaitlist();
                                         setWaitlistDialogOpen(true);
                                         setWaitlistDialogLoading(false);
                                       }}
                                     disabled={waitlistDialogLoading}
                                     sx={{ color: '#00b4d8', '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' } }}
                                   >
                                     <ChevronRightIcon fontSize="small" />
                                   </IconButton>
                                 </Tooltip>
                             </Box>

                              <Tooltip title="Mover a Completados">
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                      e.stopPropagation();
                                      moveToCompleted(c.id || '');
                                  }}
                                  sx={{ color: '#4caf50', '&:hover': { backgroundColor: 'rgba(76, 175, 80, 0.1)' } }}
                                >
                                  <DoneAllIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                           </Box>
                        </Box>

                      </CardContent>
                    </Card>
                    );
                  })}
                   {reprogrammedOrdersFilteredSearch.map((pedido, index) => {
                    console.log('DEBUG: Rendering reprogrammed order index:', index, 'ID:', pedido.id);
                    const client = clients.find(c => c.id === pedido.routeRreprogrammed?.clientId);
                    if (!client) {
                      console.log(`DEBUG: Reprogrammed order ${pedido.id} client not found in list`);
                      return null;
                    }
                    const hasFormularioName = publicClients.find(p => p.name === client.name);
                    return (
                      <Card
                        key={`repro-${pedido.id || index}`}
                        draggable={false}
                        sx={{
                          borderLeft: '4px solid #ff4d4f',
                          cursor: 'default',
                          minWidth: '280px',
                          '&:hover': {
                            boxShadow: 2
                          }
                        }}
                      >
                        <CardContent sx={{ p: 2 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1, backgroundColor: hasFormularioName ? '#e3f2fd' : 'transparent', borderRadius: 1, p: hasFormularioName ? 1 : 0 }}>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                {client.name} ({ (showReprogrammedByTransporter && waitlistFilterEstado !== 'pending') ? 'Reprogramado Transportista' : 'Reprogramados' })
                              </Typography>
                              <Typography variant="caption" display="block" color="textSecondary">
                                {client.provincia}, {client.canton}, {client.distrito}
                              </Typography>
                              <Box sx={{ display: 'flex', gap: 1, mt: 0.5, flexWrap: 'wrap', alignItems: 'center' }}>
                              {(() => {
                                const pendingOrder = getPendingOrderForClient(client.id || '');
                                return pendingOrder ? (
                                  <>
                                    <Chip 
                                      label={pendingOrder.status === 'cancelled' ? 'Cancelado' : 'Pendiente'} 
                                      size="small" 
                                      color={pendingOrder.status === 'cancelled' ? 'error' : 'warning'}
                                      sx={{ fontSize: '0.65rem', height: '16px', '& .MuiChip-label': { px: 0.5 } }} 
                                    />
                                    <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'text.secondary', fontWeight: 'bold' }}>
                                      {pendingOrder.routeName} • {pendingOrder.date ? format(pendingOrder.date, 'dd/MM/yy', { locale: es }) : 'Sin fecha'}
                                    </Typography>
                                  </>
                                ) : null;
                              })()}
                                <Tooltip title={client.googleMapsLink ? "Abrir Google Maps" : "Sin link de Google Maps"}>
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (client.googleMapsLink) window.open(client.googleMapsLink, '_blank');
                                    }}
                                    disabled={!client.googleMapsLink}
                                    sx={{
                                      color: client.googleMapsLink ? '#4285F4' : 'rgba(0,0,0,0.26)',
                                      p: 0.5,
                                      '&:hover': { backgroundColor: client.googleMapsLink ? 'rgba(66, 133, 244, 0.1)' : 'transparent' }
                                    }}
                                  >
                                    <GoogleIcon style={{ fontSize: 32 }} />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title={client.wazeLink ? "Abrir Waze" : "Sin link de Waze"}>
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (client.wazeLink) window.open(client.wazeLink, '_blank');
                                    }}
                                    disabled={!client.wazeLink}
                                    sx={{
                                      color: client.wazeLink ? '#33CCFF' : 'rgba(0,0,0,0.26)',
                                      p: 0.5,
                                      '&:hover': { backgroundColor: client.wazeLink ? 'rgba(51, 204, 255, 0.1)' : 'transparent' }
                                    }}
                                  >
                                    <FaWaze style={{ fontSize: 32 }} />
                                  </IconButton>
                                </Tooltip>
                                <Chip
                                  icon={<EventRepeatIcon style={{ fontSize: 12 }} />}
                                  label={(showReprogrammedByTransporter && waitlistFilterEstado !== 'pending') ? 'Reprogramado Transportista' : 'Reprogramados'}
                                  size="small"
                                  color={(showReprogrammedByTransporter && waitlistFilterEstado !== 'pending') ? 'warning' : 'error'}
                                  variant="outlined"
                                  sx={{
                                    fontSize: '0.65rem',
                                    height: '16px',
                                    '& .MuiChip-label': { px: 0.5 },
                                    fontWeight: 'bold'
                                  }}
                                />
                              </Box>
                              {pedido.routeRreprogrammed?.order?.orderNote && (
                                <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5, pt: 0.5, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                  <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                    Nota del Pedido:
                                  </Typography>
                                  <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'primary.main' }}>
                                    {pedido.routeRreprogrammed.order.orderNote}
                                  </Typography>
                                </Box>
                              )}
                              {(client.nota || (client as any).nota_admin) && (
                                <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5, pt: 0.5, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                  {client.nota && (
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                      <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                        Nota Cliente:
                                      </Typography>
                                      <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'text.primary' }}>
                                        {client.nota}
                                      </Typography>
                                    </Box>
                                  )}
                                  {(client as any).nota_admin && (
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                      <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                        Nota Admin:
                                      </Typography>
                                      <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'primary.main' }}>
                                        {(client as any).nota_admin}
                                      </Typography>
                                    </Box>
                                  )}
                                </Box>
                              )}
                             </Box>
                             <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5, backgroundColor: hasFormularioName ? '#e3f2fd' : 'transparent', borderRadius: 1, p: hasFormularioName ? 1 : 0 }}>
                               <Box sx={{ display: 'flex', gap: 0.5 }}>
                                <Tooltip title="Ver detalles">
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openClientDetails(client);
                                    }}
                                    sx={{ color: '#00b4d8', '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' } }}
                                  >
                                    <VisibilityIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Mover a Lista de Proceso">
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleWaitlistDialogOpen(pedido);
                                    }}
                                    sx={{ color: '#00b4d8', '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' } }}
                                  >
                                    <ChevronRightIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                              
                              <Tooltip title="Mover a Completados">
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      moveToCompleted(pedido.routeRreprogrammed?.clientId || '');
                                    }}
                                    sx={{ color: '#4caf50', '&:hover': { backgroundColor: 'rgba(76, 175, 80, 0.1)' } }}
                                  >
                                    <DoneAllIcon fontSize="small" />
                                  </IconButton>
                              </Tooltip>
                            </Box>
                          </Box>
                      </CardContent>
                    </Card>
                  )})}
                </Box>
                {/* <Button size="small" variant="outlined" sx={{ mt: 1 }} onClick={() => refreshWorkflowData(true)}>Actualizar</Button> */}
              </Paper>
            </Box>

            {/* Sección para cartas sin nombre - solo mostrar si hay cartas */}
            {waitlistClientsPublicNoNameSearch.length + waitlistClientsFromPendingNoNameSearch.length > 0 && (
              <Box sx={{ minWidth: 320 }}>
                <Paper sx={{ p: 2, borderTop: '4px solid #ff9800', borderRadius: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Cartas sin nombre</Typography>
                    <Chip label={waitlistClientsPublicNoNameSearch.length + waitlistClientsFromPendingNoNameSearch.length} size="small" sx={{ ml: 'auto' }} />
                  </Box>
                  <Typography variant="caption" color="textSecondary">Clientes que necesitan nombre para procesarse</Typography>
                 <Box
                   onDragOver={(e) => e.preventDefault()}
                   onDrop={() => handleWorkflowDrop(3)}
                   sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}
                 >
<>
                    {waitlistClientsPublicNoNameSearch.map((c, index) => {
                      const pendingOrder = getPendingOrderForClient(c.id || '');
                      return (
                        <Card
                          key={`public-no-name-${c.id || index}`}
                          draggable
                          onDragStart={() => setWorkflowDragged({ type: 'public', id: c.id || '', stage: 2 })}
                          onDragEnd={() => setWorkflowDragged(null)}
                          sx={{ 
                            borderLeft: '4px solid #ff9800',
                            boxShadow: 2,
                            cursor: 'pointer',
                            '&:hover': {
                              boxShadow: 4,
                              transform: 'translateY(-2px)'
                            }
                          }}
                        >
                          <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#ff9800' }}>
                                  Sin nombre
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                  {c.phoneNumber}
                                </Typography>
                                {c.provincia && (
                                  <Typography variant="caption" color="textSecondary">
                                    {c.provincia}, {c.canton}
                                  </Typography>
                                )}
                                 {pendingOrder && (
                                  <Box sx={{ mt: 1 }}>
                                    <Chip 
                                      label={`Pedido: ${pendingOrder.order?.items?.length || 0} items`}
                                      size="small"
                                      sx={{ 
                                        backgroundColor: '#e3f2fd',
                                        color: '#1976d2',
                                        fontSize: '0.7rem'
                                      }}
                                    />
                                    {'orderNote' in pendingOrder && pendingOrder.orderNote && (
                                      <Typography variant="body2" sx={{ fontSize: '0.75rem', mt: 0.5, color: '#555' }}>
                                        📌 Nota del Pedido: {pendingOrder.orderNote}
                                      </Typography>
                                    )}
                                    {(pendingOrder.order?.items?.length ?? 0) > 0 && (
                                      <Typography variant="body2" sx={{ fontSize: '0.75rem', mt: 0.5 }}>
                                        🧮 Total Items: {pendingOrder.order?.items?.reduce((sum: number, i: any) => sum + i.quantity, 0) ?? 0}
                                      </Typography>
                                    )}
                                  </Box>
                                )}
                              </Box>
                              <IconButton
                                size="small"
                                onClick={() => handleDeleteClick({ type: 'public', data: c })}
                                sx={{ 
                                  color: '#d32f2f',
                                  '&:hover': {
                                    backgroundColor: 'rgba(211, 47, 47, 0.04)'
                                  }
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </CardContent>
                        </Card>
                      );
                    })}
                    {waitlistClientsFromPendingNoNameSearch.map((c, index) => {
                      const pendingOrder = getPendingOrderForClient(c.id || '');
                      return (
                        <Card
                          key={`pending-no-name-${c.id || index}`}
                          draggable
                          onDragStart={() => setWorkflowDragged({ type: 'client', id: c.id || '', stage: 2 })}
                          onDragEnd={() => setWorkflowDragged(null)}
                          sx={{ 
                            borderLeft: '4px solid #ff9800',
                            boxShadow: 2,
                            cursor: 'pointer',
                            '&:hover': {
                              boxShadow: 4,
                              transform: 'translateY(-2px)'
                            }
                          }}
                        >
                          <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#ff9800' }}>
                                  Sin nombre
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                  {c.phoneNumber}
                                </Typography>
                                {c.provincia && (
                                  <Typography variant="caption" color="textSecondary">
                                    {c.provincia}, {c.canton}, {c.distrito}
                                  </Typography>
                                )}
                                 {pendingOrder && (
                                  <Box sx={{ mt: 1 }}>
                                    <Chip 
                                      label={`Pedido (${pendingOrder.order?.items?.length || 0} items)`}
                                      size="small"
                                      sx={{ 
                                        backgroundColor: '#e3f2fd',
                                        color: '#1976d2',
                                        fontSize: '0.7rem'
                                      }}
                                    />
                                    {'orderNote' in pendingOrder && pendingOrder.orderNote && (
                                      <Typography variant="body2" sx={{ fontSize: '0.75rem', mt: 0.5, color: '#555' }}>
                                        📌 Nota del Pedido: {pendingOrder.orderNote}
                                      </Typography>
                                    )}
                                    {(pendingOrder.order?.items?.length ?? 0) > 0 && (
                                      <Typography variant="body2" sx={{ fontSize: '0.75rem', mt: 0.5 }}>
                                        🧮 Total Items: {pendingOrder.order?.items?.reduce((sum: number, i: any) => sum + i.quantity, 0) ?? 0}
                                      </Typography>
                                    )}
                                  </Box>
                                )}
                              </Box>
                              <IconButton
                                size="small"
                                onClick={() => handleDeleteClick({ type: 'client', data: c as any })}
                                sx={{ 
                                  color: '#d32f2f',
                                  '&:hover': {
                                    backgroundColor: 'rgba(211, 47, 47, 0.04)'
                                  }
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </CardContent>
                        </Card>
                      );
                    })}
                    </>
                  </Box>
                </Paper>
              </Box>
            )}

            {/* Columna 2: Proceso */}
            <Box sx={{ width: 320, flexShrink: 0 }}>
              <Paper sx={{ p: 2, borderTop: '4px solid #1976d2', borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>2. Proceso</Typography>
                  <Chip label={procesoRouteOrdersFilteredSearch.length} size="small" sx={{ ml: 'auto' }} />
                </Box>
                <Box
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={() => handleWorkflowDrop(3)}
                  sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}
                >
                  {(() => {
                    console.log('Debug - Renderizando procesoRouteOrdersFilteredSearch:', procesoRouteOrdersFilteredSearch.length, 'items');
                    console.log('Debug - IDs a renderizar:', procesoRouteOrdersFilteredSearch.map(r => ({ id: r.id, clientName: r.clientName })));
                    console.log('Debug - Estado actual de routesWithNotes:', routesWithNotes);
                    return procesoRouteOrdersFilteredSearch.map((route, index) => {
                    const client = clients.find(c => c.id === route.clientId) || 
                                 publicClients.find(p => p.id === route.clientId);
                    const isRegularClient = clients.find(c => c.id === route.clientId);
                    const routeClientData = route.clientData as (Client | PublicClient | undefined) | undefined;
                    const fallbackClient = client || routeClientData || {
                      id: route.clientId,
                      name: route.clientName || 'Cliente',
                      phoneNumber: route.clientPhone || '',
                      provincia: '',
                      canton: '',
                      distrito: '',
                      googleMapsLink: '',
                      wazeLink: '',
                      nota: '',
                      nota_admin: ''
                    } as Client | PublicClient;
                    return (
                      <Card
                        key={`proc-${route.id || route.clientId}-${route.createdAt.getTime()}-${index}`}
                        draggable={isRegularClient && procesoSuccess.includes(isRegularClient.proceso || '')}
                        onDragStart={() => {
                          if (isRegularClient && procesoSuccess.includes(isRegularClient.proceso || '')) {
                            setWorkflowDragged({ type: 'client', id: isRegularClient.id || '', stage: 3 });
                          }
                        }}
                        onDragEnd={() => setWorkflowDragged(null)}
                        sx={{ 
                          borderLeft: `4px solid ${getProcesoBorderColor(isRegularClient?.proceso, route.status)}`,
                          boxShadow: isRegularClient && procesoSuccess.includes(isRegularClient.proceso || '') ? 6 : 0,
                          cursor: 'pointer',
                          opacity: route.status === 'completed' ? 0.8 : 1
                        }}
                      >
                        <CardContent sx={{ p: 2 }}>
                          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>{route.routeName}</Typography>
                          <Typography variant="caption" color="textSecondary" display="block">{format(route.createdAt, 'dd/MM/yyyy')}</Typography>
                          {client && (
                            <Box 
                              sx={{ 
                                mt: 1, 
                                bgcolor: '#e3f2fd', 
                                p: 1, 
                                borderRadius: 1,
                                cursor: 'pointer',
                                '&:hover': {
                                  backgroundColor: '#e1f5fe',
                                }
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                openRouteOrderDetails(route);
                              }}
                            >
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <Box sx={{ flex: 1 }}>
                                  <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block' }}>
                                    {fallbackClient.name}
                                  </Typography>
                                  <Typography variant="caption" color="textSecondary" display="block">
                                    {fallbackClient.provincia}, {fallbackClient.canton}, {fallbackClient.distrito}
                                  </Typography>
                                  <Box sx={{ display: 'flex', gap: 1, mt: 0.5, flexWrap: 'wrap' }}>
                                    <Tooltip title={fallbackClient.googleMapsLink ? "Abrir Google Maps" : "Sin link de Google Maps"}>
                                      <IconButton
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (fallbackClient.googleMapsLink) window.open(fallbackClient.googleMapsLink, '_blank');
                                        }}
                                        disabled={!fallbackClient.googleMapsLink}
                                        sx={{
                                          color: client.googleMapsLink ? '#4285F4' : 'rgba(0,0,0,0.26)',
                                          p: 0.5,
                                          '&:hover': { backgroundColor: client.googleMapsLink ? 'rgba(66, 133, 244, 0.1)' : 'transparent' }
                                        }}
                                      >
                                        <GoogleIcon style={{ fontSize: 32 }} />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title={fallbackClient.wazeLink ? "Abrir Waze" : "Sin link de Waze"}>
                                      <IconButton
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (fallbackClient.wazeLink) window.open(fallbackClient.wazeLink, '_blank');
                                        }}
                                        disabled={!fallbackClient.wazeLink}
                                        sx={{
                                          color: client.wazeLink ? '#33CCFF' : 'rgba(0,0,0,0.26)',
                                          p: 0.5,
                                          '&:hover': { backgroundColor: client.wazeLink ? 'rgba(51, 204, 255, 0.1)' : 'transparent' }
                                        }}
                                      >
                                        <FaWaze style={{ fontSize: 32 }} />
                                      </IconButton>
                                    </Tooltip>
                                    {(() => {
                                      const pendingOrder = getPendingOrderForClient(fallbackClient.id || '');
                                      return pendingOrder && ((pendingOrder.order?.items && pendingOrder.order.items.length > 0) || pendingOrder.orderNote) ? (
                                        <Chip
                                          label="Pedido guardado"
                                          size="small"
                                          color="success"
                                          variant="outlined"
                                          sx={{
                                            fontSize: '0.65rem',
                                            height: '16px',
                                            '& .MuiChip-label': { px: 0.5 }
                                          }}
                                        />
                                      ) : null;
                                    })()}
                                  </Box>
                                  {(() => {
                                    const pOrder = getPendingOrderForClient(fallbackClient.id || '');
                                    return pOrder?.orderNote ? (
                                      <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5, pt: 0.5, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                        <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                          Nota del Pedido:
                                        </Typography>
                                        <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'primary.main' }}>
                                          {pOrder.orderNote}
                                        </Typography>
                                      </Box>
                                    ) : null;
                                  })()}
                                  {(fallbackClient.nota || (fallbackClient as any).nota_admin) && (
                                    <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5, pt: 0.5, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                      {fallbackClient.nota && (
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                          <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                            Nota Cliente:
                                          </Typography>
                                          <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'text.primary' }}>
                                            {fallbackClient.nota}
                                          </Typography>
                                        </Box>
                                      )}
                                      {(client as any).nota_admin && (
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                          <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                            Nota Admin:
                                          </Typography>
                                          <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'primary.main' }}>
                                            {(fallbackClient as any).nota_admin}
                                          </Typography>
                                        </Box>
                                      )}
                                    </Box>
                                  )}
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Tooltip title="Ver detalles cliente">
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        openClientDetails(fallbackClient);
                                      }}
                                      sx={{ color: '#00b4d8', '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' } }}
                                    >
                                      <VisibilityIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openRouteOrderDetails(route);
                                    }}
                                    sx={{ 
                                      ml: 1,
                                      '&:hover': {
                                        backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                      }
                                    }}
                                    title="Ver detalles pedido"
                                  >
                                    <ChevronRightIcon sx={{ fontSize: 16, color: '#1976d2' }} />
                                  </IconButton>
                                  {(() => {
                                    const routeKey = `${route.clientId}-${route.createdAt.getTime()}`;
                                    const hasNote = routesWithNotes[routeKey];
                                    return hasNote;
                                  })() && (
                                    <Tooltip title="Tiene nota de pedido">
                                      <NoteIcon 
                                        sx={{ 
                                          fontSize: 16, 
                                          color: '#2e7d32',
                                          opacity: 0.8
                                        }} 
                                      />
                                    </Tooltip>
                                  )}
                                 </Box>
                              </Box>
                           </Box>
                           )}
                          
                          {/* Icono de nota si existe */}
                          {savedNotes[route.id] && (
                            <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <NoteIcon sx={{ fontSize: 16, color: '#1976d2' }} />
                              <Typography variant="caption" color="#1976d2">
                                Tiene nota
                              </Typography>
                            </Box>
                          )}
                        </CardContent>
                      </Card>
                    );
                  });
                  })()}
                  {procesoRouteOrdersFilteredSearch.length === 0 && <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'textSecondary', py: 4, textAlign: 'center' }}>Sin elementos</Typography>}
                </Box>
              </Paper>
            </Box>

            {/* Columna 3: Completados */}
            <Box sx={{ width: 320, flexShrink: 0 }}>
              <Paper sx={{ p: 2, borderTop: '4px solid #2e7d32', borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>3. Completados</Typography>
                  <Chip label={completedRouteOrdersFilteredSearch.length} size="small" sx={{ ml: 'auto' }} />
                </Box>
                <Box
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={() => handleWorkflowDrop(3)}
                  sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}
                >
                  <>
                  {completedRouteOrdersFilteredSearch.map((route, index) => {
                    const client = clients.find(c => c.id === route.clientId);
                    if (!client) return null;
                    return (
                      <Card
                        key={`done-${route.id || route.clientId}-${route.createdAt.getTime()}-${index}`}
                        sx={{
                          borderLeft: '4px solid #2e7d32',
                          position: 'relative',
                          zIndex: 10,
                          pointerEvents: 'auto'
                        }}
                      >
                        <CardContent sx={{ p: 2 }}>
                          <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>{route.routeName}</Typography>
                          <Typography variant="caption" color="textSecondary" display="block">{format(route.createdAt, 'dd/MM/yyyy')}</Typography>
                      
                           <Box sx={{ mt: 1, bgcolor: '#e8f5e9', p: 1, borderRadius: 1 }}>
                             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                               <Box sx={{ flex: 1 }}>
                                 <Typography variant="caption" sx={{ fontWeight: 'bold', display: 'block' }}>
                                   {client.name}
                                 </Typography>
                                 <Typography variant="caption" color="textSecondary" display="block">
                                   {client.provincia}, {client.canton}, {client.distrito}
                                 </Typography>
                                 <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
                                   <Tooltip title={client.googleMapsLink ? "Abrir Google Maps" : "Sin link de Google Maps"}>
                                     <IconButton
                                       size="small"
                                       onClick={(e) => {
                                         e.stopPropagation();
                                         if (client.googleMapsLink) window.open(client.googleMapsLink, '_blank');
                                       }}
                                       disabled={!client.googleMapsLink}
                                       sx={{
                                         color: client.googleMapsLink ? '#4285F4' : 'rgba(0,0,0,0.26)',
                                         p: 0.5,
                                         '&:hover': { backgroundColor: client.googleMapsLink ? 'rgba(66, 133, 244, 0.1)' : 'transparent' }
                                       }}
                                     >
                                       <GoogleIcon style={{ fontSize: 32 }} />
                                     </IconButton>
                                   </Tooltip>
                                   <Tooltip title={client.wazeLink ? "Abrir Waze" : "Sin link de Waze"}>
                                     <IconButton
                                       size="small"
                                       onClick={(e) => {
                                         e.stopPropagation();
                                         if (client.wazeLink) window.open(client.wazeLink, '_blank');
                                       }}
                                       disabled={!client.wazeLink}
                                       sx={{
                                         color: client.wazeLink ? '#33CCFF' : 'rgba(0,0,0,0.26)',
                                         p: 0.5,
                                         '&:hover': { backgroundColor: client.wazeLink ? 'rgba(51, 204, 255, 0.1)' : 'transparent' }
                                       }}
                                     >
                                       <FaWaze style={{ fontSize: 32 }} />
                                     </IconButton>
                                   </Tooltip>
                                 </Box>
                                 {(() => {
                                   const pOrder = getPendingOrderForClient(client.id || '');
                                   return pOrder?.orderNote ? (
                                     <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5, pt: 0.5, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                       <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                         Nota del Pedido:
                                       </Typography>
                                       <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'primary.main' }}>
                                         {pOrder.orderNote}
                                       </Typography>
                                     </Box>
                                   ) : null;
                                 })()}
                                 {(client.nota || client.nota_admin) && (
                                   <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 0.5, pt: 0.5, borderTop: '1px solid rgba(0,0,0,0.05)' }}>
                                     {client.nota && (
                                       <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                         <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                           Nota Cliente:
                                         </Typography>
                                         <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'text.primary' }}>
                                           {client.nota}
                                         </Typography>
                                       </Box>
                                     )}
                                     {client.nota_admin && (
                                       <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                         <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '9px', color: 'text.secondary', lineHeight: 1, textTransform: 'uppercase' }}>
                                           Nota Admin:
                                         </Typography>
                                         <Typography variant="caption" sx={{ fontSize: '11px', fontStyle: 'italic', color: 'primary.main' }}>
                                           {client.nota_admin}
                                         </Typography>
                                       </Box>
                                     )}
                                   </Box>
                                 )}
                               </Box>
                               <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                                <Tooltip title="Ver detalles cliente">
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      openClientDetails(client);
                                    }}
                                    sx={{ color: '#00b4d8', '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' } }}
                                  >
                                    <VisibilityIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openRouteOrderDetails(route);
                                  }}
                                  sx={{ 
                                    '&:hover': {
                                      backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                    }
                                  }}
                                  title="Ver detalles pedido"
                                >
                                  <EditIcon sx={{ fontSize: 16, color: '#1976d2' }} />
                                  </IconButton>
                                {/* Indicador de nota debajo del icono de editar */}
                                {(() => {
                                  const routeKey = `${route.clientId}-${route.createdAt.getTime()}`;
                                  const hasNote = routesWithNotes[routeKey];
                                  return hasNote;
                                })() && (
                                  <Tooltip title="Tiene nota de pedido">
                                    <NoteIcon 
                                      sx={{ 
                                        fontSize: 16, 
                                        color: '#2e7d32',
                                        opacity: 0.8
                                      }} 
                                    />
                                  </Tooltip>
                                )}
                                </Box>
                             </Box>
                             <Box sx={{ mt: 1, display: 'flex', gap: 0.5, alignItems: 'center' }}>
                               <Chip 
                                 size="small"
                                 label={(client as any).proceso || 'Sin proceso'}
                                 sx={{
                                   fontWeight: 'bold',
                                   fontSize: '10px',
                                   backgroundColor: (client as any).proceso ? '#2e7d32' : '#9e9e9e',
                                   color: 'white',
                                 }}
                               />
                             </Box>
                           </Box>
                         </CardContent>
                      </Card>
                   )})}
                   {completedRouteOrdersFilteredSearch.length === 0 && <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'textSecondary', py: 4, textAlign: 'center' }}>Sin elementos</Typography>}
                  </>
                 </Box>
              </Paper>
            </Box>
          </Box>

          {/* View Client Dialog - Local to CustomerTracking */}
          <Dialog
            open={localViewOpen}
            onClose={handleLocalViewClose}
            maxWidth="lg"
            fullWidth
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              },
            }}
            PaperProps={{
              sx: {
                borderRadius: '8px',
                height: 'calc(100% - 64px)',
                maxHeight: 'none',
              },
            }}
          >
            <DialogTitle sx={{
              backgroundColor: '#87CEEB',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '1.5rem',
              py: 2,
            }}>
              Detalles del Cliente: {localCurrentClient?.name}
            </DialogTitle>
            <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', height: '100%', p: 0 }}>
              <Box sx={{ display: 'flex', height: '100%' }}>
                <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #e0e0e0' }}>
                  <Typography variant="h6" gutterBottom sx={{ color: '#87CEEB', fontWeight: 'bold' }}>Información Personal</Typography>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Teléfono</Typography>
                    <Typography>{localCurrentClient?.phoneNumber}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Email</Typography>
                    <Typography>{localCurrentClient?.email}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Cédula Nacional</Typography>
                    <Typography>{localCurrentClient?.cedula_nacional}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Tipo de Documento</Typography>
                    <Typography>{localCurrentClient?.tipo_documento}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Tipo de Cliente</Typography>
                    <Typography>{localCurrentClient?.tipo_client}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Tipo de Compostera</Typography>
                    <Typography>{localCurrentClient?.tipo_compostera}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="textSecondary">Tipo de Entrega</Typography>
                    {localCurrentClient?.tipo_entrega === 'Productos' ? (
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <ShoppingCartIcon sx={{ color: 'rgb(71, 219, 226)', mr: 1 }} />
                        <Typography>Productos</Typography>
                      </Box>
                    ) : (
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <RecoleccionIcon sx={{ color: 'green', mr: 1 }} />
                        <Typography>Recolección</Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
                <Box sx={{ width: '40%', p: 3, borderRight: '1px solid #e0e0e0' }}>
                  <Typography variant="h6" gutterBottom sx={{ color: '#87CEEB', fontWeight: 'bold' }}>Ubicación</Typography>
                  <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                    <IconButton
                      onClick={() => window.open(localCurrentClient?.googleMapsLink, '_blank')}
                      disabled={!localCurrentClient?.googleMapsLink}
                      sx={{
                        color: '#0078D4',
                        backgroundColor: 'white',
                        padding: '12px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          backgroundColor: 'rgba(0, 120, 212, 0.15)',
                          transform: 'scale(1.1)',
                          boxShadow: '0 4px 8px rgba(0, 120, 212, 0.2)'
                        },
                        '&.Mui-disabled': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          color: 'rgba(0, 0, 0, 0.26)'
                        }
                      }}
                    >
                      <GoogleIcon style={{ fontSize: 32 }} />
                    </IconButton>
                    <IconButton
                      onClick={() => window.open(localCurrentClient?.wazeLink, '_blank')}
                      disabled={!localCurrentClient?.wazeLink}
                      sx={{
                        mr: '8px', // Ajuste de margen derecho
                        backgroundColor: 'white',
                        color: '#33ccff',
                        padding: '12px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                        '&:hover': {
                          backgroundColor: 'rgba(0, 120, 212, 0.15)',
                          transform: 'scale(1.1)',
                          boxShadow: '0 4px 8px rgba(0, 120, 212, 0.2)'
                        },
                        '&.Mui-disabled': {
                          backgroundColor: '#e0e0e0',
                          color: '#9e9e9e',
                        }
                      }}
                    >
                      <FaWaze style={{ fontSize: 32 }} />
                    </IconButton>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Provincia</Typography>
                    <Typography>{localCurrentClient?.provincia}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Cantón</Typography>
                    <Typography>{localCurrentClient?.canton}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Distrito</Typography>
                    <Typography>{localCurrentClient?.distrito}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Municipalidad</Typography>
                    <Typography>{localCurrentClient?.municipalidades}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Dirección y señas para llegar</Typography>
                    <Typography>{localCurrentClient?.senas}</Typography>
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" color="textSecondary">Nota del cliente</Typography>
                    <Typography>{localCurrentClient?.nota}</Typography>
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" color="textSecondary">Nota Admin</Typography>
                    <Typography>{localCurrentClient?.nota_admin}</Typography>
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" color="textSecondary">Código de Referencia</Typography>
                    <Typography>{localCurrentClient?.codigo_referencia}</Typography>
                  </Box>
                </Box>
                <Box sx={{ width: '30%', p: 3, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="h6" gutterBottom sx={{ color: '#87CEEB', fontWeight: 'bold' }}>Imagen del cliente</Typography>
                  <Box sx={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '2px dashed #87CEEB',
                    borderRadius: 2,
                    mb: 3,
                  }}>
                    {localCurrentClient?.imageUrl ? (
                      <Box sx={{ position: 'relative', width: '100%', textAlign: 'center' }}>
                        <img src={localCurrentClient.imageUrl} alt="Client" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                      </Box>
                    ) : (
                      <Typography variant="body1" color="textSecondary">Vista previa de la imagen</Typography>
                    )}
                  </Box>
                  <Typography variant="h6" gutterBottom sx={{ color: '#87CEEB', fontWeight: 'bold' }}>Mascotas</Typography>
                  <Grid container spacing={2}>
                    {['cant_gato', 'cant_perro_mini', 'cant_perro_pequeno', 'cant_perro_mediano', 'cant_perro_grande', 'cant_perro_gigante']
                      .filter(field => parseInt(localCurrentClient?.[field as keyof Client] as string, 10) > 0)
                      .map((field) => (
                        <Grid item xs={6} key={field}>
                          <Box display="flex" alignItems="center">
                            <img
                              src={`${process.env.PUBLIC_URL}/images/${field}.png`}
                              alt={columnNames[field as keyof Client]}
                              style={{ width: '40px', height: '40px', marginRight: '8px' }}
                            />
                            <Typography variant="body2">{columnNames[field as keyof Client]}: {(() => {
                              const value = localCurrentClient?.[field as keyof Client];
                              if (!value) return '';
                              if ((value as any).toDate) return format((value as any).toDate(), 'dd/MM/yyyy HH:mm');
                              return String(value);
                            })()}</Typography>
                          </Box>
                        </Grid>
                      ))}
                  </Grid>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'right', px: 3, py: 2, backgroundColor: 'rgba(135, 206, 235, 0.1)' }}>
              <Button
                 onClick={handleLocalViewClose}
                variant="outlined"
                sx={{
                  color: '#87CEEB',
                  borderColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                    borderColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                }}
              >
                Cerrar
              </Button>
            </DialogActions>
           </Dialog>

           {/* Loading centrado en pantalla para lista de espera */}
           {waitlistDialogLoading && (
             <Box
               sx={{
                 position: 'fixed',
                 top: 0,
                 left: 0,
                 width: '100%',
                 height: '100%',
                 backgroundColor: 'rgba(0, 0, 0, 0.5)',
                 display: 'flex',
                 justifyContent: 'center',
                 alignItems: 'center',
                 zIndex: 9999,
               }}
             >
               <CircularProgress size={60} sx={{ color: 'white' }} />
             </Box>
           )}

           {/* Loading global después de cerrar popup */}
           {globalLoadingAfterClose && (
             <Box
               sx={{
                 position: 'fixed',
                 top: 0,
                 left: 0,
                 width: '100%',
                 height: '100%',
                 backgroundColor: 'rgba(0, 0, 0, 0.3)',
                 display: 'flex',
                 justifyContent: 'center',
                 alignItems: 'center',
                 zIndex: 9998,
               }}
             >
               <Box sx={{
                 backgroundColor: 'white',
                 padding: 3,
                 borderRadius: 2,
                 boxShadow: 3,
                 display: 'flex',
                 flexDirection: 'column',
                 alignItems: 'center',
                 gap: 2
               }}>
                 <CircularProgress size={50} sx={{ color: '#1976d2' }} />
                 <Typography variant="body1" sx={{ color: '#666' }}>
                   Actualizando interfaz...
                 </Typography>
               </Box>
             </Box>
           )}

            <Dialog
              open={waitlistDialogOpen}
              onClose={handleCloseWaitlistDialog}
             maxWidth="md"
             fullWidth
             PaperProps={{ sx: { borderRadius: 3, maxHeight: '90vh' } }}
             transitionDuration={{ enter: 0, exit: 0 }}
           >
            <DialogTitle sx={{ 
              background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
              color: 'white',
              fontWeight: 'bold',
              textAlign: 'center',
              py: 2,
              fontSize: '1.1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1
            }}>
              <PendingActionsIcon /> 
              <Typography variant="h6" component="div">
                Lista de espera - {selectedWaitlistClient && ('name' in selectedWaitlistClient.data ? (selectedWaitlistClient.data as any).name : '')}
              </Typography>
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" color="primary" gutterBottom>Información del Cliente</Typography>
                  <Paper sx={{ p: 2, borderRadius: 2 }}>
                    <Typography variant="body2"><strong>Nombre:</strong> {'name' in (selectedWaitlistClient?.data || {}) ? (selectedWaitlistClient?.data as any).name : ''}</Typography>
                    <Typography variant="body2"><strong>Teléfono:</strong> {'phoneNumber' in (selectedWaitlistClient?.data || {}) ? (selectedWaitlistClient?.data as any).phoneNumber : ''}</Typography>
                    {'provincia' in (selectedWaitlistClient?.data || {}) && (
                      <Typography variant="body2"><strong>Ubicación:</strong> {(selectedWaitlistClient?.data as any).provincia} {(selectedWaitlistClient?.data as any).canton ? `- ${(selectedWaitlistClient?.data as any).canton}` : ''}</Typography>
                    )}
                    {/* Mostrar notas del cliente si existen */}
                    {('senas' in (selectedWaitlistClient?.data || {}) && (selectedWaitlistClient?.data as any).senas) && (
                      <Box sx={{ mt: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#666' }}>
                          Señas:
                        </Typography>
                        <Typography variant="body2" sx={{ backgroundColor: '#f5f5f5', p: 1, borderRadius: 1, mt: 0.5 }}>
                          {(selectedWaitlistClient?.data as any).senas}
                        </Typography>
                      </Box>
                    )}
                    {('nota' in (selectedWaitlistClient?.data || {}) && (selectedWaitlistClient?.data as any).nota) && (
                      <Box sx={{ mt: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#666' }}>
                          Nota:
                        </Typography>
                        <Typography variant="body2" sx={{ backgroundColor: '#f5f5f5', p: 1, borderRadius: 1, mt: 0.5 }}>
                          {(selectedWaitlistClient?.data as any).nota}
                        </Typography>
                      </Box>
                    )}
                  </Paper>
                  <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography variant="subtitle2" color="primary" gutterBottom>Asignar ruta</Typography>
                    <FormControl fullWidth>
                      <InputLabel>Ruta</InputLabel>
                      <Select
                        label="Ruta"
                        value={selectedWaitlistRouteGroupId}
                        onChange={(e) => setSelectedWaitlistRouteGroupId(e.target.value)}
                      >
                        {routeGroupsForWaitlist.map(g => (
                          <MenuItem key={g.id} value={g.id}>{g.name || g.id}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {selectedWaitlistRouteGroupId && (
                      <>
                        <Typography variant="subtitle2" color="primary" gutterBottom>
                          Fechas disponibles para esta ruta
                        </Typography>
                        {futureRouteDates.length > 0 ? (
                          <FormControl fullWidth>
                            <InputLabel>Seleccionar fecha</InputLabel>
                            <Select
                              label="Seleccionar fecha"
                              value={selectedWaitlistDate ? selectedWaitlistDate.toISOString() : ''}
                              onChange={(e) => {
                                const selectedDate = new Date(e.target.value);
                                setSelectedWaitlistDate(selectedDate);
                              }}
                            >
                              {futureRouteDates.map((date, index) => (
                                <MenuItem key={index} value={date.toISOString()}>
                                  {format(date, 'dd/MM/yyyy')}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        ) : (
                          <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic' }}>
                            No hay fechas futuras disponibles para esta ruta
                          </Typography>
                        )}
                      </>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="subtitle2" color="primary" gutterBottom>Pedido</Typography>
                    {clientPendingOrder && (
                      <IconButton 
                        size="small" 
                        onClick={() => {
                          // Pass the existing order to the OrderCreationModal for editing
                          setExistingOrderForEdit(clientPendingOrder);
                          setOpenCreateOrderModal(true);
                        }}
                        sx={{ 
                          color: '#1976d2',
                          '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.04)' }
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    )}
                  </Box>
                   <Paper sx={{ p: 2, borderRadius: 2, minHeight: '200px' }}>
                     {clientPendingOrder ? (
                      <>
                        <Grid container spacing={1}>
                          {clientPendingOrder.items?.map((item, idx) => {
                            const invItem = inventoryItems.find(i => i.id === item.inventoryItemId);
                            return (
                              <Grid item xs={12} sm={6} key={idx}>
                                <Paper sx={{ p: 1.5, borderRadius: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                                  {invItem?.imageUrl ? (
                                    <Box sx={{ width: 40, height: 40, borderRadius: 1, overflow: 'hidden', flexShrink: 0 }}>
                                      <img src={invItem.imageUrl} alt={invItem.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </Box>
                                  ) : (
                                    <Box sx={{ width: 40, height: 40, borderRadius: 1, bgcolor: '#e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                      <ShoppingCartIcon sx={{ color: '#999' }} />
                                    </Box>
                                  )}
                                  <Box>
                                    <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.8rem' }}>
                                      {invItem?.name || item.inventoryItemId}
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">
                                      Cantidad: {item.quantity}
                                    </Typography>
                                  </Box>
                                </Paper>
                              </Grid>
                            );
                            })}
                         </Grid>

                         {/* Componente de notas para el pedido - siempre visible */}
                         <Paper sx={{
                           p: 3,
                           backgroundColor: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                           border: '1px solid #dee2e6',
                           borderRadius: 2,
                           boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                           mt: 2
                         }}>
                           <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                             <NoteIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                             <Typography variant="h6" sx={{
                               fontWeight: 'bold',
                               color: '#1976d2',
                               fontSize: '1rem'
                             }}>
                               Notas del Pedido
                             </Typography>
                           </Box>
                           {renderNotesTextField()}
                           <Typography variant="caption" sx={{
                             mt: 1,
                             color: '#666',
                             fontStyle: 'italic',
                             display: 'block'
                           }}>
                             💡 Las notas se guardarán automáticamente con el pedido
                           </Typography>
                         </Paper>
                       </>
                     ) : (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Typography variant="body2" color="textSecondary">No hay pedido. Crear uno para asignar ruta.</Typography>
                        <Button variant="contained" sx={{ backgroundColor: '#00b4d8' }} onClick={() => setOpenCreateOrderModal(true)}>Crear pedido</Button>

                        {/* Componente de notas para el pedido - siempre visible */}
                        <Paper sx={{
                          p: 3,
                          backgroundColor: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                          border: '1px solid #dee2e6',
                          borderRadius: 2,
                          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                          mt: 2
                        }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                            <NoteIcon sx={{ color: '#1976d2', fontSize: 20 }} />
                            <Typography variant="h6" sx={{
                              fontWeight: 'bold',
                              color: '#1976d2',
                              fontSize: '1rem'
                            }}>
                              Notas del Pedido
                            </Typography>
                          </Box>
                          {renderNotesTextField()}
                          <Typography variant="caption" sx={{
                            mt: 1,
                            color: '#666',
                            fontStyle: 'italic',
                            display: 'block'
                          }}>
                            💡 Las notas se guardarán automáticamente con el pedido
                          </Typography>
                        </Paper>
                      </Box>
                    )}
                  </Paper>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ 
              p: 3, 
              gap: 2,
              backgroundColor: 'rgba(25, 118, 210, 0.05)',
              borderTop: '1px solid rgba(25, 118, 210, 0.12)'
            }}>
              <Button
                onClick={() => {
                  if (!selectedWaitlistClient) return;
                  const clientId = (selectedWaitlistClient.data as any).id as string;
                  saveOrderWithoutRoute(clientPendingOrder, clientId);
                }}
                variant="outlined"
                disabled={(!clientPendingOrder || !clientPendingOrder.items || clientPendingOrder.items.length === 0) && (!waitlistOrderNote || waitlistOrderNote.trim() === '')}
                sx={{
                  color: '#1976d2',
                  borderColor: '#1976d2',
                  px: 4,
                  py: 1,
                  fontWeight: 'bold',
                  '&:hover': {
                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                    borderColor: '#1565c0'
                  },
                  '&:disabled': {
                    color: 'rgba(0, 0, 0, 0.26)',
                    borderColor: 'rgba(0, 0, 0, 0.12)'
                  }
                }}
              >
                Guardar pedido sin ruta
              </Button>
              <Button
                onClick={async () => {
                  console.log('=== INICIO: Botón Guardar Pedido clickeado ===');
                  console.log('selectedWaitlistClient:', selectedWaitlistClient);
                  console.log('clientPendingOrder:', clientPendingOrder);
                  console.log('selectedWaitlistRouteGroupId:', selectedWaitlistRouteGroupId);
                  console.log('selectedWaitlistDate:', selectedWaitlistDate);
                  
                  if (!selectedWaitlistClient) {
                    console.log('ERROR: No hay cliente seleccionado');
                    setNotification({ open: true, message: 'Selecciona un cliente', type: 'warning' });
                    return;
                  }
                  if (!clientPendingOrder) {
                    console.log('ERROR: No hay pedido');
                    setNotification({ open: true, message: 'Crea un pedido primero', type: 'warning' });
                    return;
                  }
                  if (!selectedWaitlistRouteGroupId) {
                    console.log('ERROR: No hay ruta seleccionada');
                    setNotification({ open: true, message: 'Selecciona una ruta', type: 'warning' });
                    return;
                  }
                  if (!selectedWaitlistDate) {
                    console.log('ERROR: No hay fecha seleccionada');
                    setNotification({ open: true, message: 'Selecciona una fecha', type: 'warning' });
                    return;
                  }
                  
                  console.log('=== TODOS LOS DATOS OK, LLAMANDO assignOrderToRouteGroup ===');
                  const clientId = (selectedWaitlistClient.data as any).id as string;
                  await assignOrderToRouteGroup(clientPendingOrder, clientId, selectedWaitlistRouteGroupId, selectedWaitlistDate);
                  console.log('=== assignOrderToRouteGroup COMPLETADO ===');
                }} 
                variant="contained"
                sx={{
                  backgroundColor: '#1976d2',
                  color: 'white',
                  px: 4,
                  py: 1,
                  fontWeight: 'bold',
                  '&:hover': {
                    backgroundColor: '#1565c0'
                  },
                  '&:disabled': {
                    backgroundColor: 'rgba(25, 118, 210, 0.5)',
                    color: 'rgba(255, 255, 255, 0.7)'
                  }
                }}
                disabled={isSaveButtonDisabled()}
                title={getSaveButtonTooltip()}
              >
                Guardar Pedido
              </Button>
              <Button
                onClick={handleCloseWaitlistDialog}
                variant="outlined"
                sx={{
                  color: '#1976d2',
                  borderColor: '#1976d2',
                  px: 4,
                  py: 1,
                  fontWeight: 'bold',
                  '&:hover': {
                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                    borderColor: '#1565c0'
                  }
                }}
              >
                Cerrar
              </Button>
            </DialogActions>
            <OrderCreationModal
              open={openCreateOrderModal}
              onClose={() => {
                setOpenCreateOrderModal(false);
                setExistingOrderForEdit(null);
              }}
              inventoryItems={inventoryItems}
              existingOrder={existingOrderForEdit || undefined}
              clientData={selectedWaitlistClient?.data as any}
              onOrderCreated={(order) => {
                setClientPendingOrder(order);
                setOpenCreateOrderModal(false);
                setExistingOrderForEdit(null);
                setNotification({ open: true, message: existingOrderForEdit ? 'Pedido actualizado' : 'Pedido creado', type: 'success' });
              }}
            />
          </Dialog>
          {showCompletionPopup && (
            <>
              <DarkOverlay />
              <NotificationPopup>
                <AnimatedEmoji>🎉</AnimatedEmoji>
                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>¡Completado!</Typography>
                <Typography variant="body1">El cliente ha sido movido a Completados ✅</Typography>
              </NotificationPopup>
            </>
          )}
          
          {/* Dialog for route order details */}
          <Dialog
            open={routeOrderDetailsDialogOpen}
            onClose={() => {
              setRouteOrderDetailsDialogOpen(false);
              setSelectedRouteOrderForDetails(null);
              setIsSavingNote(false); // Reiniciar loading al cerrar manualmente
            }}
            maxWidth="md"
            fullWidth
            PaperProps={{ sx: { borderRadius: 3, maxHeight: '90vh' } }}
          >
            <DialogTitle sx={{ 
              background: 'linear-gradient(135deg, #00b4d8 0%, #0077b6 100%)',
              color: 'white',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}>
              <LocalShippingIcon /> Detalles del Pedido
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
              {selectedRouteOrderForDetails && (
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                      Información de la Ruta
                    </Typography>
                    <Paper sx={{ p: 2, borderRadius: 2, mb: 2 }}>
                      <Typography variant="subtitle1"><strong>Ruta:</strong> {selectedRouteOrderForDetails.routeName}</Typography>
                      <Typography variant="body2"><strong>Fecha:</strong> {format(selectedRouteOrderForDetails.createdAt, 'dd/MM/yyyy')}</Typography>
                      <Typography variant="body2"><strong>Estado:</strong> {selectedRouteOrderForDetails.status}</Typography>
                    </Paper>
                    
                    {(() => {
                      const client = clients.find(c => c.id === selectedRouteOrderForDetails.clientId) || 
                                   publicClients.find(p => p.id === selectedRouteOrderForDetails.clientId);
                      const isRegularClient = clients.find(c => c.id === selectedRouteOrderForDetails.clientId);
                      console.log('DEBUG - Cliente encontrado en detalles de ruta:', client);
                      return client ? (
                        <>
                          <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                            Información del Cliente
                          </Typography>
                          <Paper sx={{ p: 2, borderRadius: 2, borderLeft: '4px solid #00b4d8' }}>
                            <Typography variant="subtitle1"><strong>Nombre:</strong> {client.name}</Typography>
                            <Typography variant="body2"><strong>Teléfono:</strong> {client.phoneNumber}</Typography>
                            {client.email && <Typography variant="body2"><strong>Email:</strong> {client.email}</Typography>}
                            <Typography variant="body2"><strong>Dirección:</strong> {client.provincia}, {client.canton}, {client.distrito}</Typography>
                             {client.senas && <Typography variant="body2"><strong>Señas:</strong> {client.senas}</Typography>}
                            {selectedRouteOrderForDetails.status === 'completed' && isRegularClient && (
                              <Box sx={{ mt: 2 }}>
                                <ProcessSelector 
                                  client={isRegularClient}
                                  showNotifications={false}
                                  onProcessChange={async (clientId, newProcess) => {
                                  try {
                                    console.log('Popup: INICIO - Guardando proceso para cliente', clientId, 'a:', newProcess);
                                    console.log('Popup: Cliente actual:', client);
                                    console.log('Popup: Ruta actual:', selectedRouteOrderForDetails);
                                    
                                    if (!clientId) {
                                      console.error('Popup: ERROR - ID de cliente no válido');
                                      throw new Error('ID de cliente no válido');
                                    }
                                    
                                    console.log('Popup: PASO 1 - Preparando para guardar en cliente...');
                                    
                                    const clientRef = doc(db, 'clients', clientId);
                                    console.log('Popup: PASO 2 - Referencia al cliente creada:', clientRef.path);
                                    
                                    const updateData = { proceso: newProcess };
                                    console.log('Popup: PASO 3 - Datos a actualizar:', updateData);
                                    
                                    await setDoc(clientRef, updateData, { merge: true });
                                    console.log('Popup: PASO 4 - setDoc completado para cliente');
                                    
                                    const clientDocSnap = await getDoc(clientRef);
                                    if (clientDocSnap.exists()) {
                                      const savedData = clientDocSnap.data();
                                      console.log('Popup: VERIFICACIÓN CLIENTE - Dato guardado:', savedData.proceso);
                                      console.log('Popup: VERIFICACIÓN CLIENTE - Dato esperado:', newProcess);
                                      console.log('Popup: VERIFICACIÓN CLIENTE - ¿Coinciden?', savedData.proceso === newProcess);
                                      
                                      if (savedData.proceso !== newProcess) {
                                        console.error('Popup: ERROR GRAVE - El dato no se guardó correctamente en el cliente');
                                        console.error('Popup: Guardado:', savedData.proceso, 'Esperado:', newProcess);
                                        throw new Error(`El dato no se guardó correctamente. Guardado: ${savedData.proceso}, Esperado: ${newProcess}`);
                                      }
                                      console.log('Popup: ÉXITO - El dato se guardó correctamente en el cliente');
                                    } else {
                                      console.error('Popup: ERROR - El documento del cliente no existe');
                                      throw new Error('El documento del cliente no existe después de guardar');
                                    }
                                    
                                    console.log('Popup: FIN - Guardado completado exitosamente');
                                    
                                  } catch (err) {
                                    console.error('Popup: ERROR GENERAL al guardar en Firestore:', err);
                                    console.error('Popup: Stack trace:', err instanceof Error ? err.stack : 'No stack trace available');
                                    throw err;
                                  }
                                }}
                                onProcessUpdated={async () => {
                                  console.log('Popup: Proceso actualizado, recargando página...');
                                  window.location.reload();
                                }}
                              />
                            </Box>
                            )}

                          </Paper>
                        </>
                      ) : (
                        // Fallback: mostrar datos guardados en la ruta si no se encuentra en las listas
                        selectedRouteOrderForDetails?.clientData && (
                          <>
                            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                              Información del Cliente
                            </Typography>
                            <Paper sx={{ p: 2, borderRadius: 2, borderLeft: '4px solid #00b4d8' }}>
                              <Typography variant="subtitle1"><strong>Nombre:</strong> {selectedRouteOrderForDetails.clientData.name}</Typography>
                              <Typography variant="body2"><strong>Teléfono:</strong> {selectedRouteOrderForDetails.clientData.phone}</Typography>
                              {selectedRouteOrderForDetails.clientData.email && <Typography variant="body2"><strong>Email:</strong> {selectedRouteOrderForDetails.clientData.email}</Typography>}
                              <Typography variant="body2"><strong>Dirección:</strong> {selectedRouteOrderForDetails.clientData.address}</Typography>
                              {selectedRouteOrderForDetails.clientData.senas && <Typography variant="body2"><strong>Señas:</strong> {selectedRouteOrderForDetails.clientData.senas}</Typography>}
                            </Paper>
                          </>
                        )
                      );
                    })()}
                  </Grid>
                  
                  <Grid item xs={12} md={6}>
                    {/* Sección única de notas del pedido */}
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                      Nota del Pedido
                    </Typography>
                     <Paper sx={{ 
                       p: 3, 
                       borderRadius: 2, 
                       mb: 2, 
                       background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                       border: '1px solid #dee2e6',
                       boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                     }}>
                       {(() => {
                         // Consolidar todas las fuentes de notas en una sola
                          const routeKey = `${selectedRouteOrderForDetails.clientId}-${selectedRouteOrderForDetails.createdAt.getTime()}`;
                         
                         // Priorizar la nota consolidada
                         const consolidatedNote = selectedRouteOrderForDetails.notes || 
                                                  selectedRouteOrderForDetails.orderNote || 
                                                  routeOrderNotes[routeKey] || 
                                                  selectedRouteOrderForDetails.order?.routeNotes?.note_admin || '';
                         
                         if (consolidatedNote) {
                           return (
                             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                               <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                                 <Box sx={{
                                   width: 8, height: 8, borderRadius: '50%', backgroundColor: '#1976d2',
                                   marginTop: '8px', flexShrink: 0
                                 }} />
                                 <Typography variant="body1" sx={{ 
                                   flex: 1,
                                   fontSize: '0.95rem',
                                   lineHeight: 1.5,
                                   color: '#333',
                                   minHeight: '48px'
                                 }}
                                 >
                                   {consolidatedNote}
                                 </Typography>
                               </Box>
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={() => {
                                    const uniqueRouteId = `${selectedRouteOrderForDetails.clientId}-${selectedRouteOrderForDetails.createdAt.getTime()}`;
                                    setOriginalNoteValue(routeOrderNotes[uniqueRouteId] || consolidatedNote || '');
                                    setIsEditingNote(true);
                                  }}
                                  sx={{
                                   alignSelf: 'flex-end',
                                   backgroundColor: '#1976d2',
                                   color: 'white',
                                   '&:hover': {
                                     backgroundColor: '#1565c0',
                                   }
                                 }}
                               >
                                 Editar nota
                               </Button>
                             </Box>
                           );
                         } else {
                           return (
                             <Box>
                               <Box sx={{ textAlign: 'center', py: 3 }}>
                                 <Typography 
                                   variant="body2" 
                                   sx={{ 
                                     fontStyle: 'italic', 
                                     color: '#6c757d',
                                     fontSize: '0.9rem',
                                     mb: 2
                                   }}
                                 >
                                   No hay notas para este pedido
                                 </Typography>
                               </Box>
                                <Button
                                  variant="contained"
                                  size="small"
                                  onClick={() => {
                                    setOriginalNoteValue('');
                                    setIsEditingNote(true);
                                  }}
                                  sx={{
                                   alignSelf: 'flex-end',
                                   backgroundColor: '#1976d2',
                                   color: 'white',
                                   '&:hover': {
                                     backgroundColor: '#1565c0',
                                   }
                                 }}
                               >
                                 Agregar nota
                               </Button>
                             </Box>
                           );
                         }
                       })()}
                     </Paper>
                  </Grid>
                  
                  <Grid item xs={12}>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                      Productos del Pedido
                    </Typography>
                    <Box sx={{ maxHeight: '400px', overflowY: 'auto' }}>
                      {selectedRouteOrderForDetails.order?.items?.map((item, idx) => {
                        const invItem = inventoryItems.find(i => i.id === item.inventoryItemId);
                        return (
                          <Paper key={idx} sx={{ p: 2, borderRadius: 2, mb: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
                            {invItem?.imageUrl ? (
                              <Box sx={{ width: 50, height: 50, borderRadius: 1, overflow: 'hidden', flexShrink: 0 }}>
                                <img src={invItem.imageUrl} alt={invItem.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                              </Box>
                            ) : (
                              <Box sx={{ width: 50, height: 50, borderRadius: 1, overflow: 'hidden', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
                                <Typography variant="caption" color="textSecondary">Sin imagen</Typography>
                              </Box>
                            )}
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="subtitle2">{invItem?.name || 'Producto desconocido'}</Typography>
                              <Typography variant="body2" color="textSecondary">
                                Cantidad: {item.quantity}
                              </Typography>
                              {invItem?.price && (
                                <Typography variant="body2" color="primary">
                                  ₡{(invItem.price * item.quantity).toFixed(2)}
                                </Typography>
                              )}
                            </Box>
                          </Paper>
                        );
                      })}
                      {(!selectedRouteOrderForDetails.order?.items || selectedRouteOrderForDetails.order.items.length === 0) && (
                        <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'textSecondary' }}>
                          No hay productos en este pedido
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              )}
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              {(!selectedRouteOrderForDetails || selectedRouteOrderForDetails.status !== 'completed') && (
              <Button
                variant="contained"
                color="success"
                disabled={!selectedRouteOrderForDetails || selectedRouteOrderForDetails.status === 'completed' || savingRoute}
                onClick={async () => {
                  await completeRouteOrder();
                }}
              >
                Completado
              </Button>
              )}
              <Button 
                onClick={() => {
                  setRouteOrderDetailsDialogOpen(false);
                  setIsSavingNote(false); // Reiniciar loading al cerrar
                }} 
                variant="outlined"
              >
                Cerrar
              </Button>
            </DialogActions>
           </Dialog>
           
            {/* Edit Note Popup */}
            <Dialog
              open={isEditingNote}
              onClose={() => {
                if (selectedRouteOrderForDetails) {
                  const uniqueRouteId = `${selectedRouteOrderForDetails.clientId}-${selectedRouteOrderForDetails.createdAt.getTime()}`;
                  setRouteOrderNotes(prev => ({
                    ...prev,
                    [uniqueRouteId]: originalNoteValue
                  }));
                }
                setIsEditingNote(false);
              }}
              maxWidth="md"
              fullWidth
              PaperProps={{ sx: { borderRadius: 3, maxHeight: '90vh' } }}
            >
             <DialogTitle sx={{ 
               background: 'linear-gradient(135deg, #00b4d8 0%, #0077b6 100%)',
               color: 'white',
               fontWeight: 'bold',
               display: 'flex',
               alignItems: 'center',
               gap: 1
             }}>
               <EditIcon /> Editar Nota del Pedido
             </DialogTitle>
             <DialogContent sx={{ mt: 2 }}>
               {selectedRouteOrderForDetails && (
                 <Box sx={{ p: 3 }}>
                   <TextField
                     fullWidth
                     multiline
                     rows={4}
                     size="small"
                     placeholder="Editar nota para este pedido..."
                     value={routeOrderNotes[`${selectedRouteOrderForDetails?.clientId}-${selectedRouteOrderForDetails?.createdAt.getTime()}`] || ''}
                     onChange={(e) => {
                       if (!selectedRouteOrderForDetails) return;
                       
                       const uniqueRouteId = `${selectedRouteOrderForDetails.clientId}-${selectedRouteOrderForDetails.createdAt.getTime()}`;
                       setRouteOrderNotes(prev => ({
                         ...prev,
                         [uniqueRouteId]: e.target.value
                       }));
                     }}
                     sx={{ 
                       '& .MuiOutlinedInput-root': {
                         backgroundColor: 'white',
                         '& fieldset': {
                           borderColor: '#e0e0e0',
                         },
                         '&:hover fieldset': {
                           borderColor: '#1976d2',
                         },
                         '&.Mui-focused fieldset': {
                           borderColor: '#1976d2',
                         }
                       }
                     }}
                   />
                 </Box>
               )}
             </DialogContent>
              <DialogActions sx={{ p: 2 }}>
                <Button onClick={() => {
                  if (selectedRouteOrderForDetails) {
                    const uniqueRouteId = `${selectedRouteOrderForDetails.clientId}-${selectedRouteOrderForDetails.createdAt.getTime()}`;
                    setRouteOrderNotes(prev => ({
                      ...prev,
                      [uniqueRouteId]: originalNoteValue
                    }));
                  }
                  setIsEditingNote(false);
                }} variant="outlined">
                  Cancelar
                </Button>
               <Button
                 variant="contained"
                 onClick={async () => {
                   if (!selectedRouteOrderForDetails) return;
                   
                   const uniqueRouteId = `${selectedRouteOrderForDetails.clientId}-${selectedRouteOrderForDetails.createdAt.getTime()}`;
                   const noteValue = routeOrderNotes[uniqueRouteId] || '';
                   
                   if (!noteValue.trim()) {
                     setNotification({ 
                       open: true, 
                       message: 'Por favor ingrese una nota', 
                       type: 'warning' 
                     });
                     return;
                   }
                   
                   // Mostrar loading inmediatamente
                   setIsSavingNote(true);
                   
                   try {
                     // Buscar el routeGroup y la ruta específica para guardar la nota
                     const routeGroupsRef = collection(db, 'routeGroups');
                     const routeGroupsQuery = await getDocs(routeGroupsRef);
                     
                     let noteSaved = false;
                     
                     for (const routeGroupDoc of routeGroupsQuery.docs) {
                       const routesUnionRef = collection(db, `routeGroups/${routeGroupDoc.id}/routesUnion`);
                       const routesUnionSnapshot = await getDocs(routesUnionRef);
                       
                       for (const routeUnionDoc of routesUnionSnapshot.docs) {
                         const routeUnionData = routeUnionDoc.data();
                         const routes = routeUnionData.routes || [];
                         
                         // Buscar la ruta específica por clientId y fecha
                         const routeIndex = routes.findIndex((r: any) => 
                           r.clientId === selectedRouteOrderForDetails?.clientId && 
                           new Date(routeUnionData.date.toDate()).toDateString() === selectedRouteOrderForDetails.createdAt.toDateString()
                         );
                         
                         if (routeIndex !== -1) {
                           // Actualizar la nota en la ruta encontrada
                           routes[routeIndex].notes = noteValue;
                           routes[routeIndex].notesUpdatedAt = new Date();
                           
                           // También guardar en orderNote para mantener sincronización
                           routes[routeIndex].orderNote = noteValue;
                           
                           // Guardar en la base de datos
                           await setDoc(doc(db, `routeGroups/${routeGroupDoc.id}/routesUnion`, routeUnionDoc.id), {
                             ...routeUnionData,
                             routes: routes
                           }, { merge: true });
                           
                           setNotification({ 
                             open: true, 
                             message: 'Nota guardada exitosamente', 
                             type: 'success' 
                           });
                           
                           // Actualizar el estado de notas para mostrar el indicador
                           setRoutesWithNotes(prev => ({ 
                             ...prev, 
                             [uniqueRouteId]: true 
                           }));
                           
                           // Actualizar selectedRouteOrderForDetails para que se muestre la nota inmediatamente
                           setSelectedRouteOrderForDetails(prev => prev ? {
                             ...prev,
                             notes: noteValue,
                             orderNote: noteValue
                           } : null);
                           
                           noteSaved = true;
                           break;
                         }
                       }
                       
                       if (noteSaved) break;
                     }
                     
                     if (!noteSaved) {
                       throw new Error('No se encontró la ruta para guardar la nota');
                     }
                   } catch (error) {
                     console.error('Error al guardar nota:', error);
                     setNotification({ 
                       open: true, 
                       message: 'Error al guardar nota', 
                       type: 'error' 
                     });
                   } finally {
                     setIsSavingNote(false);
                     setIsEditingNote(false);
                   }
                 }}
                 disabled={isSavingNote}
                 sx={{ 
                   alignSelf: 'flex-end',
                   minWidth: '120px',
                   backgroundColor: '#1976d2',
                   '&:hover': {
                     backgroundColor: '#1565c0',
                   }
                 }}
               >
                 {isSavingNote ? 'Guardando...' : 'Guardar Nota'}
               </Button>
             </DialogActions>
           </Dialog>
         </Box>
       )}
       
       {/* Loading overlay para guardar notas */}
       {isSavingNote && (
         <Box
           sx={{
             position: 'fixed',
             top: 0,
             left: 0,
             right: 0,
             bottom: 0,
             backgroundColor: 'rgba(0, 0, 0, 0.7)',
             display: 'flex',
             alignItems: 'center',
             justifyContent: 'center',
             zIndex: 9999,
           }}
         >
           <Box
             sx={{
               backgroundColor: 'white',
               padding: 4,
               borderRadius: 2,
               display: 'flex',
               flexDirection: 'column',
               alignItems: 'center',
               gap: 2,
             }}
           >
             <CircularProgress size={60} thickness={4} />
             <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
               Guardando nota...
             </Typography>
             <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
               Por favor espera un momento
             </Typography>
           </Box>
         </Box>
       )}
      
      {/* Loading overlay para workflow drop */}
      {workflowDropLoading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              backgroundColor: 'white',
              padding: 4,
              borderRadius: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <CircularProgress size={60} thickness={4} />
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
              Procesando movimiento...
            </Typography>
            <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
              Por favor espera un momento
            </Typography>
          </Box>
        </Box>
      )}

      {/* Loading overlay para guardar ruta */}
      {savingRoute && (
        <>
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 9999,
            }}
          >
            <Box
              sx={{
                backgroundColor: 'white',
                padding: 4,
                borderRadius: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
              }}
            >
              <CircularProgress size={60} thickness={4} />
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                Guardando pedido en la ruta...
              </Typography>
              <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                Por favor espera un momento
              </Typography>
            </Box>
          </Box>
        </>
      )}
      
      {/* Dialog para confirmar la creación del cliente - LOCAL para CustomerTracking */}
      <Dialog
        open={createClientDialogOpenLocal}
        onClose={() => setCreateClientDialogOpenLocal(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          }
        }}
      >
        <DialogTitle sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
          color: 'white',
          fontWeight: 'bold',
          textAlign: 'center',
          py: 2
        }}>
          <Typography variant="h6" component="div">
            Confirmar Creación de Cliente
          </Typography>
        </DialogTitle>
        
        <DialogContent sx={{ mt: 3, pb: 2 }}>
          {selectedClientLocal && (
            <Box>
              <Typography variant="body1" gutterBottom sx={{ fontWeight: 'medium', mb: 2 }}>
                ¿Estás seguro de que deseas crear el cliente con la siguiente información?
              </Typography>
              
              <Paper sx={{ p: 2, backgroundColor: '#f8f9fa', borderRadius: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" color="primary" gutterBottom>
                      Información Personal
                    </Typography>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="body2" color="textSecondary">Nombre:</Typography>
                      <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                        {selectedClientLocal.name}
                      </Typography>
                    </Box>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="body2" color="textSecondary">Teléfono:</Typography>
                      <Typography variant="body1">
                        {selectedClientLocal.phoneNumber}
                      </Typography>
                    </Box>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="body2" color="textSecondary">Email:</Typography>
                      <Typography variant="body1">
                        {selectedClientLocal.email}
                      </Typography>
                    </Box>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="body2" color="textSecondary">Cédula:</Typography>
                      <Typography variant="body1">
                        {selectedClientLocal.cedula_nacional}
                      </Typography>
                    </Box>
                  </Grid>
                  
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" color="primary" gutterBottom>
                      Ubicación
                    </Typography>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="body2" color="textSecondary">Provincia:</Typography>
                      <Typography variant="body1">
                        {selectedClientLocal.provincia}
                      </Typography>
                    </Box>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="body2" color="textSecondary">Cantón:</Typography>
                      <Typography variant="body1">
                        {selectedClientLocal.canton}
                      </Typography>
                    </Box>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="body2" color="textSecondary">Distrito:</Typography>
                      <Typography variant="body1">
                        {selectedClientLocal.distrito}
                      </Typography>
                    </Box>
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="body2" color="textSecondary">Señas:</Typography>
                      <Typography variant="body1" sx={{ fontSize: '0.875rem' }}>
                        {selectedClientLocal.senas}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
                
                <Box sx={{ mt: 2 }}>
                  <Typography variant="subtitle2" color="primary" gutterBottom>
                    Tipo de Servicio
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <Box>
                      <Typography variant="body2" color="textSecondary">Tipo Cliente:</Typography>
                      <Typography variant="body1">
                        {selectedClientLocal.tipo_client}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="body2" color="textSecondary">Tipo Compostera:</Typography>
                      <Typography variant="body1">
                        {selectedClientLocal.tipo_compostera}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="body2" color="textSecondary">Tipo Entrega:</Typography>
                      <Typography variant="body1">
                        {selectedClientLocal.tipo_entrega}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>
          )}
        </DialogContent>
        
        <DialogActions sx={{ justifyContent: 'center', gap: 2, p: 3 }}>
          <Button
            onClick={() => {
              setCreateClientDialogOpenLocal(false);
              setSelectedClientLocal(null);
              // El efecto useEffect se encargará de limpiar workflowDragged
            }}
            variant="outlined"
            sx={{
              borderColor: '#1976d2',
              color: '#1976d2',
              '&:hover': {
                backgroundColor: 'rgba(25, 118, 210, 0.04)',
                borderColor: '#1565c0'
              },
              px: 4,
              py: 1
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={async () => {
              if (!selectedClientLocal) return;
              
              try {
                // 1. Crear el cliente en Firestore (colección 'clients')
                const clientsRef = collection(db, 'clients');
                const newClient: Omit<Client, 'id'> = {
                  name: selectedClientLocal.name,
                  phoneNumber: selectedClientLocal.phoneNumber,
                  email: selectedClientLocal.email,
                  googleMapsLink: selectedClientLocal.googleMapsLink,
                  wazeLink: selectedClientLocal.wazeLink,
                  cedula_nacional: selectedClientLocal.cedula_nacional,
                  second_phoneNumber: selectedClientLocal.second_phoneNumber,
                  tipo_documento: selectedClientLocal.tipo_documento,
                  tipo_client: selectedClientLocal.tipo_client,
                  tipo_compostera: selectedClientLocal.tipo_compostera,
                  tipo_entrega: selectedClientLocal.tipo_entrega,
                  senas: selectedClientLocal.senas,
                  nota: selectedClientLocal.nota,
                  imageUrl: selectedClientLocal.imageUrl,
                  provincia: selectedClientLocal.provincia,
                  canton: selectedClientLocal.canton,
                  distrito: selectedClientLocal.distrito,
                  municipalidades: selectedClientLocal.municipalidades,
                  cant_gato: selectedClientLocal.cant_gato,
                  cant_perro_mini: selectedClientLocal.cant_perro_mini,
                  cant_perro_pequeno: selectedClientLocal.cant_perro_pequeno,
                  cant_perro_mediano: selectedClientLocal.cant_perro_mediano,
                  cant_perro_grande: selectedClientLocal.cant_perro_grande,
                  cant_perro_gigante: selectedClientLocal.cant_perro_gigante,
                  codigo_referencia: selectedClientLocal.codigo_referencia,
                  nota_admin: '',
                  proceso: 'Inscripción pagada',
                };
                
                const createdDoc = await addDoc(clientsRef, { ...newClient, createdAt: serverTimestamp(), fromPublicForm: true });
                const newClientId = createdDoc.id;
                
                // 3. Si había un publicClient original, actualizarlo a 'completed'
                if (selectedClientLocal.id) {
                  await setDoc(doc(db, 'publicClients', selectedClientLocal.id), {
                    workflow_stage: 'converted',
                    status_create_public_client: 'completed'
                  }, { merge: true });
                }
                
                setCreateClientDialogOpenLocal(false);
                setSelectedClientLocal(null);
                setWorkflowDragged(null);
                
                // Show success popup
                setClientCreationSuccessOpen(true);
                
              } catch (error) {
                console.error('Error al crear cliente:', error);
                setNotification({ 
                  open: true, 
                  message: 'Error al crear cliente: ' + (error as Error).message, 
                  type: 'error' 
                });
              }
            }}
            variant="contained"
            sx={{
              background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #1565c0 0%, #2196f3 100%)',
              },
              px: 4,
              py: 1
            }}
          >
            Crear Cliente
          </Button>
        </DialogActions>
      </Dialog>

      {/* Success popup after client creation */}
      <Dialog
        open={clientCreationSuccessOpen}
        onClose={() => setClientCreationSuccessOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, p: 3, textAlign: 'center' } }}
      >
        <CheckCircleIcon sx={{ fontSize: 56, color: '#4caf50', mb: 2 }} />
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
          Cliente creado exitosamente
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          El cliente ha sido creado y agregado al flujo de trabajo
        </Typography>
        <Button
          onClick={() => setClientCreationSuccessOpen(false)}
          variant="contained"
          sx={{ bgcolor: '#00b4d8', '&:hover': { bgcolor: '#0098b8' }, px: 4 }}
        >
          Aceptar
        </Button>
      </Dialog>

      {/* Success popup after moving between columns */}
      <Dialog
        open={!!moveSuccessOpen}
        onClose={() => { if (moveSuccessOpen?.reload) window.location.reload(); else setMoveSuccessOpen(null); }}
        maxWidth="xs"
        fullWidth
        transitionDuration={{ enter: 0, exit: 0 }}
        PaperProps={{ sx: { borderRadius: 3, p: 3, textAlign: 'center' } }}
      >
        <CheckCircleIcon sx={{ fontSize: 56, color: '#4caf50', mb: 2 }} />
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
          Movimiento exitoso
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {moveSuccessOpen?.message}
        </Typography>
        <Button
          onClick={() => { if (moveSuccessOpen?.reload) window.location.reload(); else setMoveSuccessOpen(null); }}
          variant="contained"
          sx={{ bgcolor: '#00b4d8', '&:hover': { bgcolor: '#0098b8' }, px: 4 }}
        >
          Aceptar
        </Button>
      </Dialog>

      {/* Diálogo de confirmación de eliminación */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteCancel}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle sx={{ 
          backgroundColor: '#d32f2f', 
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <DeleteIcon />
          Confirmar Eliminación
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Typography variant="body1" sx={{ mb: 3, mt: 1 }}>
            ¿Está seguro que desea eliminar este elemento de la lista de espera?
          </Typography>
          
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#d32f2f', display: 'flex', alignItems: 'center', gap: 1 }}>
              <WarningAmberIcon fontSize="small" />
              Consecuencias de la eliminación:
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mt: 1, pl: 3 }}>
              Al confirmar, el registro será borrado permanentemente de la base de datos. El cliente o pedido desaparecerá de la lista de espera y no podrá ser recuperado ni asignado a rutas futuras.
            </Typography>
          </Box>

          {selectedClientToDelete && (
            <Box sx={{ 
              p: 2, 
              backgroundColor: '#f8f9fa', 
              borderRadius: 2,
              border: '1px solid #dee2e6',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#d32f2f' }}>
                  {
                    selectedClientToDelete.type === 'public' ? 'Cliente Público' : 
                    selectedClientToDelete.type === 'client' ? 'Cliente Regular' : 
                    selectedClientToDelete.type === 'pendingOrder' ? 'Pedido Pendiente' : 
                    'Pedido Reprogramado'
                  }
                </Typography>
                <Chip 
                  label={selectedClientToDelete.type.includes('Order') ? 'Pedido' : 'Cliente'} 
                  size="small" 
                  variant="outlined" 
                  sx={{ fontSize: '0.6rem', height: '16px' }} 
                />
              </Box>
              {(() => {
                const data = selectedClientToDelete.data;
                if (selectedClientToDelete.type === 'public' || selectedClientToDelete.type === 'client') {
                  return (
                    <>
                      <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333' }}>
                        Nombre: {data.name || 'Sin nombre'}
                      </Typography>
                      {data.provincia && (
                        <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
                          Ubicación: {data.provincia}, {data.canton}, {data.distrito}
                        </Typography>
                      )}
                    </>
                  );
                } else {
                  const order = data;
                  const routeName = selectedClientToDelete.type === 'pendingOrder' 
                    ? order.routeName 
                    : routeGroupsForWaitlist.find(rg => rg.id === order.destinyReprogrammedRouteGroupId)?.name;

                  return (
                    <>
                      <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#333' }}>
                        Ruta: {routeName || 'Sin asignar'}
                      </Typography>
                      <Typography variant="caption" color="textSecondary" sx={{ display: 'block' }}>
                        Fecha: {
                          (selectedClientToDelete.type === 'reprogrammedOrder' 
                            ? (order.destinyReprogrammedDate instanceof Date ? order.destinyReprogrammedDate : (order.destinyReprogrammedDate as any)?.toDate?.() || new Date(order.destinyReprogrammedDate))
                            : order.date
                          ) 
                          ? format(
                              (selectedClientToDelete.type === 'reprogrammedOrder' 
                                ? (order.destinyReprogrammedDate instanceof Date ? order.destinyReprogrammedDate : (order.destinyReprogrammedDate as any)?.toDate?.() || new Date(order.destinyReprogrammedDate))
                                : order.date), 
                              'dd/MM/yyyy', { locale: es }) 
                          : 'Sin fecha'
                        }
                      </Typography>
                    </>
                  );
                }
              })()}
            </Box>
          )}
          <Typography variant="body2" color="error" sx={{ mt: 2, fontWeight: 'bold' }}>
            ⚠️ Esta acción no se puede deshacer
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 3, gap: 1 }}>
          <Button
            onClick={handleDeleteCancel}
            variant="outlined"
            sx={{
              color: '#666',
              borderColor: '#666',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              }
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            variant="contained"
            sx={{
              backgroundColor: '#d32f2f',
              color: 'white',
              '&:hover': {
                backgroundColor: '#b71c1c',
              }
            }}
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

const ClientList: React.FC<ClientListProps> = (props) => {
  const {
    clients,
    publicClients,
    onUpdate,
    onDelete,
    onAddNew,
    onUpdatePublicClient,
    onAddNewPublicClient,
    onDeletePublicClient,
    savingRoute,
    setSavingRoute
  } = props;

  const [isMinimized, setIsMinimized] = useState(true);
  const [currentClient, setCurrentClient] = useState<Client | null>(null);
  const [open, setOpen] = useState(false);
  const [openPublic, setOpenPublic] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [viewOpenPublic, setViewOpenPublic] = useState(false);
  const [newTabValue, setNewTabValue] = useState(2);
  const [workflowStartDate, setWorkflowStartDate] = useState<Date | null>(subDays(new Date(), 1));
  const [workflowEndDate, setWorkflowEndDate] = useState<Date | null>(new Date());
  const [workflowSearchTerm, setWorkflowSearchTerm] = useState('');
  const [filterProvincia, setFilterProvincia] = useState('');
  const [filterCanton, setFilterCanton] = useState('');
  const [filterDistrito, setFilterDistrito] = useState('');
  const [isLocationSelected, setIsLocationSelected] = useState(false);
  const [isLocationSelectedPublic, setIsLocationSelectedPublic] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [cardFilteredClients, setCardFilteredClients] = useState<Client[]>(clients);
  const [cardFilteredClientsPublic, setCardFilteredClientsPublic] = useState<PublicClient[]>(publicClients);
  const [cardSearchTerm, setCardSearchTerm] = useState('');
  const [cardSearchTermPublic, setCardSearchTermPublic] = useState('');
  const [cardIsFilterDialogOpen, setCardIsFilterDialogOpen] = useState(false);
  const [cardIsFilterDialogOpenPublic, setCardIsFilterDialogOpenPublic] = useState(false);
  
  // Update local states when props change
  useEffect(() => {
    console.log('DEBUG - clients prop updated, refreshing local states:', clients.length);
    setCardFilteredClients(clients);
    setTableFilteredClients(clients);
  }, [clients]);
  
  useEffect(() => {
    console.log('DEBUG - publicClients prop updated, refreshing local states:', publicClients.length);
    setCardFilteredClientsPublic(publicClients);
    setPublicTableFilteredClients(publicClients);
  }, [publicClients]);
  const [cardSelectedFilters, setCardSelectedFilters] = useState<{ [key: string]: string[] }>({});
  const [cardSelectedFiltersPublic, setCardSelectedFiltersPublic] = useState<{ [key: string]: string[] }>({});
  const [tableIsFilterDialogOpen, setTableIsFilterDialogOpen] = useState(false);
  const [tableIsFilterDialogOpenPublic, setTableIsFilterDialogOpenPublic] = useState(false);
  const [tableSelectedFilters, setTableSelectedFilters] = useState<{ [key: string]: string[] }>({});
  const [tableFilteredClients, setTableFilteredClients] = useState<Client[]>(clients);
  const [tableSearchTerm, setTableSearchTerm] = useState('');
  const [tableSearchTermPublic, setTableSearchTermPublic] = useState('');
  const [tableTipoComposteraFilter, setTableTipoComposteraFilter] = useState<string[]>([]);
  const [tableTipoDocumentoFilter, setTableTipoDocumentoFilter] = useState<string[]>([]);

  const [tableTipoClienteFilter, setTableTipoClienteFilter] = useState<string[]>([]);
  const [tableProvinciaFilter, setTableProvinciaFilter] = useState<string[]>([]);
  const [tableCantonFilter, setTableCantonFilter] = useState<string[]>([]);
  const [tableDistritoFilter, setTableDistritoFilter] = useState<string[]>([]);
  const [availableCantons, setAvailableCantons] = useState<string[]>([]);
  const [availableDistricts, setAvailableDistricts] = useState<string[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [orderBy, setOrderBy] = useState<keyof Client>('name');
  const [order, setOrder] = useState<'asc' | 'desc'>('asc');
  const [openUpdateCSV, setOpenUpdateCSV] = useState(false);
  const [csvFile, setCsvFile] = useState<File | null>(null);

  const [visibleColumns, setVisibleColumns] = useState<Set<keyof Client>>(
    new Set<keyof Client>([
      'name',
      'phoneNumber',
      'email',
      'provincia',
      'canton',
      'distrito',
      'municipalidades',
      'senas',
      'nota',
      'tipo_entrega'
    ])
  );

  const [visiblePublicColumns, setVisiblePublicColumns] = useState<Set<keyof PublicClient>>(
    new Set<keyof PublicClient>([
      'name',
      'phoneNumber',
      'email',
      'provincia',
      'canton',
      'distrito',
      'senas',
      'nota',
      'tipo_entrega',
      'status_create_public_client' // Añadir la nueva columna
    ])
  );

  const [isFilterDialogOpen, setIsFilterDialogOpen] = useState(false);
  const [isColumnSelectionDialogOpen, setIsColumnSelectionDialogOpen] = useState(false);

  const [provinces, setProvinces] = useState<string[]>([]);
  const [cantons, setCantons] = useState<string[]>([]);
  const [districts, setDistricts] = useState<string[]>([]);

  const [tabValue, setTabValue] = useState(0);

  const [mainTabValue, setMainTabValue] = useState(0);

  const [isHovered, setIsHovered] = useState(false);

  const handleMainTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setMainTabValue(newValue);
  };

  // Estado para almacenar la ubicación seleccionada
  const [selectedLocation, setSelectedLocation] = useState<{ lat: number; lng: number } | null>(null);
  const [googleMapsLink, setGoogleMapsLink] = useState<string>('');
  const [wazeLink, setWazeLink] = useState<string>('');

  // Asegúrate de definir mapCenter y decodedRouteCoordinates
  const [mapCenter, setMapCenter] = useState<[number, number]>([9.9281, -84.0907]);
  const [mapCenterPublic, setMapCenterPublic] = useState<[number, number]>([9.9281, -84.0907]);
  const decodedRouteCoordinates: [number, number][] = []; // Asegúrate de que esto tenga un valor válido

  const [publicTableSelectedFilters, setPublicTableSelectedFilters] = useState<{ [key: string]: string[] }>({});
  const [publicTableFilteredClients, setPublicTableFilteredClients] = useState<PublicClient[]>(publicClients);

  // Define state for current public client
  const [currentPublicClient, setCurrentPublicClient] = useState<PublicClient | null>(null);

  // Definir los nuevos estados para el orden de PublicClient
  const [publicOrder, setPublicOrder] = useState<'asc' | 'desc'>('asc'); // Estado para la dirección del orden
  const [publicOrderBy, setPublicOrderBy] = useState<keyof PublicClient>('name'); // Estado para la propiedad por la que se ordena
  const [publicPage, setPublicPage] = useState(0); // Página actual
  const [publicRowsPerPage, setPublicRowsPerPage] = useState(5); // Filas por página

  const [selectedLocationPublic, setSelectedLocationPublic] = useState<{ lat: number; lng: number } | null>(null);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false); // State to manage dialog visibility
  const [clientIdToDelete, setClientIdToDelete] = useState<string | null>(null); // State to store the client ID to delete

  const [deleteDialogOpenPublic, setDeleteDialogOpenPublic] = useState(false); // State to manage dialog visibility
  const [clientIdToDeletePublic, setClientIdToDeletePublic] = useState<string | null>(null); // State to store the client ID to delete

  // Define el estado para el diálogo de creación de cliente
  const [createClientDialogOpen, setCreateClientDialogOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState<PublicClient | null>(null);

  const handleCreateClient = (client: PublicClient) => {
    setSelectedClient(client);
    setCreateClientDialogOpen(true);
  };
  const [selectedPublicClientForWaitlist, setSelectedPublicClientForWaitlist] = useState<PublicClient | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null); // Nuevo estado para mensajes de éxito
  const [notification, setNotification] = useState<{ open: boolean; message: string; type: 'success' | 'error' | 'warning' }>({ open: false, message: '', type: 'success' });
  const notificationSound = new Audio(`${process.env.PUBLIC_URL}/audio/Notification.mp3`); // Update the path accordingly
  const navigate = useNavigate(); // Inicializa el hook de navegación
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [pendingClients, setPendingClients] = useState<PublicClient[]>([]);
  const mapRef = useRef<LeafletMap>(null); // Create a ref with the correct type
  const mapRefFullScream = useRef<LeafletMap>(null);
  const mapRefPublic = useRef<LeafletMap>(null); // Create a ref with the correct type
  const mapRefFullScreamPublic = useRef<LeafletMap>(null);
  const [openLocationIcon, setOpenLocationIcon] = useState(false); // Estado para el diálogo de confirmación
  const [openLocationIconPublic, setOpenLocationIconPublic] = useState(false); // Estado para el diálogo de confirmación
  const [newLocation, setNewLocation] = useState<{ lat: number; lng: number } | null>(null); // Estado para la nueva ubicación
  const [isMapDialogOpen, setIsMapDialogOpen] = useState(false);
  const [isMapDialogOpenPublic, setIsMapDialogOpenPublic] = useState(false);
  // Define el icono personalizado usando un SVG
  const customIcon = L.divIcon({
    className: 'custom-icon',
    html: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41" fill="none">
             <path d="M12.5 0C19.5 0 25 6 25 13.5C25 20.5 12.5 41 12.5 41C12.5 41 0 20.5 0 13.5C0 6 5.5 0 12.5 0Z" fill="#FF0000"/>
           </svg>`,
    iconSize: [25, 41],
    iconAnchor: [12.5, 41],
  });

  // First, add these state variables at the top of your component
  const [showCoordinates, setShowCoordinates] = useState(false);
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');

  // Modify the Column Selection Dialog
  const columnOrder: (keyof Client)[] = [
    'name',
    'phoneNumber',
    'second_phoneNumber',
    'email',
    'tipo_compostera',
    'tipo_documento',
    'provincia',
    'distrito',
    'canton',
    'municipalidades',
    'wazeLink',
    'googleMapsLink',
    'senas',
    'nota',
    'tipo_entrega'
  ];



  const publicColumnNames: { [key in keyof PublicClient]: string } = {
    name: 'Nombre',
    phoneNumber: 'Teléfono',
    email: 'Correo Electrónico',
    googleMapsLink: 'Enlace Google Maps',
    wazeLink: 'Enlace Waze',
    id: 'ID',
    cedula_nacional: 'Cédula Nacional',
    second_phoneNumber: 'Teléfono Secundario',
    tipo_documento: 'Tipo de Documento',
    tipo_client: 'Tipo de Cliente',
    tipo_compostera: 'Tipo de Compostera',
    tipo_entrega: 'Tipo Entrega',
    senas: 'Señas',
    nota: 'Nota',
    imageUrl: 'URL de Imagen',
    provincia: 'Provincia',
    canton: 'Cantón',
    distrito: 'Distrito',
    municipalidades: 'Municipalidad',
    cant_gato: 'Gato 0-6Kg',
    cant_perro_mini: 'Mini 0-6Kg',
    cant_perro_pequeno: 'Pequeño 6-10Kg',
    cant_perro_mediano: 'Mediano 10-25Kg',
    cant_perro_grande: 'Grande 25-45Kg',
    cant_perro_gigante: 'Gigante +45Kg',
    status_create_public_client: 'Estado',
    codigo_referencia: 'Código de Referencia',
  };

  const [openNewLocationDialog, setOpenNewLocationDialog] = useState(false); // Estado para el nuevo diálogo

  const [locationCoordinates, setLocationCoordinates] = useState<{ lat: number; lng: number } | null>(null);
  const [locationSelected, setLocationSelected] = useState<boolean>(false);
  const [showNotification, setShowNotification] = useState(false);
  const [showNotificationInputReq, setShowNotificationInputReq] = useState(false);
  // Add new state at top of component
  const [showErrorNotification, setShowErrorNotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  // Add this validation function
  const isValidCoordinates = () => {
    const lat = Number(latitude);
    const lng = Number(longitude);
    return !isNaN(lat) && !isNaN(lng) &&
      lat >= -90 && lat <= 90 &&
      lng >= -180 && lng <= 180;
  };

  // Add this function to handle coordinate updates
  const handleUpdateCoordinates = () => {
    if (!isValidCoordinates()) return;

    const lat = Number(latitude);
    const lng = Number(longitude);

    // Update map location
    setNewLocation({ lat, lng });

    // Create Google Maps link
    // const googleMapsLink = `https://www.google.com/maps?q=${lat},${lng}`;
    // const wazeLink = `https://www.waze.com/ul?ll=${lat},${lng}&navigate=yes`;

    // Update client data
    setCurrentClient(curr => curr ? {
      ...curr,
      googleMapsLink,
      wazeLink
    } : null);

    // Update map marker
    const fakeMouseEvent = {
      latlng: L.latLng(lat, lng),
      layerPoint: L.point(0, 0),
      containerPoint: L.point(0, 0),
      originalEvent: new MouseEvent('click'),
      type: 'click',
      target: {},
      sourceTarget: {},
      propagatedFrom: {},
      layer: {}
    } as L.LeafletMouseEvent;

    handleMapClick(fakeMouseEvent);
  };

  const handleUpdateCoordinatesPublic = () => {
    if (!isValidCoordinates()) return;

    const lat = Number(latitude);
    const lng = Number(longitude);

    // Update map location
    setNewLocation({ lat, lng });

    // Create Google Maps link
    // const googleMapsLink = `https://www.google.com/maps?q=${lat},${lng}`;
    // const wazeLink = `https://www.waze.com/ul?ll=${lat},${lng}&navigate=yes`;

    // Update client data
    setCurrentPublicClient(curr => curr ? {
      ...curr,
      googleMapsLink,
      wazeLink
    } : null);

    // Update map marker
    const fakeMouseEvent = {
      latlng: L.latLng(lat, lng),
      layerPoint: L.point(0, 0),
      containerPoint: L.point(0, 0),
      originalEvent: new MouseEvent('click'),
      type: 'click',
      target: {},
      sourceTarget: {},
      propagatedFrom: {},
      layer: {}
    } as L.LeafletMouseEvent;

    handlePublicMapClick(fakeMouseEvent);
  };

  // Function to handle opening the menu
  const handleClickNotification = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  // Function to handle closing the menu
  const handleCloseNotification = () => {
    setAnchorEl(null);
  };

  const handleDeletePublicClient = (clientId: string) => {
    setClientIdToDeletePublic(clientId); // Set the client ID to delete
    setDeleteDialogOpenPublic(true); // Open the delete confirmation dialog
  };

  const confirmDeletePublicClient = async () => {
    if (clientIdToDeletePublic) {
      try {
        await onDeletePublicClient(clientIdToDeletePublic); // Llamar a la función de eliminación
        toast.success('Cliente público eliminado exitosamente'); // Mensaje de éxito

        // Aquí puedes agregar lógica para refrescar la lista de clientes públicos si es necesario
        // setPublicTableFilteredClients(prev => prev.filter(client => client.id !== clientIdToDeletePublic));

      } catch (error) {
        console.error('Error deleting public client:', error);
        toast.error('Error al eliminar cliente público'); // Mensaje de error
      } finally {
        setClientIdToDeletePublic(null); // Resetear el ID del cliente
        setDeleteDialogOpenPublic(false); // Cerrar el diálogo
      }
    }
  };

  const handleDeleteClient = (clientId: string) => {
    setClientIdToDelete(clientId); // Set the client ID to delete
    setDeleteDialogOpen(true); // Open the delete confirmation dialog
  };

  const confirmDeleteClient = async () => {
    if (clientIdToDelete) {
      await onDelete(clientIdToDelete); // Call the delete function

      setTableFilteredClients(prev => prev.filter(client => client.id !== clientIdToDelete));

      setClientIdToDelete(null); // Reset the client ID
      setDeleteDialogOpen(false); // Close the dialog
    }
  };

  const handleSaveCSVPublicClient = async () => {
    if (!csvFile) return;

    setShowNotification(true);
    try {
      // Import the processExcelFile function dynamically to avoid circular dependencies
      const { processExcelFile, findExistingClientByPhone, updateEmptyFields } = await import('../utils/excelImport');
      const { normalizeLocationText, findBestMatch } = await import('../utils/textNormalization');
      
      // Process the Excel/CSV file using the utility function
      const clients = await processExcelFile(csvFile);
      
      // Track updated clients for notification
      const updatedClients: string[] = [];
      const newClients: string[] = [];
      
      // Add each client to the database
      for (const client of clients) {
        // Normalize Canton and Distrito names to ensure proper matching with available options
        let normalizedClient = { ...client };
        // Normalize tipo_documento to match interface definition
        if (normalizedClient.tipo_documento) {
          const lowerCaseType = normalizedClient.tipo_documento.toLowerCase();
          normalizedClient.tipo_documento = 
            lowerCaseType === 'nacional' ? 'Nacional' :
            lowerCaseType === 'jurídica' ? 'Jurídica' :
            lowerCaseType === 'juridica' ? 'Jurídica' :
            lowerCaseType === 'dimex' ? 'Dimex' :
            lowerCaseType === 'nite' ? 'Nite' :
            normalizedClient.tipo_documento;
        }
        
        // Normalize Canton if province is available
        if (normalizedClient.provincia) {
          const availableCantons = costaRicaData.cantons[normalizedClient.provincia as keyof typeof costaRicaData.cantons] || [];
          if (availableCantons.length > 0 && normalizedClient.canton) {
            normalizedClient.canton = findBestMatch(normalizedClient.canton, availableCantons);
          }
          
          // Normalize Distrito if province and canton are available
          if (normalizedClient.canton) {
            const provinciaDistricts = costaRicaData.districts[normalizedClient.provincia as keyof typeof costaRicaData.districts];
            const availableDistricts = provinciaDistricts && normalizedClient.canton in provinciaDistricts ? 
              provinciaDistricts[normalizedClient.canton as keyof typeof provinciaDistricts] : [];
              
            if (availableDistricts.length > 0 && normalizedClient.distrito) {
              normalizedClient.distrito = findBestMatch(normalizedClient.distrito, availableDistricts);
            }
          }
        }
        
        // Make sure the client has the required status field
        const newClient: PublicClient = {
          ...normalizedClient,
          status_create_public_client: 'pending'
        };
        
        // Check if client already exists by phone number
        const existingClient = findExistingClientByPhone(newClient, publicTableFilteredClients);
        
        if (existingClient) {
          // Update empty fields in existing client with data from new client
          const updatedClient = updateEmptyFields(existingClient, newClient);
          await onUpdatePublicClient(updatedClient);
          updatedClients.push(updatedClient.name || updatedClient.phoneNumber);
        } else {
          // Add new client
          await onAddNewPublicClient(newClient);
          newClients.push(newClient.name || newClient.phoneNumber);
        }
      }

      // Update the UI
      setPublicTableFilteredClients(prev => [...prev]);
      setOpenUpdateCSV(false);
      
      // Show success message with details
      if (updatedClients.length > 0) {
        setSuccessMessage(`Importación exitosa: ${newClients.length} clientes nuevos agregados, ${updatedClients.length} clientes existentes actualizados`);
      } else {
        setSuccessMessage(`Clientes importados exitosamente: ${newClients.length} nuevos clientes agregados`);
      }
    } catch (error) {
      console.error('Error importing clients:', error);
      setShowErrorNotification(true);
      setErrorMessage('Error al importar clientes. Por favor verifique el formato del archivo.');
    } finally {
      setShowNotification(false);
      setCsvFile(null);
    }
  };

  const handleSavePublicClient = async () => { // Nueva función para manejar la guardado de clientes públicos
    setShowNotification(true);
    if (isPublicFormValid() && currentPublicClient) {
      if (currentPublicClient.id) {
        await onUpdatePublicClient(currentPublicClient); // Actualiza el cliente público
      } else {
        await onAddNewPublicClient(currentPublicClient); // Agrega un nuevo cliente público
      }
      setPublicTableFilteredClients(prev => {
        // Si es un nuevo cliente público, lo agregamos a la lista
        if (!currentPublicClient.id) {
          return [currentPublicClient, ...prev];
        }
        // Si es una actualización, buscamos y reemplazamos el cliente público actualizado
        return prev.map(client => (client.id === currentPublicClient.id ? currentPublicClient : client));
      });
      setOpenPublic(false);
      handleClosePublicClient(); // Cierra el diálogo
    }
    setShowNotification(false);
  };

  const isPublicFormValid = () => { // Nueva función para validar el formulario de cliente público
    console.log('Validando formulario público:', currentPublicClient); // Verifica el estado de currentPublicClient
    console.log('Ubicación seleccionada:', isLocationSelectedPublic); // Verifica el estado de isLocationSelectedPublic

    return (
      currentPublicClient?.phoneNumber.trim() !== '' &&
      currentPublicClient?.name.trim() !== '' &&
      currentPublicClient?.email.trim() !== '' &&
      currentPublicClient?.cedula_nacional.trim() !== '' &&
      isLocationSelectedPublic // Asegúrate de que la ubicación esté seleccionada
    );
  };

  // Asegúrate de que los estados se actualicen correctamente en los manejadores de eventos
  const handleInputChange = (field: keyof Client, value: string) => {
    setCurrentClient(curr => {
      if (!curr) return null;
      return { ...curr, [field]: value }; // Actualiza el campo correspondiente
    });
  };

  const handlePublicInputChange = (field: keyof PublicClient, value: string) => {
    setCurrentPublicClient(curr => {
      if (!curr) return null;
      return { ...curr, [field]: value }; // Actualiza el campo correspondiente
    });
  };

  const applyPublicFilters = () => {
    const normalizedSearch = normalizeString(tableSearchTermPublic);
    let filtered = publicClients.filter(client => {
      if (!tableSearchTermPublic) return true;
      return Object.entries(client).some(([key, value]) => {
        // Skip certain fields that shouldn't be searched
        if (['id', 'imageUrl', 'googleMapsLink', 'wazeLink'].includes(key)) return false;
        return normalizeString(String(value || '')).includes(normalizedSearch);
      });
    });

    Object.entries(publicTableSelectedFilters).forEach(([key, values]) => {
      if (values.length > 0) {
        filtered = filtered.filter(client => values.includes(client[key as keyof PublicClient] as string));
      }
    });

    setPublicTableFilteredClients(filtered);
  };

  const applyCardFilters = () => {
    const normalizedSearch = normalizeString(cardSearchTerm);
    let filtered = clients.filter(client => {
      if (!cardSearchTerm) return true;
      return Object.entries(client).some(([key, value]) => {
        // Skip certain fields that shouldn't be searched
        if (['id', 'imageUrl', 'googleMapsLink', 'wazeLink'].includes(key)) return false;
        return normalizeString(String(value || '')).includes(normalizedSearch);
      });
    });

    Object.entries(cardSelectedFilters).forEach(([key, values]) => {
      if (values.length > 0) {
        filtered = filtered.filter(client => values.includes(client[key as keyof Client] as string));
      }
    });

    setCardFilteredClients(filtered);
  };

  const applyCardFiltersPublic = () => {
    const normalizedSearch = normalizeString(cardSearchTermPublic);
    let filtered = publicClients.filter(client => {
      if (!cardSearchTermPublic) return true;
      return Object.entries(client).some(([key, value]) => {
        // Skip certain fields that shouldn't be searched
        if (['id', 'imageUrl', 'googleMapsLink', 'wazeLink'].includes(key)) return false;
        return normalizeString(String(value || '')).includes(normalizedSearch);
      });
    });

    Object.entries(publicTableSelectedFilters).forEach(([key, values]) => {
      if (values.length > 0) {
        filtered = filtered.filter(client => values.includes(client[key as keyof PublicClient] as string));
      }
    });

    setCardFilteredClientsPublic(filtered);
  };

  const applyTableFilters = () => {
    const normalizedSearch = normalizeString(tableSearchTerm);
    let filtered = clients.filter(client => {
      if (!tableSearchTerm) return true;
      return Object.entries(client).some(([key, value]) => {
        // Skip certain fields that shouldn't be searched
        if (['id', 'imageUrl', 'googleMapsLink', 'wazeLink'].includes(key)) return false;
        return normalizeString(String(value || '')).includes(normalizedSearch);
      });
    });

    Object.entries(tableSelectedFilters).forEach(([key, values]) => {
      if (values.length > 0) {
        filtered = filtered.filter(client => values.includes(client[key as keyof Client] as string));
      }
    });

    setTableFilteredClients(filtered);

    // Auto-open client details when search result is narrowed down to a single client
    if (tableSearchTerm.trim() !== '' && filtered.length === 1) {
      handleViewOpen(filtered[0]);
    }
  };

  // Function to normalize strings for accent-insensitive search
  const normalizeString = (str: string): string => {
    return str
      .normalize('NFD') // Normalize to NFD Unicode normalization form (separates base characters from diacritics)
      .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
      .toLowerCase();
  };

  const handlePublicOpen = useCallback((client: PublicClient | null = null) => {
    console.log('handlePublicOpen ejecutado - cliente:', client);
    setCurrentPublicClient(client || {
      name: '',
      phoneNumber: '',
      email: '',
      googleMapsLink: '',
      wazeLink: '',
      cedula_nacional: '',
      second_phoneNumber: '',
      tipo_documento: 'Nacional',
      tipo_client: 'Municipalidad',
      tipo_compostera: 'Recolección',
      tipo_entrega: 'Recolección',
      senas: '',
      nota: '',
      imageUrl: '',
      provincia: '',
      canton: '',
      distrito: '',
      municipalidades: '',
      cant_gato: '0',
      cant_perro_mini: '0',
      cant_perro_pequeno: '0',
      cant_perro_mediano: '0',
      cant_perro_grande: '0',
      cant_perro_gigante: '0',
      status_create_public_client: 'pending',
      codigo_referencia: '',
    });

    // Cargar los datos de canton, distrito y municipalidad si el cliente existe
    if (client) {
      setAvailableCantons(costaRicaData.cantons[client.provincia as keyof typeof costaRicaData.cantons] || []);
      const provinceDistricts = costaRicaData.districts[client.provincia as keyof typeof costaRicaData.districts];
      // Verificar que el cantón esté definido antes de cargar los distritos
      if (client.canton && provinceDistricts) {
        setAvailableDistricts(provinceDistricts[client.canton as keyof typeof provinceDistricts] || []);
        // setCurrentPublicClient(curr => curr ? { ...curr, distrito: client.distrito } : null); // Establecer el distrito
      } else {
        setAvailableDistricts([]); // Si no hay cantón, resetea los distritos
      }
    }

    setIsLocationSelectedPublic(!!client);

    if (client) {
      if (client.googleMapsLink) {
        const coordinates = extractCoordinates(client.googleMapsLink);
        if (coordinates) {
          const [lat, lng] = coordinates.split(',').map(Number);
          setSelectedLocationPublic({ lat, lng }); // Establece la ubicación seleccionada
        }
      } else {
        setSelectedLocationPublic(null); // Si no hay enlace, no hay ubicación
      }
    }

    setOpenPublic(true);
    console.log('openPublic establecido en true');
  }, []);

  useEffect(() => {
    // Auto-open client details when search result is narrowed down to a single client
    // REMOVED: auto-open when narrowed down to a single client to avoid accidental opens
  }, [tableFilteredClients, tableSearchTerm]);

  useEffect(() => {
    // Aplicar filtros a clientes y clientes públicos
    applyTableFilters();
    applyCardFilters();
    applyPublicFilters();
    applyCardFiltersPublic();

    // Filtrar clientes públicos pendientes con validación de campos requeridos
    const filteredClients = publicClients.filter(client => 
      client.status_create_public_client === 'pending' && 
      client.name && 
      client.name.trim() !== '' && 
      client.senas && 
      client.senas !== '.' && 
      client.senas.trim() !== ''
    );
    setPendingClients(filteredClients);

    // Restablecer la paginación al cambiar de pestaña
    if (newTabValue === 0) {
      setPublicPage(0); // Restablecer a la primera página al cambiar a la tabla de Client
    } else {
      setPage(0); // Restablecer a la primera página al cambiar a la tabla de PublicClient
    }
  }, [clients, cardSelectedFilters, tableSelectedFilters, cardSearchTerm, cardSearchTermPublic, tableSearchTerm, tableSearchTermPublic, publicTableSelectedFilters, publicClients, newTabValue]);

  useEffect(() => {
    // REMOVED: Auto-open the view dialog for the first result when searching in the existing clients table
  }, [tableFilteredClients, tableSearchTerm]);

  const handleTableProvinceChange = (selectedProvinces: string[]) => {
    setTableProvinciaFilter(selectedProvinces);
    setTableCantonFilter([]);
    setTableDistritoFilter([]);

    if (selectedProvinces.length === 1) {
      const province = selectedProvinces[0];
      setAvailableCantons(costaRicaData.cantons[province as keyof typeof costaRicaData.cantons] || []);
    } else {
      setAvailableCantons([]);
    }
    setAvailableDistricts([]);
  };

  const handleTableCantonChange = (selectedCantons: string[]) => {
    setTableCantonFilter(selectedCantons);
    setTableDistritoFilter([]);

    if (tableProvinciaFilter.length === 1 && selectedCantons.length === 1) {
      const province = tableProvinciaFilter[0] as keyof typeof costaRicaData.districts;
      const canton = selectedCantons[0];
      const provinceDistricts = costaRicaData.districts[province];
      if (provinceDistricts && canton in provinceDistricts) {
        setAvailableDistricts(provinceDistricts[canton as keyof typeof provinceDistricts]);
      } else {
        setAvailableDistricts([]);
      }
    } else {
      setAvailableDistricts([]);
    }
  };

  const handleFullScreen = () => {
    if (mapRef.current) {
      // Verificar si el navegador soporta la API de pantalla completa
      if (document.fullscreenEnabled) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err: unknown) => {
            console.error("Error al salir de pantalla completa:", err);
          });
        } else {
          // Get the container element of the map
          const mapContainer = mapRef.current.getContainer(); // Get the container of the Leaflet map
          if (mapContainer) {
            mapContainer.requestFullscreen().catch((err: unknown) => {
              console.error("Error al entrar en pantalla completa:", err);
            });
          } else {
            console.error("mapRef.current no tiene un contenedor válido.");
          }
        }
      } else {
        console.warn("La API de pantalla completa no está soportada en este navegador.");
      }
    } else {
      console.error("mapRef no está definido o no apunta a un elemento válido.");
    }
  };

  const handleOpenUpdateCSV = useCallback(() => {
    setOpenUpdateCSV(true);
  }, []);

  const handleOpen = useCallback((client: Client | null = null) => {
    setCurrentClient(client || {
      name: '',
      phoneNumber: '',
      email: '',
      googleMapsLink: '',
      wazeLink: '',
      cedula_nacional: '',
      second_phoneNumber: '',
      tipo_documento: 'Nacional',
      tipo_client: 'Municipalidad',
      tipo_compostera: 'Recolección',
      tipo_entrega: 'Recolección',
      senas: '',
      nota: '',
      imageUrl: '',
      provincia: '',
      canton: '',
      distrito: '',
      municipalidades: '',
      cant_gato: '0',
      cant_perro_mini: '0',
      cant_perro_pequeno: '0',
      cant_perro_mediano: '0',
      cant_perro_grande: '0',
      cant_perro_gigante: '0',
      nota_admin: '',
      codigo_referencia: '',
    });

    // Cargar los datos de canton, distrito y municipalidad si el cliente existe
    if (client) {
      setCantons(costaRicaData.cantons[client.provincia as keyof typeof costaRicaData.cantons] || []);
      const provinceDistricts = costaRicaData.districts[client.provincia as keyof typeof costaRicaData.districts];
      setDistricts(provinceDistricts ? provinceDistricts[client.canton as keyof typeof provinceDistricts] : []);
    }

    setIsLocationSelected(!!client);

    if (client && client.googleMapsLink) {
      const coordinates = extractCoordinates(client.googleMapsLink);
      if (coordinates) {
        const [lat, lng] = coordinates.split(',').map(Number);
        setSelectedLocation({ lat, lng }); // Establece la ubicación seleccionada
      }
    } else {
      setSelectedLocation(null); // Si no hay enlace, no hay ubicación
    }

    setOpen(true);
  }, []);

  const handleCardOpenFilterDialog = () => {
    setCardIsFilterDialogOpen(true);
  };

  const handleCardCloseFilterDialog = () => {
    setCardIsFilterDialogOpen(false);
  };

  const handleCardOpenFilterDialogPublic = () => {
    setCardIsFilterDialogOpenPublic(true);
  };

  const handleCardCloseFilterDialogPublic = () => {
    setCardIsFilterDialogOpenPublic(false);
  };

  const handleTableOpenFilterDialog = () => {
    setTableIsFilterDialogOpen(true);
  };

  const handleTableCloseFilterDialog = () => {
    setTableIsFilterDialogOpen(false);
  };

  const handleTableOpenFilterDialogPublic = () => {
    setTableIsFilterDialogOpenPublic(true);
  };

  const handleTableCloseFilterDialogPublic = () => {
    setTableIsFilterDialogOpenPublic(false);
  };

  const handleClosePublicClient = () => {
    setOpenPublic(false);
    setCurrentPublicClient(null);
    setSelectedLocationPublic(null);
    setLatitude('');
    setLongitude('');
  };

  const handleCloseClient = () => {
    setOpen(false);
    setCurrentClient(null);
    setSelectedLocation(null);
    setLatitude('');
    setLongitude('');
  };

  const handleViewClosePublic = () => {
    setViewOpenPublic(false);
    setCurrentPublicClient(null);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentClient(null);
    setLatitude('');
    setLongitude('');
  };

  const handleCloseDeleteDialogOpen = () => {
    setDeleteDialogOpen(false);
  };

  const handleViewOpen = (client: Client) => {
    setCurrentClient(client);
    setViewOpen(true);
  };

  const handleViewOpenPublic = (client: PublicClient) => {
    console.log('handleViewOpenPublic ejecutado - cliente:', client);
    setCurrentPublicClient(client);
    setViewOpenPublic(true);
    console.log('viewOpenPublic establecido en true');
  };

  // function openClientDetails(clientAny: any) {
  //   if (!clientAny) return;
  //   
  //   if (clientAny._isPublic || (clientAny.status_create_public_client && clientAny.status_create_public_client !== 'completed')) {
  //     handleViewOpenPublic(clientAny);
  //   } else {
  //     handleViewOpen(clientAny as Client);
  //   }
  // }

  const handleViewClose = () => {
    setViewOpen(false);
    setCurrentClient(null);
  };

  const handleSave = async () => {
    setShowNotification(true);

    if (isFormValid() && currentClient) {
      try {
        // Get reference to clients collection 
        const clientsRef = collection(db, 'clients');

        // Query to check if cedula exists
        const cedulaQuery = query(
          clientsRef,
          where('cedula_nacional', '==', currentClient.cedula_nacional)
        );

        const cedulaQuerySnapshot = await getDocs(cedulaQuery);

        // Check if found any matches (excluding current client if editing)
        const cedulaExists = cedulaQuerySnapshot.docs.some(doc =>
          doc.id !== currentClient.id // Skip current client when editing
        );

        // Replace the toast.error code with:
        if (cedulaExists) {
          setShowNotification(false);
          setShowErrorNotification(true);

          // Auto close after 3 seconds
          setTimeout(() => {
            setShowErrorNotification(false);
          }, 3000);

          return;
        }

        // Proceed with existing save logic
        if (currentClient.id) {
          await onUpdate(currentClient);
        } else {
          await onAddNew(currentClient);
        }

        setTableFilteredClients(prev => {
          if (!currentClient.id) {
            return [currentClient, ...prev];
          }
          return prev.map(client =>
            client.id === currentClient.id ? currentClient : client
          );
        });

        setOpen(false);
        handleClose();
        window.location.reload();

      } catch (error) {
        console.error('Error saving client:', error);
        toast.error('Error al guardar el cliente. Por favor intente nuevamente.');
      } finally {
        setShowNotification(false);
      }
    }
  };

  const extractCoordinates = (url: string): string | undefined => {
    const regex = /[-]?\d+\.\d+/g;
    const matches = url.match(regex);
    if (matches && matches.length >= 2) {
      return `${matches[0]},${matches[1]}`;
    }
    return undefined;
  };

  const handleLocationSelect = (location: { lat: number; lng: number }) => {
    // Solo actualizar las coordenadas y los enlaces de Google Maps y Waze
    setCurrentClient(curr => {
      if (!curr) return null;

      return {
        ...curr,
        googleMapsLink: `https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`,
        wazeLink: `https://www.waze.com/ul?ll=${location.lat},${location.lng}&navigate=yes`
      };
    });

    setIsLocationSelected(true);
  };


  // Nueva función para actualizar manualmente la ubicación
  const handleUpdateLocation = () => {
    if (currentClient && currentClient.googleMapsLink) {
      const coordinates = extractCoordinates(currentClient.googleMapsLink);
      if (coordinates) {
        const [lat, lng] = coordinates.split(',').map(Number);
        const location = findLocationInCostaRicaData({ lat, lng });
        setCurrentClient(curr => {
          if (!curr) return null;
          return {
            ...curr,
            provincia: location.provincia,
            canton: location.canton,
            distrito: location.distrito,
            // Mantenemos el valor actual de municipalidades en lugar de actualizarlo
            municipalidades: curr.municipalidades
          };
        });

        // Actualizamos los selectores
        if (location.provincia in costaRicaData.cantons) {
          setCantons(costaRicaData.cantons[location.provincia as keyof typeof costaRicaData.cantons]);
        }
        if (location.provincia in costaRicaData.districts) {
          const provinciaDistricts = costaRicaData.districts[location.provincia as keyof typeof costaRicaData.districts];
          if (provinciaDistricts && location.canton in provinciaDistricts) {
            setDistricts(provinciaDistricts[location.canton as keyof typeof provinciaDistricts]);
          }
        }
      }
    }
  };


  interface Boundary {
    minLat: number;
    maxLat: number;
    minLng: number;
    maxLng: number;
  }

  interface LocationData {
    provincia: string;
    canton: string;
    distrito: string;
  }

  const cantonBoundaries: { [key: string]: { [key: string]: Boundary } } = {
    'San José': {
      'San José': { minLat: 9.9, maxLat: 10.0, minLng: -84.1, maxLng: -84.0 },
      'Escazú': { minLat: 9.9, maxLat: 9.95, minLng: -84.2, maxLng: -84.1 },
      'Desamparados': { minLat: 9.85, maxLat: 9.95, minLng: -84.1, maxLng: -84.0 },
      'Puriscal': { minLat: 9.75, maxLat: 9.9, minLng: -84.4, maxLng: -84.2 },
      'Tarrazú': { minLat: 9.6, maxLat: 9.75, minLng: -84.1, maxLng: -83.9 },
      'Aserrí': { minLat: 9.8, maxLat: 9.9, minLng: -84.15, maxLng: -84.05 },
      'Mora': { minLat: 9.85, maxLat: 9.95, minLng: -84.3, maxLng: -84.2 },
      'Goicoechea': { minLat: 9.95, maxLat: 10.05, minLng: -84.05, maxLng: -83.95 },
      'Santa Ana': { minLat: 9.9, maxLat: 10.0, minLng: -84.25, maxLng: -84.15 },
      'Alajuelita': { minLat: 9.85, maxLat: 9.95, minLng: -84.15, maxLng: -84.05 },
      'Vázquez de Coronado': { minLat: 10.0, maxLat: 10.1, minLng: -84.0, maxLng: -83.9 },
      'Acosta': { minLat: 9.7, maxLat: 9.85, minLng: -84.3, maxLng: -84.1 },
      'Tibás': { minLat: 9.95, maxLat: 10.0, minLng: -84.1, maxLng: -84.05 },
      'Moravia': { minLat: 10.0, maxLat: 10.05, minLng: -84.05, maxLng: -83.95 },
      'Montes de Oca': { minLat: 9.95, maxLat: 10.0, minLng: -84.05, maxLng: -83.95 },
      'Turrubares': { minLat: 9.75, maxLat: 9.9, minLng: -84.6, maxLng: -84.4 },
      'Dota': { minLat: 9.55, maxLat: 9.7, minLng: -84.0, maxLng: -83.8 },
      'Curridabat': { minLat: 9.9, maxLat: 9.95, minLng: -84.05, maxLng: -83.95 },
      'Pérez Zeledón': { minLat: 9.2, maxLat: 9.5, minLng: -83.8, maxLng: -83.4 },
      'León Cortés Castro': { minLat: 9.65, maxLat: 9.8, minLng: -84.1, maxLng: -83.9 }
    },
    'Alajuela': {
      'Alajuela': { minLat: 10.0, maxLat: 10.1, minLng: -84.3, maxLng: -84.1 },
      'San Ramón': { minLat: 10.05, maxLat: 10.2, minLng: -84.6, maxLng: -84.4 },
      'Grecia': { minLat: 10.05, maxLat: 10.2, minLng: -84.35, maxLng: -84.2 },
      'San Mateo': { minLat: 9.9, maxLat: 10.0, minLng: -84.6, maxLng: -84.45 },
      'Atenas': { minLat: 9.95, maxLat: 10.05, minLng: -84.45, maxLng: -84.35 },
      'Naranjo': { minLat: 10.1, maxLat: 10.2, minLng: -84.45, maxLng: -84.35 },
      'Palmares': { minLat: 10.05, maxLat: 10.15, minLng: -84.5, maxLng: -84.4 },
      'Poás': { minLat: 10.15, maxLat: 10.25, minLng: -84.3, maxLng: -84.2 },
      'Orotina': { minLat: 9.9, maxLat: 10.0, minLng: -84.6, maxLng: -84.5 },
      'San Carlos': { minLat: 10.3, maxLat: 10.9, minLng: -84.6, maxLng: -84.0 },
      'Zarcero': { minLat: 10.15, maxLat: 10.25, minLng: -84.45, maxLng: -84.35 },
      'Sarchí': { minLat: 10.1, maxLat: 10.2, minLng: -84.4, maxLng: -84.3 },
      'Upala': { minLat: 10.8, maxLat: 11.0, minLng: -85.2, maxLng: -84.8 },
      'Los Chiles': { minLat: 10.8, maxLat: 11.1, minLng: -84.8, maxLng: -84.4 },
      'Guatuso': { minLat: 10.6, maxLat: 10.8, minLng: -84.9, maxLng: -84.6 },
      'Río Cuarto': { minLat: 10.3, maxLat: 10.5, minLng: -84.4, maxLng: -84.2 }
    },
    'Cartago': {
      'Cartago': { minLat: 9.8, maxLat: 9.9, minLng: -84.0, maxLng: -83.9 },
      'Paraíso': { minLat: 9.8, maxLat: 9.9, minLng: -83.9, maxLng: -83.8 },
      'La Unión': { minLat: 9.9, maxLat: 10.0, minLng: -84.0, maxLng: -83.9 },
      'Jiménez': { minLat: 9.7, maxLat: 9.8, minLng: -83.8, maxLng: -83.7 },
      'Turrialba': { minLat: 9.8, maxLat: 10.1, minLng: -83.7, maxLng: -83.5 },
      'Alvarado': { minLat: 9.9, maxLat: 10.0, minLng: -83.85, maxLng: -83.75 },
      'Oreamuno': { minLat: 9.9, maxLat: 10.0, minLng: -83.9, maxLng: -83.8 },
      'El Guarco': { minLat: 9.75, maxLat: 9.85, minLng: -84.0, maxLng: -83.9 }
    },
    'Heredia': {
      'Heredia': { minLat: 10.0, maxLat: 10.05, minLng: -84.15, maxLng: -84.1 },
      'Barva': { minLat: 10.05, maxLat: 10.1, minLng: -84.15, maxLng: -84.1 },
      'Santo Domingo': { minLat: 10.0, maxLat: 10.05, minLng: -84.1, maxLng: -84.05 },
      'Santa Bárbara': { minLat: 10.05, maxLat: 10.1, minLng: -84.2, maxLng: -84.15 },
      'San Rafael': { minLat: 10.05, maxLat: 10.1, minLng: -84.15, maxLng: -84.1 },
      'San Isidro': { minLat: 10.05, maxLat: 10.1, minLng: -84.1, maxLng: -84.05 },
      'Belén': { minLat: 9.95, maxLat: 10.0, minLng: -84.2, maxLng: -84.15 },
      'Flores': { minLat: 10.0, maxLat: 10.05, minLng: -84.2, maxLng: -84.15 },
      'San Pablo': { minLat: 10.0, maxLat: 10.05, minLng: -84.1, maxLng: -84.05 },
      'Sarapiquí': { minLat: 10.3, maxLat: 10.7, minLng: -84.2, maxLng: -83.8 }
    },
    'Guanacaste': {
      'Liberia': { minLat: 10.5, maxLat: 10.7, minLng: -85.5, maxLng: -85.3 },
      'Nicoya': { minLat: 10.0, maxLat: 10.2, minLng: -85.5, maxLng: -85.3 },
      'Santa Cruz': { minLat: 10.2, maxLat: 10.4, minLng: -85.7, maxLng: -85.5 },
      'Bagaces': { minLat: 10.4, maxLat: 10.6, minLng: -85.3, maxLng: -85.1 },
      'Carrillo': { minLat: 10.3, maxLat: 10.5, minLng: -85.6, maxLng: -85.4 },
      'Cañas': { minLat: 10.3, maxLat: 10.5, minLng: -85.1, maxLng: -84.9 },
      'Abangares': { minLat: 10.1, maxLat: 10.3, minLng: -85.0, maxLng: -84.8 },
      'Tilarán': { minLat: 10.3, maxLat: 10.5, minLng: -84.9, maxLng: -84.7 },
      'Nandayure': { minLat: 9.9, maxLat: 10.1, minLng: -85.3, maxLng: -85.1 },
      'La Cruz': { minLat: 10.9, maxLat: 11.1, minLng: -85.7, maxLng: -85.5 },
      'Hojancha': { minLat: 10.0, maxLat: 10.2, minLng: -85.4, maxLng: -85.2 }
    },
    'Puntarenas': {
      'Puntarenas': { minLat: 9.9, maxLat: 10.1, minLng: -84.9, maxLng: -84.7 },
      'Esparza': { minLat: 9.9, maxLat: 10.1, minLng: -84.7, maxLng: -84.5 },
      'Buenos Aires': { minLat: 9.0, maxLat: 9.2, minLng: -83.4, maxLng: -83.2 },
      'Montes de Oro': { minLat: 10.0, maxLat: 10.2, minLng: -84.6, maxLng: -84.4 },
      'Osa': { minLat: 8.8, maxLat: 9.0, minLng: -83.6, maxLng: -83.4 },
      'Quepos': { minLat: 9.4, maxLat: 9.6, minLng: -84.2, maxLng: -84.0 },
      'Golfito': { minLat: 8.6, maxLat: 8.8, minLng: -83.2, maxLng: -83.0 },
      'Coto Brus': { minLat: 8.9, maxLat: 9.1, minLng: -83.1, maxLng: -82.9 },
      'Parrita': { minLat: 9.5, maxLat: 9.7, minLng: -84.4, maxLng: -84.2 },
      'Corredores': { minLat: 8.5, maxLat: 8.7, minLng: -83.0, maxLng: -82.8 },
      'Garabito': { minLat: 9.6, maxLat: 9.8, minLng: -84.7, maxLng: -84.5 }
    },
    'Limón': {
      'Limón': { minLat: 9.9, maxLat: 10.1, minLng: -83.1, maxLng: -82.9 },
      'Pococí': { minLat: 10.3, maxLat: 10.5, minLng: -83.7, maxLng: -83.5 },
      'Siquirres': { minLat: 10.1, maxLat: 10.3, minLng: -83.5, maxLng: -83.3 },
      'Talamanca': { minLat: 9.5, maxLat: 9.7, minLng: -82.9, maxLng: -82.7 },
      'Matina': { minLat: 10.0, maxLat: 10.2, minLng: -83.3, maxLng: -83.1 },
      'Guácimo': { minLat: 10.2, maxLat: 10.4, minLng: -83.7, maxLng: -83.5 }
    }
  };

  const findLocationInCostaRicaData = (location: { lat: number; lng: number }): LocationData => {
    // Definimos límites más precisos para cada provincia
    const provinceBoundaries: { [key: string]: Boundary } = {
      'San José': { minLat: 9.5, maxLat: 10.2, minLng: -84.5, maxLng: -83.5 },
      'Alajuela': { minLat: 10.0, maxLat: 10.9, minLng: -84.5, maxLng: -83.8 },
      'Cartago': { minLat: 9.7, maxLat: 10.1, minLng: -84.0, maxLng: -83.5 },
      'Heredia': { minLat: 10.0, maxLat: 10.5, minLng: -84.2, maxLng: -83.8 },
      'Guanacaste': { minLat: 10.0, maxLat: 11.2, minLng: -85.8, maxLng: -84.8 },
      'Puntarenas': { minLat: 8.4, maxLat: 10.1, minLng: -85.0, maxLng: -83.0 },
      'Limón': { minLat: 9.0, maxLat: 10.3, minLng: -83.5, maxLng: -82.5 }
    };

    // Función para calcular la distancia entre dos puntos (Fórmula de Haversine)
    const calculateDistance = (lat1: number, lon1: number, lat2: number, lon2: number): number => {
      const R = 6371; // Radio de la Tierra en km
      const dLat = (lat2 - lat1) * Math.PI / 180;
      const dLon = (lon2 - lon1) * Math.PI / 180;
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c; // Distancia en km
    };

    // Encontrar la provincia
    let provincia = 'Desconocida';
    for (const [name, bounds] of Object.entries(provinceBoundaries)) {
      if (location.lat >= bounds.minLat && location.lat <= bounds.maxLat &&
        location.lng >= bounds.minLng && location.lng <= bounds.maxLng) {
        provincia = name;
        break;
      }
    }

    // Si no se encontró una provincia, retornar valores por defecto
    if (provincia === 'Desconocida') {
      return { provincia: 'Desconocida', canton: 'Desconocido', distrito: 'Desconocido' };
    }

    // Encontrar el cantón más cercano
    let canton = 'Desconocido';
    let minCantonDistance = Infinity;
    for (const [cantonName, bounds] of Object.entries(cantonBoundaries[provincia] || {})) {
      const cantonLat = (bounds.minLat + bounds.maxLat) / 2;
      const cantonLng = (bounds.minLng + bounds.maxLng) / 2;
      const distance = calculateDistance(location.lat, location.lng, cantonLat, cantonLng);
      if (distance < minCantonDistance) {
        minCantonDistance = distance;
        canton = cantonName;
      }
    }

    // Obtener los distritos del cantón
    const provinciaDistricts = costaRicaData.districts[provincia as keyof typeof costaRicaData.districts];
    const distritos = provinciaDistricts && canton in provinciaDistricts ? provinciaDistricts[canton as keyof typeof provinciaDistricts] : [];

    // Encontrar el distrito más cercano
    let distrito = 'Desconocido';
    let minDistritoDistance = Infinity;
    for (const d of distritos) {
      // Aquí usamos el centro del cantón como aproximación para el distrito
      const cantonBounds = cantonBoundaries[provincia][canton];
      const distritoLat = (cantonBounds.minLat + cantonBounds.maxLat) / 2;
      const distritoLng = (cantonBounds.minLng + cantonBounds.maxLng) / 2;
      const distance = calculateDistance(location.lat, location.lng, distritoLat, distritoLng);
      if (distance < minDistritoDistance) {
        minDistritoDistance = distance;
        distrito = d;
      }
    }

    return { provincia, canton, distrito };
  };

  const validateName = (name: string) => /^[A-Za-zÁ-Úá-úÑñ0-9\s]{1,29}$/.test(name); // Letras, números, espacios y caracteres especiales del español, máximo 29 caracteres
  const validatePhone = (phone: string) => /^[\d-]{1,13}$/.test(phone); // Permite números y el símbolo '-', máximo 13 caracteres
  const validateCedula = (cedula: string) => /^[\d-]{1,13}$/.test(cedula); // Solo números, máximo 13 dígitos
  const validateEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); // Validación básica de correo electrónico
  const validateSenasNota = (input: string) => /^.{0,250}$/.test(input); // Permitir cualquier carácter, máximo 250 caracteres

  const handleClientTransferFromWaitlist = async (client: PublicClient) => {
     try {
       console.log('DEBUG - Iniciando creación de cliente desde PublicClient:', client.id, client.name);
       
       // First, create the real client in the clients collection
       const clientsRef = collection(db, 'clients');
       console.log('DEBUG - clientsRef creada:', clientsRef);
       
       const newClient: Client = {
         name: client.name,
         phoneNumber: client.phoneNumber,
         email: client.email,
         googleMapsLink: client.googleMapsLink,
         wazeLink: client.wazeLink,
         cedula_nacional: client.cedula_nacional,
         second_phoneNumber: client.second_phoneNumber,
         tipo_documento: client.tipo_documento,
         tipo_client: client.tipo_client,
         tipo_compostera: client.tipo_compostera,
         tipo_entrega: client.tipo_entrega,
         senas: client.senas,
         nota: client.nota,
         imageUrl: client.imageUrl,
         provincia: client.provincia,
         canton: client.canton,
         distrito: client.distrito,
         municipalidades: client.municipalidades,
         cant_gato: client.cant_gato,
         cant_perro_mini: client.cant_perro_mini,
         cant_perro_pequeno: client.cant_perro_pequeno,
         cant_perro_mediano: client.cant_perro_mediano,
         cant_perro_grande: client.cant_perro_grande,
         cant_perro_gigante: client.cant_perro_gigante,
         codigo_referencia: client.codigo_referencia,
          nota_admin: '',
          proceso: 'Inscripción pagada',
        };
        
        console.log('DEBUG - newClient creado, intentando addDoc...');
        const createdDoc = await addDoc(clientsRef, { ...newClient, createdAt: serverTimestamp(), fromPublicForm: true });
        const newClientId = createdDoc.id;
        
        console.log('DEBUG - Cliente creado en clients collection con ID:', newClientId);
       console.log('DEBUG - Documento creado:', createdDoc);
       
       // Then update the public client to move to waitlist
       const updatedClient: PublicClient = {
         ...client,
         workflow_stage: 'waitlist' as const,
         status_create_public_client: 'completed' as const
       };
       
       console.log('DEBUG - Actualizando PublicClient a waitlist...');
       await onUpdatePublicClient(updatedClient);
       
       console.log('Cliente movido a waitlist con ID de cliente existente:', newClientId);
       
       // Force parent component to refresh data without creating duplicate
       console.log('DEBUG - Forzando recarga de datos del componente padre...');
       // Don't call onAddNew here since the client is already created in Firebase
       // The parent should automatically refresh when it detects changes in the database
       
       setShowNotification(true);
       setSuccessMessage('Cliente creado exitosamente y movido a Lista de espera');
       setTimeout(() => {
         setShowNotification(false);
       }, 3000);
       setCreateClientDialogOpen(false);
       
     } catch (error) {
       console.error('Error creating client:', error);
       setShowNotification(true);
       setSuccessMessage('Error al crear cliente');
       setTimeout(() => {
         setShowNotification(false);
       }, 3000);
     }
   };

  
  const isFormValid = () => {
    console.log('Validando formulario público:', currentClient); // Verifica el estado de currentPublicClient
    console.log('Ubicación seleccionada:', isLocationSelected); // Verifica el estado de isLocationSelectedPublic

    return (
      currentClient?.phoneNumber.trim() !== '' &&
      currentClient?.name.trim() !== '' &&
      currentClient?.email.trim() !== '' &&
      currentClient?.cedula_nacional.trim() !== '' &&
      isLocationSelected
    );
  };

  const handlePublicRequestSort = (property: keyof PublicClient) => { // Nueva función para PublicClient
    const isAsc = publicOrderBy === property && publicOrder === 'asc'; // Verificar si el orden actual es ascendente
    setPublicOrder(isAsc ? 'desc' : 'asc'); // Cambiar la dirección del orden
    setPublicOrderBy(property); // Establecer la propiedad por la que se ordena
  };

  // Función para manejar el cambio de página
  const handlePublicChangePage = (event: unknown, newPage: number) => {
    setPublicPage(newPage); // Actualizar la página actual
  };

  // Función para manejar el cambio de filas por página
  const handlePublicChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPublicRowsPerPage(parseInt(event.target.value, 10)); // Actualizar el número de filas por página
    setPublicPage(0); // Reiniciar a la primera página
  };

  const handleRequestSort = (property: keyof Client) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {

    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePrint = () => {
    window.print();
  };

  const handleOpenFilterDialog = () => {
    setIsFilterDialogOpen(true);
  };

  const handleCloseFilterDialog = () => {
    setIsFilterDialogOpen(false);
  };

  const handleOpenColumnSelectionDialog = () => {
    setIsColumnSelectionDialogOpen(true);
  };

  const handleCloseColumnSelectionDialog = () => {
    setIsColumnSelectionDialogOpen(false);
  };

  const handleColumnToggle = (column: keyof Client) => {
    setVisibleColumns(prev => {
      const newSet = new Set(prev);
      if (newSet.has(column)) {
        newSet.delete(column);
      } else {
        newSet.add(column);
      }
      return newSet;
    });
  };

  // Nueva función para manejar el cambio de columnas visibles para PublicClient
  const handlePublicColumnToggle = (column: keyof PublicClient) => {
    setVisiblePublicColumns(prev => {
      const newSet = new Set(prev);
      if (newSet.has(column)) {
        newSet.delete(column);
      } else {
        newSet.add(column);
      }
      return newSet;
    });
  };

  const handleProvinceChange = (province: string) => {
    setCurrentClient(curr => {
      if (!curr) return null;

      const updatedClient = {
        ...curr,
        provincia: province,
        canton: '',
        distrito: '',
        // Borramos la municipalidad si hay un cambio de provincia
        municipalidades: curr.provincia !== province ? '' : curr.municipalidades
      };

      // Actualiza la lista de cantones según la provincia seleccionada
      setCantons(costaRicaData.cantons[province as keyof typeof costaRicaData.cantons] || []);
      setDistricts([]); // Resetea los distritos al cambiar provincia

      return updatedClient;
    });
  };

  const handlePublicProvinceChange = (province: string) => {
    setCurrentPublicClient(curr => {
      if (!curr) return null;

      const updatedClient = {
        ...curr,
        provincia: province,
        canton: '',
        distrito: '',
        // Borramos la municipalidad si hay un cambio de provincia
        municipalidades: curr.provincia !== province ? '' : curr.municipalidades
      };

      // Actualiza la lista de cantones según la provincia seleccionada
      setAvailableCantons(costaRicaData.cantons[province as keyof typeof costaRicaData.cantons] || []);
      setAvailableDistricts([]); // Resetea los distritos al cambiar provincia

      return updatedClient;
    });
  };

  const handleCantonChange = (canton: string) => {
    setCurrentClient(curr => curr ? { ...curr, canton: canton, distrito: '' } : null);

    if (currentClient?.provincia && canton) {
      const provinciaDistricts = costaRicaData.districts[currentClient.provincia as keyof typeof costaRicaData.districts];
      if (provinciaDistricts) {
        setDistricts(provinciaDistricts[canton as keyof typeof provinciaDistricts] || []);
      } else {
        setDistricts([]);
      }
    } else {
      setDistricts([]);
    }
  };

  const handlePublicCantonChange = (canton: string) => {
    setCurrentPublicClient(curr => curr ? { ...curr, canton: canton, distrito: '' } : null);

    if (currentPublicClient?.provincia && canton) {
      const provinciaDistricts = costaRicaData.districts[currentPublicClient.provincia as keyof typeof costaRicaData.districts];
      if (provinciaDistricts) {
        setAvailableDistricts(provinciaDistricts[canton as keyof typeof provinciaDistricts] || []);
      } else {
        setAvailableDistricts([]);
      }
    } else {
      setAvailableDistricts([]);
    }
  };

  const handleQuantityChangePublic = (field: string, increment: boolean) => { // New function for PublicClient
    setCurrentPublicClient(curr => {
      if (!curr) return null;
      const currentValue = parseInt(curr[field as keyof PublicClient] as string) || 0;
      const newValue = increment ? currentValue + 1 : Math.max(0, currentValue - 1);
      return { ...curr, [field]: newValue.toString() };
    });
  };

  const handleImageUploadPublic = (event: React.ChangeEvent<HTMLInputElement>) => { // New function for PublicClient
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setCurrentPublicClient(curr => curr ? { ...curr, imageUrl: reader.result as string } : null);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleQuantityChange = (field: string, increment: boolean) => {
    setCurrentClient(curr => {
      if (!curr) return null;
      const currentValue = parseInt(curr[field as keyof Client] as string) || 0;
      const newValue = increment ? currentValue + 1 : Math.max(0, currentValue - 1);
      return { ...curr, [field]: newValue.toString() };
    });
  };

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setCurrentClient(curr => curr ? { ...curr, imageUrl: reader.result as string } : null);
      };
      reader.readAsDataURL(file);
    }
  };

  const csvData = tableFilteredClients.map(client => {
    const filteredClient: { [K in keyof Client]?: string | undefined } = {};
    Array.from(visibleColumns).forEach(column => {
      const value = client[column];
      filteredClient[column] = value && (value as any).toDate ? format((value as any).toDate(), 'dd/MM/yyyy HH:mm') : value as string;
    });
    return filteredClient;
  });

  const csvDataPublic = publicTableFilteredClients.map(client => {
    const filteredClient: { [K in keyof PublicClient]?: string | [number, number] | Timestamp | undefined } = {};
    Array.from(visiblePublicColumns).forEach(column => {
      filteredClient[column] = client[column];
    });
    return filteredClient;
  });

  const handleMapClickURL = (lat: number, lng: number) => {
    const newLocation = { lat, lng };
    setSelectedLocation(newLocation); // Actualizar la ubicación seleccionada
    setMapCenter([lat, lng]); // Actualizar el centro del mapa
    setIsLocationSelected(true); // Marcar que se ha seleccionado una ubicación

    const googleMapsLink = `https://www.google.com/maps?q=${lat},${lng}`;
    const wazeLink = `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;

    // Actualizar el cliente actual
    setCurrentClient(curr => {
      if (!curr) return null;
      return {
        ...curr,
        googleMapsLink: googleMapsLink,
        wazeLink: wazeLink
      };
    });

    // Actualizar el mapa
    if (mapRef.current) {
      mapRef.current.setView([lat, lng], 15);
    }
    if (mapRefFullScream.current) {
      mapRefFullScream.current.setView([lat, lng], 15);
    }

    // Reproducir sonido de notificación
    notificationSound.play().catch(error => {
      console.error("Error playing sound:", error);
    });

    // Mostrar mensaje de éxito
    setSuccessMessage("Ubicación actualizada exitosamente!");
  };

  // Manejo del clic en el mapa
  const handleMapClick = (event: L.LeafletMouseEvent) => {
    const { lat, lng } = event.latlng; // Asegúrate de que 'latlng' esté disponible
    setNewLocation({ lat, lng });
    setIsLocationSelectedPublic(true);
    setOpenLocationIcon(true);
  };


  const confirmLocationUpdatePrincipal = () => {
    if (locationCoordinates) { // Asegúrate de que newLocation esté definido
      const { lat, lng } = locationCoordinates; // Obtener latitud y longitud

      const newGoogleMapsLink = `https://www.google.com/maps?q=${lat},${lng}`;
      const newWazeLink = `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;
      setGoogleMapsLink(newGoogleMapsLink);
      setWazeLink(newWazeLink);

      // Actualizar el cliente actual si existe
      setCurrentClient(curr => {
        if (!curr) return null;
        return {
          ...curr,
          googleMapsLink: googleMapsLink,
          wazeLink: wazeLink,
          // Actualizar otros campos según sea necesario
        };
      });

      setSelectedLocation(locationCoordinates);

      // Play notification sound
      notificationSound.play().catch(error => {
        console.error("Error playing sound:", error);
      });

      // Show notification
      setSuccessMessage("Ubicación actualizada exitosamente!"); // Set success message

    }


    setOpenNewLocationDialog(false); // Cerrar el diálogo
  };

  const handlePublicMapClickURL = (lat: number, lng: number) => {
    const newLocation = { lat, lng };
    setSelectedLocation(newLocation); // Actualizar la ubicación seleccionada
    setNewLocation({ lat, lng }); // Establecer la nueva ubicación
    setIsLocationSelected(true);

    setLocationSelected(true);
    // setIsLocationSelected(true);

    const googleMapsLink = `https://www.google.com/maps?q=${lat},${lng}`;
    const wazeLink = `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;

    setCurrentClient(curr => {
      if (!curr) return null;
      return {
        ...curr,
        googleMapsLink: googleMapsLink,
        wazeLink: wazeLink,
        // Actualizar otros campos según sea necesario
      };
    });

    // Actualizar el mapa
    if (mapRefPublic.current) {
      mapRefPublic.current.setView([lat, lng], 15);
    }
    if (mapRefFullScreamPublic.current) {
      mapRefFullScreamPublic.current.setView([lat, lng], 15);
    }

    // Play notification sound
    notificationSound.play().catch(error => {
      console.error("Error playing sound:", error);
    });

    // Show notification
    setSuccessMessage("Ubicación actualizada exitosamente!"); // Set success message
  };

  const handlePublicMapClick = (event: L.LeafletMouseEvent) => {
    const { lat, lng } = event.latlng;
    setNewLocation({ lat, lng });
    setIsLocationSelectedPublic(true);
    setOpenLocationIconPublic(true);
    // setSelectedLocationPublic({ lat, lng }); // Set location immediately
  };

  const handleTransfer = async (selectedClient: PublicClient) => {
    // Reset notifications state
    setShowNotification(false);
    setShowErrorNotification(false);
    setShowNotificationInputReq(false);

    // Validate required fields
    const requiredFields = {
      name: 'Nombre',
      phoneNumber: 'Teléfono',
      email: 'Correo',
      cedula_nacional: 'Cédula'
    };

    // Check for empty required fields
    const emptyFields = Object.entries(requiredFields).filter(
      ([key]) => !selectedClient[key as keyof typeof requiredFields]?.trim()
    );

    if (emptyFields.length > 0) {
      setErrorMessage(`Datos incompletos: Falta ${emptyFields.map(([_, label]) => label).join(', ')}`);
      setShowNotificationInputReq(true);

      // Auto close after 3 seconds
      setTimeout(() => {
        setShowNotificationInputReq(false);
      }, 3000);
      return;
    }

    // If all required fields are present, proceed with transfer
    setShowNotification(true);

    try {
      // Get reference to clients collection 
      const clientsRef = collection(db, 'clients');

      // Query to check if cedula or phone number exists
      const cedulaQuery = query(
        clientsRef,
        where('cedula_nacional', '==', selectedClient.cedula_nacional)
      );
      const phoneQuery = query(
        clientsRef,
        where('phoneNumber', '==', selectedClient.phoneNumber)
      );

      const [cedulaQuerySnapshot, phoneQuerySnapshot] = await Promise.all([
        getDocs(cedulaQuery),
        getDocs(phoneQuery)
      ]);

      // Check if found any matches
      const cedulaExists = !cedulaQuerySnapshot.empty;
      const phoneExists = !phoneQuerySnapshot.empty;

      if (cedulaExists || phoneExists) {
        setShowNotification(false);
        setShowErrorNotification(true);
        setErrorMessage(
          cedulaExists 
            ? 'Error al transferir cliente: Ya existe un cliente con esta cédula.'
            : 'Error al transferir cliente: Ya existe un cliente con este número de teléfono.'
        );

        // Auto close after 3 seconds
        setTimeout(() => {
          setShowErrorNotification(false);
        }, 3000);

        return;
      }

      // Create Client object with required fields
      const clientData: Client = {
        name: selectedClient.name,
        phoneNumber: selectedClient.phoneNumber,
        email: selectedClient.email,
        googleMapsLink: selectedClient.googleMapsLink,
        wazeLink: selectedClient.wazeLink,
        cedula_nacional: selectedClient.cedula_nacional,
        second_phoneNumber: selectedClient.second_phoneNumber,
        tipo_documento: selectedClient.tipo_documento,
        tipo_client: selectedClient.tipo_client,
        tipo_compostera: selectedClient.tipo_compostera,
        tipo_entrega: selectedClient.tipo_entrega,
        senas: selectedClient.senas,
        nota: selectedClient.nota,
        imageUrl: selectedClient.imageUrl,
        provincia: selectedClient.provincia,
        canton: selectedClient.canton,
        distrito: selectedClient.distrito,
        municipalidades: selectedClient.municipalidades,
        cant_gato: selectedClient.cant_gato,
        cant_perro_mini: selectedClient.cant_perro_mini,
        cant_perro_pequeno: selectedClient.cant_perro_pequeno,
        cant_perro_mediano: selectedClient.cant_perro_mediano,
        cant_perro_grande: selectedClient.cant_perro_grande,
        cant_perro_gigante: selectedClient.cant_perro_gigante,
        codigo_referencia: selectedClient.codigo_referencia,
        nota_admin: '', // Add the required nota_admin field
        id: selectedClient.id || '', // Ensure id exists
      };

      // If no duplicate found, proceed with client creation
      await onAddNew(clientData);

       // Update public client status
       const updatedClient: PublicClient = {
         ...selectedClient,
         status_create_public_client: 'completed',
         workflow_stage: 'waitlist' as const,
       };
       await onUpdatePublicClient(updatedClient);

      // Play notification sound
      notificationSound.play().catch(error => {
        console.error("Error playing sound:", error);
      });

      // Show success message and reset tab
      setSuccessMessage("Cliente creado exitosamente!");
      setNewTabValue(0);
      setCreateClientDialogOpen(false);

    } catch (error) {
      console.error('Error transferring client:', error);
      setShowErrorNotification(true);
      setErrorMessage('Error al transferir el cliente. Por favor intente nuevamente.');

      setTimeout(() => {
        setShowErrorNotification(false);
      }, 3000);
    } finally {
      setShowNotification(false);
    }
  };

  const confirmLocationUpdate = () => {
    if (newLocation) {
      // Lógica para actualizar la ubicación
      const { lat, lng } = newLocation;
      const googleMapsLink = `https://www.google.com/maps?q=${lat},${lng}`;
      const wazeLink = `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;
      setIsLocationSelected(true);
      setCurrentClient(curr => {
        if (!curr) return null;
        return {
          ...curr,
          googleMapsLink: googleMapsLink,
          wazeLink: wazeLink,
          // Actualizar otros campos según sea necesario
        };
      });

      setSelectedLocation(newLocation); // Actualizar la ubicación seleccionada
      setMapCenter([lat, lng]);
      setGoogleMapsLink(googleMapsLink);
      setWazeLink(wazeLink);

      // Centrar el mapa en la nueva ubicación
      if (mapRef.current) {
        mapRef.current.flyTo([lat, lng], mapRef.current.getZoom(), {
          duration: 1, // duración de la animación en segundos
          easeLinearity: 0.25
        });
      }

      if (mapRefFullScream.current) {
        mapRefFullScream.current.flyTo([lat, lng], mapRefFullScream.current.getZoom(), {
          duration: 1, // duración de la animación en segundos
          easeLinearity: 0.25
        });
      }

      // Play notification sound
      notificationSound.play().catch(error => {
        console.error("Error playing sound:", error);
      });

      // Show notification
      setSuccessMessage("Ubicación actualizada exitosamente!"); // Set success message
    }

    setOpenLocationIcon(false); // Cerrar el diálogo

  };

  const confirmLocationUpdatePublic = () => {
    if (newLocation) {
      // Lógica para actualizar la ubicación
      const { lat, lng } = newLocation;
      const googleMapsLink = `https://www.google.com/maps?q=${lat},${lng}`;
      const wazeLink = `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;
      setLocationSelected(true);
      setCurrentPublicClient(curr => {
        if (!curr) return null;
        return {
          ...curr,
          googleMapsLink: googleMapsLink,
          wazeLink: wazeLink,
          // Actualizar otros campos según sea necesario
        };
      });

      setSelectedLocationPublic(newLocation); // Actualizar la ubicación seleccionada0
      setMapCenterPublic([lat, lng]);
      setGoogleMapsLink(googleMapsLink);
      setWazeLink(wazeLink);

      // Centrar el mapa en la nueva ubicación
      if (mapRefPublic.current) {
        mapRefPublic.current.flyTo([lat, lng], mapRefPublic.current.getZoom(), {
          duration: 1, // duración de la animación en segundos
          easeLinearity: 0.25
        });
      }

      if (mapRefFullScreamPublic.current) {
        mapRefFullScreamPublic.current.flyTo([lat, lng], mapRefFullScreamPublic.current.getZoom(), {
          duration: 1, // duración de la animación en segundos
          easeLinearity: 0.25
        });
      }

      // Play notification sound
      notificationSound.play().catch(error => {
        console.error("Error playing sound:", error);
      });

      // Show notification
      setSuccessMessage("Ubicación actualizada exitosamente!"); // Set success message
    }

    setOpenLocationIconPublic(false); // Cerrar el diálogo

  };

  const handleUpdatePublicLocation = () => { // Nueva función para actualizar provincia, cantón y distrito
    if (currentPublicClient && currentPublicClient.googleMapsLink) {
      const coordinates = extractCoordinates(currentPublicClient.googleMapsLink);
      if (coordinates) {
        const [lat, lng] = coordinates.split(',').map(Number);
        const location = findLocationInCostaRicaData({ lat, lng });
        setCurrentPublicClient(curr => {
          if (!curr) return null;
          return {
            ...curr,
            provincia: location.provincia,
            canton: location.canton,
            distrito: location.distrito,
            // Mantenemos el valor actual de municipalidades en lugar de actualizarlo
            municipalidades: curr.municipalidades
          };
        });

        // Actualizamos los selectores
        if (location.provincia in costaRicaData.cantons) {
          setAvailableCantons(costaRicaData.cantons[location.provincia as keyof typeof costaRicaData.cantons]);
        }

        if (location.provincia in costaRicaData.districts) {
          const provinciaDistricts = costaRicaData.districts[location.provincia as keyof typeof costaRicaData.districts];
          if (provinciaDistricts && location.canton in provinciaDistricts) {
            setAvailableDistricts(provinciaDistricts[location.canton as keyof typeof provinciaDistricts]);
          }
        }
      }
    }
  };

  const updateLocationFromLink = (link: string) => {
    const regex = /[-]?\d+\.\d+/g; // Expresión regular para encontrar coordenadas
    const matches = link.match(regex);
    if (matches && matches.length >= 2) {
      const lat = parseFloat(matches[0]);
      const lng = parseFloat(matches[1]);
      setSelectedLocation({ lat, lng });

      // Actualiza el estado del cliente actual con las nuevas coordenadas
      setCurrentClient(curr => curr ? { ...curr, googleMapsLink: link } : null);
    }
  };

  const updateLocationFromLinkPublic = (link: string) => {
    const regex = /[-]?\d+\.\d+/g; // Expresión regular para encontrar coordenadas
    const matches = link.match(regex);
    if (matches && matches.length >= 2) {
      const lat = parseFloat(matches[0]);
      const lng = parseFloat(matches[1]);
      setSelectedLocationPublic({ lat, lng });

      // Actualiza el estado del cliente actual con las nuevas coordenadas
      setCurrentPublicClient(curr => curr ? { ...curr, googleMapsLink: link, } : null);
    }
  };

  function extractLocationFromLink(link: string): [number, number] | null {
    // Expresión regular para encontrar coordenadas en el formato de Google Maps
    const regexGoogleMaps = /q=(-?\d+\.\d+),(-?\d+\.\d+)/; // Para enlaces como "https://www.google.com/maps?q=9.844729968551437,-84.02324949368385"
    const regexAppLink = /@(-?\d+\.\d+),(-?\d+\.\d+)/; // Para enlaces como "https://maps.app.goo.gl/dtt7HkpWPKDeCAVK9"

    let match = link.match(regexGoogleMaps);
    if (match && match.length === 3) {
      const latitude = parseFloat(match[1]);
      const longitude = parseFloat(match[2]);
      return [latitude, longitude]; // Devuelve las coordenadas como un array
    }

    match = link.match(regexAppLink);
    if (match && match.length === 3) {
      const latitude = parseFloat(match[1]);
      const longitude = parseFloat(match[2]);
      return [latitude, longitude]; // Devuelve las coordenadas como un array
    }

    return null; // Devuelve null si no se encuentran coordenadas
  }

  const getWazeCoordinates = async (link: string): Promise<[number, number] | null> => {
    try {
      // Intenta extraer coordenadas de un enlace de Waze
      const regexWaze = /ll=(-?\d+\.\d+),(-?\d+\.\d+)/; // Para enlaces como "https://waze.com/ul?ll=9.9573889,-84.0845"
      const regexAlternative = /@(-?\d+\.\d+),(-?\d+\.\d+)/; // Para enlaces alternativos de Waze

      let match = link.match(regexWaze);
      if (match && match.length === 3) {
        const latitude = parseFloat(match[1]);
        const longitude = parseFloat(match[2]);
        setSelectedLocation({ lat: latitude, lng: longitude }); // Actualiza la ubicación seleccionada

        // Actualiza el enlace de Google Maps
        setCurrentClient(curr => curr ? {
          ...curr,
          googleMapsLink: `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`
        } : null);

        return [latitude, longitude];
      }

      match = link.match(regexAlternative);
      if (match && match.length === 3) {
        const latitude = parseFloat(match[1]);
        const longitude = parseFloat(match[2]);
        setSelectedLocation({ lat: latitude, lng: longitude }); // Actualiza la ubicación seleccionada

        // Actualiza el enlace de Google Maps
        setCurrentClient(curr => curr ? {
          ...curr,
          googleMapsLink: `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`
        } : null);

        return [latitude, longitude];
      }

      return null;

    } catch (error) {
      console.error('Error parsing Waze link:', error);
      return null;
    }
  };

  async function getGoogleMapsCoordinates(link: string): Promise<[number, number] | null> {
    // Primero, intenta extraer coordenadas de un enlace de Google Maps
    const regexGoogleMaps = /q=(-?\d+\.\d+),(-?\d+\.\d+)/; // Para enlaces como "https://www.google.com/maps?q=21.142746,-101.6908378"
    const regexAlternative = /@(-?\d+\.\d+),(-?\d+\.\d+)/; // Para enlaces como "https://www.google.com.mx/maps/place/9%C2%B057'26.6%22N+84%C2%B005'04.2%22W/@9.9573889,-84.0845,17z/data=!3m1!4b1!4m4!3m3!8m2!3d9.9573889!4d-84.0845?entry=ttu&g_ep=EgoyMDI0MTEwNi4wIKXMDSoASAFQAw%3D%3D"

    let match = link.match(regexGoogleMaps);
    if (match && match.length === 3) {
      const latitude = parseFloat(match[1]);
      const longitude = parseFloat(match[2]);
      setSelectedLocation({ lat: latitude, lng: longitude }); // Set the selected location

      // Actualiza el enlace de Waze
      setCurrentClient(curr => curr ? { ...curr, wazeLink: `https://waze.com/ul?ll=${latitude},${longitude}&navigate=yes` } : null);

      return [latitude, longitude]; // Devuelve las coordenadas como un array
    }

    match = link.match(regexAlternative);
    if (match && match.length === 3) {
      const latitude = parseFloat(match[1]);
      const longitude = parseFloat(match[2]);
      setSelectedLocation({ lat: latitude, lng: longitude }); // Set the selected location

      // Actualiza el enlace de Waze
      setCurrentClient(curr => curr ? { ...curr, wazeLink: `https://waze.com/ul?ll=${latitude},${longitude}&navigate=yes` } : null);

      return [latitude, longitude]; // Devuelve las coordenadas como un array
    }

    return null; // Devuelve null si no se pueden obtener las coordenadas
  }

  const getCoordinatesFromLink = async (link: string): Promise<[number, number] | null> => {
    if (link.includes('waze.com')) {
      return getWazeCoordinates(link);
    } else if (link.includes('google.com/maps')) {
      // Existing Google Maps logic
      return getGoogleMapsCoordinates(link);
    }
    return null;
  };

  const getWazeCoordinatesPublic = async (link: string): Promise<[number, number] | null> => {
    try {
      // Intenta extraer coordenadas de un enlace de Waze
      const regexWaze = /ll=(-?\d+\.\d+),(-?\d+\.\d+)/; // Para enlaces como "https://waze.com/ul?ll=9.9573889,-84.0845"
      const regexAlternative = /@(-?\d+\.\d+),(-?\d+\.\d+)/; // Para enlaces alternativos de Waze

      let match = link.match(regexWaze);
      if (match && match.length === 3) {
        const latitude = parseFloat(match[1]);
        const longitude = parseFloat(match[2]);
        setSelectedLocationPublic({ lat: latitude, lng: longitude }); // Actualiza la ubicación seleccionada

        // Actualiza el enlace de Google Maps
        setCurrentPublicClient(curr => curr ? {
          ...curr,
          googleMapsLink: `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`
        } : null);

        return [latitude, longitude];
      }

      match = link.match(regexAlternative);
      if (match && match.length === 3) {
        const latitude = parseFloat(match[1]);
        const longitude = parseFloat(match[2]);
        setSelectedLocationPublic({ lat: latitude, lng: longitude }); // Actualiza la ubicación seleccionada

        // Actualiza el enlace de Google Maps
        setCurrentPublicClient(curr => curr ? {
          ...curr,
          googleMapsLink: `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`
        } : null);

        return [latitude, longitude];
      }

      return null;

    } catch (error) {
      console.error('Error parsing Waze link:', error);
      return null;
    }
  };

  async function getGoogleMapsCoordinatesPublic(link: string): Promise<[number, number] | null> {
    // Primero, intenta extraer coordenadas de un enlace de Google Maps
    const regexGoogleMaps = /q=(-?\d+\.\d+),(-?\d+\.\d+)/; // Para enlaces como "https://www.google.com/maps?q=21.142746,-101.6908378"
    const regexAlternative = /@(-?\d+\.\d+),(-?\d+\.\d+)/; // Para enlaces como "https://www.google.com.mx/maps/place/9%C2%B057'26.6%22N+84%C2%B005'04.2%22W/@9.9573889,-84.0845,17z/data=!3m1!4b1!4m4!3m3!8m2!3d9.9573889!4d-84.0845?entry=ttu&g_ep=EgoyMDI0MTEwNi4wIKXMDSoASAFQAw%3D%3D"

    let match = link.match(regexGoogleMaps);
    if (match && match.length === 3) {
      const latitude = parseFloat(match[1]);
      const longitude = parseFloat(match[2]);
      setSelectedLocationPublic({ lat: latitude, lng: longitude }); // Set the selected location

      // Actualiza el enlace de Waze
      setCurrentPublicClient(curr => curr ? { ...curr, wazeLink: `https://waze.com/ul?ll=${latitude},${longitude}&navigate=yes` } : null);

      return [latitude, longitude]; // Devuelve las coordenadas como un array
    }

    match = link.match(regexAlternative);
    if (match && match.length === 3) {
      const latitude = parseFloat(match[1]);
      const longitude = parseFloat(match[2]);
      setSelectedLocationPublic({ lat: latitude, lng: longitude }); // Set the selected location

      // Actualiza el enlace de Waze
      setCurrentPublicClient(curr => curr ? { ...curr, wazeLink: `https://waze.com/ul?ll=${latitude},${longitude}&navigate=yes` } : null);

      return [latitude, longitude]; // Devuelve las coordenadas como un array
    }

    return null; // Devuelve null si no se pueden obtener las coordenadas
  }

  const getCoordinatesFromLinkPublic = async (link: string): Promise<[number, number] | null> => {
    if (link.includes('waze.com')) {
      return getWazeCoordinatesPublic(link);
    } else if (link.includes('google.com/maps')) {
      // Existing Google Maps logic
      return getGoogleMapsCoordinatesPublic(link);
    }
    return null;
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        flexShrink: 0,
        color: 'rgb(0, 180, 216)',
        mb: 1
      }}>
        <h1 style={{ position: 'absolute', left: 0, margin: 0 }}>Gestión de Clientes</h1>
        {isMinimized && (
          <IconButton 
            onClick={() => setIsMinimized(false)}
            sx={{ 
              color: '#87CEEB',
              backgroundColor: 'rgba(135, 206, 235, 0.1)',
              p: 2,
              '&:hover': { backgroundColor: 'rgba(135, 206, 235, 0.2)' }
            }}
          >
            <ChevronRightIcon sx={{ fontSize: 40 }} />
          </IconButton>
        )}
      </Box>
      
      {/* linea horizontal de lado a lado con un ancho de 4px que sea de color rgb(0, 180, 216) */}
      <div style={{
        width: '100%',
        height: '4px',
        backgroundColor: 'rgb(0, 180, 216)',
        margin: '20px 0'
      }} />

      {!isMinimized && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            {/* Tabs */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Tabs
                value={newTabValue}
                onChange={(event, newValue) => {
                  setNewTabValue(newValue);
                }}
                aria-label="client tabs"
                sx={{
                  mb: 2,
                  bgcolor: 'background.paper', // Fondo de las pestañas
                  borderRadius: 2, // Bordes redondeados
                  boxShadow: 1, // Sombra para un efecto elevado
                  '& .MuiTab-root': {
                    color: '#87CEEB', // Color de texto por defecto
                    '&.Mui-selected': {
                      color: 'white', // Color de texto cuando está seleccionado
                      backgroundColor: '#87CEEB', // Fondo cuando está seleccionado
                      borderRadius: 2, // Bordes redondeados para la pestaña seleccionada
                    },
                    '&:hover': {
                      color: 'white',
                      backgroundColor: '#4675EF', // Efecto hover
                    },
                  },
                  '& .MuiTabs-indicator': {
                    backgroundColor: '#5CACEE', // Color del indicador
                  },
                }}
              >
                <Tab
                  label="Clientes Existentes"
                  icon={<CodeIcon />}
                />
                <Tab
                  label="Clientes Formulario"
                  icon={<EditIcon />}
                />
                <Tab
                  label="Seguimiento de Clientes"
                  icon={<TrendingUpIcon />}
                />
              </Tabs>
              <IconButton 
                onClick={() => setIsMinimized(true)}
                sx={{ 
                  ml: 1, 
                  color: '#87CEEB',
                  '&:hover': { color: '#4675EF' }
                }}
              >
                <ChevronLeftIcon />
              </IconButton>
            </Box>

            {/* Notification Menu */}


        {/* Notification Menu */}
         <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCloseNotification}
          PaperProps={{
            sx: {
              maxHeight: '500px',
              overflow: 'auto',
              width: '350px',
              borderRadius: '12px',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
              background: 'rgba(255, 255, 255, 0.98)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(0, 0, 0, 0.08)',
              padding: '8px 0',
            },
          }}
        >
          {pendingClients.length > 0 ? (
            <>
              <Box sx={{ p: 2, borderBottom: '1px solid rgba(0, 0, 0, 0.08)' }}>
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#1976d2' }}>
                  Clientes Pendientes
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {pendingClients.length} {pendingClients.length === 1 ? 'cliente nuevo' : 'clientes nuevos'}
                </Typography>
              </Box>
              {pendingClients.map(client => (
                <MenuItem 
                  key={client.id} 
                  onClick={handleCloseNotification}
                  sx={{
                    padding: '12px 16px',
                    '&:hover': {
                      backgroundColor: 'rgba(25, 118, 210, 0.08)',
                    },
                    transition: 'background-color 0.2s ease',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
                    <Box sx={{ 
                      display: 'flex', 
                      flexWrap: 'wrap', 
                      gap: '4px',
                      marginRight: 2,
                      maxWidth: '120px'
                    }}>
                      {parseInt(client.cant_gato, 10) > 0 && (
                        <Chip
                          icon={<img src={`${process.env.PUBLIC_URL}/images/cant_gato.png`} alt="Gato" style={{ width: '16px', height: '16px' }} />}
                          label={client.cant_gato}
                          size="small"
                          sx={{ backgroundColor: '#ffebee' }}
                        />
                      )}
                      {parseInt(client.cant_perro_mini, 10) > 0 && (
                        <Chip
                          icon={<img src={`${process.env.PUBLIC_URL}/images/cant_perro_mini.png`} alt="Perro Mini" style={{ width: '16px', height: '16px' }} />}
                          label={client.cant_perro_mini}
                          size="small"
                          sx={{ backgroundColor: '#e3f2fd' }}
                        />
                      )}
                      {parseInt(client.cant_perro_pequeno, 10) > 0 && (
                        <Chip
                          icon={<img src={`${process.env.PUBLIC_URL}/images/cant_perro_pequeno.png`} alt="Perro Pequeño" style={{ width: '16px', height: '16px' }} />}
                          label={client.cant_perro_pequeno}
                          size="small"
                          sx={{ backgroundColor: '#e8f5e9' }}
                        />
                      )}
                      {parseInt(client.cant_perro_mediano, 10) > 0 && (
                        <Chip
                          icon={<img src={`${process.env.PUBLIC_URL}/images/cant_perro_mediano.png`} alt="Perro Mediano" style={{ width: '16px', height: '16px' }} />}
                          label={client.cant_perro_mediano}
                          size="small"
                          sx={{ backgroundColor: '#fff3e0' }}
                        />
                      )}
                      {parseInt(client.cant_perro_grande, 10) > 0 && (
                        <Chip
                          icon={<img src={`${process.env.PUBLIC_URL}/images/cant_perro_grande.png`} alt="Perro Grande" style={{ width: '16px', height: '16px' }} />}
                          label={client.cant_perro_grande}
                          size="small"
                          sx={{ backgroundColor: '#f3e5f5' }}
                        />
                      )}
                      {parseInt(client.cant_perro_gigante, 10) > 0 && (
                        <Chip
                          icon={<img src={`${process.env.PUBLIC_URL}/images/cant_perro_gigante.png`} alt="Perro Gigante" style={{ width: '16px', height: '16px' }} />}
                          label={client.cant_perro_gigante}
                          size="small"
                          sx={{ backgroundColor: '#e0f7fa' }}
                        />
                      )}
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                        {client.name}
                      </Typography>
                      <Typography 
                        variant="body2" 
                        color="text.secondary"
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px'
                        }}
                      >
                        <LocationOnIcon sx={{ fontSize: 16 }} />
                        {client.provincia}, {client.canton}
                      </Typography>
                    </Box>
                  </Box>
                </MenuItem>
              ))}
            </>
          ) : (
            <Box sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="body1" color="text.secondary">
                No hay clientes pendientes
              </Typography>
            </Box>
          )}
        </Menu>
      </Box>
    )}
    {/* Tab Content */}
      {newTabValue === 0 && (
        <div>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Button
                startIcon={<AddIcon />}
                variant="contained"
                color="primary"
                onClick={() => handleOpen()}
                sx={{
                  backgroundColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgb(135, 206, 235)',
                  },
                  fontWeight: 'bold'
                }}
              >
                Agregar Cliente
              </Button>
              <FormControlLabel
                control={
                  <Switch
                    checked={mainTabValue === 1}
                    onChange={() => setMainTabValue(mainTabValue === 0 ? 1 : 0)}
                    color="primary"
                    sx={{
                      '&.MuiSwitch-root': {
                        '& .MuiSwitch-thumb': {
                          backgroundColor: 'rgb(135, 206, 235) !important',
                        }
                      },
                    }}
                  />
                }
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    {mainTabValue === 0 ? "Tabla de Clientes" : "Lista de Cartas"}
                  </span>
                }
              />
            </Box>
            {/* Notification Icon */}
            <IconButton
              onClick={handleClickNotification}
              sx={{ position: 'relative' }}
            >
              <Badge badgeContent={pendingClients.length} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>
          </Box>

          {mainTabValue === 0 && (
            // Tabla de Clientes
            <Box>
              {/* Barra de búsqueda para la tabla */}
              <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <TextField
                  variant="outlined"
                  size="small"
                  placeholder="Buscar..."
                  value={tableSearchTerm}
                  onChange={(e) => setTableSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ color: 'action.active', mr: 1 }} />,
                  }}
                  sx={{ alignItems: 'left' }}
                />
                <Box>
                  {/* Botones de acción para la tabla */}
                  <Tooltip title="Filtrar">
                    <IconButton onClick={handleTableOpenFilterDialog}>
                      <FilterIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Seleccionar columnas">
                    <IconButton onClick={handleOpenColumnSelectionDialog}>
                      <ViewColumnIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Imprimir">
                    <IconButton onClick={handlePrint}>
                      <PrintIcon />
                    </IconButton>
                  </Tooltip>
                  <CSVLink data={csvData} filename="clientes.csv">
                    <Tooltip title="Descargar CSV">
                      <IconButton>
                        <DownloadIcon />
                      </IconButton>
                    </Tooltip>
                  </CSVLink>
                </Box>
              </Box>

              {/* Chips de filtros seleccionados para la tabla */}
              <Box sx={{ mb: 2 }}>
                {Object.entries(tableSelectedFilters).map(([key, values]) => (
                  values.map(value => (
                    <Chip
                      key={`${key}-${value}`}
                      label={`${columnNames[key as keyof Client]}: ${value}`}
                      onDelete={() => {
                        const newFilters = { ...tableSelectedFilters };
                        newFilters[key] = newFilters[key].filter(v => v !== value);
                        setTableSelectedFilters(newFilters);
                        applyTableFilters();
                      }}
                      sx={{ mr: 1, backgroundColor: '#87CEEB', color: 'white' }}
                    />
                  ))
                ))}
              </Box>

              {/* Tabla de clientes */}
              <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 2 }}>
                <Table sx={{ minWidth: 650 }} aria-label="clients table">
                  <TableHead sx={{ backgroundColor: '#87CEEB' }}>
                    <TableRow>
                      {Array.from(visibleColumns).map((column) => (
                        <TableCell key={column} sx={{ color: 'white', fontWeight: 'bold' }}>
                          {/* <TableSortLabel
                            active={orderBy === column}
                            direction={orderBy === column ? order : 'asc'}
                            onClick={() => handleRequestSort(column)}
                            sx={{ color: 'white', fontWeight: 'bold' }}
                          > */}
                          {columnNames[column]}
                          {/* </TableSortLabel> */}
                        </TableCell>
                      ))}
                      <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center' }}>Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody sx={{ minHeight: '400px' }}>
                    {tableFilteredClients.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={visibleColumns.size + 1} sx={{ textAlign: 'center' }}>
                          <Typography>
                            {tableSearchTerm.trim()
                              ? 'No se encontraron resultados para la búsqueda'
                              : 'No hay clientes para mostrar'}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      <>
                        {tableFilteredClients
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((client) => (
                            <TableRow
                              key={client.id}
                              sx={{
                                '&:hover': {
                                  backgroundColor: 'rgba(0, 180, 216, 0.1)',
                                  '& .action-icons': {
                                    opacity: 1,
                                  },
                                },
                              }}
                            >
                              {Array.from(visibleColumns).map((column) => (
                                <TableCell key={column}>
                                  {column === 'tipo_entrega' ? (
                                    client[column] === 'Productos' ? (
                                      <ShoppingCartIcon sx={{ color: 'rgb(71, 219, 226)' }} />
                                    ) : (
                                      <RecoleccionIcon sx={{ color: 'green' }} />
                                    )
                                  ) : column === 'municipalidades' || column === 'senas' || column === 'nota' ? (
                                    <Tooltip title={client[column]}>
                                      <Box sx={{
                                        maxWidth: '150px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                      }}>
                                        {client[column] as string}
                                      </Box>
                                    </Tooltip>
                                  ) : (
                                    client[column] as string
                                  )}
                                </TableCell>
                              ))}
                              <TableCell>
                                <Box
                                  className="action-icons"
                                  sx={{
                                    display: 'flex',
                                    gap: 1,
                                    justifyContent: 'flex-end',
                                    opacity: 1 // Cambiado de { xs: 1, sm: 0 } a 1 para que siempre sea visible
                                  }}
                                >
                                  <IconButton
                                    size="small"
                                    onClick={() => handleViewOpen(client)}
                                    sx={{
                                      color: '#00b4d8',
                                      '&:hover': {
                                        backgroundColor: 'rgba(0, 180, 216, 0.1)',
                                      },
                                    }}
                                  >
                                    <VisibilityIcon />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    onClick={() => handleOpen(client)}
                                    sx={{
                                      color: '#00b4d8',
                                      '&:hover': {
                                        backgroundColor: 'rgba(0, 180, 216, 0.1)',
                                      },
                                    }}
                                  >
                                    <EditIcon />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    onClick={() => client.id && handleDeleteClient(client.id)}
                                    sx={{
                                      color: 'error.main',
                                      '&:hover': {
                                        backgroundColor: 'rgba(211, 47, 47, 0.1)',
                                      },
                                    }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={tableFilteredClients.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Filas por página:"
              />
            </Box>
          )}

          {mainTabValue === 1 && (
            // Lista de Cartas
            <Box>
              {/* Barra de búsqueda para la lista de cartas */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <TextField
                  variant="outlined"
                  size="small"
                  placeholder="Buscar..."
                  value={cardSearchTerm}
                  onChange={(e) => setCardSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ color: 'action.active', mr: 1 }} />,
                  }}
                  sx={{ alignItems: 'left' }}
                />
                {/* <IconButton onClick={handleCardOpenFilterDialog}>
                  <FilterIcon />
                </IconButton> */}
              </Box>

              {/* 
              <Box sx={{ mb: 2 }}>
                {Object.entries(cardSelectedFilters).map(([key, values]) => (
                  values.map(value => (
                    <Chip
                      key={`${key}-${value}`}
                      label={`${columnNames[key as keyof Client]}: ${value}`}
                      onDelete={() => {
                        const newFilters = { ...cardSelectedFilters };
                        newFilters[key] = newFilters[key].filter(v => v !== value);
                        applyCardFilters();
                        setCardSelectedFilters(newFilters);
                      }}
                      sx={{ mr: 1, mb: 1 }}
                    />
                  ))
                ))}
              </Box> */}

              {/* Lista de cartas */}
              <Grid container spacing={3}>
                {cardFilteredClients.length === 0 ? (
                  <Grid item xs={12}>
                    <Paper
                      sx={{
                        p: 3,
                        textAlign: 'center',
                        borderRadius: 2,
                        backgroundColor: 'rgba(135, 206, 235, 0.1)'
                      }}
                    >
                      <Typography>
                        {tableSearchTerm?.trim()
                          ? 'No se encontraron resultados para la búsqueda'
                          : 'No hay clientes para mostrar'}
                      </Typography>
                    </Paper>
                  </Grid>
                ) : (
                  cardFilteredClients.map((client) => (
                    <Grid item xs={12} sm={6} md={4} lg={2} key={client.id}>
                      <Paper
                        elevation={3}
                        sx={{
                          p: 3,
                          borderRadius: 2,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          position: 'relative',
                          transition: 'all 0.3s ease',
                          minHeight: '329px',
                          '&:hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: '0px 8px 30px rgba(135, 206, 235, 0.7)',
                          }
                        }}
                      >
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>{client.name}</Typography>

                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <Tooltip title="Teléfono">
                            <Box component={PhoneIcon} color="#00b4d8" sx={{ mr: 1 }} />
                          </Tooltip>
                          <Typography variant="body2">{client.phoneNumber}</Typography>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <Tooltip title="Correo">
                            <Box component={MailIcon} color="#00b4d8" sx={{ mr: 1 }} />
                          </Tooltip>
                          <Tooltip title={client.email}>
                            <Typography
                              variant="body2"
                              sx={{
                                maxWidth: '180px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                              }}
                            >
                              {client.email}
                            </Typography>
                          </Tooltip>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <Tooltip title="Ubicación">
                            <Box component={MapPinIcon} color="#00b4d8" sx={{ mr: 1 }} />
                          </Tooltip>
                          <Typography variant="body2">{client.provincia}, {client.canton}</Typography>
                        </Box>

                        <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          mt: 2,
                          flexWrap: 'wrap',
                          gap: 0.5,
                          border: '1px solid rgba(0, 180, 216, 0.2)',
                          borderRadius: 1,
                          p: 1,
                          backgroundColor: 'rgba(135, 206, 235, 0.05)'
                        }}>
                          {/* Pet icons mapping remains the same */}
                          {/* ...existing pet icons code... */}
                        </Box>

                        <Box sx={{
                          mt: 'auto',
                          pt: 2,
                          display: 'flex',
                          justifyContent: 'flex-end',
                          width: '100%',
                          gap: 1
                        }}>
                          <Tooltip title="Ver detalles">
                            <IconButton
                              size="small"
                              onClick={() => handleViewOpen(client)}
                              sx={{
                                color: '#00b4d8',
                                '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' }
                              }}
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Editar">
                            <IconButton
                              size="small"
                              onClick={() => handleOpen(client)}
                              sx={{
                                color: '#00b4d8',
                                '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' }
                              }}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Paper>
                    </Grid>
                  ))
                )}
              </Grid>
            </Box>
          )}

          {/* Delete Confirmation Dialog */}
          <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}
            fullScreen={isMobile}
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              },
            }}
            PaperProps={{
              sx: {
                borderRadius: '8px',
              },
            }}>
            <DialogTitle sx={{
              backgroundColor: '#87CEEB',
              color: 'white',
              fontWeight: 'bold'
            }}>
              Confirmar Eliminación
            </DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 4, paddingTop: '29px !important' }}>
              <Box sx={{
                backgroundColor: 'red',
                borderRadius: '50%',
                padding: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 2
              }}>
                <CloseIcon sx={{ color: 'white', fontSize: 40 }} />
              </Box>
              <Typography variant="h6" align="center" sx={{ color: '#333', fontWeight: 'bold' }}>
                ¿Está seguro de que desea eliminar este cliente?
              </Typography>
            </DialogContent>
            <DialogActions sx={{
              justifyContent: 'right',
              px: 3,
              py: 2,
              backgroundColor: 'rgba(135, 206, 235, 0.1)'
            }}>
              <Button onClick={confirmDeleteClient}
                variant="contained"
                sx={{
                  backgroundColor: '#87CEEB',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'rgb(255, 0, 0)',
                  },
                  '&:disabled': {
                    backgroundColor: 'rgba(255, 0, 0, 0.5)',
                    color: 'rgba(255, 255, 255, 0.7)',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                }}>
                Eliminar
              </Button>
              <Button
                onClick={handleCloseDeleteDialogOpen}
                variant="outlined"
                sx={{
                  color: '#87CEEB',
                  borderColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                    borderColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                  mr: 2,
                }}
              >
                Cancelar
              </Button>
            </DialogActions>
          </Dialog>

          {/* Card Filter Dialog */}
          <Dialog
            open={cardIsFilterDialogOpen}
            onClose={handleCardCloseFilterDialog}
            maxWidth="md"
            fullWidth
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(135, 206, 235, 0.1)',
              },
            }}
          >
            <DialogTitle sx={{ backgroundColor: '#87CEEB', color: 'white', fontWeight: 'bold' }}>
              Filtros de Lista de Tarjetas
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <InputLabel>Tipo Compostera</InputLabel>
                    <Select
                      multiple
                      value={cardSelectedFilters['tipo_compostera'] || []}
                      onChange={(e) => {
                        setCardSelectedFilters({
                          ...cardSelectedFilters,
                          tipo_compostera: e.target.value as string[]
                        });
                      }}
                      input={<OutlinedInput label="Tipo Compostera" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                    >
                      {['S', 'M', 'L', 'XL', 'Recolección'].map((tipo) => (
                        <MenuItem key={tipo} value={tipo}>
                          <Checkbox checked={(cardSelectedFilters['tipo_compostera'] || []).indexOf(tipo) > -1} />
                          <ListItemText primary={tipo} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <InputLabel>Tipo Documento</InputLabel>
                    <Select
                      multiple
                      value={cardSelectedFilters['tipo_documento'] || []}
                      onChange={(e) => {
                        setCardSelectedFilters({
                          ...cardSelectedFilters,
                          tipo_documento: e.target.value as string[]
                        });
                      }}
                      input={<OutlinedInput label="Tipo Documento" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                    >
                      {['Nacional', 'Jurídica', 'Dimex', 'Nite'].map((tipo) => (
                        <MenuItem key={tipo} value={tipo}>
                          <Checkbox checked={(cardSelectedFilters['tipo_documento'] || []).indexOf(tipo) > -1} />
                          <ListItemText primary={tipo} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <InputLabel>Tipo de Cliente</InputLabel>
                    <Select
                      multiple
                      value={cardSelectedFilters['tipo_client'] || []}
                      onChange={(e) => {
                        setCardSelectedFilters({
                          ...cardSelectedFilters,
                          tipo_client: e.target.value as string[]
                        });
                      }}
                      input={<OutlinedInput label="Tipo de Cliente" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                    >
                      <MenuItem value="Municipalidad">
                        <Checkbox checked={(cardSelectedFilters['tipo_client'] || []).indexOf('Municipalidad') > -1} />
                        <ListItemText primary="Municipalidad" />
                      </MenuItem>
                      <MenuItem value="Regular">
                        <Checkbox checked={(cardSelectedFilters['tipo_client'] || []).indexOf('Regular') > -1} />
                        <ListItemText primary="Regular" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Provincia</InputLabel>
                    <Select
                      multiple
                      value={cardSelectedFilters['provincia'] || []}
                      onChange={(e) => {
                        const selectedProvinces = e.target.value as string[];
                        setCardSelectedFilters({
                          ...cardSelectedFilters,
                          provincia: selectedProvinces,
                          canton: [],
                          distrito: [],
                          municipalidades: selectedProvinces.length === 1 ? [`Municipalidad de ${selectedProvinces[0]}`] : [] // Selecciona la municipalidad correspondiente
                        });
                        if (selectedProvinces.length === 1) {
                          setCantons(costaRicaData.cantons[selectedProvinces[0] as keyof typeof costaRicaData.cantons] || []);
                        } else {
                          setCantons([]);
                        }
                        setDistricts([]);
                      }}
                      input={<OutlinedInput label="Provincia" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                    >
                      {costaRicaData.provinces.sort().map((province) => (
                        <MenuItem key={province} value={province}>
                          <Checkbox checked={(cardSelectedFilters['provincia'] || []).indexOf(province) > -1} />
                          <ListItemText primary={province} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Cantón</InputLabel>
                    <Select
                      multiple
                      value={cardSelectedFilters['canton'] || []}
                      onChange={(e) => {
                        const selectedCantons = e.target.value as string[];
                        setCardSelectedFilters({
                          ...cardSelectedFilters,
                          canton: selectedCantons,
                          distrito: []
                        });
                        if (cardSelectedFilters['provincia']?.length === 1 && selectedCantons.length === 1) {
                          const province = cardSelectedFilters['provincia'][0] as keyof typeof costaRicaData.districts;
                          const canton = selectedCantons[0];
                          const provinceDistricts = costaRicaData.districts[province];
                          if (provinceDistricts && canton in provinceDistricts) {
                            setDistricts(provinceDistricts[canton as keyof typeof provinceDistricts]);
                          } else {
                            setDistricts([]);
                          }
                        } else {
                          setDistricts([]);
                        }
                      }}
                      input={<OutlinedInput label="Cantón" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                      disabled={cardSelectedFilters['provincia']?.length !== 1}
                    >
                      {cantons.sort().map((canton) => (
                        <MenuItem key={canton} value={canton}>
                          <Checkbox checked={(cardSelectedFilters['canton'] || []).indexOf(canton) > -1} />
                          <ListItemText primary={canton} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Distrito</InputLabel>
                    <Select
                      multiple
                      value={cardSelectedFilters['distrito'] || []}
                      onChange={(e) => {
                        setCardSelectedFilters({
                          ...cardSelectedFilters,
                          distrito: e.target.value as string[]
                        });
                      }}
                      input={<OutlinedInput label="Distrito" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                      disabled={cardSelectedFilters['canton']?.length !== 1}
                    >
                      {districts.map((district) => (
                        <MenuItem key={district} value={district}>
                          <Checkbox checked={(cardSelectedFilters['distrito'] || []).indexOf(district) > -1} />
                          <ListItemText primary={district} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{
              justifyContent: 'center',
              px: 3,
              py: 2,
              backgroundColor: 'rgba(135, 206, 235, 0.1)'
            }}>
              <Button
                onClick={handleCardCloseFilterDialog}
                variant="outlined"
                sx={{
                  color: '#87CEEB',
                  borderColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                    borderColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                }}
              >
                Cancelar
              </Button>
            </DialogActions>
          </Dialog>

          {/* Table Filter Dialog */}
          <Dialog
            open={tableIsFilterDialogOpen}
            onClose={handleTableCloseFilterDialog}
            maxWidth="md"
            fullWidth
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              },
            }}
          >
            <DialogTitle sx={{ backgroundColor: '#87CEEB', color: 'white', fontWeight: 'bold' }}>
              Filtros de Tabla
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <InputLabel>Tipo Compostera</InputLabel>
                    <Select
                      multiple
                      value={tableSelectedFilters['tipo_compostera'] || []}
                      onChange={(e) => {
                        setTableSelectedFilters({
                          ...tableSelectedFilters,
                          tipo_compostera: e.target.value as string[]
                        });
                      }}
                      input={<OutlinedInput label="Tipo Compostera" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                    >
                      {['S', 'M', 'L', 'XL', 'Recolección'].map((tipo) => (
                        <MenuItem key={tipo} value={tipo}>
                          <Checkbox checked={(tableSelectedFilters['tipo_compostera'] || []).indexOf(tipo) > -1} />
                          <ListItemText primary={tipo} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <InputLabel>Tipo Documento</InputLabel>
                    <Select
                      multiple
                      value={tableSelectedFilters['tipo_documento'] || []}
                      onChange={(e) => {
                        setTableSelectedFilters({
                          ...tableSelectedFilters,
                          tipo_documento: e.target.value as string[]
                        });
                      }}
                      input={<OutlinedInput label="Tipo Documento" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                    >
                      {['Nacional', 'Jurídica', 'Dimex', 'Nite'].map((tipo) => (
                        <MenuItem key={tipo} value={tipo}>
                          <Checkbox checked={(tableSelectedFilters['tipo_documento'] || []).indexOf(tipo) > -1} />
                          <ListItemText primary={tipo} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <InputLabel>Tipo de Cliente</InputLabel>
                    <Select
                      multiple
                      value={tableSelectedFilters['tipo_client'] || []}
                      onChange={(e) => {
                        setTableSelectedFilters({
                          ...tableSelectedFilters,
                          tipo_client: e.target.value as string[]
                        });
                      }}
                      input={<OutlinedInput label="Tipo de Cliente" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                    >
                      <MenuItem value="Municipalidad">
                        <Checkbox checked={(tableSelectedFilters['tipo_client'] || []).indexOf('Municipalidad') > -1} />
                        <ListItemText primary="Municipalidad" />
                      </MenuItem>
                      <MenuItem value="Regular">
                        <Checkbox checked={(tableSelectedFilters['tipo_client'] || []).indexOf('Regular') > -1} />
                        <ListItemText primary="Regular" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Provincia</InputLabel>
                    <Select
                      value={tableSelectedFilters['provincia']?.[0] || ''} // Single value
                      onChange={(e) => {
                        const selectedProvince = e.target.value as string;
                        setTableSelectedFilters({
                          ...tableSelectedFilters,
                          provincia: [selectedProvince], // Wrap in array to maintain structure
                          canton: [], // Reset canton
                          distrito: [], // Reset distrito
                          municipalidades: [`Municipalidad de ${selectedProvince}`]
                        });
                        // Update available cantons for selected province
                        setCantons(costaRicaData.cantons[selectedProvince as keyof typeof costaRicaData.cantons] || []);
                        setAvailableDistricts([]); // Reset districts
                      }}
                      input={<OutlinedInput label="Provincia" />}
                    >
                      {costaRicaData.provinces.sort().map((province) => (
                        <MenuItem key={province} value={province}>
                          <ListItemText primary={province} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Cantón</InputLabel>
                    <Select
                      value={tableSelectedFilters['canton']?.[0] || ''} // Single value
                      onChange={(e) => {
                        const selectedCanton = e.target.value as string;
                        setTableSelectedFilters({
                          ...tableSelectedFilters,
                          canton: [selectedCanton], // Wrap in array to maintain structure
                          distrito: [] // Reset distrito
                        });
                        // Update available districts for selected province and canton
                        const province = tableSelectedFilters['provincia']?.[0];
                        if (province) {
                          const provinceDistricts = costaRicaData.districts[province as keyof typeof costaRicaData.districts];
                          if (provinceDistricts && selectedCanton in provinceDistricts) {
                            setAvailableDistricts(provinceDistricts[selectedCanton as keyof typeof provinceDistricts]);
                          }
                        }
                      }}
                      input={<OutlinedInput label="Cantón" />}
                      disabled={!tableSelectedFilters['provincia']?.[0]} // Enable only if provincia is selected
                    >
                      {cantons.sort().map((canton) => (
                        <MenuItem key={canton} value={canton}>
                          <ListItemText primary={canton} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Distrito</InputLabel>
                    <Select
                      value={tableSelectedFilters['distrito']?.[0] || ''} // Single value
                      onChange={(e) => {
                        setTableSelectedFilters({
                          ...tableSelectedFilters,
                          distrito: [e.target.value as string] // Wrap in array to maintain structure
                        });
                      }}
                      input={<OutlinedInput label="Distrito" />}
                      disabled={!tableSelectedFilters['canton']?.[0]} // Enable only if canton is selected
                    >
                      {availableDistricts.sort().map((district) => (
                        <MenuItem key={district} value={district}>
                          <ListItemText primary={district} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{
              justifyContent: 'right',
              px: 3,
              py: 2,
              backgroundColor: 'rgba(135, 206, 235, 0.1)'
            }}>
              <Button
                onClick={handleTableCloseFilterDialog}
                variant="outlined"
                sx={{
                  color: '#87CEEB',
                  borderColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                    borderColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                }}
              >
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>

          {/* Filter Dialog */}
          <Dialog
            open={isFilterDialogOpen}
            onClose={handleCloseFilterDialog}
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(135, 206, 235, 0.1)',
              },
            }}

          >
            <DialogTitle>Filtros de Tabla</DialogTitle>
            <DialogContent>
              <FormControl fullWidth margin="normal">
                <InputLabel>Tipo Compostera</InputLabel>
                <Select
                  multiple
                  value={tableTipoComposteraFilter}
                  onChange={(e) => setTableTipoComposteraFilter(e.target.value as string[])}
                  input={<Input />}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {['S', 'M', 'L', 'XL', 'Recolección'].map((tipo) => (
                    <MenuItem key={tipo} value={tipo}>
                      <Checkbox checked={tableTipoComposteraFilter.indexOf(tipo) > -1} />
                      <ListItemText primary={tipo} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="normal">
                <InputLabel>Tipo Documento</InputLabel>
                <Select
                  multiple
                  value={tableTipoDocumentoFilter}
                  onChange={(e) => setTableTipoDocumentoFilter(e.target.value as string[])}
                  input={<Input />}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {['Nacional', 'Jurídica', 'Dimex', 'Nite'].map((tipo) => (
                    <MenuItem key={tipo} value={tipo}>
                      <Checkbox checked={tableTipoDocumentoFilter.indexOf(tipo) > -1} />
                      <ListItemText primary={tipo} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="normal">
                <InputLabel>Provincia</InputLabel>
                <Select
                  multiple
                  value={tableProvinciaFilter}
                  onChange={(e) => {
                    setTableProvinciaFilter(e.target.value as string[]);
                    handleProvinceChange(e.target.value as string);
                  }}
                  input={<Input />}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {provinces.sort().map((province) => (
                    <MenuItem key={province} value={province}>
                      <Checkbox checked={tableProvinciaFilter.indexOf(province) > -1} />
                      <ListItemText primary={province} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="normal">
                <InputLabel>Cantón</InputLabel>
                <Select
                  multiple
                  value={tableCantonFilter}
                  onChange={(e) => {
                    setTableCantonFilter(e.target.value as string[]);
                    handleCantonChange(e.target.value as string);
                  }}
                  input={<Input />}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {cantons.sort().map((canton) => (
                    <MenuItem key={canton} value={canton}>
                      <Checkbox checked={tableCantonFilter.indexOf(canton) > -1} />
                      <ListItemText primary={canton} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="normal">
                <InputLabel>Distrito</InputLabel>
                <Select
                  multiple
                  value={tableDistritoFilter}
                  onChange={(e) => setTableDistritoFilter(e.target.value as string[])}
                  input={<Input />}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {districts.map((district) => (
                    <MenuItem key={district} value={district}>
                      <Checkbox checked={tableDistritoFilter.indexOf(district) > -1} />
                      <ListItemText primary={district} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseFilterDialog}>Cancelar</Button>
            </DialogActions>
          </Dialog>

          {/* Column Selection Dialog */}
          <Dialog
            open={isColumnSelectionDialogOpen}
            onClose={handleCloseColumnSelectionDialog}
            PaperProps={{
              sx: {
                width: '400px',
                maxHeight: '80vh',
              }
            }}
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              },
            }}
          >
            <DialogTitle sx={{
              backgroundColor: '#87CEEB',
              color: 'white',
              fontWeight: 'bold'
            }}>
              Seleccionar Columnas
            </DialogTitle>
            <DialogContent dividers>
              <Box sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: 2
              }}>
                {columnOrder.map((column) => (
                  <FormControlLabel
                    key={column}
                    control={
                      <Checkbox
                        checked={visibleColumns.has(column)}
                        onChange={() => handleColumnToggle(column)}
                        sx={{
                          color: '#87CEEB',
                          '&.Mui-checked': {
                            color: '#87CEEB',
                          },
                        }}
                      />
                    }
                    label={columnNames[column]}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      '&:hover': {
                        backgroundColor: 'rgba(135, 206, 235, 0.08)',
                        borderRadius: '4px',
                      },
                    }}
                  />
                ))}
              </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'right', px: 3, py: 2, backgroundColor: 'rgba(135, 206, 235, 0.1)' }}>
              <Button
                onClick={handleCloseColumnSelectionDialog}
                variant="outlined"
                sx={{
                  color: '#87CEEB',
                  borderColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                    borderColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                }}
              >
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>

          {/* Add/Edit Client Dialog */}
          <Dialog
            open={open}
            onClose={handleCloseClient}
            fullScreen={isMobile}
            maxWidth={false}
            fullWidth
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              },
            }}
            PaperProps={{
              sx: {
                width: '95vw',
                height: '95vh',
                maxWidth: 'none',
                maxHeight: 'none',
                margin: '2.5vh auto',
                borderRadius: '16px',
                overflow: 'hidden',
                backdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(255, 255, 255, 0.98)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                transition: 'all 0.3s ease-in-out',
                display: 'flex',
                flexDirection: 'column',

                // Ocultar scrollbar pero mantener funcionalidad
                '*::-webkit-scrollbar': {
                  width: '0px',
                  height: '0px',
                  background: 'transparent',
                },
                '*::-webkit-scrollbar-track': {
                  background: 'transparent',
                },
                '*::-webkit-scrollbar-thumb': {
                  background: 'transparent',
                },
                // Firefox scrollbar
                '*': {
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                  '&': {
                    scrollbarWidth: 'none',
                    '-ms-overflow-style': 'none',
                  },
                },

                '& .MuiDialogTitle-root': {
                  backgroundColor: '#87CEEB',
                  color: 'white',
                  fontWeight: 'bold',
                  padding: '20px 24px',
                },
                '& .MuiDialogContent-root': {
                  flex: 1,
                  padding: '24px',
                  overflow: 'auto', // Mantener scroll funcional
                },
                '& .MuiDialogActions-root': {
                  padding: '16px 24px',
                  backgroundColor: 'rgba(135, 206, 235, 0.1)',
                },
              },
            }}
          >
            <DialogTitle sx={{
              backgroundColor: '#87CEEB',
              color: 'white',
              fontWeight: 'bold',
              padding: '16px 24px', // Altura más apropiada usando padding
              display: 'flex',
              alignItems: 'center'
            }}>
              {currentClient?.id ? 'Editar Cliente' : 'Agregar Nuevo Cliente'}
            </DialogTitle>
            <DialogContent dividers>
              <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Tabs
                  value={tabValue}
                  onChange={(event, newValue) => setTabValue(newValue)}
                  aria-label="client tabs"
                  sx={{
                    width: '33%',
                    mb: 2,
                    mt: -11,
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 1,
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    '& .MuiTab-root': {
                      color: '#87CEEB',
                      flex: 1, // Hace que cada pestaña ocupe el mismo espacio
                      minWidth: '50%', // Establece el ancho mínimo al 50% del contenedor
                      '&.Mui-selected': {
                        color: 'white',
                        backgroundColor: '#5CACEE',
                        borderRadius: 2,
                      },
                      '&:hover': {
                        color: 'white',
                        backgroundColor: '#4675EF',
                      },
                    },
                    '& .MuiTabs-indicator': {
                      backgroundColor: '#5CACEE',
                    },
                  }}
                >
                  <Tab label="Datos Personales y Ubicación" />
                  <Tab label="Mascotas e Imagen" />
                </Tabs>

                <Box sx={{ height: '100%' }}>
                  {tabValue === 0 && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                      <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                        <Grid item xs={12} md={6}>
                          <Box sx={{
                            width: '48.5%', // Asegura que el contenedor llene todo el ancho
                            height: '80%',  // Cambiado de calc(100% - 16px)
                            mb: 2,
                            position: 'absolute', // Cambiado a absolute
                            top: 88, // Añade el margen superior negativo
                            left: 13,
                            right: 0,
                            bottom: 0, // Asegura que el contenedor llene todo el espacio vertical
                            borderRadius: '10px',
                            boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.3)',
                            overflow: 'hidden', // Cambiado a hidden para evitar desbordamiento
                            zIndex: 1
                          }}>
                            <MapContainer
                              ref={mapRef}
                              center={selectedLocation || mapCenter}
                              zoom={15}
                              style={{
                                height: '100%',
                                width: '100%',
                                borderRadius: '10px'
                              }}
                              attributionControl={false}
                            >
                              <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                              />
                              {/* Agrega un componente de mapa que maneje el clic */}
                              <MapEventHandler onClick={handleMapClick} />
                              {/* Marcador para la ubicación seleccionada */}
                              {selectedLocation && (
                                <Marker position={selectedLocation} icon={new L.Icon({
                                  iconUrl: `${process.env.PUBLIC_URL}/images/puntoMapa.png`,
                                  iconSize: [29, 35],
                                  popupAnchor: [0, -35]
                                })}>
                                </Marker>
                              )}
                            </MapContainer>
                            <Box sx={{
                              position: 'absolute',
                              top: 10,
                              left: '50%', // Centrar horizontalmente
                              transform: 'translateX(-50%)', // Ajuste para centrado perfecto
                              backgroundColor: 'rgba(255,255,255,0.8)',
                              padding: '5px 10px',
                              borderRadius: '20px',
                              fontSize: '0.8rem',
                              fontWeight: 'bold',
                              boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                              zIndex: 1000,
                              whiteSpace: 'nowrap' // Evita que el texto se rompa en múltiples líneas
                            }}>
                              Selecciona la ubicación del cliente
                            </Box>

                            <IconButton
                              onMouseEnter={() => setIsHovered(true)}
                              onMouseLeave={() => setIsHovered(false)}
                              onClick={handleUpdateLocation}
                              sx={{
                                position: 'absolute',
                                top: 270, // Aligned with the form fields
                                right: 10,
                                backgroundColor: 'orange',
                                color: 'white',
                                animation: `${rotateAnimation} 4s linear infinite`,
                                '&:hover': {
                                  backgroundColor: 'darkorange',
                                  animation: 'none',
                                },
                                '& .MuiSvgIcon-root': {
                                  fontSize: '2rem',
                                },
                                zIndex: 1000
                              }}
                            >
                              {isHovered ? <RefreshIcon /> : <UpdateIcon />}
                            </IconButton>

                            <IconButton
                              onClick={() => setIsMapDialogOpen(true)}
                              sx={{
                                position: 'absolute',
                                top: 11,
                                right: 10,
                                backgroundColor: '#87CEEB',
                                color: 'white',
                                '&:hover': {
                                  backgroundColor: '#5CACEE',
                                },
                                zIndex: 1000,
                                padding: '11px', // Increased padding
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                '& svg': { // Target the icon
                                  width: '1.7rem', // Larger icon size
                                  height: '1.7rem', // Larger icon size
                                }
                              }}
                            >
                              <FullscreenIcon />
                            </IconButton>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={6} p={2}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={4}>
                              <TextField
                                autoFocus
                                margin="dense"
                                label="Nombre y Apellidos"
                                type="text"
                                fullWidth
                                error={!!currentClient?.name && !validateName(currentClient.name)} // Validación de nombre
                                helperText={!!currentClient?.name && !validateName(currentClient.name) ? 'El nombre solo debe contener letras y números, y tener un máximo de 29 caracteres.' : ''}
                                value={currentClient?.name || ''}
                                onChange={(e) => setCurrentClient(curr => curr ? { ...curr, name: e.target.value } : null)}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <TextField
                                margin="dense"
                                label="Teléfono"
                                type="tel"
                                fullWidth
                                error={!!currentClient?.phoneNumber && !validatePhone(currentClient.phoneNumber)} // Validación de teléfono
                                helperText={!!currentClient?.phoneNumber && !validatePhone(currentClient.phoneNumber) ? 'El teléfono debe ser numérico y tener hasta 13 dígitos.' : ''}
                                value={currentClient?.phoneNumber || ''}
                                onChange={(e) => setCurrentClient(curr => curr ? { ...curr, phoneNumber: e.target.value } : null)}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <TextField
                                margin="dense"
                                label="Teléfono Secundario"
                                type="tel"
                                fullWidth
                                error={!!currentClient?.second_phoneNumber && !validatePhone(currentClient.second_phoneNumber)} // Validación de teléfono secundario
                                helperText={!!currentClient?.second_phoneNumber && !validatePhone(currentClient.second_phoneNumber) ? 'El teléfono debe ser numérico y tener hasta 13 dígitos.' : ''}
                                value={currentClient?.second_phoneNumber || ''}
                                onChange={(e) => setCurrentClient(curr => curr ? { ...curr, second_phoneNumber: e.target.value } : null)}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <TextField
                                margin="dense"
                                label="Correo Electrónico"
                                type="email"
                                fullWidth
                                error={!!currentClient?.email && !validateEmail(currentClient.email)} // Validación de correo electrónico
                                helperText={!!currentClient?.email && !validateEmail(currentClient.email) ? 'Ingrese un correo electrónico válido.' : ''}
                                value={currentClient?.email || ''}
                                onChange={(e) => setCurrentClient(curr => curr ? { ...curr, email: e.target.value } : null)}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <TextField
                                margin="dense"
                                label="Cédula Nacional"
                                type="text"
                                fullWidth
                                error={!!currentClient?.cedula_nacional && !validateCedula(currentClient.cedula_nacional)} // Validación de cédula
                                helperText={!!currentClient?.cedula_nacional && !validateCedula(currentClient.cedula_nacional) ? 'La cédula debe ser numérica y tener hasta 13 dígitos.' : ''}
                                value={currentClient?.cedula_nacional || ''}
                                onChange={(e) => setCurrentClient(curr => curr ? { ...curr, cedula_nacional: e.target.value } : null)}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel
                                  sx={{ backgroundColor: 'white', padding: '0 4px' }} // Estilo agregado al InputLabel
                                >
                                  Tipo de Documento
                                </InputLabel>
                                <Select
                                  value={currentClient?.tipo_documento || ''}
                                  onChange={(e) => setCurrentClient(curr => curr ? { ...curr, tipo_documento: e.target.value as 'Nacional' | 'Jurídica' | 'Dimex' | 'Nite' } : null)}
                                  sx={{
                                    '& .MuiSelect-select': {
                                      border: 'none', // Eliminar el borde del select
                                    },
                                    '&:before': {
                                      border: 'none', // Eliminar la línea antes del select
                                    },
                                    '&:after': {
                                      border: 'none', // Eliminar la línea después del select
                                    },
                                  }}
                                >
                                  <MenuItem value="Nacional">Nacional</MenuItem>
                                  <MenuItem value="Jurídica">Jurídica</MenuItem>
                                  <MenuItem value="Dimex">Dimex</MenuItem>
                                  <MenuItem value="Nite">Nite</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel
                                  sx={{ backgroundColor: 'white', padding: '0 4px' }} // Estilo agregado al InputLabel
                                >
                                  Tipo de Cliente
                                </InputLabel>
                                <Select
                                  value={currentClient?.tipo_client || ''}
                                  onChange={(e) => {
                                    const newTipoClient = e.target.value as 'Municipalidad' | 'Regular';
                                    setCurrentClient(curr => {
                                      if (curr) {
                                        const updatedClient = { ...curr, tipo_client: newTipoClient };
                                        // Si cambia de Municipalidad a Regular, borramos la municipalidad seleccionada
                                        if (newTipoClient === 'Regular') {
                                          updatedClient.municipalidades = '';
                                        }
                                        return updatedClient;
                                      }
                                      return null;
                                    });
                                  }}
                                  sx={{
                                    '& .MuiSelect-select': {
                                      border: 'none', // Eliminar el borde del select
                                    },
                                    '&:before': {
                                      border: 'none', // Eliminar la línea antes del select
                                    },
                                    '&:after': {
                                      border: 'none', // Eliminar la línea después del select
                                    },
                                  }}
                                >
                                  <MenuItem value="Municipalidad">Municipalidad</MenuItem>
                                  <MenuItem value="Regular">Regular</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel
                                  sx={{ backgroundColor: 'white', padding: '0 4px' }} // Estilo agregado al InputLabel
                                >
                                  Tipo de Compostera
                                </InputLabel>
                                <Select
                                  value={currentClient?.tipo_compostera || ''}
                                  onChange={(e) => setCurrentClient(curr => curr ? { ...curr, tipo_compostera: e.target.value as 'S' | 'M' | 'L' | 'XL' | 'Recolección' } : null)}
                                  sx={{
                                    '& .MuiSelect-select': {
                                      border: 'none', // Eliminar el borde del select
                                    },
                                    '&:before': {
                                      border: 'none', // Eliminar la línea antes del select
                                    },
                                    '&:after': {
                                      border: 'none', // Eliminar la línea después del select
                                    },
                                  }}
                                >
                                  <MenuItem value="S">S</MenuItem>
                                  <MenuItem value="M">M</MenuItem>
                                  <MenuItem value="L">L</MenuItem>
                                  <MenuItem value="XL">XL</MenuItem>
                                  <MenuItem value="Recolección">Recolección</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel
                                  sx={{ backgroundColor: 'white', padding: '0 4px' }} // Estilo agregado al InputLabel
                                >
                                  Tipo de Entrega
                                </InputLabel>
                                <Select
                                  value={currentClient?.tipo_entrega || ''}
                                  onChange={(e) => setCurrentClient(curr => curr ? { ...curr, tipo_entrega: e.target.value as 'Productos' | 'Recolección' } : null)}
                                  sx={{
                                    '& .MuiSelect-select': {
                                      border: 'none', // Eliminar el borde del select
                                    },
                                    '&:before': {
                                      border: 'none', // Eliminar la línea antes del select
                                    },
                                    '&:after': {
                                      border: 'none', // Eliminar la línea después del select
                                    },
                                  }}
                                >
                                  <MenuItem value="Productos">
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                      <ShoppingCartIcon sx={{ color: 'rgb(71, 219, 226)', mr: 1 }} />
                                      Productos
                                    </Box>
                                  </MenuItem>
                                  <MenuItem value="Recolección">
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                      <RecoleccionIcon sx={{ color: 'green', mr: 1 }} />
                                      Recolección
                                    </Box>
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel sx={{ backgroundColor: 'white', padding: '0 4px' }}>
                                  Provincia
                                </InputLabel>
                                <Select
                                  value={currentClient?.provincia || ''}
                                  onChange={(e) => handleProvinceChange(e.target.value as string)}
                                  sx={{
                                    '& .MuiSelect-select': { border: 'none' },
                                    '&:before': { border: 'none' },
                                    '&:after': { border: 'none' },
                                  }}
                                >
                                  {[...costaRicaData.provinces].sort().map((province) => (
                                    <MenuItem key={province} value={province}>{province}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel sx={{ backgroundColor: 'white', padding: '0 4px' }}>
                                  Cantón
                                </InputLabel>
                                <Select
                                  value={currentClient?.canton || ''}
                                  onChange={(e) => {
                                    const selectedCanton = e.target.value as string;
                                    setCurrentClient(curr => curr ? { ...curr, canton: selectedCanton, distrito: '' } : null);
                                    setDistricts(costaRicaData.districts[currentClient?.provincia as keyof typeof costaRicaData.districts]?.[selectedCanton as keyof typeof costaRicaData.districts[keyof typeof costaRicaData.districts]] || []);
                                  }}
                                  sx={{
                                    '& .MuiSelect-select': { border: 'none' },
                                    '&:before': { border: 'none' },
                                    '&:after': { border: 'none' },
                                  }}
                                >
                                  {[...cantons].sort().map((canton) => (
                                    <MenuItem key={canton} value={canton}>{canton}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel sx={{ backgroundColor: 'white', padding: '0 4px' }}>
                                  Distrito
                                </InputLabel>
                                <Select
                                  value={currentClient?.distrito || ''}
                                  onChange={(e) => setCurrentClient(curr => curr ? { ...curr, distrito: e.target.value } : null)}
                                  sx={{
                                    '& .MuiSelect-select': { border: 'none' },
                                    '&:before': { border: 'none' },
                                    '&:after': { border: 'none' },
                                  }}
                                >
                                  {[...districts].sort().map((district) => (
                                    <MenuItem key={district} value={district}>{district}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                fullWidth
                                label="Enlace de Google Maps"
                                value={currentClient?.googleMapsLink || ''}
                                onChange={async (e) => { // Marcar la función como asíncrona
                                  const newLink = e.target.value;
                                  setCurrentClient(curr => curr ? { ...curr, googleMapsLink: newLink } : null);
                                  updateLocationFromLink(newLink); // Actualiza la ubicación en el mapa
                                  // Nueva lógica para centrar el mapa en la nueva ubicación
                                  const location = await getCoordinatesFromLink(newLink); // Función para obtener las coordenadas del enlace
                                  if (location) {
                                    const [lat, lng] = location;
                                    setSelectedLocation({ lat, lng });
                                    mapRef.current?.setView([lat, lng], 15);
                                    setIsLocationSelected(true);
                                    setLatitude(lat.toString());
                                    setLongitude(lng.toString());

                                    // Llamar a handleMapClickURL con las coordenadas directamente
                                    handleMapClickURL(lat, lng);
                                  } else {
                                    console.error('No se pudieron obtener las coordenadas. Verifica el enlace:', newLink);
                                  }
                                }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={() => window.open(currentClient?.googleMapsLink, '_blank')}
                                        disabled={!currentClient?.googleMapsLink}
                                        edge="end"
                                        sx={{
                                          color: '#0078D4',
                                          backgroundColor: 'rgba(0, 120, 212, 0.08)',
                                          padding: '12px',
                                          transition: 'all 0.3s ease',
                                          '&:hover': {
                                            backgroundColor: 'rgba(0, 120, 212, 0.15)',
                                            transform: 'scale(1.1)',
                                            boxShadow: '0 4px 8px rgba(0, 120, 212, 0.2)'
                                          },
                                          '&.Mui-disabled': {
                                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                            color: 'rgba(0, 0, 0, 0.26)'
                                          }
                                        }}
                                      >
                                        <GoogleIcon style={{ fontSize: 32 }} />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                fullWidth
                                label="Enlace de Waze"
                                value={currentClient?.wazeLink || ''}
                                onChange={async (e) => {
                                  const newLink = e.target.value;
                                  setCurrentClient(curr => curr ? { ...curr, wazeLink: newLink } : null);
                                  updateLocationFromLink(newLink); // Actualiza la ubicación en el mapa
                                  // Nueva lógica para centrar el mapa en la nueva ubicación
                                  const location = await getCoordinatesFromLink(newLink); // Función para obtener las coordenadas del enlace
                                  if (location) {
                                    const [lat, lng] = location;
                                    setSelectedLocation({ lat, lng });
                                    mapRefFullScream.current?.setView([lat, lng], 15);
                                    setIsLocationSelected(true);
                                    setLatitude(lat.toString());
                                    setLongitude(lng.toString());

                                    // Llamar a handleMapClickURL con las coordenadas directamente
                                    handleMapClickURL(lat, lng);
                                  } else {
                                    console.error('No se pudieron obtener las coordenadas. Verifica el enlace:', newLink);
                                  }
                                }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={() => window.open(currentClient?.wazeLink, '_blank')}
                                        disabled={!currentClient?.wazeLink}
                                        edge="end"
                                        sx={{
                                          color: '#0078D4',
                                          backgroundColor: 'rgba(0, 120, 212, 0.08)',
                                          padding: '12px',
                                          transition: 'all 0.3s ease',
                                          '&:hover': {
                                            backgroundColor: 'rgba(0, 120, 212, 0.15)',
                                            transform: 'scale(1.1)',
                                            boxShadow: '0 4px 8px rgba(0, 120, 212, 0.2)'
                                          },
                                          '&.Mui-disabled': {
                                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                            color: 'rgba(0, 0, 0, 0.26)'
                                          }
                                        }}
                                      >
                                        <FaWaze style={{ fontSize: 32 }} />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                margin="dense"
                                label="Señas"
                                type="text"
                                fullWidth
                                multiline
                                rows={2}
                                value={currentClient?.senas || ''}
                                onChange={(e) => setCurrentClient(curr => curr ? { ...curr, senas: e.target.value } : null)}
                              />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                              <TextField
                                margin="dense"
                                label="Nota del Cliente"
                                type="text"
                                fullWidth
                                multiline
                                rows={2}
                                value={currentClient?.nota || ''}
                                onChange={(e) => setCurrentClient(curr => curr ? { ...curr, nota: e.target.value } : null)}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                margin="dense"
                                label="Código de Referencia"
                                type="text"
                                fullWidth
                                value={currentClient?.codigo_referencia || ''}
                                onChange={(e) => setCurrentClient(curr => curr ? { ...curr, codigo_referencia: e.target.value } : null)}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                margin="dense"
                                label="Nota Admin"
                                type="text"
                                fullWidth
                                multiline
                                rows={2}
                                value={currentClient?.nota_admin || ''}
                                onChange={(e) => setCurrentClient(curr => curr ? { ...curr, nota_admin: e.target.value } : null)}
                              />
                            </Grid>
                          </Grid>
                          <Grid item xs={12}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={showCoordinates}
                                  onChange={(e) => setShowCoordinates(e.target.checked)}
                                  sx={{
                                    color: '#87CEEB',
                                    '&.Mui-checked': {
                                      color: '#87CEEB',
                                    },
                                  }}
                                />
                              }
                              label="Mostrar campos de coordenadas"
                            />
                          </Grid>

                          {showCoordinates && (
                            <>
                              <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
                                {showCoordinates && (
                                  <Box sx={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: 2,
                                  }}>
                                    <TextField
                                      margin="dense"
                                      label="Latitud"
                                      type="number"
                                      size="small"
                                      value={currentPublicClient?.location ? currentPublicClient.location[0] : latitude}
                                      onChange={(e) => setLatitude(e.target.value)}
                                      inputProps={{
                                        step: 'any',
                                        min: -90,
                                        max: 90
                                      }}
                                      error={(!!latitude || !!currentPublicClient?.location) && !isValidCoordinates()}
                                      helperText={!!latitude && !isValidCoordinates() ? 'Latitud debe estar entre -90 y 90' : ''}
                                      sx={{
                                        flex: 1,
                                        '& .MuiOutlinedInput-root': {
                                          backgroundColor: 'white'
                                        }
                                      }}
                                    />
                                    <TextField
                                      margin="dense"
                                      label="Longitud"
                                      type="number"
                                      size="small"
                                      value={currentPublicClient?.location ? currentPublicClient.location[1] : longitude}
                                      onChange={(e) => setLongitude(e.target.value)}
                                      inputProps={{
                                        step: 'any',
                                        min: -180,
                                        max: 180
                                      }}
                                      error={(!!longitude || !!currentPublicClient?.location) && !isValidCoordinates()}
                                      helperText={!!longitude && !isValidCoordinates() ? 'Longitud debe estar entre -180 y 180' : ''}
                                      sx={{
                                        flex: 1,
                                        '& .MuiOutlinedInput-root': {
                                          backgroundColor: 'white'
                                        }
                                      }}
                                    />
                                    <Button
                                      variant="contained"
                                      onClick={handleUpdateCoordinates}
                                      disabled={!latitude || !longitude || !isValidCoordinates()}
                                      sx={{
                                        height: 40,
                                        mt: 1,
                                        backgroundColor: '#87CEEB',
                                        color: 'white',
                                        '&:hover': {
                                          backgroundColor: '#5CACEE',
                                        },
                                        '&:disabled': {
                                          backgroundColor: 'rgba(135, 206, 235, 0.5)',
                                          color: 'rgba(255, 255, 255, 0.7)',
                                        },
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1
                                      }}
                                    >
                                      <LocationOnIcon />
                                      Actualizar Ubicación
                                    </Button>
                                  </Box>
                                )}
                              </Grid>
                            </>
                          )}
                        </Grid>
                        <Dialog
                          open={isMapDialogOpen}
                          onClose={() => setIsMapDialogOpen(false)}
                          fullScreen={isMobile}
                          maxWidth={false} // Permite ancho personalizado
                          fullWidth
                          BackdropProps={{
                            sx: {
                              backgroundColor: 'rgba(0, 0, 0, 0.8)',
                            },
                          }}
                          PaperProps={{
                            sx: {
                              width: '95vw', // 95% del ancho de la ventana
                              height: '95vh', // 95% del alto de la ventana
                              maxWidth: 'none', // Elimina el ancho máximo predeterminado
                              maxHeight: 'none', // Elimina el alto máximo predeterminado
                              margin: '2.5vh auto', // Centra verticalmente
                              borderRadius: '16px', // Bordes redondeados más pronunciados
                              overflow: 'hidden', // Evita el desbordamiento
                              // Efecto de cristal y sombra
                              backdropFilter: 'blur(8px)',
                              backgroundColor: 'rgba(255, 255, 255, 0.98)',
                              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                              // Transición suave
                              transition: 'all 0.3s ease-in-out',
                              // Ajustes para el contenido interno
                              display: 'flex',
                              flexDirection: 'column',
                              '& .MuiDialogTitle-root': {
                                backgroundColor: '#87CEEB',
                                color: 'white',
                                fontWeight: 'bold',
                                padding: '20px 24px',
                              },
                              '& .MuiDialogContent-root': {
                                flex: 1,
                                overflow: 'auto',
                                padding: '24px',
                              },
                              '& .MuiDialogActions-root': {
                                padding: '16px 24px',
                                backgroundColor: 'rgba(135, 206, 235, 0.1)',
                              }
                            },
                          }}
                        >
                          <DialogTitle sx={{
                            backgroundColor: '#87CEEB',
                            color: 'white',
                            fontWeight: 'bold',
                            padding: '16px 24px', // Altura más apropiada usando padding
                            display: 'flex',
                            alignItems: 'center'
                          }}>Mapa</DialogTitle>
                          <DialogContent>
                            <MapContainer
                              ref={mapRefFullScream}
                              center={selectedLocation || mapCenter}
                              zoom={18}
                              style={{
                                height: '100%',
                                width: '100%',
                                borderRadius: '10px'
                              }}
                              attributionControl={false}
                            >
                              <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                              />
                              <MapEventHandler onClick={handleMapClick} />
                              {selectedLocation && (
                                <Marker position={selectedLocation} icon={new L.Icon({
                                  iconUrl: `${process.env.PUBLIC_URL}/images/puntoMapa.png`,
                                  iconSize: [29, 35],
                                  popupAnchor: [0, -35]
                                })}>
                                </Marker>
                              )}
                            </MapContainer>
                          </DialogContent>
                          <DialogActions sx={{
                            px: 3,
                            py: 2,
                            backgroundColor: 'rgba(135, 206, 235, 0.1)',
                            minHeight: '72px', // Altura fija para el DialogActions
                          }}>
                            <Box sx={{
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              position: 'relative', // Para posicionamiento absoluto del botón central
                              gap: 2
                            }}>

                              <IconButton
                                onClick={() => window.open(currentClient?.googleMapsLink, '_blank')}
                                disabled={!currentClient?.googleMapsLink}
                                sx={{
                                  backgroundColor: 'white',
                                  color: '#0078D4',
                                  padding: '8px',
                                  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                                  '&:hover': {
                                    backgroundColor: '#f5f5f5',
                                    transform: 'scale(1.05)',
                                  },
                                  '&.Mui-disabled': {
                                    backgroundColor: '#e0e0e0',
                                    color: '#9e9e9e',
                                  }
                                }}
                              >
                                <GoogleIcon sx={{ fontSize: 24 }} />
                              </IconButton>

                              <IconButton
                                onClick={() => window.open(currentClient?.wazeLink, '_blank')}
                                disabled={!currentClient?.wazeLink}
                                sx={{
                                  mr: '8px', // Ajuste de margen derecho
                                  backgroundColor: 'white',
                                  color: '#33ccff',
                                  padding: '8px',
                                  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                                  '&:hover': {
                                    backgroundColor: '#f5f5f5',
                                    transform: 'scale(1.05)',
                                  },
                                  '&.Mui-disabled': {
                                    backgroundColor: '#e0e0e0',
                                    color: '#9e9e9e',
                                  }
                                }}
                              >
                                <FaWaze style={{ fontSize: 24 }} />
                              </IconButton>

                              {/* Checkbox a la izquierda */}
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={showCoordinates}
                                    onChange={(e) => setShowCoordinates(e.target.checked)}
                                    sx={{
                                      color: '#87CEEB',
                                      '&.Mui-checked': {
                                        color: '#87CEEB',
                                      },
                                    }}
                                  />
                                }
                                label="Mostrar campos de coordenadas"
                              />

                              {/* Campos de coordenadas y botón en el centro */}
                              {showCoordinates && (
                                <Box sx={{
                                  position: 'absolute',
                                  left: '50%',
                                  transform: 'translateX(-50%)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 2,
                                  zIndex: 1
                                }}>
                                  <TextField
                                    margin="dense"
                                    label="Latitud"
                                    type="number"
                                    size="small"
                                    value={currentPublicClient?.location ? currentPublicClient.location[0] : latitude}
                                    onChange={(e) => setLatitude(e.target.value)}
                                    inputProps={{
                                      step: 'any',
                                      min: -90,
                                      max: 90
                                    }}
                                    error={(!!latitude || !!currentPublicClient?.location) && !isValidCoordinates()}
                                    helperText={!!latitude && !isValidCoordinates() ? 'Latitud debe estar entre -90 y 90' : ''}
                                    sx={{
                                      width: '150px',
                                      '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'white'
                                      }
                                    }}
                                  />
                                  <TextField
                                    margin="dense"
                                    label="Longitud"
                                    type="number"
                                    size="small"
                                    value={currentPublicClient?.location ? currentPublicClient.location[1] : longitude}
                                    onChange={(e) => setLongitude(e.target.value)}
                                    inputProps={{
                                      step: 'any',
                                      min: -180,
                                      max: 180
                                    }}
                                    error={(!!longitude || !!currentPublicClient?.location) && !isValidCoordinates()}
                                    helperText={!!longitude && !isValidCoordinates() ? 'Longitud debe estar entre -180 y 180' : ''}
                                    sx={{
                                      width: '150px',
                                      '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'white'
                                      }
                                    }}
                                  />
                                  <Button
                                    variant="contained"
                                    onClick={handleUpdateCoordinates}
                                    disabled={!latitude || !longitude || !isValidCoordinates()}
                                    sx={{
                                      height: 40,
                                      backgroundColor: '#87CEEB',
                                      color: 'white',
                                      '&:hover': {
                                        backgroundColor: '#5CACEE',
                                      },
                                      '&:disabled': {
                                        backgroundColor: 'rgba(135, 206, 235, 0.5)',
                                        color: 'rgba(255, 255, 255, 0.7)',
                                      },
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 1
                                    }}
                                  >
                                    <LocationOnIcon />
                                    Actualizar Ubicación
                                  </Button>
                                </Box>
                              )}

                              {/* Botón Cancelar a la derecha */}
                              <Button
                                onClick={() => {
                                  setIsMapDialogOpen(false)
                                }}
                                variant="outlined"
                                sx={{
                                  color: '#87CEEB',
                                  borderColor: '#87CEEB',
                                  '&:hover': {
                                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                                    borderColor: '#5CACEE',
                                  },
                                  fontWeight: 'bold',
                                  px: 4,
                                  py: 1,
                                  marginLeft: 'auto'
                                }}
                              >
                                Cancelar
                              </Button>
                            </Box>
                          </DialogActions>
                        </Dialog>
                      </Grid>
                    </Box>
                  )}

                  {tabValue === 1 && (
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'row' }}> {/* Cambiado a 'row' para alinear horizontalmente */}
                      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', paddingRight: 2, mr: 2 }}> {/* Añadido margen derecho */}
                        <Grid container spacing={2} sx={{ mb: 2, flex: 1, mt: 2, ml: 2 }}> {/* Añadido margin top y left */}
                          {['cant_gato', 'cant_perro_mini', 'cant_perro_pequeno', 'cant_perro_mediano', 'cant_perro_grande', 'cant_perro_gigante'].map((field) => (
                            <Grid item xs={12} sm={6} md={4} key={field}>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                sx={{
                                  border: '2px solid #87CEEB', // Borde alrededor del Box
                                  borderRadius: 2, // Bordes redondeados
                                  transition: 'transform 0.3s ease', // Transición para el hover
                                  '&:hover': {
                                    transform: 'scale(1.02)', // Escalar ligeramente al pasar el mouse
                                  },
                                  padding: 1, // Espaciado interno
                                }}
                              >
                                <Box display="flex" flexDirection="column" alignItems="center">
                                  <Box sx={{ textAlign: 'center', mb: 1 }}> {/* Ajustar margen inferior */}
                                    <img
                                      src={`${process.env.PUBLIC_URL}/images/${field}.png`}
                                      alt={columnNames[field as keyof Client]}
                                      style={{ width: '70px', height: '70px' }} // Aumentar tamaño de la imagen
                                    />
                                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{columnNames[field as keyof Client]?.split(' ')[0]}</Typography>
                                    <Typography variant="body2">{columnNames[field as keyof Client]?.split(' ')[1]}</Typography>
                                  </Box>
                                </Box>
                                <Box display="flex" flexDirection="column" alignItems="center" sx={{ ml: 1 }}> {/* Ajustar margen a la izquierda */}
                                  <Typography variant="body2" sx={{ mb: 1 }}>Cantidad:</Typography> {/* Texto pequeño arriba */}
                                  <Box display="flex" alignItems="center">
                                    <IconButton
                                      onClick={() => handleQuantityChange(field, false)}
                                      sx={{ color: '#87CEEB' }}
                                    >
                                      <RemoveIcon />
                                    </IconButton>
                                    <TextField
                                      value={currentClient?.[field as keyof Client] || '0'}
                                      onChange={(e) => setCurrentClient(curr => curr ? { ...curr, [field]: e.target.value } : null)}
                                      inputProps={{
                                        style: { textAlign: 'center' },
                                        min: 0,
                                      }}
                                      sx={{
                                        width: '50px',
                                        '& .MuiInputBase-input': {
                                          padding: '5px',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                          '& fieldset': {
                                            borderColor: 'transparent',
                                          },
                                          '&:hover fieldset': {
                                            borderColor: 'transparent',
                                          },
                                          '&.Mui-focused fieldset': {
                                            borderColor: 'transparent',
                                          },
                                        },
                                      }}
                                    />
                                    <IconButton
                                      onClick={() => handleQuantityChange(field, true)}
                                      sx={{ color: '#87CEEB' }}
                                    >
                                      <AddIcon />
                                    </IconButton>
                                  </Box>
                                </Box>
                              </Box>
                            </Grid>
                          ))}

                        </Grid>
                      </Box>
                      <Box
                        sx={{
                          width: '35%', // Ajustado el tamaño del Box
                          display: 'flex',
                          flexDirection: 'column',
                          paddingLeft: 2,
                        }}
                      >
                        <Typography variant="h6" sx={{ mb: 2 }}>Imagen del cliente</Typography>
                        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px dashed #87CEEB', borderRadius: 2, mb: 2 }}>
                          {currentClient?.imageUrl ? (
                            <Box sx={{ position: 'relative', width: '100%', textAlign: 'center' }}>
                              <IconButton
                                sx={{
                                  position: 'absolute',
                                  right: 5,
                                  top: 5,
                                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                  '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                  },
                                  zIndex: 1,
                                }}
                                onClick={() => {
                                  if (currentClient) {
                                    setCurrentClient({
                                      ...currentClient,
                                      imageUrl: ''
                                    });
                                  }
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                              <img src={currentClient.imageUrl} alt="Client" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                            </Box>
                          ) : (
                            <Typography variant="body1" color="textSecondary">Vista previa de la imagen</Typography>
                          )}
                        </Box>
                        <input
                          accept="image/*"
                          style={{ display: 'none' }}
                          id="raised-button-file"
                          type="file"
                          onChange={handleImageUpload}
                        />
                        <label htmlFor="raised-button-file">
                          <Button
                            variant="contained"
                            component="span"
                            startIcon={<CloudUploadIcon />}
                            fullWidth
                            sx={{
                              backgroundColor: '#87CEEB',
                              '&:hover': {
                                backgroundColor: '#5CACEE',
                              },
                            }}
                          >
                            Subir Imagen
                          </Button>
                        </label>
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
            </DialogContent>
            <DialogActions sx={{
              justifyContent: 'right',
              px: 3,
              py: 2,
              backgroundColor: 'rgba(135, 206, 235, 0.1)'
            }}>
              <Button
                onClick={handleSave}
                variant="contained"
                disabled={!isFormValid()}
                sx={{
                  backgroundColor: '#87CEEB',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#5CACEE',
                  },
                  '&:disabled': {
                    backgroundColor: 'rgba(135, 206, 235, 0.5)',
                    color: 'rgba(255, 255, 255, 0.7)',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                }}
              >
                Guardar
              </Button>
              <Button
                onClick={handleClose}
                variant="outlined"
                sx={{
                  color: '#87CEEB',
                  borderColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                    borderColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                  mr: 2,
                }}
              >
                Cancelar
              </Button>
            </DialogActions>
          </Dialog>

          {/* View Client Dialog */}
          <Dialog
            open={viewOpen}
            onClose={handleViewClose}
            fullScreen={isMobile}
            maxWidth="lg"
            fullWidth
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              },
            }}
            PaperProps={{
              sx: {
                borderRadius: '8px',
                height: 'calc(100% - 64px)',
                maxHeight: 'none',
              },
            }}
          >
            <DialogTitle sx={{
              backgroundColor: '#87CEEB',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '1.5rem',
              py: 2,
            }}>
              Detalles del Cliente: {currentClient?.name}
            </DialogTitle>
            <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', height: '100%', p: 0 }}>
              <Box sx={{ display: 'flex', height: '100%' }}>
                <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #e0e0e0' }}>
                  <Typography variant="h6" gutterBottom sx={{ color: '#87CEEB', fontWeight: 'bold' }}>Información Personal</Typography>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Teléfono</Typography>
                    <Typography>{currentClient?.phoneNumber}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Email</Typography>
                    <Typography>{currentClient?.email}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Cédula Nacional</Typography>
                    <Typography>{currentClient?.cedula_nacional}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Tipo de Documento</Typography>
                    <Typography>{currentClient?.tipo_documento}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Tipo de Cliente</Typography>
                    <Typography>{currentClient?.tipo_client}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Tipo de Compostera</Typography>
                    <Typography>{currentClient?.tipo_compostera}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="textSecondary">Tipo de Entrega</Typography>
                    {currentClient?.tipo_entrega === 'Productos' ? (
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <ShoppingCartIcon sx={{ color: 'rgb(71, 219, 226)', mr: 1 }} />
                        <Typography>Productos</Typography>
                      </Box>
                    ) : (
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <RecoleccionIcon sx={{ color: 'green', mr: 1 }} />
                        <Typography>Recolección</Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
                <Box sx={{ width: '40%', p: 3, borderRight: '1px solid #e0e0e0' }}>
                  <Typography variant="h6" gutterBottom sx={{ color: '#87CEEB', fontWeight: 'bold' }}>Ubicación</Typography>
                  <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                    <IconButton
                      onClick={() => window.open(currentClient?.googleMapsLink, '_blank')}
                      disabled={!currentClient?.googleMapsLink}
                      sx={{
                        color: '#0078D4',
                        backgroundColor: 'white',
                        padding: '12px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          backgroundColor: 'rgba(0, 120, 212, 0.15)',
                          transform: 'scale(1.1)',
                          boxShadow: '0 4px 8px rgba(0, 120, 212, 0.2)'
                        },
                        '&.Mui-disabled': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          color: 'rgba(0, 0, 0, 0.26)'
                        }
                      }}
                    >
                      <GoogleIcon style={{ fontSize: 32 }} />
                    </IconButton>
                    <IconButton
                      onClick={() => window.open(currentClient?.wazeLink, '_blank')}
                      disabled={!currentClient?.wazeLink}
                      sx={{
                        mr: '8px', // Ajuste de margen derecho
                        backgroundColor: 'white',
                        color: '#33ccff',
                        padding: '12px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                        '&:hover': {
                          backgroundColor: 'rgba(0, 120, 212, 0.15)',
                          transform: 'scale(1.1)',
                          boxShadow: '0 4px 8px rgba(0, 120, 212, 0.2)'
                        },
                        '&.Mui-disabled': {
                          backgroundColor: '#e0e0e0',
                          color: '#9e9e9e',
                        }
                      }}
                    >
                      <FaWaze style={{ fontSize: 32 }} />
                    </IconButton>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Provincia</Typography>
                    <Typography>{currentClient?.provincia}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Cantón</Typography>
                    <Typography>{currentClient?.canton}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Distrito</Typography>
                    <Typography>{currentClient?.distrito}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Municipalidad</Typography>
                    <Typography>{currentClient?.municipalidades}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Dirección y señas para llegar</Typography>
                    <Typography>{currentClient?.senas}</Typography>
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" color="textSecondary">Nota del cliente</Typography>
                    <Typography>{currentClient?.nota}</Typography>
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" color="textSecondary">Nota Admin</Typography> {/* Nuevo campo */}
                    <Typography>{currentClient?.nota_admin}</Typography> {/* Muestra el valor de nota_admin */}
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" color="textSecondary">Código de Referencia</Typography>
                    <Typography>{currentClient?.codigo_referencia}</Typography>
                  </Box>
                </Box>
                <Box sx={{ width: '30%', p: 3, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="h6" gutterBottom sx={{ color: '#87CEEB', fontWeight: 'bold' }}>Imagen del cliente</Typography>
                  <Box sx={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '2px dashed #87CEEB',
                    borderRadius: 2,
                    mb: 3,
                  }}>
                    {currentClient?.imageUrl ? (
                      <Box sx={{ position: 'relative', width: '100%', textAlign: 'center' }}>
                        <img src={currentClient.imageUrl} alt="Client" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                      </Box>
                    ) : (
                      <Typography variant="body1" color="textSecondary">Vista previa de la imagen</Typography>
                    )}
                  </Box>
                  <Typography variant="h6" gutterBottom sx={{ color: '#87CEEB', fontWeight: 'bold' }}>Mascotas</Typography>
                  <Grid container spacing={2}>
                    {['cant_gato', 'cant_perro_mini', 'cant_perro_pequeno', 'cant_perro_mediano', 'cant_perro_grande', 'cant_perro_gigante']
                      .filter(field => parseInt(currentClient?.[field as keyof Client] as string, 10) > 0)
                      .map((field) => (
                        <Grid item xs={6} key={field}>
                          <Box display="flex" alignItems="center">
                            <img
                              src={`${process.env.PUBLIC_URL}/images/${field}.png`}
                              alt={columnNames[field as keyof Client]}
                              style={{ width: '40px', height: '40px', marginRight: '8px' }}
                            />
                            <Typography variant="body2">{columnNames[field as keyof Client]}: {(() => {
                              const value = currentClient?.[field as keyof Client];
                              if (!value) return '';
                              if ((value as any).toDate) return format((value as any).toDate(), 'dd/MM/yyyy HH:mm');
                              return String(value);
                            })()}</Typography>
                          </Box>
                        </Grid>
                      ))}
                  </Grid>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'right', px: 3, py: 2, backgroundColor: 'rgba(135, 206, 235, 0.1)' }}>
              <Button
                onClick={handleViewClose}
                variant="outlined"
                sx={{
                  color: '#87CEEB',
                  borderColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                    borderColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                }}
              >
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {/* Public Client Dialog */}
      {newTabValue === 1 && (
        <div>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Button
                startIcon={<SaveAltIcon />}
                variant="contained"
                color="primary"
                onClick={() => handleOpenUpdateCSV()}
                sx={{
                  backgroundColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgb(135, 206, 235)',
                  },
                  fontWeight: 'bold'
                }}
              >
                Importar Clientes
              </Button>
              <FormControlLabel
                control={
                  <Switch
                    checked={mainTabValue === 1}
                    onChange={() => setMainTabValue(mainTabValue === 0 ? 1 : 0)}
                    color="primary"
                    sx={{
                      '&.MuiSwitch-root': {
                        '& .MuiSwitch-thumb': {
                          backgroundColor: 'rgb(135, 206, 235) !important',
                        }
                      },
                    }}
                  />
                }
                label={
                  <span style={{ fontWeight: 'bold' }}>
                    {mainTabValue === 0 ? "Tabla de Clientes" : "Lista de Cartas"}
                  </span>
                }
              />
            </Box>
            {/* Notification Icon */}
            <IconButton
              onClick={handleClickNotification}
              sx={{ position: 'relative' }}
            >
              <Badge badgeContent={pendingClients.length} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>
          </Box>

          {mainTabValue === 0 && (
            // Tabla de Clientes
            <Box>
              {/* Barra de búsqueda para la tabla */}
              <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <TextField
                  variant="outlined"
                  size="small"
                  placeholder="Buscar..."
                  value={tableSearchTermPublic}
                  onChange={(e) => setTableSearchTermPublic(e.target.value)}
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ color: 'action.active', mr: 1 }} />,
                  }}
                  sx={{ alignItems: 'left' }}
                />
                <Box>
                  {/* Botones de acción para la tabla */}
                  <Tooltip title="Filtrar">
                    <IconButton onClick={handleTableOpenFilterDialogPublic}>
                      <FilterIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Seleccionar columnas">
                    <IconButton onClick={handleOpenColumnSelectionDialog}>
                      <ViewColumnIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Imprimir">
                    <IconButton onClick={handlePrint}>
                      <PrintIcon />
                    </IconButton>
                  </Tooltip>
                  <CSVLink data={csvDataPublic} filename="clientes.csv">
                    <Tooltip title="Descargar CSV">
                      <IconButton>
                        <DownloadIcon />
                      </IconButton>
                    </Tooltip>
                  </CSVLink>
                </Box>
              </Box>

              {/* Chips de filtros seleccionados para la tabla */}
              <Box sx={{ mb: 2 }}>
                {Object.entries(publicTableSelectedFilters).map(([key, values]) => (
                  values.map(value => (
                    <Chip
                      key={`${key}-${value}`}
                      label={`${publicColumnNames[key as keyof PublicClient]}: ${value}`}
                      onDelete={() => {
                        const newFilters = { ...publicTableSelectedFilters }; // Asegúrate de usar publicTableSelectedFilters
                        newFilters[key] = newFilters[key].filter(v => v !== value); // Filtra el valor a eliminar
                        setPublicTableSelectedFilters(newFilters); // Actualiza el estado con los nuevos filtros
                        applyPublicFilters(); // Aplica los filtros actualizados
                      }}
                      sx={{ mr: 1, backgroundColor: '#87CEEB', color: 'white' }}
                    />
                  ))
                ))}
              </Box>

              {/* Tabla de clientes */}
              <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 2 }}>
                <Table sx={{ minWidth: 650 }} aria-label="clients table">
                  <TableHead sx={{ backgroundColor: '#87CEEB' }}>
                    <TableRow>
                      {Array.from(visiblePublicColumns).map((column) => (
                        <TableCell key={column} sx={{ color: 'white', fontWeight: 'bold' }}>
                          {publicColumnNames[column]}
                        </TableCell>
                      ))}
                      <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center' }}>Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody sx={{ minHeight: '400px' }}>
                    {publicTableFilteredClients.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={visiblePublicColumns.size + 1} sx={{ textAlign: 'center' }}>
                          <Typography>
                            {tableSearchTermPublic.trim()
                              ? 'No se encontraron resultados para la búsqueda'
                              : 'No hay clientes públicos para mostrar'}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      <>
                        {publicTableFilteredClients
                          .sort((a, b) => {
                            const statusA = a.status_create_public_client;
                            const statusB = b.status_create_public_client;
                            if (statusA === 'pending' && statusB !== 'pending') return -1;
                            if (statusA !== 'pending' && statusB === 'pending') return 1;
                            return 0;
                          })
                          .slice(publicPage * publicRowsPerPage, publicPage * publicRowsPerPage + publicRowsPerPage) // Cambiar page por publicPage y rowsPerPage por publicRowsPerPage
                          .map((client) => (
                            <TableRow
                              key={client.id}
                              sx={{
                                '&:hover': {
                                  backgroundColor: 'rgba(0, 180, 216, 0.1)',
                                  '& .action-icons': {
                                    opacity: 1
                                  }
                                }
                              }}
                            >
                              {Array.from(visiblePublicColumns).map((column) => (
                                <TableCell key={column}>
                                  {column === 'tipo_entrega' ? (
                                    client[column] === 'Productos' ? (
                                      <ShoppingCartIcon sx={{ color: 'rgb(71, 219, 226)' }} />
                                    ) : (
                                      <RecoleccionIcon sx={{ color: 'green' }} />
                                    )
                                  ) : column === 'status_create_public_client' ? (
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                      {client[column] === 'pending' ? (
                                        <Tooltip title="Pendiente">
                                          <AccessTimeIcon sx={{ color: '#87CEEB' }} />
                                        </Tooltip>
                                      ) : client[column] === 'completed' ? (
                                        <Tooltip title="Completado">
                                          <CheckCircleIcon sx={{ color: 'green' }} />
                                        </Tooltip>
                                      ) : (
                                        <Tooltip title="Cancelado">
                                          <CancelIcon sx={{ color: 'red' }} />
                                        </Tooltip>
                                      )}
                                      {/* <Typography>
                                        {client[column] === 'pending' ? 'Pendiente' :
                                          client[column] === 'completed' ? 'Completado' : 'Cancelado'}
                                      </Typography> */}
                                    </Box>
                                  ) : column === 'createdAt' ? (
                                    client[column] ? (
                                      (client[column] as Timestamp).toDate ? (
                                        format((client[column] as Timestamp).toDate(), 'dd/MM/yyyy HH:mm')
                                      ) : String(client[column])
                                    ) : '-'
                                  ) : ['municipalidades', 'senas', 'nota'].includes(column) ? (
                                    <Tooltip title={String(client[column] || '')}>
                                      <Box sx={{
                                        maxWidth: '150px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                      }}>
                                        {String(client[column] || '')}
                                      </Box>
                                    </Tooltip>
                                  ) : (
                                    String(client[column] || '')
                                  )}
                                </TableCell>
                              ))}
                              <TableCell>
                                <Box
                                  className="action-icons"
                                  sx={{
                                    display: 'flex',
                                    gap: 1,
                                    justifyContent: 'flex-end',
                                    opacity: 1
                                  }}
                                >
                                  <IconButton
                                    size="small"
                                    onClick={() => handleViewOpenPublic(client)}
                                    sx={{
                                      color: '#00b4d8',
                                      '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' }
                                    }}
                                  >
                                    <VisibilityIcon />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    onClick={() => handleCreateClient({ ...client })}
                                    disabled={client.status_create_public_client === 'completed'}
                                    sx={{
                                      color: '#00b4d8',
                                      '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' }
                                    }}
                                  >
                                    <TransferIcon />
                                  </IconButton>
                                  <IconButton
                                    size="small"
                                    onClick={() => client.id && handleDeletePublicClient(client.id)}
                                    sx={{
                                      color: 'error.main',
                                      '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.1)' }
                                    }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={publicTableFilteredClients.length}
                rowsPerPage={publicRowsPerPage}
                page={publicPage}
                onPageChange={handlePublicChangePage}
                onRowsPerPageChange={handlePublicChangeRowsPerPage}
                labelRowsPerPage="Filas por página:"
              />
            </Box>
          )}

          {mainTabValue === 1 && (
            // Lista de Cartas
            <Box>
              {/* Barra de búsqueda para la lista de cartas */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <TextField
                  variant="outlined"
                  size="small"
                  placeholder="Buscar..."
                  value={cardSearchTermPublic}
                  onChange={(e) => setCardSearchTermPublic(e.target.value)}
                  InputProps={{
                    startAdornment: <SearchIcon sx={{ color: 'action.active', mr: 1 }} />,
                  }}
                  sx={{ alignItems: 'left' }}
                />
              </Box>

              <Grid container spacing={3}>
                {cardFilteredClientsPublic.length === 0 ? (
                  <Grid item xs={12}>
                    <Paper sx={{
                      p: 3,
                      textAlign: 'center',
                      borderRadius: 2,
                      backgroundColor: 'rgba(135, 206, 235, 0.1)'
                    }}>
                      <Typography>
                        {tableSearchTermPublic?.trim()
                          ? 'No se encontraron resultados para la búsqueda'
                          : 'No hay clientes públicos para mostrar'}
                      </Typography>
                    </Paper>
                  </Grid>
                ) : (
                  cardFilteredClientsPublic.map((client) => (
                    <Grid item xs={12} sm={6} md={4} lg={2} key={client.id}>
                      <Paper elevation={3} sx={{
                        p: 3,
                        borderRadius: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        position: 'relative',
                        transition: 'all 0.3s ease',
                        minHeight: '329px',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: '0px 8px 30px rgba(135, 206, 235, 0.7)',
                        }
                      }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>{client.name}</Typography>

                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <Tooltip title="Teléfono">
                            <Box component={PhoneIcon} color="#00b4d8" sx={{ mr: 1 }} />
                          </Tooltip>
                          <Typography variant="body2">{client.phoneNumber}</Typography>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <Tooltip title="Correo">
                            <Box component={MailIcon} color="#00b4d8" sx={{ mr: 1 }} />
                          </Tooltip>
                          <Tooltip title={client.email}>
                            <Typography variant="body2" sx={{
                              maxWidth: '180px',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}>
                              {client.email}
                            </Typography>
                          </Tooltip>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <Tooltip title="Ubicación">
                            <Box component={MapPinIcon} color="#00b4d8" sx={{ mr: 1 }} />
                          </Tooltip>
                          <Typography variant="body2">{client.provincia}, {client.canton}</Typography>
                        </Box>

                        <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          mt: 2,
                          flexWrap: 'wrap',
                          gap: 0.5,
                          border: '1px solid rgba(0, 180, 216, 0.2)',
                          borderRadius: 1,
                          p: 1,
                          backgroundColor: 'rgba(135, 206, 235, 0.05)'
                        }}>
                          {[
                            { count: client.cant_gato, type: 'gato', alt: 'Gato' },
                            { count: client.cant_perro_mini, type: 'perro_mini', alt: 'Perro Mini' },
                            { count: client.cant_perro_pequeno, type: 'perro_pequeno', alt: 'Perro Pequeño' },
                            { count: client.cant_perro_mediano, type: 'perro_mediano', alt: 'Perro Mediano' },
                            { count: client.cant_perro_grande, type: 'perro_grande', alt: 'Perro Grande' },
                            { count: client.cant_perro_gigante, type: 'perro_gigante', alt: 'Perro Gigante' }
                          ].map(({ count, type, alt }) => (
                            Array.from({ length: parseInt(count, 10) || 0 }).map((_, index) => (
                              <Tooltip key={`${type}-${index}`} title={alt}>
                                <img
                                  src={`${process.env.PUBLIC_URL}/images/cant_${type}.png`}
                                  alt={alt}
                                  style={{ width: '30px', height: '30px', marginRight: '2px' }}
                                />
                              </Tooltip>
                            ))
                          ))}
                        </Box>

                        <Box sx={{
                          mt: 'auto',
                          pt: 2,
                          display: 'flex',
                          justifyContent: 'flex-end',
                          width: '100%',
                          gap: 1
                        }}>
                          <Tooltip title="Ver detalles">
                            <IconButton
                              size="small"
                              onClick={() => handleViewOpenPublic(client)}
                              sx={{
                                color: '#00b4d8',
                                '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' }
                              }}
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Editar">
                            <IconButton
                              size="small"
                              onClick={() => handlePublicOpen(client)}
                              sx={{
                                color: '#00b4d8',
                                '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' }
                              }}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={client.status_create_public_client === 'completed' ? 'Cliente ya creado' : 'Crear cliente'}>
                            <span>
                              <IconButton
                                size="small"
                                onClick={() => handleCreateClient({ ...client })}
                                disabled={client.status_create_public_client === 'completed'}
                                sx={{
                                  color: '#00b4d8',
                                  '&:hover': { backgroundColor: 'rgba(0, 180, 216, 0.1)' },
                                  '&.Mui-disabled': {
                                    color: 'rgba(0, 0, 0, 0.26)'
                                  }
                                }}
                              >
                                <TransferIcon />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </Box>
                      </Paper>
                    </Grid>
                  ))
                )}
              </Grid>
            </Box>
          )}

          {/* Dialog para confirmar la creación del cliente */}
          <Dialog
            open={createClientDialogOpen}
            onClose={() => setCreateClientDialogOpen(false)}
            fullWidth
            maxWidth="sm"
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              },
            }}
            PaperProps={{
              sx: {
                borderRadius: '8px',
              },
            }}
          >
            <DialogTitle sx={{
              backgroundColor: '#87CEEB',
              color: 'white',
              fontWeight: 'bold'
            }}>
              Confirmar Creación de Cliente
            </DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 4, paddingTop: '29px !important' }}>
              <Box sx={{
                backgroundColor: 'green',
                borderRadius: '50%',
                padding: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 2
              }}>
                <CreateIcon sx={{ color: 'white', fontSize: 40 }} />
              </Box>
              <Typography variant="h6" align="center" sx={{ color: '#333', fontWeight: 'bold' }}>
                ¿Está seguro de que desea crear este cliente como definitivo?
              </Typography>
            </DialogContent>
            <DialogActions sx={{
              justifyContent: 'right',
              px: 3,
              py: 2,
              backgroundColor: 'rgba(135, 206, 235, 0.1)'
            }}>
              <Button onClick={() => {
                if (selectedClient) {
                  handleClientTransferFromWaitlist(selectedClient);
                }
              }}
                variant="contained"
                sx={{
                  backgroundColor: '#87CEEB',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                }}>
                Crear Cliente
              </Button>
              <Button onClick={() => setCreateClientDialogOpen(false)}
                variant="outlined"
                sx={{
                  color: '#87CEEB',
                  borderColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                    borderColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                  mr: 2,
                }}
              >
                Cancelar
              </Button>
            </DialogActions>
          </Dialog>

          {/* Delete Confirmation Dialog */}
          <Dialog open={deleteDialogOpenPublic} onClose={() => setDeleteDialogOpenPublic(false)}
            fullScreen={isMobile}
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              },
            }}
            PaperProps={{
              sx: {
                borderRadius: '8px',
              },
            }}>
            <DialogTitle sx={{
              backgroundColor: '#87CEEB',
              color: 'white',
              fontWeight: 'bold'
            }}>
              Confirmar Eliminación</DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 4, paddingTop: '29px !important' }}>
              <Box sx={{
                backgroundColor: 'red',
                borderRadius: '50%',
                padding: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 2
              }}>
                <CloseIcon sx={{ color: 'white', fontSize: 40 }} />
              </Box>
              <Typography variant="h6" align="center" sx={{ color: '#333', fontWeight: 'bold' }}>
                ¿Está seguro de que desea eliminar este cliente público?
              </Typography>
            </DialogContent>
            <DialogActions sx={{
              justifyContent: 'right',
              px: 3,
              py: 2,
              backgroundColor: 'rgba(135, 206, 235, 0.1)'
            }}>
              <Button onClick={confirmDeletePublicClient}
                variant="contained"
                sx={{
                  backgroundColor: '#87CEEB',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'rgb(255, 0, 0)',
                  },
                  '&:disabled': {
                    backgroundColor: 'rgba(255, 0, 0, 0.5)',
                    color: 'rgba(255, 255, 255, 0.7)',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                }}>
                Eliminar
              </Button>
              <Button onClick={() => setDeleteDialogOpenPublic(false)}
                variant="outlined"
                sx={{
                  color: '#87CEEB',
                  borderColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                    borderColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                  mr: 2,
                }}
              >
                Cancelar
              </Button>
            </DialogActions>
          </Dialog>

          {/* Card Filter Dialog */}
          <Dialog
            open={cardIsFilterDialogOpenPublic}
            onClose={handleCardCloseFilterDialogPublic}
            maxWidth="md"
            fullWidth
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(135, 206, 235, 0.1)',
              },
            }}
          >
            <DialogTitle sx={{ backgroundColor: '#87CEEB', color: 'white', fontWeight: 'bold' }}>
              Filtros de Lista de Tarjetas
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <InputLabel>Tipo Compostera</InputLabel>
                    <Select
                      multiple
                      value={cardSelectedFilters['tipo_compostera'] || []}
                      onChange={(e) => {
                        setCardSelectedFiltersPublic({
                          ...cardSelectedFiltersPublic,
                          tipo_compostera: e.target.value as string[]
                        });
                      }}
                      input={<OutlinedInput label="Tipo Compostera" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                    >
                      {['S', 'M', 'L', 'XL', 'Recolección'].map((tipo) => (
                        <MenuItem key={tipo} value={tipo}>
                          <Checkbox checked={(cardSelectedFiltersPublic['tipo_compostera'] || []).indexOf(tipo) > -1} />
                          <ListItemText primary={tipo} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <InputLabel>Tipo Documento</InputLabel>
                    <Select
                      multiple
                      value={cardSelectedFilters['tipo_documento'] || []}
                      onChange={(e) => {
                        setCardSelectedFiltersPublic({
                          ...cardSelectedFiltersPublic,
                          tipo_documento: e.target.value as string[]
                        });
                      }}
                      input={<OutlinedInput label="Tipo Documento" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                    >
                      {['Nacional', 'Jurídica', 'Dimex', 'Nite'].map((tipo) => (
                        <MenuItem key={tipo} value={tipo}>
                          <Checkbox checked={(cardSelectedFiltersPublic['tipo_documento'] || []).indexOf(tipo) > -1} />
                          <ListItemText primary={tipo} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <InputLabel>Tipo de Cliente</InputLabel>
                    <Select
                      multiple
                      value={cardSelectedFilters['tipo_client'] || []}
                      onChange={(e) => {
                        setCardSelectedFilters({
                          ...cardSelectedFiltersPublic,
                          tipo_client: e.target.value as string[]
                        });
                      }}
                      input={<OutlinedInput label="Tipo de Cliente" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                    >
                      <MenuItem value="Municipalidad">
                        <Checkbox checked={(cardSelectedFiltersPublic['tipo_client'] || []).indexOf('Municipalidad') > -1} />
                        <ListItemText primary="Municipalidad" />
                      </MenuItem>
                      <MenuItem value="Regular">
                        <Checkbox checked={(cardSelectedFiltersPublic['tipo_client'] || []).indexOf('Regular') > -1} />
                        <ListItemText primary="Regular" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Provincia</InputLabel>
                    <Select
                      multiple
                      value={cardSelectedFilters['provincia'] || []}
                      onChange={(e) => {
                        const selectedProvinces = e.target.value as string[];
                        setCardSelectedFiltersPublic({
                          ...cardSelectedFiltersPublic,
                          provincia: selectedProvinces,
                          canton: [],
                          distrito: [],
                          municipalidades: selectedProvinces.length === 1 ? [`Municipalidad de ${selectedProvinces[0]}`] : [] // Selecciona la municipalidad correspondiente
                        });
                        if (selectedProvinces.length === 1) {
                          setAvailableCantons(costaRicaData.cantons[selectedProvinces[0] as keyof typeof costaRicaData.cantons] || []);
                        } else {
                          setAvailableCantons([]);
                        }
                        setAvailableDistricts([]);
                      }}
                      input={<OutlinedInput label="Provincia" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                    >
                      {costaRicaData.provinces.sort().map((province) => (
                        <MenuItem key={province} value={province}>
                          <Checkbox checked={(cardSelectedFiltersPublic['provincia'] || []).indexOf(province) > -1} />
                          <ListItemText primary={province} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Cantón</InputLabel>
                    <Select
                      multiple
                      value={cardSelectedFilters['canton'] || []}
                      onChange={(e) => {
                        const selectedCantons = e.target.value as string[];
                        setCardSelectedFiltersPublic({
                          ...cardSelectedFiltersPublic,
                          canton: selectedCantons,
                          distrito: []
                        });
                        if (cardSelectedFilters['provincia']?.length === 1 && selectedCantons.length === 1) {
                          const province = cardSelectedFilters['provincia'][0] as keyof typeof costaRicaData.districts;
                          const canton = selectedCantons[0];
                          const provinceDistricts = costaRicaData.districts[province];
                          if (provinceDistricts && canton in provinceDistricts) {
                            setAvailableDistricts(provinceDistricts[canton as keyof typeof provinceDistricts]);
                          } else {
                            setAvailableDistricts([]);
                          }
                        } else {
                          setAvailableDistricts([]);
                        }
                      }}
                      input={<OutlinedInput label="Cantón" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                      disabled={cardSelectedFilters['provincia']?.length !== 1}
                    >
                      {cantons.sort().map((canton) => (
                        <MenuItem key={canton} value={canton}>
                          <Checkbox checked={(cardSelectedFiltersPublic['canton'] || []).indexOf(canton) > -1} />
                          <ListItemText primary={canton} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Distrito</InputLabel>
                    <Select
                      multiple
                      value={cardSelectedFilters['distrito'] || []}
                      onChange={(e) => {
                        setCardSelectedFiltersPublic({
                          ...cardSelectedFiltersPublic,
                          distrito: e.target.value as string[]
                        });
                      }}
                      input={<OutlinedInput label="Distrito" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                      disabled={cardSelectedFilters['canton']?.length !== 1}
                    >
                      {availableDistricts.sort().map((district) => (
                        <MenuItem key={district} value={district}>
                          <Checkbox checked={(cardSelectedFiltersPublic['distrito'] || []).indexOf(district) > -1} />
                          <ListItemText primary={district} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{
              justifyContent: 'center',
              px: 3,
              py: 2,
              backgroundColor: 'rgba(135, 206, 235, 0.1)'
            }}>
              <Button
                onClick={handleCardCloseFilterDialogPublic}
                variant="outlined"
                sx={{
                  color: '#87CEEB',
                  borderColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                    borderColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                }}
              >
                Cancelar
              </Button>
            </DialogActions>
          </Dialog>

          {/* Table Filter Dialog */}
          <Dialog
            open={tableIsFilterDialogOpenPublic}
            onClose={handleTableCloseFilterDialogPublic}
            maxWidth="md"
            fullWidth
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              },
            }}
          >
            <DialogTitle sx={{ backgroundColor: '#87CEEB', color: 'white', fontWeight: 'bold' }}>
              Filtros de Tabla
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <InputLabel>Tipo Compostera</InputLabel>
                    <Select
                      multiple
                      value={publicTableSelectedFilters['tipo_compostera'] || []}
                      onChange={(e) => {
                        setPublicTableSelectedFilters({
                          ...publicTableSelectedFilters,
                          tipo_compostera: e.target.value as string[]
                        });
                      }}
                      input={<OutlinedInput label="Tipo Compostera" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                    >
                      {['S', 'M', 'L', 'XL', 'Recolección'].map((tipo) => (
                        <MenuItem key={tipo} value={tipo}>
                          <Checkbox checked={(publicTableSelectedFilters['tipo_compostera'] || []).indexOf(tipo) > -1} />
                          <ListItemText primary={tipo} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <InputLabel>Tipo Documento</InputLabel>
                    <Select
                      multiple
                      value={publicTableSelectedFilters['tipo_documento'] || []}
                      onChange={(e) => {
                        setPublicTableSelectedFilters({
                          ...publicTableSelectedFilters,
                          tipo_documento: e.target.value as string[]
                        });
                      }}
                      input={<OutlinedInput label="Tipo Documento" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                    >
                      {['Nacional', 'Jurídica', 'Dimex', 'Nite'].map((tipo) => (
                        <MenuItem key={tipo} value={tipo}>
                          <Checkbox checked={(publicTableSelectedFilters['tipo_documento'] || []).indexOf(tipo) > -1} />
                          <ListItemText primary={tipo} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                    <InputLabel>Tipo de Cliente</InputLabel>
                    <Select
                      multiple
                      value={publicTableSelectedFilters['tipo_client'] || []}
                      onChange={(e) => {
                        setPublicTableSelectedFilters({
                          ...publicTableSelectedFilters,
                          tipo_client: e.target.value as string[]
                        });
                      }}
                      input={<OutlinedInput label="Tipo de Cliente" />}
                      renderValue={(selected) => (selected as string[]).join(', ')}
                    >
                      <MenuItem value="Municipalidad">
                        <Checkbox checked={(publicTableSelectedFilters['tipo_client'] || []).indexOf('Municipalidad') > -1} />
                        <ListItemText primary="Municipalidad" />
                      </MenuItem>
                      <MenuItem value="Regular">
                        <Checkbox checked={(publicTableSelectedFilters['tipo_client'] || []).indexOf('Regular') > -1} />
                        <ListItemText primary="Regular" />
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined" >
                    <InputLabel>Provincia</InputLabel>
                    <Select
                      value={publicTableSelectedFilters['provincia']?.[0] || ''}
                      onChange={(e) => {
                        const selectedProvinces = e.target.value as string;
                        setPublicTableSelectedFilters({
                          ...publicTableSelectedFilters,
                          provincia: [selectedProvinces],
                          canton: [],
                          distrito: [],
                          municipalidades: [`Municipalidad de ${selectedProvinces}`] // Selecciona la municipalidad correspondiente
                        });

                        setAvailableCantons(costaRicaData.cantons[selectedProvinces as keyof typeof costaRicaData.cantons] || []);
                        setAvailableDistricts([]);
                      }}
                      input={<OutlinedInput label="Provincia" />}
                    >
                      {costaRicaData.provinces.sort().map((province) => (
                        <MenuItem key={province} value={province}>
                          <ListItemText primary={province} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Cantón</InputLabel>
                    <Select
                      value={publicTableSelectedFilters['canton']?.[0] || ''}
                      onChange={(e) => {
                        const selectedCantons = e.target.value as string;
                        setPublicTableSelectedFilters({
                          ...publicTableSelectedFilters,
                          canton: [selectedCantons],
                          distrito: []
                        });
                        const province = publicTableSelectedFilters['provincia'][0];
                        if (province) {
                          const provinceDistricts = costaRicaData.districts[province as keyof typeof costaRicaData.districts];
                          if (provinceDistricts && selectedCantons in provinceDistricts) {
                            setAvailableDistricts(provinceDistricts[selectedCantons as keyof typeof provinceDistricts]);
                          }
                        }
                      }}
                      input={<OutlinedInput label="Cantón" />}
                      disabled={!publicTableSelectedFilters['provincia']?.[0]}
                    >
                      {availableCantons.map((canton) => (
                        <MenuItem key={canton} value={canton}>
                          <ListItemText primary={canton} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>Distrito</InputLabel>
                    <Select
                      value={publicTableSelectedFilters['distrito']?.[0] || ''}
                      onChange={(e) => {
                        setPublicTableSelectedFilters({
                          ...publicTableSelectedFilters,
                          distrito: [e.target.value as string]
                        });
                      }}
                      input={<OutlinedInput label="Distrito" />}
                      disabled={!publicTableSelectedFilters['canton']?.[0]}
                    >
                      {availableDistricts.sort().map((district) => (
                        <MenuItem key={district} value={district}>
                          <ListItemText primary={district} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{
              justifyContent: 'right',
              px: 3,
              py: 2,
              backgroundColor: 'rgba(135, 206, 235, 0.1)'
            }}>
              <Button
                onClick={handleTableCloseFilterDialogPublic}
                variant="outlined"
                sx={{
                  color: '#87CEEB',
                  borderColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                    borderColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                }}
              >
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>

          {/* Filter Dialog */}
          <Dialog
            open={isFilterDialogOpen}
            onClose={handleCloseFilterDialog}
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(135, 206, 235, 0.1)',
              },
            }}

          >
            <DialogTitle>Filtros de Tabla</DialogTitle>
            <DialogContent>
              <FormControl fullWidth margin="normal">
                <InputLabel>Tipo Compostera</InputLabel>
                <Select
                  multiple
                  value={tableTipoComposteraFilter}
                  onChange={(e) => setTableTipoComposteraFilter(e.target.value as string[])}
                  input={<Input />}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {['S', 'M', 'L', 'XL', 'Recolección'].map((tipo) => (
                    <MenuItem key={tipo} value={tipo}>
                      <Checkbox checked={tableTipoComposteraFilter.indexOf(tipo) > -1} />
                      <ListItemText primary={tipo} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="normal">
                <InputLabel>Tipo Documento</InputLabel>
                <Select
                  multiple
                  value={tableTipoDocumentoFilter}
                  onChange={(e) => setTableTipoDocumentoFilter(e.target.value as string[])}
                  input={<Input />}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {['Nacional', 'Jurídica', 'Dimex', 'Nite'].map((tipo) => (
                    <MenuItem key={tipo} value={tipo}>
                      <Checkbox checked={tableTipoDocumentoFilter.indexOf(tipo) > -1} />
                      <ListItemText primary={tipo} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="normal">
                <InputLabel>Provincia</InputLabel>
                <Select
                  multiple
                  value={tableProvinciaFilter}
                  onChange={(e) => {
                    setTableProvinciaFilter(e.target.value as string[]);
                    handlePublicProvinceChange(e.target.value as string);
                  }}
                  input={<Input />}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {provinces.sort().map((province) => (
                    <MenuItem key={province} value={province}>
                      <Checkbox checked={tableProvinciaFilter.indexOf(province) > -1} />
                      <ListItemText primary={province} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="normal">
                <InputLabel>Cantón</InputLabel>
                <Select
                  multiple
                  value={tableCantonFilter}
                  onChange={(e) => {
                    setTableCantonFilter(e.target.value as string[]);
                    handlePublicCantonChange(e.target.value as string);
                  }}
                  input={<Input />}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {cantons.sort().map((canton) => (
                    <MenuItem key={canton} value={canton}>
                      <Checkbox checked={tableCantonFilter.indexOf(canton) > -1} />
                      <ListItemText primary={canton} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth margin="normal">
                <InputLabel>Distrito</InputLabel>
                <Select
                  multiple
                  value={tableDistritoFilter}
                  onChange={(e) => setTableDistritoFilter(e.target.value as string[])}
                  input={<Input />}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {availableDistricts.sort().map((district) => (
                    <MenuItem key={district} value={district}>
                      <Checkbox checked={tableDistritoFilter.indexOf(district) > -1} />
                      <ListItemText primary={district} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseFilterDialog}>Cancelar</Button>
            </DialogActions>
          </Dialog>

          {/* Column Selection Dialog */}
          <Dialog
            open={isColumnSelectionDialogOpen}
            onClose={handleCloseColumnSelectionDialog}
            PaperProps={{
              sx: {
                width: '400px',
                maxHeight: '80vh',
              }
            }}
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              },
            }}
          >
            <DialogTitle sx={{
              backgroundColor: '#87CEEB',
              color: 'white',
              fontWeight: 'bold'
            }}>
              Seleccionar Columnas
            </DialogTitle>
            <DialogContent dividers>
              <Box sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: 2
              }}>
                {columnOrder.map((column) => (
                  <FormControlLabel
                    key={column}
                    control={
                      <Checkbox
                        checked={visiblePublicColumns.has(column as keyof PublicClient)}
                        onChange={() => handlePublicColumnToggle(column as keyof PublicClient)}
                        sx={{
                          color: '#87CEEB',
                          '&.Mui-checked': {
                            color: '#87CEEB',
                          },
                        }}
                      />
                    }
                    label={publicColumnNames[column as keyof typeof publicColumnNames]}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      '&:hover': {
                        backgroundColor: 'rgba(135, 206, 235, 0.08)',
                        borderRadius: '4px',
                      },
                    }}
                  />
                ))}
              </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'right', px: 3, py: 2, backgroundColor: 'rgba(135, 206, 235, 0.1)' }}>
              <Button
                onClick={handleCloseColumnSelectionDialog}
                variant="outlined"
                sx={{
                  color: '#87CEEB',
                  borderColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                    borderColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                }}
              >
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>

          {/* Add/Edit Client Dialog */}
          <Dialog
            open={openPublic}
            onClose={handleClosePublicClient}
            fullScreen={isMobile}
            maxWidth={false}
            fullWidth
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              },
            }}
            PaperProps={{
              sx: {
                width: '95vw',
                height: '95vh',
                maxWidth: 'none',
                maxHeight: 'none',
                margin: '2.5vh auto',
                borderRadius: '16px',
                overflow: 'hidden',
                backdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(255, 255, 255, 0.98)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                transition: 'all 0.3s ease-in-out',
                display: 'flex',
                flexDirection: 'column',

                // Ocultar scrollbar pero mantener funcionalidad
                '*::-webkit-scrollbar': {
                  width: '0px',
                  height: '0px',
                  background: 'transparent',
                },
                '*::-webkit-scrollbar-track': {
                  background: 'transparent',
                },
                '*::-webkit-scrollbar-thumb': {
                  background: 'transparent',
                },
                // Firefox scrollbar
                '*': {
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                  '&': {
                    scrollbarWidth: 'none',
                    '-ms-overflow-style': 'none',
                  },
                },

                '& .MuiDialogTitle-root': {
                  backgroundColor: '#87CEEB',
                  color: 'white',
                  fontWeight: 'bold',
                  padding: '20px 24px',
                },
                '& .MuiDialogContent-root': {
                  flex: 1,
                  padding: '24px',
                  overflow: 'auto', // Mantener scroll funcional
                },
                '& .MuiDialogActions-root': {
                  padding: '16px 24px',
                  backgroundColor: 'rgba(135, 206, 235, 0.1)',
                },
              },
            }}
          >
            <DialogTitle sx={{
              backgroundColor: '#87CEEB',
              color: 'white',
              fontWeight: 'bold',
              padding: '16px 24px', // Altura más apropiada usando padding
              display: 'flex',
              alignItems: 'center'
            }}>
              {currentPublicClient?.id ? 'Editar Cliente Público' : 'Agregar Nuevo Cliente Público'}
            </DialogTitle>
            <DialogContent dividers>
              <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Tabs
                  value={tabValue}
                  onChange={(event, newValue) => setTabValue(newValue)}
                  aria-label="client tabs"
                  sx={{
                    width: '33%',
                    mb: 2,
                    mt: -11,
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 1,
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    '& .MuiTab-root': {
                      color: '#87CEEB',
                      flex: 1, // Hace que cada pestaña ocupe el mismo espacio
                      minWidth: '50%', // Establece el ancho mínimo al 50% del contenedor
                      '&.Mui-selected': {
                        color: 'white',
                        backgroundColor: '#5CACEE',
                        borderRadius: 2,
                      },
                      '&:hover': {
                        color: 'white',
                        backgroundColor: '#4675EF',
                      },
                    },
                    '& .MuiTabs-indicator': {
                      backgroundColor: '#5CACEE',
                    },
                  }}
                >
                  <Tab label="Datos Personales y Ubicación" />
                  <Tab label="Mascotas e Imagen" />
                </Tabs>

                <Box sx={{ height: '100%' }}>
                  {tabValue === 0 && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                      <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                        <Grid item xs={12} md={6}>
                          <Box sx={{
                            width: '48.5%', // Asegura que el contenedor llene todo el ancho
                            height: '80%',  // Cambiado de calc(100% - 16px)
                            mb: 2,
                            position: 'absolute', // Cambiado a absolute
                            top: 88, // Añade el margen superior negativo
                            left: 13,
                            right: 0,
                            bottom: 0, // Asegura que el contenedor llene todo el espacio vertical
                            borderRadius: '10px',
                            boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.3)',
                            overflow: 'hidden', // Cambiado a hidden para evitar desbordamiento
                            zIndex: 1
                          }}>
                            {/* <IconButton
                            onClick={handleFullScreen}
                            sx={{
                              position: 'absolute',
                              top: 10,
                              right: 10,
                              backgroundColor: 'rgba(255, 255, 255, 0.8)',
                              zIndex: 1000, // Asegúrate de que el botón esté por encima de otros elementos
                              '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 1)',
                              },
                            }}
                          >
                            <FullscreenIcon />
                          </IconButton> */}
                            <MapContainer
                              ref={mapRefPublic}
                              center={selectedLocationPublic || (currentPublicClient?.location ? { lat: currentPublicClient.location[0], lng: currentPublicClient.location[1] } : mapCenterPublic)}
                              zoom={15}
                              style={{
                                height: '100%',
                                width: '100%',
                                borderRadius: '10px'
                              }}
                              attributionControl={false}
                            >
                              <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                              />
                              {/* Agrega un componente de mapa que maneje el clic */}
                              <MapEventHandler onClick={handlePublicMapClick} />
                              {/* Marcador para la ubicación seleccionada */}
                              {(selectedLocationPublic || currentPublicClient?.location) && (
                                <Marker position={selectedLocationPublic || (currentPublicClient?.location ? { lat: currentPublicClient.location[0], lng: currentPublicClient.location[1] } : mapCenterPublic)} icon={new L.Icon({
                                  iconUrl: `${process.env.PUBLIC_URL}/images/puntoMapa.png`,
                                  iconSize: [29, 35],
                                  popupAnchor: [0, -35]
                                })}>
                                  {/* <Popup>
                                    <div>
                                      <strong>Ubicación seleccionada</strong>
                                      <br />
                                      <a href={googleMapsLink} target="_blank" rel="noopener noreferrer">Google Maps</a>
                                      <br />
                                      <a href={wazeLink} target="_blank" rel="noopener noreferrer">Waze</a>
                                    </div>
                                  </Popup> */}
                                </Marker>
                              )}
                            </MapContainer>
                            <Box sx={{
                              position: 'absolute',
                              top: 10,
                              left: '50%', // Centrar horizontalmente
                              transform: 'translateX(-50%)', // Ajuste para centrado perfecto
                              backgroundColor: 'rgba(255,255,255,0.8)',
                              padding: '5px 10px',
                              borderRadius: '20px',
                              fontSize: '0.8rem',
                              fontWeight: 'bold',
                              boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                              zIndex: 1000,
                              whiteSpace: 'nowrap' // Evita que el texto se rompa en múltiples líneas
                            }}>
                              Selecciona la ubicación del cliente
                            </Box>
                            <IconButton
                              onMouseEnter={() => setIsHovered(true)}
                              onMouseLeave={() => setIsHovered(false)}
                              onClick={handleUpdateLocation}
                              sx={{
                                position: 'absolute',
                                top: 270, // Aligned with the form fields
                                right: 10,
                                backgroundColor: 'orange',
                                color: 'white',
                                animation: `${rotateAnimation} 4s linear infinite`,
                                '&:hover': {
                                  backgroundColor: 'darkorange',
                                  animation: 'none',
                                },
                                '& .MuiSvgIcon-root': {
                                  fontSize: '2rem',
                                },
                                zIndex: 1000
                              }}
                            >
                              {isHovered ? <RefreshIcon /> : <UpdateIcon />}
                            </IconButton>

                            <IconButton
                              onClick={() => setIsMapDialogOpenPublic(true)}
                              sx={{
                                position: 'absolute',
                                top: 11,
                                right: 10,
                                backgroundColor: '#87CEEB',
                                color: 'white',
                                '&:hover': {
                                  backgroundColor: '#5CACEE',
                                },
                                zIndex: 1000,
                                padding: '11px', // Increased padding
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                '& svg': { // Target the icon
                                  width: '1.7rem', // Larger icon size
                                  height: '1.7rem', // Larger icon size
                                }
                              }}
                            >
                              <FullscreenIcon />
                            </IconButton>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={4}>
                              <TextField
                                autoFocus
                                margin="dense"
                                label="Nombre y Apellidos"
                                type="text"
                                fullWidth
                                error={!!currentPublicClient?.name && !validateName(currentPublicClient.name)} // Validación de nombre
                                helperText={!!currentPublicClient?.name && !validateName(currentPublicClient.name) ? 'El nombre solo debe contener letras y números, y tener un máximo de 29 caracteres.' : ''}
                                value={currentPublicClient?.name || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setCurrentPublicClient(curr => curr ? { ...curr, name: value } : null);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <TextField
                                margin="dense"
                                label="Teléfono"
                                type="tel"
                                fullWidth
                                error={!!currentPublicClient?.phoneNumber && !validatePhone(currentPublicClient.phoneNumber)} // Validación de teléfono
                                helperText={!!currentPublicClient?.phoneNumber && !validatePhone(currentPublicClient.phoneNumber) ? 'El teléfono debe ser numérico y tener hasta 13 dígitos.' : ''}
                                value={currentPublicClient?.phoneNumber || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setCurrentPublicClient(curr => curr ? { ...curr, phoneNumber: value } : null);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <TextField
                                margin="dense"
                                label="Teléfono Secundario"
                                type="tel"
                                fullWidth
                                error={!!currentPublicClient?.second_phoneNumber && !validatePhone(currentPublicClient.second_phoneNumber)} // Validación de teléfono secundario
                                helperText={!!currentPublicClient?.second_phoneNumber && !validatePhone(currentPublicClient.second_phoneNumber) ? 'El teléfono debe ser numérico y tener hasta 13 dígitos.' : ''}
                                value={currentPublicClient?.second_phoneNumber || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setCurrentPublicClient(curr => curr ? { ...curr, second_phoneNumber: value } : null);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <TextField
                                margin="dense"
                                label="Correo Electrónico"
                                type="email"
                                fullWidth
                                error={!!currentPublicClient?.email && !validateEmail(currentPublicClient.email)} // Validación de correo electrónico
                                helperText={!!currentPublicClient?.email && !validateEmail(currentPublicClient.email) ? 'Ingrese un correo electrónico válido.' : ''}
                                value={currentPublicClient?.email || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setCurrentPublicClient(curr => curr ? { ...curr, email: value } : null);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <TextField
                                margin="dense"
                                label="Cédula Nacional"
                                type="text"
                                fullWidth
                                error={!!currentPublicClient?.cedula_nacional && !validateCedula(currentPublicClient.cedula_nacional)} // Validación de cédula
                                helperText={!!currentPublicClient?.cedula_nacional && !validateCedula(currentPublicClient.cedula_nacional) ? 'La cédula debe ser numérica y tener hasta 13 dígitos.' : ''}
                                value={currentPublicClient?.cedula_nacional || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setCurrentPublicClient(curr => curr ? { ...curr, cedula_nacional: value } : null);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel
                                  sx={{ backgroundColor: 'white', padding: '0 4px' }} // Estilo agregado al InputLabel
                                >
                                  Tipo de Documento
                                </InputLabel>
                                <Select
                                  value={currentPublicClient?.tipo_documento || ''}
                                  onChange={(e) => setCurrentPublicClient(curr => curr ? { ...curr, tipo_documento: e.target.value as 'Nacional' | 'Jurídica' | 'Dimex' | 'Nite' } : null)}
                                  sx={{
                                    '& .MuiSelect-select': {
                                      border: 'none', // Eliminar el borde del select
                                    },
                                    '&:before': {
                                      border: 'none', // Eliminar la línea antes del select
                                    },
                                    '&:after': {
                                      border: 'none', // Eliminar la línea después del select
                                    },
                                  }}
                                >
                                  <MenuItem value="Nacional">Nacional</MenuItem>
                                  <MenuItem value="Jurídica">Jurídica</MenuItem>
                                  <MenuItem value="Dimex">Dimex</MenuItem>
                                  <MenuItem value="Nite">Nite</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel
                                  sx={{ backgroundColor: 'white', padding: '0 4px' }} // Estilo agregado al InputLabel
                                >
                                  Tipo de Cliente
                                </InputLabel>
                                <Select
                                  value={currentPublicClient?.tipo_client || ''}
                                  onChange={(e) => {
                                    const newTipoClient = e.target.value as 'Municipalidad' | 'Regular';
                                    setCurrentPublicClient(curr => {
                                      if (curr) {
                                        const updatedClient = { ...curr, tipo_client: newTipoClient };
                                        // Si cambia de Municipalidad a Regular, borramos la municipalidad seleccionada
                                        if (newTipoClient === 'Regular') {
                                          updatedClient.municipalidades = '';
                                        }
                                        return updatedClient;
                                      }
                                      return null;
                                    });
                                  }}
                                  sx={{
                                    '& .MuiSelect-select': {
                                      border: 'none', // Eliminar el borde del select
                                    },
                                    '&:before': {
                                      border: 'none', // Eliminar la línea antes del select
                                    },
                                    '&:after': {
                                      border: 'none', // Eliminar la línea después del select
                                    },
                                  }}
                                >
                                  <MenuItem value="Municipalidad">Municipalidad</MenuItem>
                                  <MenuItem value="Regular">Regular</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel
                                  sx={{ backgroundColor: 'white', padding: '0 4px' }} // Estilo agregado al InputLabel
                                >
                                  Tipo de Compostera
                                </InputLabel>
                                <Select
                                  value={currentPublicClient?.tipo_compostera || ''}
                                  onChange={(e) => setCurrentPublicClient(curr => curr ? { ...curr, tipo_compostera: e.target.value as 'S' | 'M' | 'L' | 'XL' | 'Recolección' } : null)}
                                  sx={{
                                    '& .MuiSelect-select': {
                                      border: 'none', // Eliminar el borde del select
                                    },
                                    '&:before': {
                                      border: 'none', // Eliminar la línea antes del select
                                    },
                                    '&:after': {
                                      border: 'none', // Eliminar la línea después del select
                                    },
                                  }}
                                >
                                  <MenuItem value="S">S</MenuItem>
                                  <MenuItem value="M">M</MenuItem>
                                  <MenuItem value="L">L</MenuItem>
                                  <MenuItem value="XL">XL</MenuItem>
                                  <MenuItem value="Recolección">Recolección</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel
                                  sx={{ backgroundColor: 'white', padding: '0 4px' }} // Estilo agregado al InputLabel
                                >
                                  Tipo Entrega
                                </InputLabel>
                                <Select
                                  value={currentPublicClient?.tipo_entrega || ''}
                                  onChange={(e) => setCurrentPublicClient(curr => curr ? { ...curr, tipo_entrega: e.target.value as 'Productos' | 'Recolección' } : null)}
                                  sx={{
                                    '& .MuiSelect-select': {
                                      border: 'none', // Eliminar el borde del select
                                    },
                                    '&:before': {
                                      border: 'none', // Eliminar la línea antes del select
                                    },
                                    '&:after': {
                                      border: 'none', // Eliminar la línea después del select
                                    },
                                  }}
                                >
                                  <MenuItem value="Productos">
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                      <ShoppingCartIcon sx={{ color: 'rgb(71, 219, 226)', mr: 1 }} />
                                      Productos
                                    </Box>
                                  </MenuItem>
                                  <MenuItem value="Recolección">
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                      <RecoleccionIcon sx={{ color: 'green', mr: 1 }} />
                                      Recolección
                                    </Box>
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel
                                  sx={{ backgroundColor: 'white', padding: '0 4px' }} // Estilo agregado al InputLabel
                                >
                                  Provincia
                                </InputLabel>
                                <Select
                                  value={currentPublicClient?.provincia || ''}
                                  onChange={(e) => handlePublicProvinceChange(e.target.value as string)}
                                  sx={{
                                    '& .MuiSelect-select': { border: 'none' },
                                    '&:before': { border: 'none' },
                                    '&:after': { border: 'none' },
                                  }}
                                >
                                  {[...costaRicaData.provinces].sort().map((province) => (
                                    <MenuItem key={province} value={province}>{province}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel
                                  sx={{ backgroundColor: 'white', padding: '0 4px' }} // Estilo agregado al InputLabel
                                >
                                  Cantón
                                </InputLabel>
                                <Select
                                  value={currentPublicClient?.canton || ''}
                                  onChange={(e) => {
                                    const selectedCanton = e.target.value as string;
                                    setCurrentPublicClient(curr => curr ? { ...curr, canton: selectedCanton, distrito: '' } : null);
                                    // Actualiza distritos según el cantón seleccionado
                                    setAvailableDistricts(costaRicaData.districts[currentPublicClient?.provincia as keyof typeof costaRicaData.districts]?.[selectedCanton as keyof typeof costaRicaData.districts[keyof typeof costaRicaData.districts]] || []);
                                  }}
                                  sx={{
                                    '& .MuiSelect-select': { border: 'none' },
                                    '&:before': { border: 'none' },
                                    '&:after': { border: 'none' },
                                  }}
                                >
                                  {[...availableCantons].sort().map((canton) => (
                                    <MenuItem key={canton} value={canton}>{canton}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <FormControl fullWidth margin="dense">
                                <InputLabel
                                  sx={{ backgroundColor: 'white', padding: '0 4px' }} // Estilo agregado al InputLabel
                                >
                                  Distrito
                                </InputLabel>
                                <Select
                                  value={currentPublicClient?.distrito || ''}
                                  onChange={(e) => setCurrentPublicClient(curr => curr ? { ...curr, distrito: e.target.value } : null)}
                                  sx={{
                                    '& .MuiSelect-select': { border: 'none' },
                                    '&:before': { border: 'none' },
                                    '&:after': { border: 'none' },
                                  }}
                                >
                                  {[...availableDistricts].sort().map((district) => (
                                    <MenuItem key={district} value={district}>{district}</MenuItem>))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                fullWidth
                                label="Enlace de Google Maps"
                                value={currentPublicClient?.googleMapsLink || ''}
                                onChange={async (e) => {
                                  const newLink = e.target.value;
                                  setCurrentPublicClient(curr => curr ? { ...curr, googleMapsLink: newLink } : null);
                                  updateLocationFromLinkPublic(newLink);
                                  const location = await getCoordinatesFromLinkPublic(newLink);
                                  if (location) {
                                    const [lat, lng] = location;
                                    setSelectedLocationPublic({ lat, lng });
                                    mapRefFullScreamPublic.current?.setView([lat, lng], 15);
                                    setIsLocationSelectedPublic(true);
                                    setLatitude(lat.toString());
                                    setLongitude(lng.toString());

                                    handlePublicMapClickURL(lat, lng);
                                  } else {
                                    console.error('No se pudieron obtener las coordenadas. Verifica el enlace:', newLink);
                                  }
                                }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={() => window.open(currentPublicClient?.googleMapsLink, '_blank')}
                                        disabled={!currentPublicClient?.googleMapsLink}
                                        edge="end"
                                        sx={{
                                          color: '#0078D4',
                                          backgroundColor: 'rgba(0, 120, 212, 0.08)',
                                          padding: '12px',
                                          transition: 'all 0.3s ease',
                                          '&:hover': {
                                            backgroundColor: 'rgba(0, 120, 212, 0.15)',
                                            transform: 'scale(1.1)',
                                            boxShadow: '0 4px 8px rgba(0, 120, 212, 0.2)'
                                          },
                                          '&.Mui-disabled': {
                                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                            color: 'rgba(0, 0, 0, 0.26)'
                                          }
                                        }}
                                      >
                                        <GoogleIcon style={{ fontSize: 32 }} />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                fullWidth
                                label="Enlace de Waze"
                                value={currentPublicClient?.wazeLink || ''}
                                onChange={async (e) => {
                                  const newLink = e.target.value;
                                  setCurrentPublicClient(curr => curr ? { ...curr, wazeLink: newLink } : null);
                                  updateLocationFromLinkPublic(newLink);
                                  const location = await getCoordinatesFromLinkPublic(newLink);
                                  if (location) {
                                    const [lat, lng] = location;
                                    setSelectedLocationPublic({ lat, lng });
                                    mapRefFullScreamPublic.current?.setView([lat, lng], 15);
                                    setIsLocationSelectedPublic(true);
                                    setLatitude(lat.toString());
                                    setLongitude(lng.toString());

                                    handlePublicMapClickURL(lat, lng);
                                  } else {
                                    console.error('No se pudieron obtener las coordenadas. Verifica el enlace:', newLink);
                                  }

                                }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={() => window.open(currentPublicClient?.wazeLink, '_blank')}
                                        disabled={!currentPublicClient?.wazeLink}
                                        edge="end"
                                        sx={{
                                          color: '#0078D4',
                                          backgroundColor: 'rgba(0, 120, 212, 0.08)',
                                          padding: '12px',
                                          transition: 'all 0.3s ease',
                                          '&:hover': {
                                            backgroundColor: 'rgba(0, 120, 212, 0.15)',
                                            transform: 'scale(1.1)',
                                            boxShadow: '0 4px 8px rgba(0, 120, 212, 0.2)'
                                          },
                                          '&.Mui-disabled': {
                                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                            color: 'rgba(0, 0, 0, 0.26)'
                                          }
                                        }}
                                      >
                                        <FaWaze style={{ fontSize: 32 }} />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                margin="dense"
                                label="Señas"
                                type="text"
                                fullWidth
                                multiline
                                rows={2}
                                error={!!currentPublicClient?.senas && !validateSenasNota(currentPublicClient.senas)} // Validación de señas
                                helperText={!!currentPublicClient?.senas && !validateSenasNota(currentPublicClient.senas) ? 'Las señas pueden tener hasta 250 caracteres.' : ''}
                                value={currentPublicClient?.senas || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setCurrentPublicClient(curr => curr ? { ...curr, senas: value } : null);
                                }}
                              />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                              <TextField
                                margin="dense"
                                label="Nota de Cliente"
                                type="text"
                                fullWidth
                                multiline
                                rows={2}
                                error={!!currentPublicClient?.nota && !validateSenasNota(currentPublicClient.nota)} // Validación de nota
                                helperText={!!currentPublicClient?.nota && !validateSenasNota(currentPublicClient.nota) ? 'La nota puede tener hasta 250 caracteres.' : ''}
                                value={currentPublicClient?.nota || ''}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setCurrentPublicClient(curr => curr ? { ...curr, nota: value } : null);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                margin="dense"
                                label="Código de Referencia"
                                type="text"
                                fullWidth
                                value={currentPublicClient?.codigo_referencia || ''}
                                onChange={(e) => setCurrentPublicClient(curr => curr ? { ...curr, codigo_referencia: e.target.value } : null)}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={showCoordinates}
                                    onChange={(e) => setShowCoordinates(e.target.checked)}
                                    sx={{
                                      color: '#87CEEB',
                                      '&.Mui-checked': {
                                        color: '#87CEEB',
                                      },
                                    }}
                                  />
                                }
                                label="Mostrar campos de coordenadas"
                              />
                            </Grid>

                            {showCoordinates && (
                              <>
                                <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
                                  {showCoordinates && (
                                    <Box sx={{
                                      display: 'flex',
                                      alignItems: 'flex-start',
                                      gap: 2,
                                    }}>
                                      <TextField
                                        margin="dense"
                                        label="Latitud"
                                        type="number"
                                        size="small"
                                        value={currentPublicClient?.location ? currentPublicClient.location[0] : latitude}
                                        onChange={(e) => setLatitude(e.target.value)}
                                        inputProps={{
                                          step: 'any',
                                          min: -90,
                                          max: 90
                                        }}
                                        error={(!!latitude || !!currentPublicClient?.location) && !isValidCoordinates()}
                                        helperText={!!latitude && !isValidCoordinates() ? 'Latitud debe estar entre -90 y 90' : ''}
                                        sx={{
                                          flex: 1,
                                          '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white'
                                          }
                                        }}
                                      />
                                      <TextField
                                        margin="dense"
                                        label="Longitud"
                                        type="number"
                                        size="small"
                                        value={currentPublicClient?.location ? currentPublicClient.location[1] : longitude}
                                        onChange={(e) => setLongitude(e.target.value)}
                                        inputProps={{
                                          step: 'any',
                                          min: -180,
                                          max: 180
                                        }}
                                        error={(!!longitude || !!currentPublicClient?.location) && !isValidCoordinates()}
                                        helperText={!!longitude && !isValidCoordinates() ? 'Longitud debe estar entre -180 y 180' : ''}
                                        sx={{
                                          flex: 1,
                                          '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white'
                                          }
                                        }}
                                      />
                                      <Button
                                        variant="contained"
                                        onClick={handleUpdateCoordinatesPublic}
                                        disabled={!latitude || !longitude || !isValidCoordinates()}
                                        sx={{
                                          height: 40,
                                          mt: 1,
                                          backgroundColor: '#87CEEB',
                                          color: 'white',
                                          '&:hover': {
                                            backgroundColor: '#5CACEE',
                                          },
                                          '&:disabled': {
                                            backgroundColor: 'rgba(135, 206, 235, 0.5)',
                                            color: 'rgba(255, 255, 255, 0.7)',
                                          },
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: 1
                                        }}
                                      >
                                        <LocationOnIcon />
                                        Actualizar Ubicación
                                      </Button>
                                    </Box>
                                  )}
                                </Grid>
                              </>
                            )}
                          </Grid>
                        </Grid>
                        <Dialog
                          open={isMapDialogOpenPublic}
                          onClose={() => setIsMapDialogOpenPublic(false)}
                          fullScreen={isMobile}
                          maxWidth={false} // Permite ancho personalizado
                          fullWidth
                          BackdropProps={{
                            sx: {
                              backgroundColor: 'rgba(0, 0, 0, 0.8)',
                            },
                          }}
                          PaperProps={{
                            sx: {
                              width: '95vw', // 95% del ancho de la ventana
                              height: '95vh', // 95% del alto de la ventana
                              maxWidth: 'none', // Elimina el ancho máximo predeterminado
                              maxHeight: 'none', // Elimina el alto máximo predeterminado
                              margin: '2.5vh auto', // Centra verticalmente
                              borderRadius: '16px', // Bordes redondeados más pronunciados
                              overflow: 'hidden', // Evita el desbordamiento
                              // Efecto de cristal y sombra
                              backdropFilter: 'blur(8px)',
                              backgroundColor: 'rgba(255, 255, 255, 0.98)',
                              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                              // Transición suave
                              transition: 'all 0.3s ease-in-out',
                              // Ajustes para el contenido interno
                              display: 'flex',
                              flexDirection: 'column',
                              '& .MuiDialogTitle-root': {
                                backgroundColor: '#87CEEB',
                                color: 'white',
                                fontWeight: 'bold',
                                padding: '20px 24px',
                              },
                              '& .MuiDialogContent-root': {
                                flex: 1,
                                overflow: 'auto',
                                padding: '24px',
                              },
                              '& .MuiDialogActions-root': {
                                padding: '16px 24px',
                                backgroundColor: 'rgba(135, 206, 235, 0.1)',
                              }
                            },
                          }}
                        >
                          <DialogTitle sx={{
                            backgroundColor: '#87CEEB',
                            color: 'white',
                            fontWeight: 'bold',
                            padding: '16px 24px', // Altura más apropiada usando padding
                            display: 'flex',
                            alignItems: 'center'
                          }}>Mapa</DialogTitle>
                          <DialogContent>
                            <MapContainer
                              ref={mapRefFullScreamPublic}
                              center={selectedLocationPublic || mapCenterPublic}
                              zoom={15}
                              style={{ height: '100%', width: '100%', borderRadius: '10px' }}
                              attributionControl={false}
                            >
                              <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                              />
                              <MapEventHandler onClick={handlePublicMapClick} />
                              {(selectedLocationPublic || (currentPublicClient?.location && currentPublicClient.location.length === 2)) && (
                                <Marker 
                                  position={selectedLocationPublic || { lat: currentPublicClient!.location![0], lng: currentPublicClient!.location![1] }}
                                  icon={new L.Icon({
                                    iconUrl: `${process.env.PUBLIC_URL}/images/puntoMapa.png`,
                                    iconSize: [29, 35],
                                    popupAnchor: [0, -35]
                                  })}
                                />
                              )}
                            </MapContainer>
                          </DialogContent>
                          <DialogActions sx={{
                            minHeight: '72px',
                            px: 3,
                            py: 2,
                            backgroundColor: 'rgba(135, 206, 235, 0.1)'
                          }}>
                            <Box sx={{
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              position: 'relative', // Para posicionamiento absoluto del botón central
                              gap: 2
                            }}>

                              <IconButton
                                onClick={() => window.open(currentPublicClient?.googleMapsLink, '_blank')}
                                disabled={!currentPublicClient?.googleMapsLink}
                                sx={{
                                  backgroundColor: 'white',
                                  color: '#0078D4',
                                  padding: '8px',
                                  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                                  '&:hover': {
                                    backgroundColor: '#f5f5f5',
                                    transform: 'scale(1.05)',
                                  },
                                  '&.Mui-disabled': {
                                    backgroundColor: '#e0e0e0',
                                    color: '#9e9e9e',
                                  }
                                }}
                              >
                                <GoogleIcon sx={{ fontSize: 24 }} />
                              </IconButton>

                              <IconButton
                                onClick={() => window.open(currentPublicClient?.wazeLink, '_blank')}
                                disabled={!currentPublicClient?.wazeLink}
                                sx={{
                                  mr: '8px', // Ajuste de margen derecho
                                  backgroundColor: 'white',
                                  color: '#33ccff',
                                  padding: '8px',
                                  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                                  '&:hover': {
                                    backgroundColor: '#f5f5f5',
                                    transform: 'scale(1.05)',
                                  },
                                  '&.Mui-disabled': {
                                    backgroundColor: '#e0e0e0',
                                    color: '#9e9e9e',
                                  }
                                }}
                              >
                                <FaWaze style={{ fontSize: 24 }} />
                              </IconButton>

                              {/* Checkbox a la izquierda */}
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={showCoordinates}
                                    onChange={(e) => setShowCoordinates(e.target.checked)}
                                    sx={{
                                      color: '#87CEEB',
                                      '&.Mui-checked': {
                                        color: '#87CEEB',
                                      },
                                    }}
                                  />
                                }
                                label="Mostrar campos de coordenadas"
                              />

                              {/* Campos de coordenadas y botón en el centro */}
                              {showCoordinates && (
                                <Box sx={{
                                  position: 'absolute',
                                  left: '50%',
                                  transform: 'translateX(-50%)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 2,
                                  zIndex: 1
                                }}>
                                  <TextField
                                    margin="dense"
                                    label="Latitud"
                                    type="number"
                                    size="small"
                                    value={currentPublicClient?.location ? currentPublicClient.location[0] : latitude}
                                    onChange={(e) => setLatitude(e.target.value)}
                                    inputProps={{
                                      step: 'any',
                                      min: -90,
                                      max: 90
                                    }}
                                    error={(!!latitude || !!currentPublicClient?.location) && !isValidCoordinates()}
                                    helperText={!!latitude && !isValidCoordinates() ? 'Latitud debe estar entre -90 y 90' : ''}
                                    sx={{
                                      width: '150px',
                                      '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'white'
                                      }
                                    }}
                                  />
                                  <TextField
                                    margin="dense"
                                    label="Longitud"
                                    type="number"
                                    size="small"
                                    value={currentPublicClient?.location ? currentPublicClient.location[1] : longitude}
                                    onChange={(e) => setLongitude(e.target.value)}
                                    inputProps={{
                                      step: 'any',
                                      min: -180,
                                      max: 180
                                    }}
                                    error={(!!longitude || !!currentPublicClient?.location) && !isValidCoordinates()}
                                    helperText={!!longitude && !isValidCoordinates() ? 'Longitud debe estar entre -180 y 180' : ''}
                                    sx={{
                                      width: '150px',
                                      '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'white'
                                      }
                                    }}
                                  />
                                  <Button
                                    variant="contained"
                                    onClick={handleUpdateCoordinatesPublic}
                                    disabled={!latitude || !longitude || !isValidCoordinates()}
                                    sx={{
                                      height: 40,
                                      backgroundColor: '#87CEEB',
                                      color: 'white',
                                      '&:hover': {
                                        backgroundColor: '#5CACEE',
                                      },
                                      '&:disabled': {
                                        backgroundColor: 'rgba(135, 206, 235, 0.5)',
                                        color: 'rgba(255, 255, 255, 0.7)',
                                      },
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 1
                                    }}
                                  >
                                    <LocationOnIcon />
                                    Actualizar Ubicación
                                  </Button>
                                </Box>
                              )}
                              <Button onClick={() => setIsMapDialogOpenPublic(false)}
                                variant="outlined"
                                sx={{
                                  color: '#87CEEB',
                                  borderColor: '#87CEEB',
                                  '&:hover': {
                                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                                    borderColor: '#5CACEE',
                                  },
                                  fontWeight: 'bold',
                                  px: 4,
                                  py: 1,
                                  marginLeft: 'auto'
                                }}>Cancelar</Button>
                            </Box>
                          </DialogActions>
                        </Dialog>
                      </Grid>
                    </Box>
                  )}

                  {tabValue === 1 && (
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'row' }}>
                      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', paddingRight: 2, mr: 2 }}> {/* Añadido margen derecho */}
                        <Grid container spacing={2} sx={{ mb: 2, flex: 1, mt: 2, ml: 2 }}> {/* Añadido margin top y left */}
                          {['cant_gato', 'cant_perro_mini', 'cant_perro_pequeno', 'cant_perro_mediano', 'cant_perro_grande', 'cant_perro_gigante'].map((field) => (
                            <Grid item xs={12} sm={6} md={4} key={field}>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                sx={{
                                  border: '1px solid #87CEEB', // Borde alrededor del Box
                                  borderRadius: 2, // Bordes redondeados
                                  transition: 'transform 0.3s ease', // Transición para el hover
                                  '&:hover': {
                                    transform: 'scale(1.02)', // Escalar ligeramente al pasar el mouse
                                  },
                                  padding: 1, // Espaciado interno
                                }}
                              >
                                <Box display="flex" flexDirection="column" alignItems="center">
                                  <Box sx={{ textAlign: 'center', mb: 1 }}> {/* Ajustar margen inferior */}
                                    <img
                                      src={`${process.env.PUBLIC_URL}/images/${field}.png`}
                                      alt={publicColumnNames[field as keyof PublicClient]}
                                      style={{
                                        width: '70px',
                                        height: '70px',
                                        transition: 'transform 0.3s ease', // Añadir transición
                                      }}
                                      className="image-hover" // Clase para la animación
                                    />
                                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{publicColumnNames[field as keyof PublicClient]?.split(' ')[0]}</Typography>
                                    <Typography variant="body2">{publicColumnNames[field as keyof PublicClient]?.split(' ')[1]}</Typography>
                                  </Box>
                                </Box>
                                <Box display="flex" flexDirection="column" alignItems="center" sx={{ ml: 1 }}> {/* Ajustar margen a la izquierda */}
                                  <Typography variant="body2" sx={{ mb: 1 }}>Cantidad:</Typography> {/* Texto pequeño arriba */}
                                  <Box display="flex" alignItems="center">
                                    <IconButton
                                      onClick={() => handleQuantityChangePublic(field, false)}
                                      sx={{ color: '#87CEEB' }}
                                    >
                                      <RemoveIcon />
                                    </IconButton>
                                    <TextField
                                      value={currentPublicClient?.[field as keyof PublicClient] || '0'}
                                      onChange={(e) => setCurrentPublicClient(curr => curr ? { ...curr, [field]: e.target.value } : null)}
                                      inputProps={{
                                        style: { textAlign: 'center' },
                                        min: 0,
                                      }}
                                      sx={{
                                        width: '50px',
                                        '& .MuiInputBase-input': {
                                          padding: '5px',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                          '& fieldset': {
                                            borderColor: 'transparent',
                                          },
                                          '&:hover fieldset': {
                                            borderColor: 'transparent',
                                          },
                                          '&.Mui-focused fieldset': {
                                            borderColor: 'transparent',
                                          },
                                        },
                                      }}
                                    />
                                    <IconButton
                                      onClick={() => handleQuantityChangePublic(field, true)}
                                      sx={{ color: '#87CEEB' }}
                                    >
                                      <AddIcon />
                                    </IconButton>
                                  </Box>
                                </Box>
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                      <Box
                        sx={{
                          width: '35%', // Ajustado el tamaño del Box
                          display: 'flex',
                          flexDirection: 'column',
                          paddingLeft: 2,
                        }}
                      >
                        <Typography variant="h6" sx={{ mb: 2 }}>Imagen del cliente</Typography>
                        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px dashed #87CEEB', borderRadius: 2, mb: 2 }}>
                          {currentPublicClient?.imageUrl ? (
                            <Box sx={{ position: 'relative', width: '100%', textAlign: 'center' }}>
                              <IconButton
                                sx={{
                                  position: 'absolute',
                                  right: 5,
                                  top: 5,
                                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                  '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                  },
                                  zIndex: 1,
                                }}
                                onClick={() => {
                                  if (currentPublicClient) {
                                    setCurrentPublicClient({
                                      ...currentPublicClient,
                                      imageUrl: ''
                                    });
                                  }
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                              <img src={currentPublicClient.imageUrl} alt="Client" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                            </Box>
                          ) : (
                            <Typography variant="body1" color="textSecondary">Vista previa de la imagen</Typography>
                          )}
                        </Box>
                        <input
                          accept="image/*"
                          style={{ display: 'none' }}
                          id="raised-button-file"
                          type="file"
                          onChange={handleImageUploadPublic}
                        />
                        <label htmlFor="raised-button-file">
                          <Button
                            variant="contained"
                            component="span"
                            startIcon={<CloudUploadIcon />}
                            fullWidth
                            sx={{
                              backgroundColor: '#87CEEB',
                              '&:hover': {
                                backgroundColor: '#5CACEE',
                              },
                            }}
                          >
                            Subir Imagen
                          </Button>
                        </label>
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
            </DialogContent>
            <DialogActions sx={{
              justifyContent: 'right',
              px: 3,
              py: 2,
              backgroundColor: 'rgba(135, 206, 235, 0.1)'
            }}>
              <Button
                onClick={handleSavePublicClient}
                variant="contained"
                disabled={!isPublicFormValid()}
                sx={{
                  backgroundColor: '#87CEEB',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#5CACEE',
                  },
                  '&:disabled': {
                    backgroundColor: 'rgba(135, 206, 235, 0.5)',
                    color: 'rgba(255, 255, 255, 0.7)',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                }}
              >
                Guardar
              </Button>
              <Button
                onClick={handleClosePublicClient}
                variant="outlined"
                sx={{
                  color: '#87CEEB',
                  borderColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                    borderColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                  mr: 2,
                }}
              >
                Cancelar
              </Button>
            </DialogActions>
          </Dialog>

          {/* View Client Dialog */}
          <Dialog
            open={viewOpenPublic}
            onClose={handleViewClosePublic}
            fullScreen={isMobile}
            maxWidth="lg"
            fullWidth
            BackdropProps={{
              sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              },
            }}
            PaperProps={{
              sx: {
                borderRadius: '8px',
                height: 'calc(100% - 64px)',
                maxHeight: 'none',
              },
            }}
          >
            <DialogTitle sx={{
              backgroundColor: '#87CEEB',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '1.5rem',
              py: 2,
            }}>
              Detalles del Cliente: {currentPublicClient?.name}
            </DialogTitle>
            <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', height: '100%', p: 0 }}>
              <Box sx={{ display: 'flex', height: '100%' }}>
                <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #e0e0e0' }}>
                  <Typography variant="h6" gutterBottom sx={{ color: '#87CEEB', fontWeight: 'bold' }}>Información Personal</Typography>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Teléfono</Typography>
                    <Typography>{currentPublicClient?.phoneNumber}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Email</Typography>
                    <Typography>{currentPublicClient?.email}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Cédula Nacional</Typography>
                    <Typography>{currentPublicClient?.cedula_nacional}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Tipo de Documento</Typography>
                    <Typography>{currentPublicClient?.tipo_documento}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Tipo de Cliente</Typography>
                    <Typography>{currentPublicClient?.tipo_client}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Tipo de Compostera</Typography>
                    <Typography>{currentPublicClient?.tipo_compostera}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="textSecondary">Tipo de Entrega</Typography>
                    {currentPublicClient?.tipo_entrega === 'Productos' ? (
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <ShoppingCartIcon sx={{ color: 'rgb(71, 219, 226)', mr: 1 }} />
                        <Typography>Productos</Typography>
                      </Box>
                    ) : (
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <RecoleccionIcon sx={{ color: 'green', mr: 1 }} />
                        <Typography>Recolección</Typography>
                      </Box>
                    )}
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Provincia</Typography>
                    <Typography>{currentPublicClient?.provincia}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Cantón</Typography>
                    <Typography>{currentPublicClient?.canton}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Distrito</Typography>
                    <Typography>{currentPublicClient?.distrito}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Municipalidad</Typography>
                    <Typography>{currentPublicClient?.municipalidades}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="textSecondary">Dirección y señas para llegar</Typography>
                    <Typography>{currentPublicClient?.senas}</Typography>
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" color="textSecondary">Nota del cliente</Typography>
                    <Typography>{currentPublicClient?.nota}</Typography>
                  </Box>
                  <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle2" color="textSecondary">Código de Referencia</Typography>
                    <Typography>{currentPublicClient?.codigo_referencia}</Typography>
                  </Box>
                </Box>
                <Box sx={{ width: '30%', p: 3, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="h6" gutterBottom sx={{ color: '#87CEEB', fontWeight: 'bold' }}>Imagen del cliente</Typography>
                  <Box sx={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '2px dashed #87CEEB',
                    borderRadius: 2,
                    mb: 2
                  }}>
                    {currentPublicClient?.imageUrl ? (
                      <img src={currentPublicClient.imageUrl} alt="Client" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                    ) : (
                      <Typography variant="body1" color="textSecondary">No hay imagen disponible</Typography>
                    )}
                  </Box>
                  <Typography variant="h6" gutterBottom sx={{ color: '#87CEEB', fontWeight: 'bold' }}>Mascotas</Typography>
                  <Grid container spacing={1}>
                    {['cant_gato', 'cant_perro_mini', 'cant_perro_pequeno', 'cant_perro_mediano', 'cant_perro_grande', 'cant_perro_gigante'].map((field) => (
                      <Grid item xs={6} key={field}>
                        <Box display="flex" alignItems="center">
                          <img
                            src={`${process.env.PUBLIC_URL}/images/${field}.png`}
                            alt={publicColumnNames[field as keyof PublicClient]}
                            style={{ width: '40px', height: '40px', marginRight: '8px' }}
                          />
<Typography variant="body2"><>{publicColumnNames[field as keyof PublicClient]}: {currentPublicClient?.[field as keyof PublicClient]}</></Typography>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'right', px: 3, py: 2, backgroundColor: 'rgba(135, 206, 235, 0.1)' }}>
              <Button
                onClick={handleViewClosePublic}
                variant="outlined"
                sx={{
                  color: '#87CEEB',
                  borderColor: '#87CEEB',
                  '&:hover': {
                    backgroundColor: 'rgba(135, 206, 235, 0.1)',
                    borderColor: '#5CACEE',
                  },
                  fontWeight: 'bold',
                  px: 4,
                  py: 1,
                }}
              >
                Cerrar
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openNewLocationDialog}
            onClose={() => setOpenNewLocationDialog(false)}
            PaperProps={{
              sx: {
                width: '293px',
                borderRadius: '11px',
              },
            }}
          >
            <DialogTitle sx={{ fontWeight: 'bold', textAlign: 'center', marginTop: '18px' }}>
              <img src={`${process.env.PUBLIC_URL}/images/iconoMoradoMapa.png`} alt="Icono Morado Mapa" style={{ width: '36px', height: '46px', marginRight: '8px', justifySelf: 'center', marginBottom: '6px' }} />
              <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1.2rem', color: '#333' }}>
                ¿Querés confirmar<br />
                tu nueva ubicación?
              </Typography>
            </DialogTitle>
            <DialogContent>
              <Box sx={{ display: 'flex', alignItems: 'center', padding: 2, justifyContent: 'center' }}>
                <DialogContentText sx={{
                  margin: 0,
                  color: 'black',
                  fontWeight: '500',
                  fontSize: '0.875rem',
                  textAlign: 'center',
                }}>
                  Asegurate de que tu nueva locación<br />
                  seleccionada sea la correcta.
                </DialogContentText>
              </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', marginBottom: '8px' }}>
              <Button onClick={() => setOpenNewLocationDialog(false)} sx={{
                color: '#6C7A8B',
                borderColor: 'white',
                backgroundColor: 'white',
                fontWeight: 'bold',
                px: 4,
                py: 1,
                borderRadius: '25px',
                textTransform: 'none'
              }}>
                Cancelar
              </Button>
              <Button onClick={confirmLocationUpdatePrincipal} sx={{
                backgroundColor: '#87CEEB',
                fontWeight: 'bold',
                color: '#6C7A8B',
                px: 4,
                py: 1,
                borderRadius: '25px',
                textTransform: 'none'
              }}>
                Confirmar
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {newTabValue === 2 && (
        <Box sx={{ p: 3 }}>
          <CustomerTracking
            isMinimized={isMinimized}
            clients={clients}
            publicClients={publicClients}
            handlePublicOpen={handlePublicOpen}
            handleViewOpenPublic={handleViewOpenPublic}
            onUpdatePublicClient={onUpdatePublicClient}
            onDeletePublicClient={onDeletePublicClient}
            onUpdateClient={onUpdate}
            openPublic={openPublic}
            setOpenPublic={setOpenPublic}
            viewOpenPublic={viewOpenPublic}
            setViewOpenPublic={setViewOpenPublic}
            currentPublicClient={currentPublicClient}
            setCurrentPublicClient={setCurrentPublicClient}
            setSelectedPublicClientForWaitlist={setSelectedPublicClientForWaitlist}
            setMainNotification={setNotification}
            currentClient={currentClient}
            setCurrentClient={setCurrentClient}
            open={open}
            setOpen={setOpen}
            viewOpen={viewOpen}
            setViewOpen={setViewOpen}
            newTabValue={newTabValue}
            setNewTabValue={setNewTabValue}
            setTableSearchTerm={setTableSearchTerm}
            workflowStartDate={workflowStartDate}
            setWorkflowStartDate={setWorkflowStartDate}
            workflowEndDate={workflowEndDate}
            setWorkflowEndDate={setWorkflowEndDate}
            workflowSearchTerm={workflowSearchTerm}
            setWorkflowSearchTerm={setWorkflowSearchTerm}
            filterProvincia={filterProvincia}
            setFilterProvincia={setFilterProvincia}
            filterCanton={filterCanton}
            setFilterCanton={setFilterCanton}
            filterDistrito={filterDistrito}
            setFilterDistrito={setFilterDistrito}
            handleOpen={handleOpen}
          />
        </Box>
      )}


      <Dialog
        open={openLocationIcon}
        onClose={() => setOpenLocationIcon(false)}
        PaperProps={{
          sx: {
            width: '293px',
            borderRadius: '11px',
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 'bold', textAlign: 'center', marginTop: '18px' }}>
          <img src={`${process.env.PUBLIC_URL}/images/iconoMoradoMapa.png`} alt="Icono Morado Mapa" style={{ width: '36px', height: '46px', marginRight: '8px', justifySelf: 'center', marginBottom: '6px' }} />
          <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1.2rem', color: '#333' }}>
            ¿Querés actualizar<br />
            tu ubicación?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', alignItems: 'center', padding: 2, justifyContent: 'center' }}> {/* Contenedor con padding y centrado */}
            <DialogContentText sx={{
              margin: 0,
              color: 'black', // Color de texto más oscuro para mejor contraste
              fontWeight: '500', // Peso de fuente más ligero
              fontSize: '0.875rem', // Tamaño de fuente más pequeño
              textAlign: 'center', // Centrar el texto
            }}>
              Asegurate de que tu locación<br />
              seleccionada sea la correcta.
            </DialogContentText>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', marginBottom: '8px' }}>
          <Button onClick={() => setOpenLocationIcon(false)} sx={{
            color: '#6C7A8B',
            borderColor: 'white',
            backgroundColor: 'white',
            fontWeight: 'bold',
            px: 4,
            py: 1,
            borderRadius: '25px',
            textTransform: 'none'
          }}>
            Cancelar
          </Button>
          <Button onClick={confirmLocationUpdate} sx={{
            backgroundColor: '#87CEEB',
            fontWeight: 'bold',
            color: '#6C7A8B',
            px: 4,
            py: 1,
            borderRadius: '25px',
            textTransform: 'none'
          }}>
            Actualizar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openLocationIconPublic}
        onClose={() => setOpenLocationIconPublic(false)}
        PaperProps={{
          sx: {
            width: '293px',
            borderRadius: '11px',
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 'bold', textAlign: 'center', marginTop: '18px' }}>
          <img src={`${process.env.PUBLIC_URL}/images/iconoMoradoMapa.png`} alt="Icono Morado Mapa" style={{ width: '36px', height: '46px', marginRight: '8px', justifySelf: 'center', marginBottom: '6px' }} />
          <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1.2rem', color: '#333' }}>
            ¿Querés actualizar<br />
            tu ubicación?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', alignItems: 'center', padding: 2, justifyContent: 'center' }}> {/* Contenedor con padding y centrado */}
            <DialogContentText sx={{
              margin: 0,
              color: 'black', // Color de texto más oscuro para mejor contraste
              fontWeight: '500', // Peso de fuente más ligero
              fontSize: '0.875rem', // Tamaño de fuente más pequeño
              textAlign: 'center', // Centrar el texto
            }}>
              Asegurate de que tu locación<br />
              seleccionada sea la correcta.
            </DialogContentText>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', marginBottom: '8px' }}>
          <Button onClick={() => setOpenLocationIconPublic(false)} sx={{
            color: '#6C7A8B',
            borderColor: 'white',
            backgroundColor: 'white',
            fontWeight: 'bold',
            px: 4,
            py: 1,
            borderRadius: '25px',
            textTransform: 'none'
          }}>
            Cancelar
          </Button>
          <Button onClick={confirmLocationUpdatePublic} sx={{
            backgroundColor: '#87CEEB',
            fontWeight: 'bold',
            color: '#6C7A8B',
            px: 4,
            py: 1,
            borderRadius: '25px',
            textTransform: 'none'
          }}>
            Actualizar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openUpdateCSV}
        onClose={() => setOpenUpdateCSV(false)}
        PaperProps={{
          sx: {
            width: '450px', // Un poco más ancho para mejor presentación
            borderRadius: '16px',
            overflow: 'hidden'
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 'bold',
            textAlign: 'center',
            backgroundColor: '#87CEEB',
            color: 'white',
            pt: 3,
            pb: 3
          }}
        >
          <Box sx={{ mb: 2 }}>
            <TableChartIcon sx={{ fontSize: 48, mb: 1 }} />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1.3rem' }}>
            Importar Clientes desde Archivo
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: 4 }}>
          <Box
            sx={{
              mt: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: 3,
              border: '2px dashed #87CEEB',
              borderRadius: '12px',
              backgroundColor: 'rgba(135, 206, 235, 0.05)',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: 'rgba(135, 206, 235, 0.1)',
                borderColor: '#5CACEE',
                transform: 'translateY(-2px)'
              },
            }}
            component="label"
            onDragOver={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onDrop={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const file = e.dataTransfer.files[0];
              if (file?.type === "text/csv") {
                setCsvFile(file);
              }
            }}
          >
            <input
              type="file"
              accept=".csv,.xlsx,.xls"
              hidden
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) {
                  setCsvFile(file);
                }
              }}
            />
            <CloudUploadIcon
              sx={{
                fontSize: 56,
                color: '#87CEEB',
                mb: 2,
                transition: 'transform 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.1)'
                }
              }}
            />
            <Typography variant="h6" sx={{ fontWeight: '500', color: '#333', mb: 1 }}>
              {csvFile ? csvFile.name : 'Arrastra tu archivo CSV o Excel aquí'}
            </Typography>
            <Typography variant="body2" sx={{ color: '#666' }}>
              o haz clic para seleccionar
            </Typography>
          </Box>
          {csvFile && (
            <Box sx={{ mt: 3, textAlign: 'center' }}>
              <Chip
                icon={<CheckCircleIcon sx={{ color: '#4caf50' }} />}
                label={`Archivo seleccionado: ${csvFile.name}`}
                sx={{
                  backgroundColor: 'rgba(76, 175, 80, 0.1)',
                  color: '#4caf50',
                  fontWeight: '500',
                  py: 1
                }}
              />
            </Box>
          )}
          <Typography
            variant="body2"
            sx={{
              mt: 3,
              color: '#666',
              textAlign: 'center',
              backgroundColor: 'rgba(135, 206, 235, 0.1)',
              p: 2,
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1
            }}
          >
            Asegúrate de que tu archivo CSV o Excel contenga las columnas necesarias
            <Tooltip
              title={
                <Box sx={{ p: 1 }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
                    Formato de columnas requerido:
                  </Typography>
                  <Typography variant="body2" component="div">
                    <ul style={{ margin: '10px 0 0 0', paddingLeft: 20 }}>
                      <li><b>Consecutivo Mensual (No requerido)</b></li>
                      <li><b>Nombre:</b> Nombre del cliente</li>
                      <li><b>Apellidos:</b> Apellidos del cliente (opcional)</li>
                      <li><b>tipo de documento:</b> Nacional, Jurídica, Dimex o Nite (opcional)</li>
                      <li><b>Cédula:</b> Número de cédula (opcional)</li>
                      <li><b>Correo Electrónico:</b> Email del cliente (opcional)</li>
                      <li><b>Teléfono:</b> Número de teléfono</li>
                      <li><b>Teléfono Secundario:</b> Número de teléfono secundario (opcional)</li>
                      <li><b>tipo de cliente:</b> Regular o Municipalidad</li>
                      <li><b>Provincia:</b> Provincia</li>
                      <li><b>Cantón:</b> Cantón</li>
                      <li><b>Distrito:</b> Distrito</li>
                      <li><b>Dirección exacta:</b> Dirección detallada</li>
                      <li><b>notas:</b> Notas adicionales (opcional)</li>
                      <li><b>Mascotas (No requerido)</b></li>
                      <li><b>Latitud:</b> Latitud (opcional)</li>
                      <li><b>Longitud:</b> Longitud (opcional)</li>
                    </ul>
                  </Typography>
                </Box>
              }
              arrow
              placement="top"
            >
              <HelpOutlineIcon
                sx={{
                  color: '#87CEEB',
                  cursor: 'help',
                  '&:hover': {
                    color: '#5CACEE'
                  }
                }}
              />
            </Tooltip>
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: 'center',
            p: 3,
            backgroundColor: 'rgba(135, 206, 235, 0.05)'
          }}
        >
          <Button
            onClick={() => setOpenUpdateCSV(false)}
            sx={{
              color: '#6C7A8B',
              borderColor: '#6C7A8B',
              backgroundColor: 'white',
              fontWeight: 'bold',
              px: 4,
              py: 1,
              borderRadius: '25px',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: 'rgba(108, 122, 139, 0.1)'
              }
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSaveCSVPublicClient}
            disabled={!csvFile}
            startIcon={<SaveAltIcon />}
            sx={{
              backgroundColor: '#87CEEB',
              fontWeight: 'bold',
              color: 'white',
              px: 4,
              py: 1,
              borderRadius: '25px',
              textTransform: 'none',
              ml: 2,
              '&:hover': {
                backgroundColor: '#5CACEE'
              },
              '&:disabled': {
                backgroundColor: 'rgba(135, 206, 235, 0.5)',
                color: 'rgba(255, 255, 255, 0.7)'
              }
            }}
          >
            Importar Clientes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Success Snackbar */}
      <Snackbar open={!!successMessage} autoHideDuration={6000} onClose={() => setSuccessMessage(null)}>
        <Alert onClose={() => setSuccessMessage(null)} severity="success" sx={{ width: '100%', backgroundColor: 'green', color: 'white' }}>
          {successMessage}
        </Alert>
      </Snackbar>

      {/* General Notification Snackbar */}
      <Snackbar 
        open={notification.open} 
        autoHideDuration={4000} 
        onClose={() => setNotification({ ...notification, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setNotification({ ...notification, open: false })} 
          severity={notification.type}
          sx={{ width: '100%' }}
        >
          {notification.message}
        </Alert>
      </Snackbar>

      {/* Error Snackbar */}
      <Snackbar
        open={showErrorNotification}
        autoHideDuration={3000}
        onClose={() => setShowErrorNotification(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setShowErrorNotification(false)}
          severity="error"
          sx={{ width: '100%' }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>

      {showNotification && (
        <>
          <DarkOverlay />
          <NotificationPopup>
            <AnimatedEmoji style={{ animationDelay: '0s' }}>✨</AnimatedEmoji>
            <Typography
              sx={{
                color: '#1a1a1a',
                fontWeight: 600,
                fontSize: '1.5rem',
                letterSpacing: '-0.02em',
              }}
            >
              Actualizando
            </Typography>
            <AnimatedEmoji style={{ animationDelay: '0.2s' }}>🎉</AnimatedEmoji>
          </NotificationPopup>
        </>
      )}

      {showNotificationInputReq && (
        <>
         <ErrorNotificationPopup>
            <AnimatedEmoji style={{ animationDelay: '0s' }}>⚠️</AnimatedEmoji>
            <Typography
              sx={{
                color: '#1a1a1a',
                fontWeight: 600,
                fontSize: '1.5rem',
                letterSpacing: '-0.02em',
                textAlign: 'center'
              }}
            >
              Error al guardar cliente
            </Typography>
            <Typography
              sx={{
                color: '#666',
                textAlign: 'center'
              }}
            >
              {errorMessage}
            </Typography>
            <AnimatedEmoji style={{ animationDelay: '0.2s' }}>❌</AnimatedEmoji>
          </ErrorNotificationPopup>
        </>
      )}

      {showErrorNotification && (
        <>
          <ErrorNotificationPopup>
            <AnimatedEmoji style={{ animationDelay: '0s' }}>⚠️</AnimatedEmoji>
            <Typography
              sx={{
                color: '#1a1a1a',
                fontWeight: 600,
                fontSize: '1.5rem',
                letterSpacing: '-0.02em',
                textAlign: 'center'
              }}
            >
              Error al guardar cliente
            </Typography>
            <Typography
              sx={{
                color: '#666',
                textAlign: 'center'
              }}
            >
              Ya existe un cliente registrado con esta cédula nacional.
              Por favor verifique el número e intente nuevamente.
            </Typography>
            <AnimatedEmoji style={{ animationDelay: '0.2s' }}>❌</AnimatedEmoji>
          </ErrorNotificationPopup>
        </>
      )}

      {/* View Client Dialog - Global */}
      <Dialog
        open={viewOpenPublic}
        onClose={handleViewClosePublic}
        fullScreen={isMobile}
        maxWidth="lg"
        fullWidth
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
          },
        }}
        PaperProps={{
          sx: {
            borderRadius: '8px',
            height: 'calc(100% - 64px)',
            maxHeight: 'none',
          },
        }}
      >
        <DialogTitle sx={{
          backgroundColor: '#87CEEB',
          color: 'white',
          fontWeight: 'bold',
          padding: '16px 24px',
          display: 'flex',
          alignItems: 'center'
        }}>
          Detalles del Cliente
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', height: '100%' }}>
            <Box sx={{ width: '70%', p: 3, overflowY: 'auto' }}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">Nombre y Apellidos</Typography>
                <Typography>{currentPublicClient?.name}</Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">Teléfono</Typography>
                <Typography>{currentPublicClient?.phoneNumber}</Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">Teléfono Secundario</Typography>
                <Typography>{currentPublicClient?.second_phoneNumber}</Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">Correo Electrónico</Typography>
                <Typography>{currentPublicClient?.email}</Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">Cédula Nacional</Typography>
                <Typography>{currentPublicClient?.cedula_nacional}</Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">Tipo de Documento</Typography>
                <Typography>{currentPublicClient?.tipo_documento}</Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">Tipo de Cliente</Typography>
                <Typography>{currentPublicClient?.tipo_client}</Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">Tipo de Compostera</Typography>
                <Typography>{currentPublicClient?.tipo_compostera}</Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">Tipo Entrega</Typography>
                <Typography>{currentPublicClient?.tipo_entrega}</Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">Provincia</Typography>
                <Typography>{currentPublicClient?.provincia}</Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">Cantón</Typography>
                <Typography>{currentPublicClient?.canton}</Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">Distrito</Typography>
                <Typography>{currentPublicClient?.distrito}</Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">Municipalidad</Typography>
                <Typography>{currentPublicClient?.municipalidades}</Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" color="textSecondary">Dirección y señas para llegar</Typography>
                <Typography>{currentPublicClient?.senas}</Typography>
              </Box>
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" color="textSecondary">Nota del cliente</Typography>
                <Typography>{currentPublicClient?.nota}</Typography>
              </Box>
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" color="textSecondary">Código de Referencia</Typography>
                <Typography>{currentPublicClient?.codigo_referencia}</Typography>
              </Box>
            </Box>
            <Box sx={{ width: '30%', p: 3, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h6" gutterBottom sx={{ color: '#87CEEB', fontWeight: 'bold' }}>Imagen del cliente</Typography>
              <Box sx={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '2px dashed #87CEEB',
                borderRadius: 2,
                mb: 2
              }}>
                {currentPublicClient?.imageUrl ? (
                  <img src={currentPublicClient.imageUrl} alt="Client" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                ) : (
                  <Typography variant="body1" color="textSecondary">No hay imagen disponible</Typography>
                )}
              </Box>
              <Typography variant="h6" gutterBottom sx={{ color: '#87CEEB', fontWeight: 'bold' }}>Mascotas</Typography>
              <Grid container spacing={1}>
                {['cant_gato', 'cant_perro_mini', 'cant_perro_pequeno', 'cant_perro_mediano', 'cant_perro_grande', 'cant_perro_gigante'].map((field) => (
                  <Grid item xs={6} key={field}>
                    <Box display="flex" alignItems="center">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/${field}.png`}
                        alt={publicColumnNames[field as keyof PublicClient]}
                        style={{ width: '40px', height: '40px', marginRight: '8px' }}
                      />
                      <Typography variant="body2">{React.createElement(React.Fragment, null, publicColumnNames[field as keyof PublicClient], ": ", (currentPublicClient?.[field as keyof PublicClient] as any)?.toDate ? (currentPublicClient?.[field as keyof PublicClient] as any).toDate().toLocaleString() : String(currentPublicClient?.[field as keyof PublicClient] ?? ''))}</Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'right', px: 3, py: 2, backgroundColor: 'rgba(135, 206, 235, 0.1)' }}>
          <Button
            onClick={handleViewClosePublic}
            variant="outlined"
            sx={{
              color: '#87CEEB',
              borderColor: '#87CEEB',
              '&:hover': {
                backgroundColor: 'rgba(135, 206, 235, 0.1)',
                borderColor: '#5CACEE',
              },
              fontWeight: 'bold',
              px: 4,
              py: 1,
            }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Client Dialog - Global */}
      <Dialog
        open={openPublic}
        onClose={handleClosePublicClient}
        fullScreen={isMobile}
        maxWidth={false}
        fullWidth
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
          },
        }}
        PaperProps={{
          sx: {
            width: '95vw',
            height: '95vh',
            maxWidth: 'none',
            maxHeight: 'none',
            margin: '2.5vh auto',
            borderRadius: '16px',
            overflow: 'hidden',
            backdropFilter: 'blur(8px)',
            backgroundColor: 'rgba(255, 255, 255, 0.98)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
            transition: 'all 0.3s ease-in-out',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <DialogTitle sx={{
          backgroundColor: '#87CEEB',
          color: 'white',
          fontWeight: 'bold',
          padding: '16px 24px',
          display: 'flex',
          alignItems: 'center'
        }}>
          {currentPublicClient?.id ? 'Editar Cliente Público' : 'Agregar Nuevo Cliente Público'}
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Tabs
              value={tabValue}
              onChange={(event, newValue) => setTabValue(newValue)}
              aria-label="client tabs"
              sx={{
                width: '33%',
                mb: 2,
                mt: -11,
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 1,
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                '& .MuiTab-root': {
                  color: '#87CEEB',
                  flex: 1,
                  minWidth: '50%',
                  '&.Mui-selected': {
                    color: 'white',
                    backgroundColor: '#5CACEE',
                    borderRadius: 2,
                  },
                  '&:hover': {
                    color: 'white',
                    backgroundColor: '#4675EF',
                  },
                  '& .MuiTabs-indicator': {
                    backgroundColor: '#5CACEE',
                  },
                },
              }}
            >
              <Tab label="Datos Personales y Ubicación" />
              <Tab label="Mascotas e Imagen" />
            </Tabs>

            <Box sx={{ height: '100%' }}>
              {tabValue === 0 && (
                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                    <Grid item xs={12} md={6}>
                      <Box sx={{
                        width: '48.5%',
                        height: '80%',
                        mb: 2,
                        position: 'absolute',
                        top: 88,
                        left: 13,
                        right: 0,
                        bottom: 0,
                        borderRadius: '10px',
                        boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.3)',
                        overflow: 'hidden',
                        zIndex: 1
                      }}>
                        <MapContainer
                          ref={mapRefPublic}
                          center={selectedLocationPublic || (currentPublicClient?.location ? { lat: currentPublicClient.location[0], lng: currentPublicClient.location[1] } : mapCenterPublic)}
                          zoom={15}
                          style={{
                            height: '100%',
                            width: '100%',
                            borderRadius: '10px'
                          }}
                          attributionControl={false}
                        >
                          <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                          />
                          <MapEventHandler onClick={handlePublicMapClick} />
                          {(selectedLocationPublic || currentPublicClient?.location) && (
                            <Marker position={selectedLocationPublic || (currentPublicClient?.location ? { lat: currentPublicClient.location[0], lng: currentPublicClient.location[1] } : mapCenterPublic)} icon={new L.Icon({
                              iconUrl: `${process.env.PUBLIC_URL}/images/puntoMapa.png`,
                              iconSize: [29, 35],
                              popupAnchor: [0, -35]
                            })} />
                          )}
                        </MapContainer>
                        <Box sx={{
                          position: 'absolute',
                          top: 10,
                          left: '50%',
                          transform: 'translateX(-50%)',
                          backgroundColor: 'rgba(255,255,255,0.8)',
                          padding: '5px 10px',
                          borderRadius: '20px',
                          fontSize: '0.8rem',
                          fontWeight: 'bold',
                          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                          zIndex: 1000,
                          whiteSpace: 'nowrap'
                        }}>
                          Selecciona la ubicación del cliente
                        </Box>
                        <IconButton
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                          onClick={handleUpdateLocation}
                          sx={{
                            position: 'absolute',
                            top: 270,
                            right: 10,
                            backgroundColor: 'orange',
                            color: 'white',
                            animation: `${rotateAnimation} 4s linear infinite`,
                            '&:hover': {
                              backgroundColor: 'darkorange',
                              animation: 'none',
                            },
                            '& .MuiSvgIcon-root': {
                              fontSize: '2rem',
                            },
                            zIndex: 1000
                          }}
                        >
                          {isHovered ? <RefreshIcon /> : <UpdateIcon />}
                        </IconButton>

                        <IconButton
                          onClick={() => setIsMapDialogOpenPublic(true)}
                          sx={{
                            position: 'absolute',
                            top: 11,
                            right: 10,
                            backgroundColor: '#87CEEB',
                            color: 'white',
                            '&:hover': {
                              backgroundColor: '#5CACEE',
                            },
                            zIndex: 1000,
                            padding: '11px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                            '& svg': {
                              width: '1.7rem',
                              height: '1.7rem',
                            }
                          }}
                        >
                          <FullscreenIcon />
                        </IconButton>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Grid container spacing={2} sx={{ mt: 2, ml: 2 }}>
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            autoFocus
                            margin="dense"
                            label="Nombre y Apellidos"
                            type="text"
                            fullWidth
                            error={!!currentPublicClient?.name && !validateName(currentPublicClient.name)}
                            helperText={!!currentPublicClient?.name && !validateName(currentPublicClient.name) ? 'El nombre solo debe contener letras y números, y tener un máximo de 29 caracteres.' : ''}
                            value={currentPublicClient?.name || ''}
                            onChange={(e) => {
                              const value = e.target.value;
                              setCurrentPublicClient(curr => curr ? { ...curr, name: value } : null);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            margin="dense"
                            label="Teléfono"
                            type="tel"
                            fullWidth
                            error={!!currentPublicClient?.phoneNumber && !validatePhone(currentPublicClient.phoneNumber)}
                            helperText={!!currentPublicClient?.phoneNumber && !validatePhone(currentPublicClient.phoneNumber) ? 'El teléfono debe ser numérico y tener hasta 13 dígitos.' : ''}
                            value={currentPublicClient?.phoneNumber || ''}
                            onChange={(e) => {
                              const value = e.target.value;
                              setCurrentPublicClient(curr => curr ? { ...curr, phoneNumber: value } : null);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            margin="dense"
                            label="Teléfono Secundario"
                            type="tel"
                            fullWidth
                            error={!!currentPublicClient?.second_phoneNumber && !validatePhone(currentPublicClient.second_phoneNumber)}
                            helperText={!!currentPublicClient?.second_phoneNumber && !validatePhone(currentPublicClient.second_phoneNumber) ? 'El teléfono debe ser numérico y tener hasta 13 dígitos.' : ''}
                            value={currentPublicClient?.second_phoneNumber || ''}
                            onChange={(e) => {
                              const value = e.target.value;
                              setCurrentPublicClient(curr => curr ? { ...curr, second_phoneNumber: value } : null);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            margin="dense"
                            label="Correo Electrónico"
                            type="email"
                            fullWidth
                            error={!!currentPublicClient?.email && !validateEmail(currentPublicClient.email)}
                            helperText={!!currentPublicClient?.email && !validateEmail(currentPublicClient.email) ? 'Ingrese un correo electrónico válido.' : ''}
                            value={currentPublicClient?.email || ''}
                            onChange={(e) => {
                              const value = e.target.value;
                              setCurrentPublicClient(curr => curr ? { ...curr, email: value } : null);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            margin="dense"
                            label="Cédula Nacional"
                            type="text"
                            fullWidth
                            error={!!currentPublicClient?.cedula_nacional && !validateCedula(currentPublicClient.cedula_nacional)}
                            helperText={!!currentPublicClient?.cedula_nacional && !validateCedula(currentPublicClient.cedula_nacional) ? 'La cédula debe ser numérica y tener hasta 13 dígitos.' : ''}
                            value={currentPublicClient?.cedula_nacional || ''}
                            onChange={(e) => {
                              const value = e.target.value;
                              setCurrentPublicClient(curr => curr ? { ...curr, cedula_nacional: value } : null);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <FormControl fullWidth margin="dense">
                            <InputLabel sx={{ backgroundColor: 'white', padding: '0 4px' }}>
                              Tipo de Documento
                            </InputLabel>
                            <Select
                              value={currentPublicClient?.tipo_documento || ''}
                              onChange={(e) => setCurrentPublicClient(curr => curr ? { ...curr, tipo_documento: e.target.value as 'Nacional' | 'Jurídica' | 'Dimex' | 'Nite' } : null)}
                              sx={{
                                '& .MuiSelect-select': { border: 'none' },
                                '&:before': { border: 'none' },
                                '&:after': { border: 'none' },
                              }}
                            >
                              <MenuItem value="Nacional">Nacional</MenuItem>
                              <MenuItem value="Jurídica">Jurídica</MenuItem>
                              <MenuItem value="Dimex">Dimex</MenuItem>
                              <MenuItem value="Nite">Nite</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <FormControl fullWidth margin="dense">
                            <InputLabel sx={{ backgroundColor: 'white', padding: '0 4px' }}>
                              Tipo de Cliente
                            </InputLabel>
                            <Select
                              value={currentPublicClient?.tipo_client || ''}
                              onChange={(e) => {
                                const newTipoClient = e.target.value as 'Municipalidad' | 'Regular';
                                setCurrentPublicClient(curr => {
                                  if (curr) {
                                    const updatedClient = { ...curr, tipo_client: newTipoClient };
                                    if (newTipoClient === 'Regular') {
                                      updatedClient.municipalidades = '';
                                    }
                                    return updatedClient;
                                  }
                                  return null;
                                });
                              }}
                              sx={{
                                '& .MuiSelect-select': { border: 'none' },
                                '&:before': { border: 'none' },
                                '&:after': { border: 'none' },
                              }}
                            >
                              <MenuItem value="Municipalidad">Municipalidad</MenuItem>
                              <MenuItem value="Regular">Regular</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <FormControl fullWidth margin="dense">
                            <InputLabel sx={{ backgroundColor: 'white', padding: '0 4px' }}>
                              Tipo de Compostera
                            </InputLabel>
                            <Select
                              value={currentPublicClient?.tipo_compostera || ''}
                              onChange={(e) => setCurrentPublicClient(curr => curr ? { ...curr, tipo_compostera: e.target.value as 'S' | 'M' | 'L' | 'XL' | 'Recolección' } : null)}
                              sx={{
                                '& .MuiSelect-select': { border: 'none' },
                                '&:before': { border: 'none' },
                                '&:after': { border: 'none' },
                              }}
                            >
                              <MenuItem value="S">S</MenuItem>
                              <MenuItem value="M">M</MenuItem>
                              <MenuItem value="L">L</MenuItem>
                              <MenuItem value="XL">XL</MenuItem>
                              <MenuItem value="Recolección">Recolección</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <FormControl fullWidth margin="dense">
                            <InputLabel sx={{ backgroundColor: 'white', padding: '0 4px' }}>
                              Tipo Entrega
                            </InputLabel>
                            <Select
                              value={currentPublicClient?.tipo_entrega || ''}
                              onChange={(e) => setCurrentPublicClient(curr => curr ? { ...curr, tipo_entrega: e.target.value as 'Productos' | 'Recolección' } : null)}
                              sx={{
                                '& .MuiSelect-select': {
                                  border: 'none',
                                },
                                '&:before': {
                                  border: 'none',
                                },
                                '&:after': {
                                  border: 'none',
                                },
                              }}
                            >
                              <MenuItem value="Productos">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  <ShoppingCartIcon sx={{ color: 'rgb(71, 219, 226)', mr: 1 }} />
                                  Productos
                                </Box>
                              </MenuItem>
                              <MenuItem value="Recolección">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  <RecoleccionIcon sx={{ color: 'green', mr: 1 }} />
                                  Recolección
                                </Box>
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                            <InputLabel sx={{ backgroundColor: 'white', padding: '0 4px' }}>
                              Provincia
                            </InputLabel>
                            <Select
                              value={currentPublicClient?.provincia || ''}
                              onChange={(e) => handlePublicProvinceChange(e.target.value as string)}
                              sx={{
                                '& .MuiSelect-select': { border: 'none' },
                                '&:before': { border: 'none' },
                                '&:after': { border: 'none' },
                              }}
                            >
                              {[...costaRicaData.provinces].sort().map((province) => (
                                <MenuItem key={province} value={province}>{province}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                            <InputLabel sx={{ backgroundColor: 'white', padding: '0 4px' }}>
                              Cantón
                            </InputLabel>
                            <Select
                              value={currentPublicClient?.canton || ''}
                              onChange={(e) => {
                                const selectedCanton = e.target.value as string;
                                setCurrentPublicClient(curr => curr ? { ...curr, canton: selectedCanton, distrito: '' } : null);
                                setAvailableDistricts(costaRicaData.districts[currentPublicClient?.provincia as keyof typeof costaRicaData.districts]?.[selectedCanton as keyof typeof costaRicaData.districts[keyof typeof costaRicaData.districts]] || []);
                              }}
                              sx={{
                                '& .MuiSelect-select': { border: 'none' },
                                '&:before': { border: 'none' },
                                '&:after': { border: 'none' },
                              }}
                            >
                              {[...availableCantons].sort().map((canton) => (
                                <MenuItem key={canton} value={canton}>{canton}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
                            <InputLabel sx={{ backgroundColor: 'white', padding: '0 4px' }}>
                              Distrito
                            </InputLabel>
                            <Select
                              value={currentPublicClient?.distrito || ''}
                              onChange={(e) => setCurrentPublicClient(curr => curr ? { ...curr, distrito: e.target.value } : null)}
                              sx={{
                                '& .MuiSelect-select': { border: 'none' },
                                '&:before': { border: 'none' },
                                '&:after': { border: 'none' },
                              }}
                            >
                              {[...availableDistricts].sort().map((district) => (
                                <MenuItem key={district} value={district}>{district}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            margin="dense"
                            label="Señas"
                            type="text"
                            fullWidth
                            multiline
                            rows={2}
                            error={!!currentPublicClient?.senas && !validateSenasNota(currentPublicClient.senas)}
                            helperText={!!currentPublicClient?.senas && !validateSenasNota(currentPublicClient.senas) ? 'Las señas pueden tener hasta 250 caracteres.' : ''}
                            value={currentPublicClient?.senas || ''}
                            onChange={(e) => {
                              const value = e.target.value;
                              setCurrentPublicClient(curr => curr ? { ...curr, senas: value } : null);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            margin="dense"
                            label="Nota de Cliente"
                            type="text"
                            fullWidth
                            multiline
                            rows={2}
                            error={!!currentPublicClient?.nota && !validateSenasNota(currentPublicClient.nota)}
                            helperText={!!currentPublicClient?.nota && !validateSenasNota(currentPublicClient.nota) ? 'La nota puede tener hasta 250 caracteres.' : ''}
                            value={currentPublicClient?.nota || ''}
                            onChange={(e) => {
                              const value = e.target.value;
                              setCurrentPublicClient(curr => curr ? { ...curr, nota: value } : null);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            margin="dense"
                            label="Código de Referencia"
                            type="text"
                            fullWidth
                            value={currentPublicClient?.codigo_referencia || ''}
                            onChange={(e) => setCurrentPublicClient(curr => curr ? { ...curr, codigo_referencia: e.target.value } : null)}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  </Box>
                )}
                  {tabValue === 1 && (
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'row' }}>
                      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', paddingRight: 2, mr: 2 }}>
                        <Grid container spacing={2} sx={{ mb: 2, flex: 1, mt: 2, ml: 2 }}>
                          {['cant_gato', 'cant_perro_mini', 'cant_perro_pequeno', 'cant_perro_mediano', 'cant_perro_grande', 'cant_perro_gigante'].map((field) => (
                            <Grid item xs={12} sm={6} md={4} key={field}>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                sx={{
                                  border: '2px solid #87CEEB',
                                  borderRadius: 2,
                                  transition: 'transform 0.3s ease',
                                  '&:hover': {
                                    transform: 'scale(1.02)',
                                  },
                                  padding: 1,
                                }}
                              >
                                <Box display="flex" flexDirection="column" alignItems="center">
                                  <Box sx={{ textAlign: 'center', mb: 1 }}>
                                    <img
                                      src={`${process.env.PUBLIC_URL}/images/${field}.png`}
                                      alt={columnNames[field as keyof Client]}
                                      style={{ width: '70px', height: '70px' }}
                                    />
                                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{columnNames[field as keyof Client]?.split(' ')[0]}</Typography>
                                    <Typography variant="body2">{columnNames[field as keyof Client]?.split(' ')[1]}</Typography>
                                  </Box>
                                </Box>
                                <Box display="flex" flexDirection="column" alignItems="center" sx={{ ml: 1 }}>
                                  <Typography variant="body2" sx={{ mb: 1 }}>Cantidad:</Typography>
                                  <Box display="flex" alignItems="center">
                                    <IconButton
                                      onClick={() => handleQuantityChangePublic(field, false)}
                                      sx={{ color: '#87CEEB' }}
                                    >
                                      <RemoveIcon />
                                    </IconButton>
                                    <TextField
                                      value={currentPublicClient?.[field as keyof PublicClient] || '0'}
                                      onChange={(e) => setCurrentPublicClient(curr => curr ? { ...curr, [field]: e.target.value } : null)}
                                      inputProps={{
                                        style: { textAlign: 'center' },
                                        min: 0,
                                      }}
                                      sx={{
                                        width: '50px',
                                        '& .MuiInputBase-input': {
                                          padding: '5px',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                          '& fieldset': {
                                            borderColor: 'transparent',
                                          },
                                          '&:hover fieldset': {
                                            borderColor: 'transparent',
                                          },
                                          '&.Mui-focused fieldset': {
                                            borderColor: 'transparent',
                                          },
                                        },
                                      }}
                                    />
                                    <IconButton
                                      onClick={() => handleQuantityChangePublic(field, true)}
                                      sx={{ color: '#87CEEB' }}
                                    >
                                      <AddIcon />
                                    </IconButton>
                                  </Box>
                                </Box>
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                      <Box
                        sx={{
                          width: '35%',
                          display: 'flex',
                          flexDirection: 'column',
                          paddingLeft: 2,
                        }}
                      >
                        <Typography variant="h6" sx={{ mb: 2 }}>Imagen del cliente</Typography>
                        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px dashed #87CEEB', borderRadius: 2, mb: 2 }}>
                          {currentPublicClient?.imageUrl ? (
                            <Box sx={{ position: 'relative', width: '100%', textAlign: 'center' }}>
                              <IconButton
                                sx={{
                                  position: 'absolute',
                                  right: 5,
                                  top: 5,
                                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                  '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                  },
                                  zIndex: 1,
                                }}
                                onClick={() => {
                                  if (currentPublicClient) {
                                    setCurrentPublicClient({
                                      ...currentPublicClient,
                                      imageUrl: ''
                                    });
                                  }
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                              <img src={currentPublicClient.imageUrl} alt="Client" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                            </Box>
                          ) : (
                            <Typography variant="body1" color="textSecondary">Vista previa de la imagen</Typography>
                          )}
                        </Box>
                        <input
                          accept="image/*"
                          style={{ display: 'none' }}
                          id="raised-button-file-public"
                          type="file"
                          onChange={handleImageUploadPublic}
                        />
                        <label htmlFor="raised-button-file-public">
                          <Button
                            variant="contained"
                            component="span"
                            sx={{
                              backgroundColor: '#87CEEB',
                              color: 'white',
                              '&:hover': {
                                backgroundColor: '#5CACEE',
                              },
                              fontWeight: 'bold',
                            }}
                          >
                            Subir Imagen
                          </Button>
                        </label>
                      </Box>
                    </Box>
                )}
              </Box>
            </Box>
          </DialogContent>
          <DialogActions sx={{
            justifyContent: 'right',
            px: 3,
            py: 2,
            backgroundColor: 'rgba(135, 206, 235, 0.1)'
          }}>
            <Button
              onClick={handleSavePublicClient}
              variant="contained"
              disabled={!isPublicFormValid()}
              sx={{
                backgroundColor: '#87CEEB',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#5CACEE',
                },
                '&:disabled': {
                  backgroundColor: 'rgba(135, 206, 235, 0.5)',
                  color: 'rgba(255, 255, 255, 0.7)',
                },
                fontWeight: 'bold',
                px: 4,
                py: 1,
              }}
            >
              Guardar
            </Button>
            <Button
              onClick={handleClosePublicClient}
              variant="outlined"
              sx={{
                color: '#87CEEB',
                borderColor: '#87CEEB',
                '&:hover': {
                  backgroundColor: 'rgba(135, 206, 235, 0.1)',
                  borderColor: '#5CACEE',
                },
                fontWeight: 'bold',
                px: 4,
                py: 1,
                mr: 2,
              }}
            >
              Cancelar
            </Button>
          </DialogActions>
        </Dialog>

      {/* Loading overlay para guardar ruta */}
      {savingRoute && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: 'rgba(0, 0, 0, 0.7)'
          }}
          open={true}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <CircularProgress color="inherit" size={60} />
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Guardando pedido en la ruta...
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              Por favor espera un momento
            </Typography>
          </Box>
        </Backdrop>
      )}
    </Box>
  );
};

// Componente de loading que se renderiza fuera del componente principal
const RouteSavingLoader = ({ savingRoute }: { savingRoute: boolean }) => {
  if (!savingRoute) return null;
  
  return (
    <Backdrop
      sx={{ 
        color: '#fff', 
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.7)'
      }}
      open={true}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        <CircularProgress color="inherit" size={60} />
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Guardando pedido en la ruta...
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.8 }}>
          Por favor espera un momento
        </Typography>
      </Box>
    </Backdrop>
  );
};

// Componente wrapper que maneja el estado
const ClientListWithLoader: React.FC<ClientListProps> = (props) => {
  const [savingRoute, setSavingRoute] = useState(false);
  
  return (
    <>
      <ClientList {...props} savingRoute={savingRoute} setSavingRoute={setSavingRoute} />
      <RouteSavingLoader savingRoute={savingRoute} />
    </>
  );
};

export default ClientListWithLoader;
